"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[22],{

/***/ 64889:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$_": function() { return /* binding */ Footer; },
/* harmony export */   "Bz": function() { return /* binding */ initialDataProvider; },
/* harmony export */   "Df": function() { return /* binding */ ELanguage; },
/* harmony export */   "QS": function() { return /* binding */ EPages; },
/* harmony export */   "h4": function() { return /* binding */ Header$1; }
/* harmony export */ });
/* unused harmony exports AuthButton, EMode, ESection, ETopBannerZoneName, FindJobsTab, getBottomText, getSeoKeywordAPI, getTopBanner, handleChangeLanguage, useInitialData */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _microfrontends_react_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(232);
/* harmony import */ var _microfrontends_react_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45896);
/* harmony import */ var _microfrontends_react_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(31545);
/* harmony import */ var _microfrontends_react_components__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(13952);
/* harmony import */ var _microfrontends_react_components__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(77203);
/* harmony import */ var _microfrontends_react_components__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(18089);
/* harmony import */ var _microfrontends_react_components__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(93809);
/* harmony import */ var _microfrontends_react_components__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(93570);
/* harmony import */ var _microfrontends_react_components__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(23877);
/* harmony import */ var _microfrontends_react_components__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(78190);
/* harmony import */ var _microfrontends_react_components__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(182);
/* harmony import */ var _microfrontends_react_components__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(48421);
/* harmony import */ var _microfrontends_react_components__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(59523);
/* harmony import */ var _microfrontends_react_components__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(25035);
/* harmony import */ var _microfrontends_react_components__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(31970);
/* harmony import */ var _microfrontends_react_components__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(88904);
/* harmony import */ var _microfrontends_react_components__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(11908);
/* harmony import */ var _microfrontends_react_components__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(42793);
/* harmony import */ var _microfrontends_react_components__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(76576);
/* harmony import */ var _microfrontends_react_components__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(70676);
/* harmony import */ var _microfrontends_react_components__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(38431);
/* harmony import */ var _microfrontends_react_components__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(30871);
/* harmony import */ var _microfrontends_react_components__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(81781);
/* harmony import */ var _microfrontends_react_components__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(22365);
/* harmony import */ var _microfrontends_react_components__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(45867);
/* harmony import */ var _microfrontends_react_components__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(18700);
/* harmony import */ var _microfrontends_react_components__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(20560);
/* harmony import */ var _microfrontends_react_components__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(77091);
/* harmony import */ var _microfrontends_react_components__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(60542);
/* harmony import */ var _microfrontends_react_components__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(83773);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(19521);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(73935);
/* provided dependency */ var process = __webpack_require__(83454);





function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  strings.raw = raw;
  return strings;
}

var EMode;

(function (EMode) {
  EMode["STAGING"] = "staging";
  EMode["RELEASE"] = "release";
  EMode["PRODUCTION"] = "production";
})(EMode || (EMode = {}));

var URL_KEYWORD_SUFFIX_EN = 'kw';
var URL_SUFFIX_EN = 'en';
var URL_KEYWORD_SUFFIX_VI = 'kv';
var URL_SUFFIX_VI = 'vn';
var ELanguage;

(function (ELanguage) {
  ELanguage["VI"] = "vi";
  ELanguage["EN"] = "en";
})(ELanguage || (ELanguage = {}));

var EPages;

(function (EPages) {
  EPages["HOME_PAGE"] = "homepage";
  EPages["SEARCH_RESULT"] = "searchResult";
  EPages["SEO_LANDING_PAGE"] = "SEOLandingPage";
  EPages["TOP_MANAGEMENT_JOBS"] = "topManagementJobs";
  EPages["INTERVIEW"] = "interview";
  EPages["SALARY"] = "salary";
  EPages["COMPANY_LIST"] = "companyList";
  EPages["JOB_DETAIL"] = "jobDetail";
  EPages["MY_CAREER_CENTER"] = "myCareerCenter";
  EPages["DASHBOARD"] = "dashboard";
  EPages["PROFILE_SETTINGS"] = "profileSettings";
  EPages["MY_COMPANIES"] = "myCompanies";
  EPages["PROFILE_VIEWS"] = "profileViews";
  EPages["MY_JOBS"] = "myJobs";
  EPages["JOB_ALERTS"] = "jobAlerts";
  EPages["MY_PROFILE"] = "myProfile";
  EPages["ACCOUNT_SETTINGS"] = "accountSettings";
  EPages["OTHER"] = "other";
  EPages["MY_ACCOUNT"] = "myAccount";
  EPages["WOW_CV"] = "wowCv";
  EPages["REFERRAL_CANDIDATES"] = "referralCandidates";
  EPages["CAREER_TOOLS"] = "careerTools";
  EPages["SALARY_CONVERTER"] = "salaryConverter";
  EPages["CAREER_PATH"] = "careerPath";
  EPages["NUMEROLOGY"] = "numerology";
  EPages["EMPOWER_GROWTH"] = "empowerGrowth";
  EPages["CAREER_NEWBIES"] = "careerNewbies";
  EPages["RECOMMENDED_JOBS"] = "recommendedJobs";
  EPages["HR_INSIDER"] = "HRInsider";
  EPages["ACCOUNT_CENTER"] = "accountCenter";
  EPages["SYNC_PROFILE"] = "syncProfile";
  EPages["CHARGE_STATION"] = "chargeStation";
  EPages["ORDER_MANAGEMENT"] = "orderMangagement";
  EPages["NONE"] = "none";
})(EPages || (EPages = {}));

var ESection;

(function (ESection) {
  ESection["SAVED_JOB"] = "saved_job";
  ESection["APPLIED_JOB"] = "applied_job";
  ESection["VIEWED_JOB"] = "viewed_job";
})(ESection || (ESection = {}));

var ETopBannerZoneName;

(function (ETopBannerZoneName) {
  ETopBannerZoneName["EMPTY"] = "";
  ETopBannerZoneName["SEARCH_RESULT"] = "topBannerSearchResult";
  ETopBannerZoneName["JOB_DETAIL"] = "topBannerJobDetail";
  ETopBannerZoneName["HOME_PAGE"] = "topBannerHomePage";
})(ETopBannerZoneName || (ETopBannerZoneName = {}));

var AppShellContext = react__WEBPACK_IMPORTED_MODULE_0__.createContext({
  langCode: ELanguage.VI,
  bottomSEOContent: null,
  mode: EMode.STAGING,
  user: null,
  keyword: '',
  companyIndustries: [],
  jobFunctions: [],
  locationId: [],
  categoryId: [],
  locations: [],
  pageName: '',
  theme: null
});

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var js_cookie = createCommonjsModule(function (module, exports) {
(function (factory) {
	var registeredInModuleLoader;
	{
		module.exports = factory();
		registeredInModuleLoader = true;
	}
	if (!registeredInModuleLoader) {
		var OldCookies = window.Cookies;
		var api = window.Cookies = factory();
		api.noConflict = function () {
			window.Cookies = OldCookies;
			return api;
		};
	}
}(function () {
	function extend () {
		var i = 0;
		var result = {};
		for (; i < arguments.length; i++) {
			var attributes = arguments[ i ];
			for (var key in attributes) {
				result[key] = attributes[key];
			}
		}
		return result;
	}

	function decode (s) {
		return s.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
	}

	function init (converter) {
		function api() {}

		function set (key, value, attributes) {
			if (typeof document === 'undefined') {
				return;
			}

			attributes = extend({
				path: '/'
			}, api.defaults, attributes);

			if (typeof attributes.expires === 'number') {
				attributes.expires = new Date(new Date() * 1 + attributes.expires * 864e+5);
			}

			// We're using "expires" because "max-age" is not supported by IE
			attributes.expires = attributes.expires ? attributes.expires.toUTCString() : '';

			try {
				var result = JSON.stringify(value);
				if (/^[\{\[]/.test(result)) {
					value = result;
				}
			} catch (e) {}

			value = converter.write ?
				converter.write(value, key) :
				encodeURIComponent(String(value))
					.replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);

			key = encodeURIComponent(String(key))
				.replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent)
				.replace(/[\(\)]/g, escape);

			var stringifiedAttributes = '';
			for (var attributeName in attributes) {
				if (!attributes[attributeName]) {
					continue;
				}
				stringifiedAttributes += '; ' + attributeName;
				if (attributes[attributeName] === true) {
					continue;
				}

				// Considers RFC 6265 section 5.2:
				// ...
				// 3.  If the remaining unparsed-attributes contains a %x3B (";")
				//     character:
				// Consume the characters of the unparsed-attributes up to,
				// not including, the first %x3B (";") character.
				// ...
				stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
			}

			return (document.cookie = key + '=' + value + stringifiedAttributes);
		}

		function get (key, json) {
			if (typeof document === 'undefined') {
				return;
			}

			var jar = {};
			// To prevent the for loop in the first place assign an empty array
			// in case there are no cookies at all.
			var cookies = document.cookie ? document.cookie.split('; ') : [];
			var i = 0;

			for (; i < cookies.length; i++) {
				var parts = cookies[i].split('=');
				var cookie = parts.slice(1).join('=');

				if (!json && cookie.charAt(0) === '"') {
					cookie = cookie.slice(1, -1);
				}

				try {
					var name = decode(parts[0]);
					cookie = (converter.read || converter)(cookie, name) ||
						decode(cookie);

					if (json) {
						try {
							cookie = JSON.parse(cookie);
						} catch (e) {}
					}

					jar[name] = cookie;

					if (key === name) {
						break;
					}
				} catch (e) {}
			}

			return key ? jar[key] : jar;
		}

		api.set = set;
		api.get = function (key) {
			return get(key, false /* read as raw */);
		};
		api.getJSON = function (key) {
			return get(key, true /* read as json */);
		};
		api.remove = function (key, attributes) {
			set(key, '', extend(attributes, {
				expires: -1
			}));
		};

		api.defaults = {};

		api.withConverter = init;

		return api;
	}

	return init(function () {});
}));
});

var env = {
  vi: {
    staging: {
      inTechLogoUrl: 'https://staging.vietnamworks.com/assets-page-container/images/vnw-intech-logo_2x.png',
      inTechUrl: 'https://intech.vietnamworks.com/',
      logoUrl: 'https://staging.vietnamworks.com/assets-page-container/images/vnw_empower_growth_logo_white.png',
      blueLogoUrl: 'https://staging.vietnamworks.com/assets-page-container/images/vnw_empower_growth_logo.png',
      jobSeekerUrl: 'https://staging.vietnamworks.com',
      jobSeekerImageUrl: 'https://staging-images.vietnamworks.com',
      employerUrl: 'https://staging-employer.vietnamworks.com/?lang=1&utm_source_navi=header&utm_medium_navi=jsployersite',
      loginUrl: 'https://staging.vietnamworks.com/dang-nhap?type=login',
      registrationUrl: 'https://staging.vietnamworks.com/dang-ky',
      learningUrl: 'https://kyna.vn/554381?utm_source_navi=vnw.site&utm_medium_navi=header',
      hrInsiderUrl: 'https://www.vietnamworks.com/hrinsider/',
      logoutUrl: 'https://staging-secure.vietnamworks.com/logout/vi?client_id=3',
      faqUrl: 'https://staging-faq.vietnamworks.com/vi?utm_source_navi=footer',
      facebookLoginUrl: 'https://staging.vietnamworks.com/dang-nhap?type=facebook',
      googleLoginUrl: 'https://staging.vietnamworks.com/dang-nhap?type=google',
      hotKeywordAPI: 'https://staging-ms.vietnamworks.com/hot-keywords/api/v2/hot-keywords',
      suggestionAPI: 'https://staging-ms.vietnamworks.com/hot-keywords/api/v2/keywords/suggestion',
      jobChannelURL: 'https://staging.vietnamworks.com/kenh-viec-lam/',
      bottomTextUrl: 'https://staging-ms.vietnamworks.com/banners/v1.0/bottom-text',
      topBannerUrl: 'https://staging-ms.vietnamworks.com/banners/v1.0/top-banner',
      employerPostJob: 'https://staging-employer.vietnamworks.com/?utm_source_navi=footer&lang=1#jobPosting',
      employerSearchResume: 'https://staging-employer.vietnamworks.com/?utm_source_navi=footer&lang=1#resumeSearch',
      employerOtherServices: 'https://www.vietnamworks.com/hrinsider/nha-tuyen-dung?utm_source=homepage&utm_medium=hp_header',
      employerContact: 'https://staging-employer.vietnamworks.com/?utm_source_navi=header&utm_medium_navi=jsployersite&lang=1#contact',
      msBasePath: 'https://staging-ms.vietnamworks.com',
      appId: '5_5s8na3qyquckws4ogkgk88g44oosccwwsc8ckcg4s0ogws8s8o',
      themeApiUrl: 'https://staging-ms.vietnamworks.com/banners/v1.0/themes',
      wowCvUrl: 'https://staging.vietnamworks.com/wowcv',
      myProfileUrl: 'https://staging.vietnamworks.com/ho-so',
      getSearchableAPI: 'https://staging-ms.vietnamworks.com/api-gateway/v1.1/profile/resume-setting-info',
      makeSearchableAPI: 'https://staging-ms.vietnamworks.com/api-gateway/v1.0/profile/resume-change-searchable',
      uploadCvAPI: 'https://staging-ms.vietnamworks.com/api-gateway/v1.0/profile/update-resume-file',
      suggestJobTitleAPI: 'https://staging-ms.vietnamworks.com/api-gateway/v1.0/suggest-job-title',
      attachedResumeAPI: 'https://staging-ms.vietnamworks.com/api-gateway/v1.0/profile/attached-profile',
      createAnonyJobAlertAPI: 'https://staging-ms.vietnamworks.com/api-gateway/v1.0/job-alerts-anonymous',
      popupTypeAPI: 'https://staging-ms.vietnamworks.com/api-gateway/v1.0/checking-popup',
      resumeSummaryAPI: 'https://staging-ms.vietnamworks.com/api-gateway/v1.0/profile/resume-summary',
      bigImageUrl: 'https://staging.vietnamworks.com/assets-page-container/images/bg.png',
      trackingAPI: 'https://staging-ms.vietnamworks.com/log-aggregator/v2/track-banner-click',
      cookieDomain: '.vietnamworks.com',
      internalRefererUrls: '.*\\.vietnamworks\\.com',
      bannerService: 'https://staging-ms.vietnamworks.com/banners/v1.0',
      pageContainerImageService: 'https://staging.vietnamworks.com/assets-page-container/images',
      zaloWidgetOaid: '2477265076863435153',
      enableJobFunction: '1',
      facebookIcon: 'https://staging-images.vietnamworks.com/icon/social-icons/facebook.svg',
      youtubeIcon: 'https://staging-images.vietnamworks.com/icon/social-icons/youtube.svg',
      linkedinIcon: 'https://staging-images.vietnamworks.com/icon/social-icons/linkedin.svg',
      tiktokIcon: 'https://staging-images.vietnamworks.com/icon/social-icons/tiktok.svg',
      spotifyIcon: 'https://staging-images.vietnamworks.com/icon/social-icons/spotify.svg',
      facebookLink: 'https://bit.ly/3r5zg7J',
      youtubeLink: 'https://bit.ly/3R9BXA2',
      linkedinLink: 'https://bit.ly/44WjeLX',
      tiktokLink: 'https://bit.ly/3R6ahfe',
      spotifyLink: 'https://spoti.fi/45VQtiO',
      sortDefaultIndex: 'vnw_job_new_staging'
    },
    release: {
      inTechLogoUrl: 'https://release.vietnamworks.com/assets-page-container/images/vnw-intech-logo_2x.png',
      inTechUrl: 'https://intech.vietnamworks.com/',
      logoUrl: 'https://release.vietnamworks.com/assets-page-container/images/vnw_empower_growth_logo_white.png',
      blueLogoUrl: 'https://release.vietnamworks.com/assets-page-container/images/vnw_empower_growth_logo.png',
      jobSeekerUrl: 'https://release.vietnamworks.com',
      jobSeekerImageUrl: 'https://release-images.vietnamworks.com',
      employerUrl: 'https://release-employer.vietnamworks.com/?lang=1&utm_source_navi=header&utm_medium_navi=jsployersite',
      loginUrl: 'https://release.vietnamworks.com/dang-nhap?type=login',
      registrationUrl: 'https://release.vietnamworks.com/dang-ky',
      learningUrl: 'https://kyna.vn/554381?utm_source_navi=vnw.site&utm_medium_navi=header',
      hrInsiderUrl: 'https://www.vietnamworks.com/hrinsider/',
      logoutUrl: 'https://release-secure.vietnamworks.com/logout/vi?client_id=3',
      faqUrl: 'https://release-faq.vietnamworks.com/vi?utm_source_navi=footer',
      facebookLoginUrl: 'https://release.vietnamworks.com/dang-nhap?type=facebook',
      googleLoginUrl: 'https://release.vietnamworks.com/dang-nhap?type=google',
      hotKeywordAPI: 'https://release-ms.vietnamworks.com/hot-keywords/api/v2/hot-keywords',
      suggestionAPI: 'https://release-ms.vietnamworks.com/hot-keywords/api/v2/keywords/suggestion',
      jobChannelURL: 'https://release.vietnamworks.com/kenh-viec-lam/',
      bottomTextUrl: 'https://release-ms.vietnamworks.com/banners/v1.0/bottom-text',
      topBannerUrl: 'https://release-ms.vietnamworks.com/banners/v1.0/top-banner',
      employerPostJob: 'https://release-employer.vietnamworks.com/?utm_source_navi=footer&lang=1#jobPosting',
      employerSearchResume: 'https://release-employer.vietnamworks.com/?utm_source_navi=footer&lang=1#resumeSearch',
      employerOtherServices: 'https://www.vietnamworks.com/hrinsider/nha-tuyen-dung?utm_source=homepage&utm_medium=hp_header',
      employerContact: 'https://release-employer.vietnamworks.com/?utm_source_navi=header&utm_medium_navi=jsployersite&lang=1#contact',
      msBasePath: 'https://release-ms.vietnamworks.com',
      appId: '4_2jou0kf7tsqo4s0c048goswckossk48kgc4c80ksok40cwwcss',
      themeApiUrl: 'https://release-ms.vietnamworks.com/banners/v1.0/themes',
      wowCvUrl: 'https://release.vietnamworks.com/wowcv',
      myProfileUrl: 'https://release.vietnamworks.com/ho-so',
      getSearchableAPI: 'https://release-ms.vietnamworks.com/api-gateway/v1.1/profile/resume-setting-info',
      makeSearchableAPI: 'https://release-ms.vietnamworks.com/api-gateway/v1.0/profile/resume-change-searchable',
      uploadCvAPI: 'https://release-ms.vietnamworks.com/api-gateway/v1.0/profile/update-resume-file',
      suggestJobTitleAPI: 'https://release-ms.vietnamworks.com/api-gateway/v1.0/suggest-job-title',
      attachedResumeAPI: 'https://release-ms.vietnamworks.com/api-gateway/v1.0/profile/attached-profile',
      createAnonyJobAlertAPI: 'https://release-ms.vietnamworks.com/api-gateway/v1.0/job-alerts-anonymous',
      popupTypeAPI: 'https://release-ms.vietnamworks.com/api-gateway/v1.0/checking-popup',
      resumeSummaryAPI: 'https://release-ms.vietnamworks.com/api-gateway/v1.0/profile/resume-summary',
      bigImageUrl: 'https://release.vietnamworks.com/assets-page-container/images/bg.png',
      trackingAPI: 'https://release-ms.vietnamworks.com/log-aggregator/v2/track-banner-click',
      cookieDomain: '.vietnamworks.com',
      internalRefererUrls: '.*\\.vietnamworks\\.com',
      bannerService: 'https://release-ms.vietnamworks.com/banners/v1.0',
      pageContainerImageService: 'https://release.vietnamworks.com/assets-page-container/images',
      zaloWidgetOaid: '2477265076863435153',
      enableJobFunction: '1',
      facebookIcon: 'https://release-images.vietnamworks.com/icon/social-icons/facebook.svg',
      youtubeIcon: 'https://release-images.vietnamworks.com/icon/social-icons/youtube.svg',
      linkedinIcon: 'https://release-images.vietnamworks.com/icon/social-icons/linkedin.svg',
      tiktokIcon: 'https://release-images.vietnamworks.com/icon/social-icons/tiktok.svg',
      spotifyIcon: 'https://release-images.vietnamworks.com/icon/social-icons/spotify.svg',
      facebookLink: 'https://bit.ly/3r5zg7J',
      youtubeLink: 'https://bit.ly/3R9BXA2',
      linkedinLink: 'https://bit.ly/44WjeLX',
      tiktokLink: 'https://bit.ly/3R6ahfe',
      spotifyLink: 'https://spoti.fi/45VQtiO',
      sortDefaultIndex: 'release_vnw_job_v2'
    },
    production: {
      inTechLogoUrl: 'https://www.vietnamworks.com/assets-page-container/images/vnw-intech-logo_2x.png',
      inTechUrl: 'https://intech.vietnamworks.com/',
      logoUrl: 'https://www.vietnamworks.com/assets-page-container/images/vnw_empower_growth_logo_white.png',
      blueLogoUrl: 'https://www.vietnamworks.com/assets-page-container/images/vnw_empower_growth_logo.png',
      jobSeekerUrl: 'https://www.vietnamworks.com',
      jobSeekerImageUrl: 'https://images.vietnamworks.com',
      employerUrl: 'https://employer.vietnamworks.com/?lang=1&utm_source_navi=header&utm_medium_navi=jsployersite',
      loginUrl: 'https://www.vietnamworks.com/dang-nhap?type=login',
      registrationUrl: 'https://www.vietnamworks.com/dang-ky',
      learningUrl: 'https://kyna.vn/554381?utm_source_navi=vnw.site&utm_medium_navi=header',
      hrInsiderUrl: 'https://www.vietnamworks.com/hrinsider/',
      logoutUrl: 'https://secure.vietnamworks.com/logout/vi?client_id=3',
      faqUrl: 'https://faq.vietnamworks.com/vi?utm_source_navi=footer',
      facebookLoginUrl: 'https://www.vietnamworks.com/dang-nhap?type=facebook',
      googleLoginUrl: 'https://www.vietnamworks.com/dang-nhap?type=google',
      hotKeywordAPI: 'https://ms.vietnamworks.com/hot-keywords/api/v2/hot-keywords',
      suggestionAPI: 'https://ms.vietnamworks.com/hot-keywords/api/v2/keywords/suggestion',
      jobChannelURL: 'https://www.vietnamworks.com/kenh-viec-lam/',
      bottomTextUrl: 'https://ms.vietnamworks.com/banners/v1.0/bottom-text',
      topBannerUrl: 'https://ms.vietnamworks.com/banners/v1.0/top-banner',
      employerPostJob: 'https://employer.vietnamworks.com/?utm_source_navi=footer&lang=1#jobPosting',
      employerSearchResume: 'https://employer.vietnamworks.com/?utm_source_navi=footer&lang=1#resumeSearch',
      employerOtherServices: 'https://www.vietnamworks.com/hrinsider/nha-tuyen-dung?utm_source=homepage&utm_medium=hp_header',
      employerContact: 'https://employer.vietnamworks.com/?utm_source_navi=header&utm_medium_navi=jsployersite&lang=1#contact',
      msBasePath: 'https://ms.vietnamworks.com',
      appId: '4_2jou0kf7tsqo4s0c048goswckossk48kgc4c80ksok40cwwcss',
      themeApiUrl: 'https://ms.vietnamworks.com/banners/v1.0/themes',
      wowCvUrl: 'https://www.vietnamworks.com/wowcv',
      myProfileUrl: 'https://www.vietnamworks.com/ho-so',
      getSearchableAPI: 'https://ms.vietnamworks.com/api-gateway/v1.1/profile/resume-setting-info',
      makeSearchableAPI: 'https://ms.vietnamworks.com/api-gateway/v1.0/profile/resume-change-searchable',
      uploadCvAPI: 'https://ms.vietnamworks.com/api-gateway/v1.0/profile/update-resume-file',
      suggestJobTitleAPI: 'https://ms.vietnamworks.com/api-gateway/v1.0/suggest-job-title',
      attachedResumeAPI: 'https://ms.vietnamworks.com/api-gateway/v1.0/profile/attached-profile',
      createAnonyJobAlertAPI: 'https://ms.vietnamworks.com/api-gateway/v1.0/job-alerts-anonymous',
      popupTypeAPI: 'https://ms.vietnamworks.com/api-gateway/v1.0/checking-popup',
      resumeSummaryAPI: 'https://ms.vietnamworks.com/api-gateway/v1.0/profile/resume-summary',
      bigImageUrl: 'https://www.vietnamworks.com/assets-page-container/images/bg.png',
      trackingAPI: 'https://ms.vietnamworks.com/log-aggregator/v2/track-banner-click',
      cookieDomain: '.vietnamworks.com',
      internalRefererUrls: '.*\\.vietnamworks\\.com',
      bannerService: 'https://ms.vietnamworks.com/banners/v1.0',
      pageContainerImageService: 'https://vietnamworks.com/assets-page-container/images',
      zaloWidgetOaid: '2477265076863435153',
      enableJobFunction: '1',
      facebookIcon: 'https://images.vietnamworks.com/icon/social-icons/facebook.svg',
      youtubeIcon: 'https://images.vietnamworks.com/icon/social-icons/youtube.svg',
      linkedinIcon: 'https://images.vietnamworks.com/icon/social-icons/linkedin.svg',
      tiktokIcon: 'https://images.vietnamworks.com/icon/social-icons/tiktok.svg',
      spotifyIcon: 'https://images.vietnamworks.com/icon/social-icons/spotify.svg',
      facebookLink: 'https://bit.ly/3r5zg7J',
      youtubeLink: 'https://bit.ly/3R9BXA2',
      linkedinLink: 'https://bit.ly/44WjeLX',
      tiktokLink: 'https://bit.ly/3R6ahfe',
      spotifyLink: 'https://spoti.fi/45VQtiO',
      sortDefaultIndex: 'vnw_job_v2'
    }
  },
  en: {
    staging: {
      inTechLogoUrl: 'https://staging.vietnamworks.com/assets-page-container/images/vnw-intech-logo_2x.png',
      inTechUrl: 'https://intech.vietnamworks.com/',
      logoUrl: 'https://staging.vietnamworks.com/assets-page-container/images/vnw_empower_growth_logo_white.png',
      blueLogoUrl: 'https://staging.vietnamworks.com/assets-page-container/images/vnw_empower_growth_logo.png',
      jobSeekerUrl: 'https://staging.vietnamworks.com',
      jobSeekerImageUrl: 'https://staging-images.vietnamworks.com',
      employerUrl: 'https://staging-employer.vietnamworks.com/?lang=2&utm_source_navi=header&utm_medium_navi=jsployersite',
      loginUrl: 'https://staging.vietnamworks.com/login?type=login',
      registrationUrl: 'https://staging.vietnamworks.com/sign-up',
      learningUrl: 'https://kyna.vn/554381?utm_source_navi=vnw.site&utm_medium_navi=header',
      hrInsiderUrl: 'https://www.vietnamworks.com/hrinsider/',
      logoutUrl: 'https://staging-secure.vietnamworks.com/logout/en?client_id=3',
      faqUrl: 'https://staging-faq.vietnamworks.com/en?utm_source_navi=footer',
      facebookLoginUrl: 'https://staging.vietnamworks.com/login?type=facebook',
      googleLoginUrl: 'https://staging.vietnamworks.com/login?type=google',
      hotKeywordAPI: 'https://staging-ms.vietnamworks.com/hot-keywords/api/v2/hot-keywords',
      suggestionAPI: 'https://staging-ms.vietnamworks.com/hot-keywords/api/v2/keywords/suggestion',
      jobChannelURL: 'https://staging.vietnamworks.com/job-channel/',
      bottomTextUrl: 'https://staging-ms.vietnamworks.com/banners/v1.0/bottom-text',
      topBannerUrl: 'https://staging-ms.vietnamworks.com/banners/v1.0/top-banner',
      employerPostJob: 'https://staging-employer.vietnamworks.com/?utm_source_navi=footer&lang=2#jobPosting',
      employerSearchResume: 'https://staging-employer.vietnamworks.com/?utm_source_navi=footer&lang=2#resumeSearch',
      employerOtherServices: 'https://www.vietnamworks.com/hrinsider/nha-tuyen-dung?utm_source=homepage&utm_medium=hp_header',
      employerContact: 'https://staging-employer.vietnamworks.com/?utm_source_navi=header&utm_medium_navi=jsployersite&lang=2#contact',
      msBasePath: 'https://staging-ms.vietnamworks.com',
      appId: '5_5s8na3qyquckws4ogkgk88g44oosccwwsc8ckcg4s0ogws8s8o',
      themeApiUrl: 'https://staging-ms.vietnamworks.com/banners/v1.0/themes',
      wowCvUrl: 'https://staging.vietnamworks.com/wowcv/en',
      myProfileUrl: 'https://staging.vietnamworks.com/my-profile',
      getSearchableAPI: 'https://staging-ms.vietnamworks.com/api-gateway/v1.1/profile/resume-setting-info',
      makeSearchableAPI: 'https://staging-ms.vietnamworks.com/api-gateway/v1.0/profile/resume-change-searchable',
      uploadCvAPI: 'https://staging-ms.vietnamworks.com/api-gateway/v1.0/profile/update-resume-file',
      suggestJobTitleAPI: 'https://staging-ms.vietnamworks.com/api-gateway/v1.0/suggest-job-title',
      attachedResumeAPI: 'https://staging-ms.vietnamworks.com/api-gateway/v1.0/profile/attached-profile',
      createAnonyJobAlertAPI: 'https://staging-ms.vietnamworks.com/api-gateway/v1.0/job-alerts-anonymous',
      popupTypeAPI: 'https://staging-ms.vietnamworks.com/api-gateway/v1.0/checking-popup',
      resumeSummaryAPI: 'https://staging-ms.vietnamworks.com/api-gateway/v1.0/profile/resume-summary',
      bigImageUrl: 'https://staging.vietnamworks.com/assets-page-container/images/bg.png',
      trackingAPI: 'https://staging-ms.vietnamworks.com/log-aggregator/v2/track-banner-click',
      cookieDomain: '.vietnamworks.com',
      internalRefererUrls: '.*\\.vietnamworks\\.com',
      bannerService: 'https://staging-ms.vietnamworks.com/banners/v1.0',
      pageContainerImageService: 'https://staging.vietnamworks.com/assets-page-container/images',
      zaloWidgetOaid: '2477265076863435153',
      enableJobFunction: '1',
      facebookIcon: 'https://staging-images.vietnamworks.com/icon/social-icons/facebook.svg',
      youtubeIcon: 'https://staging-images.vietnamworks.com/icon/social-icons/youtube.svg',
      linkedinIcon: 'https://staging-images.vietnamworks.com/icon/social-icons/linkedin.svg',
      tiktokIcon: 'https://staging-images.vietnamworks.com/icon/social-icons/tiktok.svg',
      spotifyIcon: 'https://staging-images.vietnamworks.com/icon/social-icons/spotify.svg',
      facebookLink: 'https://bit.ly/3r5zg7J',
      youtubeLink: 'https://bit.ly/3R9BXA2',
      linkedinLink: 'https://bit.ly/44WjeLX',
      tiktokLink: 'https://bit.ly/3R6ahfe',
      spotifyLink: 'https://spoti.fi/45VQtiO',
      sortDefaultIndex: 'vnw_job_new_staging'
    },
    release: {
      inTechLogoUrl: 'https://release.vietnamworks.com/assets-page-container/images/vnw-intech-logo_2x.png',
      inTechUrl: 'https://intech.vietnamworks.com/',
      logoUrl: 'https://release.vietnamworks.com/assets-page-container/images/vnw_empower_growth_logo_white.png',
      blueLogoUrl: 'https://release.vietnamworks.com/assets-page-container/images/vnw_empower_growth_logo.png',
      jobSeekerUrl: 'https://release.vietnamworks.com',
      jobSeekerImageUrl: 'https://release-images.vietnamworks.com',
      employerUrl: 'https://release-employer.vietnamworks.com/?lang=2&utm_source_navi=header&utm_medium_navi=jsployersite',
      loginUrl: 'https://release.vietnamworks.com/login?type=login',
      registrationUrl: 'https://release.vietnamworks.com/sign-up',
      learningUrl: 'https://kyna.vn/554381?utm_source_navi=vnw.site&utm_medium_navi=header',
      hrInsiderUrl: 'hthttps://www.vietnamworks.com/hrinsider/',
      logoutUrl: 'https://release-secure.vietnamworks.com/logout/en?client_id=3',
      faqUrl: 'https://release-faq.vietnamworks.com/en?utm_source_navi=footer',
      facebookLoginUrl: 'https://release.vietnamworks.com/login?type=facebook',
      googleLoginUrl: 'https://release.vietnamworks.com/login?type=google',
      hotKeywordAPI: 'https://release-ms.vietnamworks.com/hot-keywords/api/v2/hot-keywords',
      suggestionAPI: 'https://release-ms.vietnamworks.com/hot-keywords/api/v2/keywords/suggestion',
      jobChannelURL: 'https://release.vietnamworks.com/job-channel/',
      bottomTextUrl: 'https://release-ms.vietnamworks.com/banners/v1.0/bottom-text',
      topBannerUrl: 'https://release-ms.vietnamworks.com/banners/v1.0/top-banner',
      employerPostJob: 'https://release-employer.vietnamworks.com/?utm_source_navi=footer&lang=2#jobPosting',
      employerSearchResume: 'https://release-employer.vietnamworks.com/?utm_source_navi=footer&lang=2#resumeSearch',
      employerOtherServices: 'https://www.vietnamworks.com/hrinsider/nha-tuyen-dung?utm_source=homepage&utm_medium=hp_header',
      employerContact: 'https://release-employer.vietnamworks.com/?utm_source_navi=header&utm_medium_navi=jsployersite&lang=2#contact',
      msBasePath: 'https://release-ms.vietnamworks.com',
      appId: '4_2jou0kf7tsqo4s0c048goswckossk48kgc4c80ksok40cwwcss',
      themeApiUrl: 'https://release-ms.vietnamworks.com/banners/v1.0/themes',
      wowCvUrl: 'https://release.vietnamworks.com/wowcv/en',
      myProfileUrl: 'https://release.vietnamworks.com/my-profile',
      getSearchableAPI: 'https://release-ms.vietnamworks.com/api-gateway/v1.1/profile/resume-setting-info',
      makeSearchableAPI: 'https://release-ms.vietnamworks.com/api-gateway/v1.0/profile/resume-change-searchable',
      uploadCvAPI: 'https://release-ms.vietnamworks.com/api-gateway/v1.0/profile/update-resume-file',
      suggestJobTitleAPI: 'https://release-ms.vietnamworks.com/api-gateway/v1.0/suggest-job-title',
      attachedResumeAPI: 'https://release-ms.vietnamworks.com/api-gateway/v1.0/profile/attached-profile',
      createAnonyJobAlertAPI: 'https://release-ms.vietnamworks.com/api-gateway/v1.0/job-alerts-anonymous',
      popupTypeAPI: 'https://release-ms.vietnamworks.com/api-gateway/v1.0/checking-popup',
      resumeSummaryAPI: 'https://release-ms.vietnamworks.com/api-gateway/v1.0/profile/resume-summary',
      bigImageUrl: 'https://release.vietnamworks.com/assets-page-container/images/bg.png',
      trackingAPI: 'https://release-ms.vietnamworks.com/log-aggregator/v2/track-banner-click',
      cookieDomain: '.vietnamworks.com',
      internalRefererUrls: '.*\\.vietnamworks\\.com',
      bannerService: 'https://release-ms.vietnamworks.com/banners/v1.0',
      pageContainerImageService: 'https://release.vietnamworks.com/assets-page-container/images',
      zaloWidgetOaid: '2477265076863435153',
      enableJobFunction: '1',
      facebookIcon: 'https://release-images.vietnamworks.com/icon/social-icons/facebook.svg',
      youtubeIcon: 'https://release-images.vietnamworks.com/icon/social-icons/youtube.svg',
      linkedinIcon: 'https://release-images.vietnamworks.com/icon/social-icons/linkedin.svg',
      tiktokIcon: 'https://release-images.vietnamworks.com/icon/social-icons/tiktok.svg',
      spotifyIcon: 'https://release-images.vietnamworks.com/icon/social-icons/spotify.svg',
      facebookLink: 'https://bit.ly/3r5zg7J',
      youtubeLink: 'https://bit.ly/3R9BXA2',
      linkedinLink: 'https://bit.ly/44WjeLX',
      tiktokLink: 'https://bit.ly/3R6ahfe',
      spotifyLink: 'https://spoti.fi/45VQtiO',
      sortDefaultIndex: 'release_vnw_job_v2'
    },
    production: {
      inTechLogoUrl: 'https://www.vietnamworks.com/assets-page-container/images/vnw-intech-logo_2x.png',
      inTechUrl: 'https://intech.vietnamworks.com/',
      logoUrl: 'https://www.vietnamworks.com/assets-page-container/images/vnw_empower_growth_logo_white.png',
      blueLogoUrl: 'https://www.vietnamworks.com/assets-page-container/images/vnw_empower_growth_logo.png',
      jobSeekerUrl: 'https://www.vietnamworks.com',
      jobSeekerImageUrl: 'https://images.vietnamworks.com',
      employerUrl: 'https://employer.vietnamworks.com/?lang=2&utm_source_navi=header&utm_medium_navi=jsployersite',
      loginUrl: 'https://www.vietnamworks.com/login?type=login',
      registrationUrl: 'https://www.vietnamworks.com/sign-up',
      learningUrl: 'https://kyna.vn/554381?utm_source_navi=vnw.site&utm_medium_navi=header',
      hrInsiderUrl: 'https://www.vietnamworks.com/hrinsider/',
      logoutUrl: 'https://secure.vietnamworks.com/logout/en?client_id=3',
      faqUrl: 'https://faq.vietnamworks.com/en?utm_source_navi=footer',
      facebookLoginUrl: 'https://www.vietnamworks.com/login?type=facebook',
      googleLoginUrl: 'https://www.vietnamworks.com/login?type=google',
      hotKeywordAPI: 'https://ms.vietnamworks.com/hot-keywords/api/v2/hot-keywords',
      suggestionAPI: 'https://ms.vietnamworks.com/hot-keywords/api/v2/keywords/suggestion',
      jobChannelURL: 'https://www.vietnamworks.com/job-channel/',
      bottomTextUrl: 'https://ms.vietnamworks.com/banners/v1.0/bottom-text',
      topBannerUrl: 'https://ms.vietnamworks.com/banners/v1.0/top-banner',
      employerPostJob: 'https://employer.vietnamworks.com/?utm_source_navi=footer&lang=2#jobPosting',
      employerSearchResume: 'https://employer.vietnamworks.com/?utm_source_navi=footer&lang=2#resumeSearch',
      employerOtherServices: 'https://www.vietnamworks.com/hrinsider/nha-tuyen-dung?utm_source=homepage&utm_medium=hp_header',
      employerContact: 'https://employer.vietnamworks.com/?utm_source_navi=header&utm_medium_navi=jsployersite&lang=2#contact',
      msBasePath: 'https://ms.vietnamworks.com',
      appId: '4_2jou0kf7tsqo4s0c048goswckossk48kgc4c80ksok40cwwcss',
      themeApiUrl: 'https://ms.vietnamworks.com/banners/v1.0/themes',
      wowCvUrl: 'https://www.vietnamworks.com/wowcv/en',
      myProfileUrl: 'https://www.vietnamworks.com/my-profile',
      getSearchableAPI: 'https://ms.vietnamworks.com/api-gateway/v1.1/profile/resume-setting-info',
      makeSearchableAPI: 'https://ms.vietnamworks.com/api-gateway/v1.0/profile/resume-change-searchable',
      uploadCvAPI: 'https://ms.vietnamworks.com/api-gateway/v1.0/profile/update-resume-file',
      suggestJobTitleAPI: 'https://ms.vietnamworks.com/api-gateway/v1.0/suggest-job-title',
      attachedResumeAPI: 'https://ms.vietnamworks.com/api-gateway/v1.0/profile/attached-profile',
      createAnonyJobAlertAPI: 'https://ms.vietnamworks.com/api-gateway/v1.0/job-alerts-anonymous',
      popupTypeAPI: 'https://ms.vietnamworks.com/api-gateway/v1.0/checking-popup',
      resumeSummaryAPI: 'https://ms.vietnamworks.com/api-gateway/v1.0/profile/resume-summary',
      bigImageUrl: 'https://www.vietnamworks.com/assets-page-container/images/bg.png',
      trackingAPI: 'https://ms.vietnamworks.com/log-aggregator/v2/track-banner-click',
      cookieDomain: '.vietnamworks.com',
      internalRefererUrls: '.*\\.vietnamworks\\.com',
      bannerService: 'https://ms.vietnamworks.com/banners/v1.0',
      pageContainerImageService: 'https://vietnamworks.com/assets-page-container/images',
      zaloWidgetOaid: '2477265076863435153',
      enableJobFunction: '1',
      facebookIcon: 'https://images.vietnamworks.com/icon/social-icons/facebook.svg',
      youtubeIcon: 'https://images.vietnamworks.com/icon/social-icons/youtube.svg',
      linkedinIcon: 'https://images.vietnamworks.com/icon/social-icons/linkedin.svg',
      tiktokIcon: 'https://images.vietnamworks.com/icon/social-icons/tiktok.svg',
      spotifyIcon: 'https://images.vietnamworks.com/icon/social-icons/spotify.svg',
      facebookLink: 'https://bit.ly/3r5zg7J',
      youtubeLink: 'https://bit.ly/3R9BXA2',
      linkedinLink: 'https://bit.ly/44WjeLX',
      tiktokLink: 'https://bit.ly/3R6ahfe',
      spotifyLink: 'https://spoti.fi/45VQtiO',
      sortDefaultIndex: 'vnw_job_v2'
    }
  }
};

var countryData = [
	{
		id: 1,
		name: "Việt Nam",
		nameEn: "Vietnam"
	},
	{
		id: 2,
		name: "Afghanistan",
		nameEn: "Afghanistan"
	},
	{
		id: 3,
		name: "Albania",
		nameEn: "Albania"
	},
	{
		id: 4,
		name: "Algeria",
		nameEn: "Algeria"
	},
	{
		id: 5,
		name: "American Samoa",
		nameEn: "American Samoa"
	},
	{
		id: 6,
		name: "Andorra",
		nameEn: "Andorra"
	},
	{
		id: 7,
		name: "Angola",
		nameEn: "Angola"
	},
	{
		id: 8,
		name: "Anguilla",
		nameEn: "Anguilla"
	},
	{
		id: 9,
		name: "Antarctica",
		nameEn: "Antarctica"
	},
	{
		id: 10,
		name: "Antigua And Barbuda",
		nameEn: "Antigua And Barbuda"
	},
	{
		id: 11,
		name: "Argentina",
		nameEn: "Argentina"
	},
	{
		id: 12,
		name: "Armenia",
		nameEn: "Armenia"
	},
	{
		id: 13,
		name: "Aruba",
		nameEn: "Aruba"
	},
	{
		id: 14,
		name: "Úc",
		nameEn: "Australia"
	},
	{
		id: 15,
		name: "Áo",
		nameEn: "Austria"
	},
	{
		id: 16,
		name: "Azerbaijan",
		nameEn: "Azerbaijan"
	},
	{
		id: 17,
		name: "Bahamas",
		nameEn: "Bahamas"
	},
	{
		id: 18,
		name: "Bahrain",
		nameEn: "Bahrain"
	},
	{
		id: 19,
		name: "Bangladesh",
		nameEn: "Bangladesh"
	},
	{
		id: 20,
		name: "Barbados",
		nameEn: "Barbados"
	},
	{
		id: 21,
		name: "Belarus",
		nameEn: "Belarus"
	},
	{
		id: 22,
		name: "Bỉ",
		nameEn: "Belgium"
	},
	{
		id: 23,
		name: "Belize",
		nameEn: "Belize"
	},
	{
		id: 24,
		name: "Benin",
		nameEn: "Benin"
	},
	{
		id: 25,
		name: "Bermuda",
		nameEn: "Bermuda"
	},
	{
		id: 26,
		name: "Bhutan",
		nameEn: "Bhutan"
	},
	{
		id: 27,
		name: "Bolivia",
		nameEn: "Bolivia"
	},
	{
		id: 28,
		name: "Bosnia And Herzegowina",
		nameEn: "Bosnia And Herzegowina"
	},
	{
		id: 29,
		name: "Botswana",
		nameEn: "Botswana"
	},
	{
		id: 30,
		name: "Bouvet Island",
		nameEn: "Bouvet Island"
	},
	{
		id: 31,
		name: "Brazil",
		nameEn: "Brazil"
	},
	{
		id: 32,
		name: "British Indian Ocean Territory",
		nameEn: "British Indian Ocean Territory"
	},
	{
		id: 33,
		name: "Brunei Darussalam",
		nameEn: "Brunei Darussalam"
	},
	{
		id: 34,
		name: "Bulgaria",
		nameEn: "Bulgaria"
	},
	{
		id: 35,
		name: "Burkina Faso",
		nameEn: "Burkina Faso"
	},
	{
		id: 36,
		name: "Burundi",
		nameEn: "Burundi"
	},
	{
		id: 37,
		name: "Cambodia",
		nameEn: "Cambodia"
	},
	{
		id: 38,
		name: "Cameroon",
		nameEn: "Cameroon"
	},
	{
		id: 39,
		name: "Canada",
		nameEn: "Canada"
	},
	{
		id: 40,
		name: "Cape Verde",
		nameEn: "Cape Verde"
	},
	{
		id: 41,
		name: "Cayman Islands",
		nameEn: "Cayman Islands"
	},
	{
		id: 42,
		name: "Central African Republic",
		nameEn: "Central African Republic"
	},
	{
		id: 43,
		name: "Chad",
		nameEn: "Chad"
	},
	{
		id: 44,
		name: "Chile",
		nameEn: "Chile"
	},
	{
		id: 45,
		name: "Trung Quốc",
		nameEn: "China"
	},
	{
		id: 46,
		name: "Christmas Island",
		nameEn: "Christmas Island"
	},
	{
		id: 47,
		name: "Cocos (Keeling) Islands",
		nameEn: "Cocos (Keeling) Islands"
	},
	{
		id: 48,
		name: "Colombia",
		nameEn: "Colombia"
	},
	{
		id: 49,
		name: "Comoros",
		nameEn: "Comoros"
	},
	{
		id: 50,
		name: "Congo",
		nameEn: "Congo"
	},
	{
		id: 51,
		name: "Cook Islands",
		nameEn: "Cook Islands"
	},
	{
		id: 52,
		name: "Costa Rica",
		nameEn: "Costa Rica"
	},
	{
		id: 53,
		name: "Cote D'Ivoire",
		nameEn: "Cote D'Ivoire"
	},
	{
		id: 54,
		name: "Croatia",
		nameEn: "Croatia"
	},
	{
		id: 55,
		name: "Cuba",
		nameEn: "Cuba"
	},
	{
		id: 56,
		name: "Cyprus",
		nameEn: "Cyprus"
	},
	{
		id: 57,
		name: "Czech Republic",
		nameEn: "Czech Republic"
	},
	{
		id: 58,
		name: "Denmark",
		nameEn: "Denmark"
	},
	{
		id: 59,
		name: "Djibouti",
		nameEn: "Djibouti"
	},
	{
		id: 60,
		name: "Dominica",
		nameEn: "Dominica"
	},
	{
		id: 61,
		name: "Dominican Republic",
		nameEn: "Dominican Republic"
	},
	{
		id: 62,
		name: "East Timor",
		nameEn: "East Timor"
	},
	{
		id: 63,
		name: "Ecuador",
		nameEn: "Ecuador"
	},
	{
		id: 64,
		name: "Egypt",
		nameEn: "Egypt"
	},
	{
		id: 65,
		name: "El Salvador",
		nameEn: "El Salvador"
	},
	{
		id: 66,
		name: "Equatorial Guinea",
		nameEn: "Equatorial Guinea"
	},
	{
		id: 67,
		name: "Eritrea",
		nameEn: "Eritrea"
	},
	{
		id: 68,
		name: "Estonia",
		nameEn: "Estonia"
	},
	{
		id: 69,
		name: "Ethiopia",
		nameEn: "Ethiopia"
	},
	{
		id: 70,
		name: "Falkland Islands",
		nameEn: "Falkland Islands"
	},
	{
		id: 71,
		name: "Faroe Islands",
		nameEn: "Faroe Islands"
	},
	{
		id: 72,
		name: "Fiji",
		nameEn: "Fiji"
	},
	{
		id: 73,
		name: "Finland",
		nameEn: "Finland"
	},
	{
		id: 74,
		name: "France",
		nameEn: "France"
	},
	{
		id: 75,
		name: "France, Metropolitan",
		nameEn: "France, Metropolitan"
	},
	{
		id: 76,
		name: "French Guiana",
		nameEn: "French Guiana"
	},
	{
		id: 77,
		name: "French Polynesia",
		nameEn: "French Polynesia"
	},
	{
		id: 78,
		name: "French Southern Territories",
		nameEn: "French Southern Territories"
	},
	{
		id: 79,
		name: "Gabon",
		nameEn: "Gabon"
	},
	{
		id: 80,
		name: "Gambia",
		nameEn: "Gambia"
	},
	{
		id: 81,
		name: "Georgia",
		nameEn: "Georgia"
	},
	{
		id: 82,
		name: "Germany",
		nameEn: "Germany"
	},
	{
		id: 83,
		name: "Ghana",
		nameEn: "Ghana"
	},
	{
		id: 84,
		name: "Gibraltar",
		nameEn: "Gibraltar"
	},
	{
		id: 85,
		name: "Greece",
		nameEn: "Greece"
	},
	{
		id: 86,
		name: "Greenland",
		nameEn: "Greenland"
	},
	{
		id: 87,
		name: "Grenada",
		nameEn: "Grenada"
	},
	{
		id: 88,
		name: "Guadeloupe",
		nameEn: "Guadeloupe"
	},
	{
		id: 89,
		name: "Guam",
		nameEn: "Guam"
	},
	{
		id: 90,
		name: "Guatemala",
		nameEn: "Guatemala"
	},
	{
		id: 91,
		name: "Guinea",
		nameEn: "Guinea"
	},
	{
		id: 92,
		name: "Guinea-Bissau",
		nameEn: "Guinea-Bissau"
	},
	{
		id: 93,
		name: "Guyana",
		nameEn: "Guyana"
	},
	{
		id: 94,
		name: "Haiti",
		nameEn: "Haiti"
	},
	{
		id: 95,
		name: "Heard And Mc Donald Islands",
		nameEn: "Heard And Mc Donald Islands"
	},
	{
		id: 96,
		name: "Honduras",
		nameEn: "Honduras"
	},
	{
		id: 97,
		name: "Hong Kong",
		nameEn: "Hong Kong"
	},
	{
		id: 98,
		name: "Hungary",
		nameEn: "Hungary"
	},
	{
		id: 99,
		name: "Iceland",
		nameEn: "Iceland"
	},
	{
		id: 100,
		name: "India",
		nameEn: "India"
	},
	{
		id: 101,
		name: "Indonesia",
		nameEn: "Indonesia"
	},
	{
		id: 102,
		name: "Iran",
		nameEn: "Iran"
	},
	{
		id: 103,
		name: "Iraq",
		nameEn: "Iraq"
	},
	{
		id: 104,
		name: "Ireland",
		nameEn: "Ireland"
	},
	{
		id: 105,
		name: "Israel",
		nameEn: "Israel"
	},
	{
		id: 106,
		name: "Italy",
		nameEn: "Italy"
	},
	{
		id: 107,
		name: "Jamaica",
		nameEn: "Jamaica"
	},
	{
		id: 108,
		name: "Japan",
		nameEn: "Japan"
	},
	{
		id: 109,
		name: "Jordan",
		nameEn: "Jordan"
	},
	{
		id: 110,
		name: "Kazakhstan",
		nameEn: "Kazakhstan"
	},
	{
		id: 111,
		name: "Kenya",
		nameEn: "Kenya"
	},
	{
		id: 112,
		name: "Kiribati",
		nameEn: "Kiribati"
	},
	{
		id: 113,
		name: "North Korea (People's Republic Of Korea)",
		nameEn: "North Korea (People's Republic Of Korea)"
	},
	{
		id: 114,
		name: "South Korea (Republic Of Korea)",
		nameEn: "South Korea (Republic Of Korea)"
	},
	{
		id: 115,
		name: "Kuwait",
		nameEn: "Kuwait"
	},
	{
		id: 116,
		name: "Kyrgyzstan",
		nameEn: "Kyrgyzstan"
	},
	{
		id: 117,
		name: "Lao People's Republic",
		nameEn: "Lao People's Republic"
	},
	{
		id: 118,
		name: "Latvia",
		nameEn: "Latvia"
	},
	{
		id: 119,
		name: "Lebanon",
		nameEn: "Lebanon"
	},
	{
		id: 120,
		name: "Lesotho",
		nameEn: "Lesotho"
	},
	{
		id: 121,
		name: "Liberia",
		nameEn: "Liberia"
	},
	{
		id: 122,
		name: "Libyan Arab Jamahiriya",
		nameEn: "Libyan Arab Jamahiriya"
	},
	{
		id: 123,
		name: "Liechtenstein",
		nameEn: "Liechtenstein"
	},
	{
		id: 124,
		name: "Lithuania",
		nameEn: "Lithuania"
	},
	{
		id: 125,
		name: "Luxembourg",
		nameEn: "Luxembourg"
	},
	{
		id: 126,
		name: "Macau",
		nameEn: "Macau"
	},
	{
		id: 127,
		name: "Macedonia",
		nameEn: "Macedonia"
	},
	{
		id: 128,
		name: "Madagascar",
		nameEn: "Madagascar"
	},
	{
		id: 129,
		name: "Malawi",
		nameEn: "Malawi"
	},
	{
		id: 130,
		name: "Malaysia",
		nameEn: "Malaysia"
	},
	{
		id: 131,
		name: "Maldives",
		nameEn: "Maldives"
	},
	{
		id: 132,
		name: "Mali",
		nameEn: "Mali"
	},
	{
		id: 133,
		name: "Malta",
		nameEn: "Malta"
	},
	{
		id: 134,
		name: "Marshall Islands",
		nameEn: "Marshall Islands"
	},
	{
		id: 135,
		name: "Martinique",
		nameEn: "Martinique"
	},
	{
		id: 136,
		name: "Mauritania",
		nameEn: "Mauritania"
	},
	{
		id: 137,
		name: "Mauritius",
		nameEn: "Mauritius"
	},
	{
		id: 138,
		name: "Mayotte",
		nameEn: "Mayotte"
	},
	{
		id: 139,
		name: "Mexico",
		nameEn: "Mexico"
	},
	{
		id: 140,
		name: "Micronesia",
		nameEn: "Micronesia"
	},
	{
		id: 141,
		name: "Moldova",
		nameEn: "Moldova"
	},
	{
		id: 142,
		name: "Monaco",
		nameEn: "Monaco"
	},
	{
		id: 143,
		name: "Mongolia",
		nameEn: "Mongolia"
	},
	{
		id: 144,
		name: "Montserrat",
		nameEn: "Montserrat"
	},
	{
		id: 145,
		name: "Morocco",
		nameEn: "Morocco"
	},
	{
		id: 146,
		name: "Mozambique",
		nameEn: "Mozambique"
	},
	{
		id: 147,
		name: "Myanmar",
		nameEn: "Myanmar"
	},
	{
		id: 148,
		name: "Namibia",
		nameEn: "Namibia"
	},
	{
		id: 149,
		name: "Nauru",
		nameEn: "Nauru"
	},
	{
		id: 150,
		name: "Nepal",
		nameEn: "Nepal"
	},
	{
		id: 151,
		name: "Netherlands",
		nameEn: "Netherlands"
	},
	{
		id: 152,
		name: "Netherlands Antilles",
		nameEn: "Netherlands Antilles"
	},
	{
		id: 153,
		name: "New Caledonia",
		nameEn: "New Caledonia"
	},
	{
		id: 154,
		name: "New Zealand",
		nameEn: "New Zealand"
	},
	{
		id: 155,
		name: "Nicaragua",
		nameEn: "Nicaragua"
	},
	{
		id: 156,
		name: "Niger",
		nameEn: "Niger"
	},
	{
		id: 157,
		name: "Nigeria",
		nameEn: "Nigeria"
	},
	{
		id: 158,
		name: "Niue",
		nameEn: "Niue"
	},
	{
		id: 159,
		name: "Norfolk Island",
		nameEn: "Norfolk Island"
	},
	{
		id: 160,
		name: "Northern Mariana Islands",
		nameEn: "Northern Mariana Islands"
	},
	{
		id: 161,
		name: "Norway",
		nameEn: "Norway"
	},
	{
		id: 162,
		name: "Oman",
		nameEn: "Oman"
	},
	{
		id: 163,
		name: "Pakistan",
		nameEn: "Pakistan"
	},
	{
		id: 164,
		name: "Palau",
		nameEn: "Palau"
	},
	{
		id: 165,
		name: "Panama",
		nameEn: "Panama"
	},
	{
		id: 166,
		name: "Papua New Guinea",
		nameEn: "Papua New Guinea"
	},
	{
		id: 167,
		name: "Paraguay",
		nameEn: "Paraguay"
	},
	{
		id: 168,
		name: "Peru",
		nameEn: "Peru"
	},
	{
		id: 169,
		name: "Philippines",
		nameEn: "Philippines"
	},
	{
		id: 170,
		name: "Pitcairn",
		nameEn: "Pitcairn"
	},
	{
		id: 171,
		name: "Poland",
		nameEn: "Poland"
	},
	{
		id: 172,
		name: "Portugal",
		nameEn: "Portugal"
	},
	{
		id: 173,
		name: "Puerto Rico",
		nameEn: "Puerto Rico"
	},
	{
		id: 174,
		name: "Qatar",
		nameEn: "Qatar"
	},
	{
		id: 175,
		name: "Reunion",
		nameEn: "Reunion"
	},
	{
		id: 176,
		name: "Romania",
		nameEn: "Romania"
	},
	{
		id: 177,
		name: "Russian Federation",
		nameEn: "Russian Federation"
	},
	{
		id: 178,
		name: "Rwanda",
		nameEn: "Rwanda"
	},
	{
		id: 179,
		name: "Saint Kitts And Nevis",
		nameEn: "Saint Kitts And Nevis"
	},
	{
		id: 180,
		name: "Saint Lucia",
		nameEn: "Saint Lucia"
	},
	{
		id: 181,
		name: "Saint Vincent And The Grenadines",
		nameEn: "Saint Vincent And The Grenadines"
	},
	{
		id: 182,
		name: "Samoa",
		nameEn: "Samoa"
	},
	{
		id: 183,
		name: "San Marino",
		nameEn: "San Marino"
	},
	{
		id: 184,
		name: "Sao Tome And Principe",
		nameEn: "Sao Tome And Principe"
	},
	{
		id: 185,
		name: "Saudi Arabia",
		nameEn: "Saudi Arabia"
	},
	{
		id: 186,
		name: "Senegal",
		nameEn: "Senegal"
	},
	{
		id: 187,
		name: "Seychelles",
		nameEn: "Seychelles"
	},
	{
		id: 188,
		name: "Sierra Leone",
		nameEn: "Sierra Leone"
	},
	{
		id: 189,
		name: "Singapore",
		nameEn: "Singapore"
	},
	{
		id: 190,
		name: "Slovakia",
		nameEn: "Slovakia"
	},
	{
		id: 191,
		name: "Slovenia",
		nameEn: "Slovenia"
	},
	{
		id: 192,
		name: "Solomon Islands",
		nameEn: "Solomon Islands"
	},
	{
		id: 193,
		name: "Somalia",
		nameEn: "Somalia"
	},
	{
		id: 194,
		name: "South Africa",
		nameEn: "South Africa"
	},
	{
		id: 195,
		name: "South Georgia/South Sandwich Islands",
		nameEn: "South Georgia/South Sandwich Islands"
	},
	{
		id: 196,
		name: "Spain",
		nameEn: "Spain"
	},
	{
		id: 197,
		name: "Sri Lanka",
		nameEn: "Sri Lanka"
	},
	{
		id: 198,
		name: "St Helena",
		nameEn: "St Helena"
	},
	{
		id: 199,
		name: "St Pierre and Miquelon",
		nameEn: "St Pierre and Miquelon"
	},
	{
		id: 200,
		name: "Sudan",
		nameEn: "Sudan"
	},
	{
		id: 201,
		name: "Suriname",
		nameEn: "Suriname"
	},
	{
		id: 202,
		name: "Svalbard And Jan Mayen Islands",
		nameEn: "Svalbard And Jan Mayen Islands"
	},
	{
		id: 203,
		name: "Swaziland",
		nameEn: "Swaziland"
	},
	{
		id: 204,
		name: "Sweden",
		nameEn: "Sweden"
	},
	{
		id: 205,
		name: "Switzerland",
		nameEn: "Switzerland"
	},
	{
		id: 206,
		name: "Syrian Arab Republic",
		nameEn: "Syrian Arab Republic"
	},
	{
		id: 207,
		name: "Taiwan",
		nameEn: "Taiwan"
	},
	{
		id: 208,
		name: "Tajikistan",
		nameEn: "Tajikistan"
	},
	{
		id: 209,
		name: "Tanzania",
		nameEn: "Tanzania"
	},
	{
		id: 210,
		name: "Thailand",
		nameEn: "Thailand"
	},
	{
		id: 211,
		name: "Togo",
		nameEn: "Togo"
	},
	{
		id: 212,
		name: "Tokelau",
		nameEn: "Tokelau"
	},
	{
		id: 213,
		name: "Tonga",
		nameEn: "Tonga"
	},
	{
		id: 214,
		name: "Trinidad And Tobago",
		nameEn: "Trinidad And Tobago"
	},
	{
		id: 215,
		name: "Tunisia",
		nameEn: "Tunisia"
	},
	{
		id: 216,
		name: "Turkey",
		nameEn: "Turkey"
	},
	{
		id: 217,
		name: "Turkmenistan",
		nameEn: "Turkmenistan"
	},
	{
		id: 218,
		name: "Turks And Caicos Islands",
		nameEn: "Turks And Caicos Islands"
	},
	{
		id: 219,
		name: "Tuvalu",
		nameEn: "Tuvalu"
	},
	{
		id: 220,
		name: "Uganda",
		nameEn: "Uganda"
	},
	{
		id: 221,
		name: "Ukraine",
		nameEn: "Ukraine"
	},
	{
		id: 222,
		name: "United Arab Emirates",
		nameEn: "United Arab Emirates"
	},
	{
		id: 223,
		name: "United Kingdom",
		nameEn: "United Kingdom"
	},
	{
		id: 224,
		name: "United States",
		nameEn: "United States"
	},
	{
		id: 225,
		name: "United States Minor Outlying Islands",
		nameEn: "United States Minor Outlying Islands"
	},
	{
		id: 226,
		name: "Uruguay",
		nameEn: "Uruguay"
	},
	{
		id: 227,
		name: "Uzbekistan",
		nameEn: "Uzbekistan"
	},
	{
		id: 228,
		name: "Vanuatu",
		nameEn: "Vanuatu"
	},
	{
		id: 229,
		name: "Vatican City State",
		nameEn: "Vatican City State"
	},
	{
		id: 230,
		name: "Venezuela",
		nameEn: "Venezuela"
	},
	{
		id: 231,
		name: "Virgin Islands (British)",
		nameEn: "Virgin Islands (British)"
	},
	{
		id: 232,
		name: "Virgin Islands (U.S.)",
		nameEn: "Virgin Islands (U.S.)"
	},
	{
		id: 233,
		name: "Wallis And Futuna Islands",
		nameEn: "Wallis And Futuna Islands"
	},
	{
		id: 234,
		name: "Western Sahara",
		nameEn: "Western Sahara"
	},
	{
		id: 235,
		name: "Yemen",
		nameEn: "Yemen"
	},
	{
		id: 236,
		name: "Zaire",
		nameEn: "Zaire"
	},
	{
		id: 237,
		name: "Zambia",
		nameEn: "Zambia"
	},
	{
		id: 238,
		name: "Zimbabwe",
		nameEn: "Zimbabwe"
	},
	{
		id: 239,
		name: "Nước khác",
		nameEn: "Other"
	}
];

var districtData = {
	"2": [
	{
		id: 90,
		name: "Huyện An Phú",
		nameEn: "An Phu",
		order: 0
	},
	{
		id: 93,
		name: "Huyện Châu Phú",
		nameEn: "Chau Phu",
		order: 0
	},
	{
		id: 96,
		name: "Huyện Châu Thành",
		nameEn: "Chau Thanh",
		order: 0
	},
	{
		id: 97,
		name: "Huyện Chợ Mới",
		nameEn: "Cho Moi",
		order: 0
	},
	{
		id: 92,
		name: "Huyện Phú Tân",
		nameEn: "Phu Tan",
		order: 0
	},
	{
		id: 98,
		name: "Huyện Thoại Sơn",
		nameEn: "Thoai Son",
		order: 0
	},
	{
		id: 95,
		name: "Huyện Tri Tôn",
		nameEn: "Tri Ton",
		order: 0
	},
	{
		id: 94,
		name: "Huyện Tịnh Biên",
		nameEn: "Tinh Bien",
		order: 0
	},
	{
		id: 89,
		name: "Thành phố Châu Đốc",
		nameEn: "Chau Doc",
		order: 0
	},
	{
		id: 88,
		name: "Thành phố Long Xuyên",
		nameEn: "Long Xuyen",
		order: 0
	},
	{
		id: 91,
		name: "Thị xã Tân Châu",
		nameEn: "Tan Chau",
		order: 0
	}
],
	"3": [
	{
		id: 101,
		name: "Huyện Châu Đức",
		nameEn: "Chau Duc",
		order: 0
	},
	{
		id: 106,
		name: "Huyện Côn Đảo",
		nameEn: "Con Dao",
		order: 0
	},
	{
		id: 103,
		name: "Huyện Long Điền",
		nameEn: "Long Dien",
		order: 0
	},
	{
		id: 102,
		name: "Huyện Xuyên Mộc",
		nameEn: "Xuyen Moc",
		order: 0
	},
	{
		id: 104,
		name: "Huyện Đất Đỏ",
		nameEn: "Dat Do",
		order: 0
	},
	{
		id: 100,
		name: "Thành phố Bà Rịa",
		nameEn: "Ba Ria",
		order: 0
	},
	{
		id: 99,
		name: "Thành phố Vũng Tàu",
		nameEn: "Vung Tau",
		order: 0
	},
	{
		id: 105,
		name: "Thị xã Phú Mỹ",
		nameEn: "Phu My",
		order: 0
	}
],
	"4": [
	{
		id: 119,
		name: "Huyện Ba Bể",
		nameEn: "Ba Be",
		order: 0
	},
	{
		id: 121,
		name: "Huyện Bạch Thông",
		nameEn: "Bach Thong",
		order: 0
	},
	{
		id: 123,
		name: "Huyện Chợ Mới",
		nameEn: "Cho Moi",
		order: 0
	},
	{
		id: 122,
		name: "Huyện Chợ Đồn",
		nameEn: "Cho Don",
		order: 0
	},
	{
		id: 124,
		name: "Huyện Na Rì",
		nameEn: "Na Ri",
		order: 0
	},
	{
		id: 120,
		name: "Huyện Ngân Sơn",
		nameEn: "Ngan Son",
		order: 0
	},
	{
		id: 118,
		name: "Huyện Pác Nặm",
		nameEn: "Pac Nam",
		order: 0
	},
	{
		id: 117,
		name: "Thành Phố Bắc Kạn",
		nameEn: "Bac Kan",
		order: 0
	}
],
	"5": [
	{
		id: 116,
		name: "Huyện Hiệp Hòa",
		nameEn: "Hiep Hoa",
		order: 0
	},
	{
		id: 110,
		name: "Huyện Lạng Giang",
		nameEn: "Lang Giang",
		order: 0
	},
	{
		id: 111,
		name: "Huyện Lục Nam",
		nameEn: "Luc Nam",
		order: 0
	},
	{
		id: 112,
		name: "Huyện Lục Ngạn",
		nameEn: "Luc Ngan",
		order: 0
	},
	{
		id: 113,
		name: "Huyện Sơn Động",
		nameEn: "Son Dong",
		order: 0
	},
	{
		id: 109,
		name: "Huyện Tân Yên",
		nameEn: "Tan Yen",
		order: 0
	},
	{
		id: 115,
		name: "Huyện Việt Yên",
		nameEn: "Viet Yen",
		order: 0
	},
	{
		id: 114,
		name: "Huyện Yên Dũng",
		nameEn: "Yen Dung",
		order: 0
	},
	{
		id: 108,
		name: "Huyện Yên Thế",
		nameEn: "Yen The",
		order: 0
	},
	{
		id: 107,
		name: "Thành phố Bắc Giang",
		nameEn: "Bac Giang",
		order: 0
	}
],
	"6": [
	{
		id: 131,
		name: "Huyện Hoà Bình",
		nameEn: "Hoa Binh",
		order: 0
	},
	{
		id: 126,
		name: "Huyện Hồng Dân",
		nameEn: "Hong Dan",
		order: 0
	},
	{
		id: 127,
		name: "Huyện Phước Long",
		nameEn: "Phuoc Long",
		order: 0
	},
	{
		id: 128,
		name: "Huyện Vĩnh Lợi",
		nameEn: "Vinh Loi",
		order: 0
	},
	{
		id: 130,
		name: "Huyện Đông Hải",
		nameEn: "Dong Hai",
		order: 0
	},
	{
		id: 125,
		name: "Thành phố Bạc Liêu",
		nameEn: "Bac Lieu",
		order: 0
	},
	{
		id: 129,
		name: "Thị xã Giá Rai",
		nameEn: "Gia Rai",
		order: 0
	}
],
	"7": [
	{
		id: 138,
		name: "Huyện Gia Bình",
		nameEn: "Gia Binh",
		order: 0
	},
	{
		id: 139,
		name: "Huyện Lương Tài",
		nameEn: "Luong Tai",
		order: 0
	},
	{
		id: 134,
		name: "Huyện Quế Võ",
		nameEn: "Que Vo",
		order: 0
	},
	{
		id: 137,
		name: "Huyện Thuận Thành",
		nameEn: "Thuan Thanh",
		order: 0
	},
	{
		id: 135,
		name: "Huyện Tiên Du",
		nameEn: "Tien Du",
		order: 0
	},
	{
		id: 133,
		name: "Huyện Yên Phong",
		nameEn: "Yen Phong",
		order: 0
	},
	{
		id: 132,
		name: "Thành phố Bắc Ninh",
		nameEn: "Bac Ninh",
		order: 0
	},
	{
		id: 136,
		name: "Thành phố Từ Sơn",
		nameEn: "Tu Son",
		order: 0
	}
],
	"8": [
	{
		id: 146,
		name: "Huyện Ba Tri",
		nameEn: "Ba Tri",
		order: 0
	},
	{
		id: 145,
		name: "Huyện Bình Đại",
		nameEn: "Binh Dai",
		order: 0
	},
	{
		id: 141,
		name: "Huyện Châu Thành",
		nameEn: "Chau Thanh",
		order: 0
	},
	{
		id: 142,
		name: "Huyện Chợ Lách",
		nameEn: "Cho Lach",
		order: 0
	},
	{
		id: 144,
		name: "Huyện Giồng Trôm",
		nameEn: "Giong Trom",
		order: 0
	},
	{
		id: 148,
		name: "Huyện Mỏ Cày Bắc",
		nameEn: "Mo Cay Bac",
		order: 0
	},
	{
		id: 143,
		name: "Huyện Mỏ Cày Nam",
		nameEn: "Mo Cay Nam",
		order: 0
	},
	{
		id: 147,
		name: "Huyện Thạnh Phú",
		nameEn: "Thanh Phu",
		order: 0
	},
	{
		id: 140,
		name: "Thành phố Bến Tre",
		nameEn: "Ben Tre",
		order: 0
	}
],
	"10": [
	{
		id: 150,
		name: "Huyện An Lão",
		nameEn: "An Lao",
		order: 0
	},
	{
		id: 152,
		name: "Huyện Hoài Ân",
		nameEn: "Hoai An",
		order: 0
	},
	{
		id: 156,
		name: "Huyện Phù Cát",
		nameEn: "Phu Cat",
		order: 0
	},
	{
		id: 153,
		name: "Huyện Phù Mỹ",
		nameEn: "Phu My",
		order: 0
	},
	{
		id: 158,
		name: "Huyện Tuy Phước",
		nameEn: "Tuy Phuoc",
		order: 0
	},
	{
		id: 155,
		name: "Huyện Tây Sơn",
		nameEn: "Tay Son",
		order: 0
	},
	{
		id: 159,
		name: "Huyện Vân Canh",
		nameEn: "Van Canh",
		order: 0
	},
	{
		id: 154,
		name: "Huyện Vĩnh Thạnh",
		nameEn: "Vinh Thanh",
		order: 0
	},
	{
		id: 149,
		name: "Thành phố Quy Nhơn",
		nameEn: "Quy Nhon",
		order: 0
	},
	{
		id: 157,
		name: "Thị xã An Nhơn",
		nameEn: "An Nhon",
		order: 0
	},
	{
		id: 151,
		name: "Thị xã Hoài Nhơn",
		nameEn: "Hoai Nhon",
		order: 0
	}
],
	"11": [
	{
		id: 161,
		name: "Huyện Bàu Bàng",
		nameEn: "Bau Bang",
		order: 0
	},
	{
		id: 168,
		name: "Huyện Bắc Tân Uyên",
		nameEn: "Bac Tan Uyen",
		order: 0
	},
	{
		id: 162,
		name: "Huyện Dầu Tiếng",
		nameEn: "Dau Tieng",
		order: 0
	},
	{
		id: 164,
		name: "Huyện Phú Giáo",
		nameEn: "Phu Giao",
		order: 0
	},
	{
		id: 166,
		name: "Thành phố Dĩ An",
		nameEn: "Di An",
		order: 0
	},
	{
		id: 167,
		name: "Thành phố Thuận An",
		nameEn: "Thuan An",
		order: 0
	},
	{
		id: 160,
		name: "Thành phố Thủ Dầu Một",
		nameEn: "Thu Dau Mot",
		order: 0
	},
	{
		id: 163,
		name: "Thị xã Bến Cát",
		nameEn: "Ben Cat",
		order: 0
	},
	{
		id: 165,
		name: "Thị xã Tân Uyên",
		nameEn: "Tan Uyen",
		order: 0
	}
],
	"12": [
	{
		id: 172,
		name: "Huyện Bù Gia Mập",
		nameEn: "Bu Gia Map",
		order: 0
	},
	{
		id: 177,
		name: "Huyện Bù Đăng",
		nameEn: "Bu Dang",
		order: 0
	},
	{
		id: 174,
		name: "Huyện Bù Đốp",
		nameEn: "Bu Dop",
		order: 0
	},
	{
		id: 175,
		name: "Huyện Hớn Quản",
		nameEn: "Hon Quan",
		order: 0
	},
	{
		id: 173,
		name: "Huyện Lộc Ninh",
		nameEn: "Loc Ninh",
		order: 0
	},
	{
		id: 179,
		name: "Huyện Phú Riềng",
		nameEn: "Phu Rieng",
		order: 0
	},
	{
		id: 176,
		name: "Huyện Đồng Phú",
		nameEn: "Dong Phu",
		order: 0
	},
	{
		id: 170,
		name: "Thành phố Đồng Xoài",
		nameEn: "Dong Xoai",
		order: 0
	},
	{
		id: 171,
		name: "Thị xã Bình Long",
		nameEn: "Binh Long",
		order: 0
	},
	{
		id: 178,
		name: "Thị xã Chơn Thành",
		nameEn: "Chon Thanh",
		order: 0
	},
	{
		id: 169,
		name: "Thị xã Phước Long",
		nameEn: "Phuoc Long",
		order: 0
	}
],
	"13": [
	{
		id: 183,
		name: "Huyện Bắc Bình",
		nameEn: "Bac Binh",
		order: 0
	},
	{
		id: 184,
		name: "Huyện Hàm Thuận Bắc",
		nameEn: "Ham Thuan Bac",
		order: 0
	},
	{
		id: 185,
		name: "Huyện Hàm Thuận Nam",
		nameEn: "Ham Thuan Nam",
		order: 0
	},
	{
		id: 188,
		name: "Huyện Hàm Tân",
		nameEn: "Ham Tan",
		order: 0
	},
	{
		id: 189,
		name: "Huyện Phú Quí",
		nameEn: "Phu Qui",
		order: 0
	},
	{
		id: 182,
		name: "Huyện Tuy Phong",
		nameEn: "Tuy Phong",
		order: 0
	},
	{
		id: 186,
		name: "Huyện Tánh Linh",
		nameEn: "Tanh Linh",
		order: 0
	},
	{
		id: 187,
		name: "Huyện Đức Linh",
		nameEn: "Duc Linh",
		order: 0
	},
	{
		id: 180,
		name: "Thành phố Phan Thiết",
		nameEn: "Phan Thiet",
		order: 0
	},
	{
		id: 181,
		name: "Thị xã La Gi",
		nameEn: "La Gi",
		order: 0
	}
],
	"14": [
	{
		id: 194,
		name: "Huyện Cái Nước",
		nameEn: "Cai Nuoc",
		order: 0
	},
	{
		id: 198,
		name: "Huyện Ngọc Hiển",
		nameEn: "Ngoc Hien",
		order: 0
	},
	{
		id: 196,
		name: "Huyện Năm Căn",
		nameEn: "Nam Can",
		order: 0
	},
	{
		id: 197,
		name: "Huyện Phú Tân",
		nameEn: "Phu Tan",
		order: 0
	},
	{
		id: 192,
		name: "Huyện Thới Bình",
		nameEn: "Thoi Binh",
		order: 0
	},
	{
		id: 193,
		name: "Huyện Trần Văn Thời",
		nameEn: "Tran Van Thoi",
		order: 0
	},
	{
		id: 191,
		name: "Huyện U Minh",
		nameEn: "U Minh",
		order: 0
	},
	{
		id: 195,
		name: "Huyện Đầm Dơi",
		nameEn: "Dam Doi",
		order: 0
	},
	{
		id: 190,
		name: "Thành phố Cà Mau",
		nameEn: "Ca Mau",
		order: 0
	}
],
	"15": [
	{
		id: 70,
		name: "Huyện Cờ Đỏ",
		nameEn: "Co Do",
		order: 0
	},
	{
		id: 71,
		name: "Huyện Phong Điền",
		nameEn: "Phong Dien",
		order: 0
	},
	{
		id: 72,
		name: "Huyện Thới Lai",
		nameEn: "Thoi Lai",
		order: 0
	},
	{
		id: 69,
		name: "Huyện Vĩnh Thạnh",
		nameEn: "Vinh Thanh",
		order: 0
	},
	{
		id: 66,
		name: "Quận Bình Thuỷ",
		nameEn: "Binh Thuy",
		order: 0
	},
	{
		id: 67,
		name: "Quận Cái Răng",
		nameEn: "Cai Rang",
		order: 0
	},
	{
		id: 64,
		name: "Quận Ninh Kiều",
		nameEn: "Ninh Kieu",
		order: 0
	},
	{
		id: 68,
		name: "Quận Thốt Nốt",
		nameEn: "Thot Not",
		order: 0
	},
	{
		id: 65,
		name: "Quận Ô Môn",
		nameEn: "O Mon",
		order: 0
	}
],
	"16": [
	{
		id: 200,
		name: "Huyện Bảo Lâm",
		nameEn: "Bao Lam",
		order: 0
	},
	{
		id: 201,
		name: "Huyện Bảo Lạc",
		nameEn: "Bao Lac",
		order: 0
	},
	{
		id: 206,
		name: "Huyện Hoà An",
		nameEn: "Hoa An",
		order: 0
	},
	{
		id: 202,
		name: "Huyện Hà Quảng",
		nameEn: "Ha Quang",
		order: 0
	},
	{
		id: 204,
		name: "Huyện Hạ Lang",
		nameEn: "Ha Lang",
		order: 0
	},
	{
		id: 207,
		name: "Huyện Nguyên Bình",
		nameEn: "Nguyen Binh",
		order: 0
	},
	{
		id: 205,
		name: "Huyện Quảng Hòa",
		nameEn: "Quang Hoa",
		order: 0
	},
	{
		id: 208,
		name: "Huyện Thạch An",
		nameEn: "Thach An",
		order: 0
	},
	{
		id: 203,
		name: "Huyện Trùng Khánh",
		nameEn: "Trung Khanh",
		order: 0
	},
	{
		id: 199,
		name: "Thành phố Cao Bằng",
		nameEn: "Cao Bang",
		order: 0
	}
],
	"17": [
	{
		id: 62,
		name: "Huyện Hoàng Sa",
		nameEn: "Hoang Sa",
		order: 0
	},
	{
		id: 61,
		name: "Huyện Hòa Vang",
		nameEn: "Hoa Vang",
		order: 0
	},
	{
		id: 60,
		name: "Quận Cẩm Lệ",
		nameEn: "Cam Le",
		order: 0
	},
	{
		id: 57,
		name: "Quận Hải Châu",
		nameEn: "Hai Chau",
		order: 0
	},
	{
		id: 55,
		name: "Quận Liên Chiểu",
		nameEn: "Lien Chieu",
		order: 0
	},
	{
		id: 59,
		name: "Quận Ngũ Hành Sơn",
		nameEn: "Ngu Hanh Son",
		order: 0
	},
	{
		id: 58,
		name: "Quận Sơn Trà",
		nameEn: "Son Tra",
		order: 0
	},
	{
		id: 56,
		name: "Quận Thanh Khê",
		nameEn: "Thanh Khe",
		order: 0
	}
],
	"18": [
	{
		id: 213,
		name: "Huyện Buôn Đôn",
		nameEn: "Buon Don",
		order: 0
	},
	{
		id: 223,
		name: "Huyện Cư Kuin",
		nameEn: "Cu Kuin",
		order: 0
	},
	{
		id: 214,
		name: "Huyện Cư M'gar",
		nameEn: "Cu M'gar",
		order: 0
	},
	{
		id: 211,
		name: "Huyện Ea H'leo",
		nameEn: "Ea H'leo",
		order: 0
	},
	{
		id: 217,
		name: "Huyện Ea Kar",
		nameEn: "Ea Kar",
		order: 0
	},
	{
		id: 212,
		name: "Huyện Ea Súp",
		nameEn: "Ea Sup",
		order: 0
	},
	{
		id: 221,
		name: "Huyện Krông A Na",
		nameEn: "Krong A Na",
		order: 0
	},
	{
		id: 219,
		name: "Huyện Krông Bông",
		nameEn: "Krong Bong",
		order: 0
	},
	{
		id: 215,
		name: "Huyện Krông Búk",
		nameEn: "Krong Buk",
		order: 0
	},
	{
		id: 216,
		name: "Huyện Krông Năng",
		nameEn: "Krong Nang",
		order: 0
	},
	{
		id: 220,
		name: "Huyện Krông Pắc",
		nameEn: "Krong Pac",
		order: 0
	},
	{
		id: 222,
		name: "Huyện Lắk",
		nameEn: "Lak",
		order: 0
	},
	{
		id: 218,
		name: "Huyện M'Đrắk",
		nameEn: "M'Drak",
		order: 0
	},
	{
		id: 209,
		name: "Thành phố Buôn Ma Thuột",
		nameEn: "Buon Ma Thuot",
		order: 0
	},
	{
		id: 210,
		name: "Thị Xã Buôn Hồ",
		nameEn: "Buon Ho",
		order: 0
	}
],
	"19": [
	{
		id: 249,
		name: "Huyện Cẩm Mỹ",
		nameEn: "Cam My",
		order: 0
	},
	{
		id: 250,
		name: "Huyện Long Thành",
		nameEn: "Long Thanh",
		order: 0
	},
	{
		id: 252,
		name: "Huyện Nhơn Trạch",
		nameEn: "Nhon Trach",
		order: 0
	},
	{
		id: 248,
		name: "Huyện Thống Nhất",
		nameEn: "Thong Nhat",
		order: 0
	},
	{
		id: 247,
		name: "Huyện Trảng Bom",
		nameEn: "Trang Bom",
		order: 0
	},
	{
		id: 244,
		name: "Huyện Tân Phú",
		nameEn: "Tan Phu",
		order: 0
	},
	{
		id: 245,
		name: "Huyện Vĩnh Cửu",
		nameEn: "Vinh Cuu",
		order: 0
	},
	{
		id: 251,
		name: "Huyện Xuân Lộc",
		nameEn: "Xuan Loc",
		order: 0
	},
	{
		id: 246,
		name: "Huyện Định Quán",
		nameEn: "Dinh Quan",
		order: 0
	},
	{
		id: 242,
		name: "Thành phố Biên Hòa",
		nameEn: "Bien Hoa",
		order: 0
	},
	{
		id: 243,
		name: "Thành phố Long Khánh",
		nameEn: "Long Khanh",
		order: 0
	}
],
	"20": [
	{
		id: 260,
		name: "Huyện Cao Lãnh",
		nameEn: "Cao Lanh District",
		order: 0
	},
	{
		id: 264,
		name: "Huyện Châu Thành",
		nameEn: "Chau Thanh",
		order: 0
	},
	{
		id: 257,
		name: "Huyện Hồng Ngự",
		nameEn: "Hong Ngu District",
		order: 0
	},
	{
		id: 263,
		name: "Huyện Lai Vung",
		nameEn: "Lai Vung",
		order: 0
	},
	{
		id: 262,
		name: "Huyện Lấp Vò",
		nameEn: "Lap Vo",
		order: 0
	},
	{
		id: 258,
		name: "Huyện Tam Nông",
		nameEn: "Tam Nong",
		order: 0
	},
	{
		id: 261,
		name: "Huyện Thanh Bình",
		nameEn: "Thanh Binh",
		order: 0
	},
	{
		id: 259,
		name: "Huyện Tháp Mười",
		nameEn: "Thap Muoi",
		order: 0
	},
	{
		id: 256,
		name: "Huyện Tân Hồng",
		nameEn: "Tan Hong",
		order: 0
	},
	{
		id: 253,
		name: "Thành phố Cao Lãnh",
		nameEn: "Cao Lanh City",
		order: 0
	},
	{
		id: 255,
		name: "Thành phố Hồng Ngự",
		nameEn: "Hong Ngu City",
		order: 0
	},
	{
		id: 254,
		name: "Thành phố Sa Đéc",
		nameEn: "Sa Dec",
		order: 0
	}
],
	"21": [
	{
		id: 275,
		name: "Huyện Chư Prông",
		nameEn: "Chu Prong",
		order: 0
	},
	{
		id: 270,
		name: "Huyện Chư Păh",
		nameEn: "Chu Pah",
		order: 0
	},
	{
		id: 281,
		name: "Huyện Chư Pưh",
		nameEn: "Chu Puh",
		order: 0
	},
	{
		id: 276,
		name: "Huyện Chư Sê",
		nameEn: "Chu Se",
		order: 0
	},
	{
		id: 271,
		name: "Huyện Ia Grai",
		nameEn: "Ia Grai",
		order: 0
	},
	{
		id: 278,
		name: "Huyện Ia Pa",
		nameEn: "Ia Pa",
		order: 0
	},
	{
		id: 268,
		name: "Huyện KBang",
		nameEn: "KBang",
		order: 0
	},
	{
		id: 279,
		name: "Huyện Krông Pa",
		nameEn: "Krong Pa",
		order: 0
	},
	{
		id: 273,
		name: "Huyện Kông Chro",
		nameEn: "Kong Chro",
		order: 0
	},
	{
		id: 272,
		name: "Huyện Mang Yang",
		nameEn: "Mang Yang",
		order: 0
	},
	{
		id: 280,
		name: "Huyện Phú Thiện",
		nameEn: "Phu Thien",
		order: 0
	},
	{
		id: 277,
		name: "Huyện Đăk Pơ",
		nameEn: "Dak Po",
		order: 0
	},
	{
		id: 269,
		name: "Huyện Đăk Đoa",
		nameEn: "Dak Doa",
		order: 0
	},
	{
		id: 274,
		name: "Huyện Đức Cơ",
		nameEn: "Duc Co",
		order: 0
	},
	{
		id: 265,
		name: "Thành phố Pleiku",
		nameEn: "Pleiku",
		order: 0
	},
	{
		id: 266,
		name: "Thị xã An Khê",
		nameEn: "An Khe",
		order: 0
	},
	{
		id: 267,
		name: "Thị xã Ayun Pa",
		nameEn: "Ayun Pa",
		order: 0
	}
],
	"22": [
	{
		id: 288,
		name: "Huyện Bắc Mê",
		nameEn: "Bac Me",
		order: 0
	},
	{
		id: 291,
		name: "Huyện Bắc Quang",
		nameEn: "Bac Quang",
		order: 0
	},
	{
		id: 289,
		name: "Huyện Hoàng Su Phì",
		nameEn: "Hoang Su Phi",
		order: 0
	},
	{
		id: 284,
		name: "Huyện Mèo Vạc",
		nameEn: "Meo Vac",
		order: 0
	},
	{
		id: 292,
		name: "Huyện Quang Bình",
		nameEn: "Quang Binh",
		order: 0
	},
	{
		id: 286,
		name: "Huyện Quản Bạ",
		nameEn: "Ba",
		order: 0
	},
	{
		id: 287,
		name: "Huyện Vị Xuyên",
		nameEn: "Vi Xuyen",
		order: 0
	},
	{
		id: 290,
		name: "Huyện Xín Mần",
		nameEn: "Xin Man",
		order: 0
	},
	{
		id: 285,
		name: "Huyện Yên Minh",
		nameEn: "Yen Minh",
		order: 0
	},
	{
		id: 283,
		name: "Huyện Đồng Văn",
		nameEn: "Dong Van",
		order: 0
	},
	{
		id: 282,
		name: "Thành phố Hà Giang",
		nameEn: "Ha Giang",
		order: 0
	}
],
	"23": [
	{
		id: 297,
		name: "Huyện Bình Lục",
		nameEn: "Binh Luc",
		order: 0
	},
	{
		id: 295,
		name: "Huyện Kim Bảng",
		nameEn: "Kim Bang",
		order: 0
	},
	{
		id: 298,
		name: "Huyện Lý Nhân",
		nameEn: "Ly Nhan",
		order: 0
	},
	{
		id: 296,
		name: "Huyện Thanh Liêm",
		nameEn: "Thanh Liem",
		order: 0
	},
	{
		id: 293,
		name: "Thành phố Phủ Lý",
		nameEn: "Phu Ly",
		order: 0
	},
	{
		id: 294,
		name: "Thị xã Duy Tiên",
		nameEn: "Duy Tien",
		order: 0
	}
],
	"24": [
	{
		id: 16,
		name: "Huyện Ba Vì",
		nameEn: "Ba Vi",
		order: 0
	},
	{
		id: 17,
		name: "Huyện Chương Mỹ",
		nameEn: "Chuong My",
		order: 0
	},
	{
		id: 20,
		name: "Huyện Gia Lâm",
		nameEn: "Gia Lam",
		order: 0
	},
	{
		id: 21,
		name: "Huyện Hoài Đức",
		nameEn: "Hoai Duc",
		order: 0
	},
	{
		id: 22,
		name: "Huyện Mê Linh",
		nameEn: "Me Linh",
		order: 0
	},
	{
		id: 23,
		name: "Huyện Mỹ Đức",
		nameEn: "My Duc",
		order: 0
	},
	{
		id: 24,
		name: "Huyện Phú Xuyên",
		nameEn: "Phu Xuyen",
		order: 0
	},
	{
		id: 25,
		name: "Huyện Phúc Thọ",
		nameEn: "Phuc Tho",
		order: 0
	},
	{
		id: 26,
		name: "Huyện Quốc Oai",
		nameEn: "Quoc Oai",
		order: 0
	},
	{
		id: 27,
		name: "Huyện Sóc Sơn",
		nameEn: "Soc Son",
		order: 0
	},
	{
		id: 29,
		name: "Huyện Thanh Oai",
		nameEn: "Thanh Oai",
		order: 0
	},
	{
		id: 30,
		name: "Huyện Thanh Trì",
		nameEn: "Thanh Tri",
		order: 0
	},
	{
		id: 31,
		name: "Huyện Thường Tín",
		nameEn: "Thuong Tin",
		order: 0
	},
	{
		id: 28,
		name: "Huyện Thạch Thất",
		nameEn: "Thach That",
		order: 0
	},
	{
		id: 18,
		name: "Huyện Đan Phượng",
		nameEn: "Dan Phuong",
		order: 0
	},
	{
		id: 19,
		name: "Huyện Đông Anh",
		nameEn: "Dong Anh",
		order: 0
	},
	{
		id: 33,
		name: "Huyện Ứng Hòa",
		nameEn: "Ung Hoa",
		order: 0
	},
	{
		id: 5,
		name: "Quận Ba Đình",
		nameEn: "Ba Dinh",
		order: 0
	},
	{
		id: 63,
		name: "Quận Bắc Từ Liêm",
		nameEn: "North Tu Liem",
		order: 0
	},
	{
		id: 6,
		name: "Quận Cầu Giấy",
		nameEn: "Cau Giay",
		order: 0
	},
	{
		id: 9,
		name: "Quận Hai Bà Trưng",
		nameEn: "Hai Ba Trung",
		order: 0
	},
	{
		id: 10,
		name: "Quận Hoàn Kiếm",
		nameEn: "Hoan Kiem",
		order: 0
	},
	{
		id: 11,
		name: "Quận Hoàng Mai",
		nameEn: "Hoang Mai",
		order: 0
	},
	{
		id: 8,
		name: "Quận Hà Đông",
		nameEn: "Ha Dong",
		order: 0
	},
	{
		id: 12,
		name: "Quận Long Biên",
		nameEn: "Long Bien",
		order: 0
	},
	{
		id: 54,
		name: "Quận Nam Từ Liêm",
		nameEn: "South Tu Liem",
		order: 0
	},
	{
		id: 14,
		name: "Quận Thanh Xuân",
		nameEn: "Thanh Xuan",
		order: 0
	},
	{
		id: 13,
		name: "Quận Tây Hồ",
		nameEn: "Tay Ho",
		order: 0
	},
	{
		id: 32,
		name: "Quận Từ Liêm",
		nameEn: "Tu Liem",
		order: 0
	},
	{
		id: 7,
		name: "Quận Đống Đa",
		nameEn: "Dong Da",
		order: 0
	},
	{
		id: 15,
		name: "Thị xã Sơn Tây",
		nameEn: "Son Tay",
		order: 0
	}
],
	"26": [
	{
		id: 305,
		name: "Huyện Can Lộc",
		nameEn: "Can Loc",
		order: 0
	},
	{
		id: 308,
		name: "Huyện Cẩm Xuyên",
		nameEn: "Cam Xuyen",
		order: 0
	},
	{
		id: 306,
		name: "Huyện Hương Khê",
		nameEn: "Huong Khe",
		order: 0
	},
	{
		id: 301,
		name: "Huyện Hương Sơn",
		nameEn: "Huong Son",
		order: 0
	},
	{
		id: 309,
		name: "Huyện Kỳ Anh",
		nameEn: "Ky Anh District",
		order: 0
	},
	{
		id: 310,
		name: "Huyện Lộc Hà",
		nameEn: "Loc Ha",
		order: 0
	},
	{
		id: 304,
		name: "Huyện Nghi Xuân",
		nameEn: "Nghi Xuan",
		order: 0
	},
	{
		id: 307,
		name: "Huyện Thạch Hà",
		nameEn: "Thach Ha",
		order: 0
	},
	{
		id: 303,
		name: "Huyện Vũ Quang",
		nameEn: "Vu Quang",
		order: 0
	},
	{
		id: 302,
		name: "Huyện Đức Thọ",
		nameEn: "Duc Tho",
		order: 0
	},
	{
		id: 299,
		name: "Thành phố Hà Tĩnh",
		nameEn: "Ha Tinh",
		order: 0
	},
	{
		id: 300,
		name: "Thị xã Hồng Lĩnh",
		nameEn: "Hong Linh",
		order: 0
	},
	{
		id: 311,
		name: "Thị xã Kỳ Anh",
		nameEn: "Ky Anh Town",
		order: 0
	}
],
	"27": [
	{
		id: 319,
		name: "Huyện Bình Giang",
		nameEn: "Binh Giang",
		order: 0
	},
	{
		id: 318,
		name: "Huyện Cẩm Giàng",
		nameEn: "Cam Giang",
		order: 0
	},
	{
		id: 320,
		name: "Huyện Gia Lộc",
		nameEn: "Gia Loc",
		order: 0
	},
	{
		id: 316,
		name: "Huyện Kim Thành",
		nameEn: "Kim Thanh",
		order: 0
	},
	{
		id: 314,
		name: "Huyện Nam Sách",
		nameEn: "Nam Sach",
		order: 0
	},
	{
		id: 322,
		name: "Huyện Ninh Giang",
		nameEn: "Ninh Giang",
		order: 0
	},
	{
		id: 317,
		name: "Huyện Thanh Hà",
		nameEn: "Thanh Ha",
		order: 0
	},
	{
		id: 323,
		name: "Huyện Thanh Miện",
		nameEn: "Thanh Mien",
		order: 0
	},
	{
		id: 321,
		name: "Huyện Tứ Kỳ",
		nameEn: "Tu Ky",
		order: 0
	},
	{
		id: 313,
		name: "Thành phố Chí Linh",
		nameEn: "Chi Linh",
		order: 0
	},
	{
		id: 312,
		name: "Thành phố Hải Dương",
		nameEn: "Hai Duong",
		order: 0
	},
	{
		id: 315,
		name: "Thị xã Kinh Môn",
		nameEn: "Kinh Mon",
		order: 0
	}
],
	"28": [
	{
		id: 81,
		name: "Huyện An Dương",
		nameEn: "An Duong",
		order: 0
	},
	{
		id: 82,
		name: "Huyện An Lão",
		nameEn: "An Lao",
		order: 0
	},
	{
		id: 87,
		name: "Huyện Bạch Long Vĩ",
		nameEn: "Bach Long Vi",
		order: 0
	},
	{
		id: 86,
		name: "Huyện Cát Hải",
		nameEn: "Cat Hai",
		order: 0
	},
	{
		id: 83,
		name: "Huyện Kiến Thuỵ",
		nameEn: "Kien Thuy",
		order: 0
	},
	{
		id: 80,
		name: "Huyện Thuỷ Nguyên",
		nameEn: "Thuy Nguyen",
		order: 0
	},
	{
		id: 84,
		name: "Huyện Tiên Lãng",
		nameEn: "Tien Lang",
		order: 0
	},
	{
		id: 85,
		name: "Huyện Vĩnh Bảo",
		nameEn: "Vinh Bao",
		order: 0
	},
	{
		id: 79,
		name: "Quận Dương Kinh",
		nameEn: "Duong Kinh",
		order: 0
	},
	{
		id: 76,
		name: "Quận Hải An",
		nameEn: "Hai An",
		order: 0
	},
	{
		id: 73,
		name: "Quận Hồng Bàng",
		nameEn: "Hong Bang",
		order: 0
	},
	{
		id: 77,
		name: "Quận Kiến An",
		nameEn: "Kien An",
		order: 0
	},
	{
		id: 75,
		name: "Quận Lê Chân",
		nameEn: "Le Chan",
		order: 0
	},
	{
		id: 74,
		name: "Quận Ngô Quyền",
		nameEn: "Ngo Quyen",
		order: 0
	},
	{
		id: 78,
		name: "Quận Đồ Sơn",
		nameEn: "Do Son",
		order: 0
	}
],
	"29": [
	{
		id: 51,
		name: "Huyện Bình Chánh",
		nameEn: "Binh Chanh",
		order: 0
	},
	{
		id: 53,
		name: "Huyện Cần Giờ",
		nameEn: "Can Gio",
		order: 0
	},
	{
		id: 49,
		name: "Huyện Củ Chi",
		nameEn: "Cu Chi",
		order: 0
	},
	{
		id: 50,
		name: "Huyện Hóc Môn",
		nameEn: "Hoc Mon",
		order: 0
	},
	{
		id: 52,
		name: "Huyện Nhà Bè",
		nameEn: "Nha Be",
		order: 0
	},
	{
		id: 1,
		name: "Quận 1",
		nameEn: "District 1",
		order: 0
	},
	{
		id: 39,
		name: "Quận 10",
		nameEn: "District 10",
		order: 0
	},
	{
		id: 40,
		name: "Quận 11",
		nameEn: "District 11",
		order: 0
	},
	{
		id: 41,
		name: "Quận 12",
		nameEn: "District 12",
		order: 0
	},
	{
		id: 3,
		name: "Quận 3",
		nameEn: "District 3",
		order: 0
	},
	{
		id: 4,
		name: "Quận 4",
		nameEn: "District 4",
		order: 0
	},
	{
		id: 34,
		name: "Quận 5",
		nameEn: "District 5",
		order: 0
	},
	{
		id: 35,
		name: "Quận 6",
		nameEn: "District 6",
		order: 0
	},
	{
		id: 36,
		name: "Quận 7",
		nameEn: "District 7",
		order: 0
	},
	{
		id: 37,
		name: "Quận 8",
		nameEn: "District 8",
		order: 0
	},
	{
		id: 45,
		name: "Quận Bình Thạnh",
		nameEn: "Binh Thanh",
		order: 0
	},
	{
		id: 48,
		name: "Quận Bình Tân",
		nameEn: "Binh Tan",
		order: 0
	},
	{
		id: 42,
		name: "Quận Gò Vấp",
		nameEn: "Go Vap",
		order: 0
	},
	{
		id: 46,
		name: "Quận Phú Nhuận",
		nameEn: "Phu Nhuan",
		order: 0
	},
	{
		id: 43,
		name: "Quận Tân Bình",
		nameEn: "Tan Binh",
		order: 0
	},
	{
		id: 44,
		name: "Quận Tân Phú",
		nameEn: "Tan Phu",
		order: 0
	},
	{
		id: 47,
		name: "Thành phố Thủ Đức",
		nameEn: "Thu Duc",
		order: 0
	}
],
	"30": [
	{
		id: 336,
		name: "Huyện Cao Phong",
		nameEn: "Cao Phong",
		order: 0
	},
	{
		id: 335,
		name: "Huyện Kim Bôi",
		nameEn: "Kim Boi",
		order: 0
	},
	{
		id: 334,
		name: "Huyện Lương Sơn",
		nameEn: "Luong Son",
		order: 0
	},
	{
		id: 339,
		name: "Huyện Lạc Sơn",
		nameEn: "Lac Son",
		order: 0
	},
	{
		id: 341,
		name: "Huyện Lạc Thủy",
		nameEn: "Lac Thuy",
		order: 0
	},
	{
		id: 338,
		name: "Huyện Mai Châu",
		nameEn: "Mai Chau",
		order: 0
	},
	{
		id: 337,
		name: "Huyện Tân Lạc",
		nameEn: "Tan Lac",
		order: 0
	},
	{
		id: 340,
		name: "Huyện Yên Thủy",
		nameEn: "Yen Thuy",
		order: 0
	},
	{
		id: 333,
		name: "Huyện Đà Bắc",
		nameEn: "Da Bac",
		order: 0
	},
	{
		id: 332,
		name: "Thành phố Hòa Bình",
		nameEn: "Hoa Binh",
		order: 0
	}
],
	"32": [
	{
		id: 348,
		name: "Huyện Khoái Châu",
		nameEn: "Khoai Chau",
		order: 0
	},
	{
		id: 349,
		name: "Huyện Kim Động",
		nameEn: "Kim Dong",
		order: 0
	},
	{
		id: 351,
		name: "Huyện Phù Cừ",
		nameEn: "Phu Cu",
		order: 0
	},
	{
		id: 350,
		name: "Huyện Tiên Lữ",
		nameEn: "Tien Lu",
		order: 0
	},
	{
		id: 344,
		name: "Huyện Văn Giang",
		nameEn: "Van Giang",
		order: 0
	},
	{
		id: 343,
		name: "Huyện Văn Lâm",
		nameEn: "Van Lam",
		order: 0
	},
	{
		id: 345,
		name: "Huyện Yên Mỹ",
		nameEn: "Yen My",
		order: 0
	},
	{
		id: 347,
		name: "Huyện Ân Thi",
		nameEn: "An Thi",
		order: 0
	},
	{
		id: 342,
		name: "Thành phố Hưng Yên",
		nameEn: "Hung Yen",
		order: 0
	},
	{
		id: 346,
		name: "Thị xã Mỹ Hào",
		nameEn: "My Hao",
		order: 0
	}
],
	"33": [
	{
		id: 354,
		name: "Huyện Cam Lâm",
		nameEn: "Cam Lam",
		order: 0
	},
	{
		id: 358,
		name: "Huyện Diên Khánh",
		nameEn: "Dien Khanh",
		order: 0
	},
	{
		id: 359,
		name: "Huyện Khánh Sơn",
		nameEn: "Khanh Son",
		order: 0
	},
	{
		id: 357,
		name: "Huyện Khánh Vĩnh",
		nameEn: "Khanh Vinh",
		order: 0
	},
	{
		id: 360,
		name: "Huyện Trường Sa",
		nameEn: "Truong Sa",
		order: 0
	},
	{
		id: 355,
		name: "Huyện Vạn Ninh",
		nameEn: "Van Ninh",
		order: 0
	},
	{
		id: 353,
		name: "Thành phố Cam Ranh",
		nameEn: "Cam Ranh",
		order: 0
	},
	{
		id: 352,
		name: "Thành phố Nha Trang",
		nameEn: "Nha Trang",
		order: 0
	},
	{
		id: 356,
		name: "Thị xã Ninh Hòa",
		nameEn: "Ninh Hoa",
		order: 0
	}
],
	"34": [
	{
		id: 385,
		name: "Huyện Ia H' Drai",
		nameEn: "Ia H' Drai",
		order: 0
	},
	{
		id: 380,
		name: "Huyện Kon Plông",
		nameEn: "Kon Plong",
		order: 0
	},
	{
		id: 381,
		name: "Huyện Kon Rẫy",
		nameEn: "Kon Ray",
		order: 0
	},
	{
		id: 378,
		name: "Huyện Ngọc Hồi",
		nameEn: "Ngoc Hoi",
		order: 0
	},
	{
		id: 383,
		name: "Huyện Sa Thầy",
		nameEn: "Sa Thay",
		order: 0
	},
	{
		id: 384,
		name: "Huyện Tu Mơ Rông",
		nameEn: "Tu Mo Rong",
		order: 0
	},
	{
		id: 377,
		name: "Huyện Đắk Glei",
		nameEn: "Dak Glei",
		order: 0
	},
	{
		id: 382,
		name: "Huyện Đắk Hà",
		nameEn: "Dak Ha",
		order: 0
	},
	{
		id: 379,
		name: "Huyện Đắk Tô",
		nameEn: "Dak To",
		order: 0
	},
	{
		id: 376,
		name: "Thành phố Kon Tum",
		nameEn: "Kon Tum",
		order: 0
	}
],
	"35": [
	{
		id: 388,
		name: "Huyện Mường Tè",
		nameEn: "Muong Te",
		order: 0
	},
	{
		id: 393,
		name: "Huyện Nậm Nhùn",
		nameEn: "Nam Nhun",
		order: 0
	},
	{
		id: 390,
		name: "Huyện Phong Thổ",
		nameEn: "Phong Tho",
		order: 0
	},
	{
		id: 389,
		name: "Huyện Sìn Hồ",
		nameEn: "Sin Ho",
		order: 0
	},
	{
		id: 387,
		name: "Huyện Tam Đường",
		nameEn: "Tam Duong",
		order: 0
	},
	{
		id: 391,
		name: "Huyện Than Uyên",
		nameEn: "Than Uyen",
		order: 0
	},
	{
		id: 392,
		name: "Huyện Tân Uyên",
		nameEn: "Tan Uyen",
		order: 0
	},
	{
		id: 386,
		name: "Thành phố Lai Châu",
		nameEn: "Lai Chau",
		order: 0
	}
],
	"36": [
	{
		id: 402,
		name: "Huyện Bảo Lâm",
		nameEn: "Bao Lam",
		order: 0
	},
	{
		id: 405,
		name: "Huyện Cát Tiên",
		nameEn: "Cat Tien",
		order: 0
	},
	{
		id: 401,
		name: "Huyện Di Linh",
		nameEn: "Di Linh",
		order: 0
	},
	{
		id: 398,
		name: "Huyện Lâm Hà",
		nameEn: "Lam Ha",
		order: 0
	},
	{
		id: 397,
		name: "Huyện Lạc Dương",
		nameEn: "Lac Duong",
		order: 0
	},
	{
		id: 396,
		name: "Huyện Đam Rông",
		nameEn: "Dam Rong",
		order: 0
	},
	{
		id: 399,
		name: "Huyện Đơn Dương",
		nameEn: "Don Duong",
		order: 0
	},
	{
		id: 403,
		name: "Huyện Đạ Huoai",
		nameEn: "Da Huoai",
		order: 0
	},
	{
		id: 404,
		name: "Huyện Đạ Tẻh",
		nameEn: "Da Teh",
		order: 0
	},
	{
		id: 400,
		name: "Huyện Đức Trọng",
		nameEn: "Duc Trong",
		order: 0
	},
	{
		id: 395,
		name: "Thành phố Bảo Lộc",
		nameEn: "Bao Loc",
		order: 0
	},
	{
		id: 394,
		name: "Thành phố Đà Lạt",
		nameEn: "Da Lat",
		order: 0
	}
],
	"37": [
	{
		id: 408,
		name: "Huyện Bình Gia",
		nameEn: "Binh Gia",
		order: 0
	},
	{
		id: 412,
		name: "Huyện Bắc Sơn",
		nameEn: "Bac Son",
		order: 0
	},
	{
		id: 410,
		name: "Huyện Cao Lộc",
		nameEn: "Cao Loc",
		order: 0
	},
	{
		id: 414,
		name: "Huyện Chi Lăng",
		nameEn: "Chi Lang",
		order: 0
	},
	{
		id: 413,
		name: "Huyện Hữu Lũng",
		nameEn: "Huu Lung",
		order: 0
	},
	{
		id: 415,
		name: "Huyện Lộc Bình",
		nameEn: "Loc Binh",
		order: 0
	},
	{
		id: 407,
		name: "Huyện Tràng Định",
		nameEn: "Trang Dinh",
		order: 0
	},
	{
		id: 409,
		name: "Huyện Văn Lãng",
		nameEn: "Van Lang",
		order: 0
	},
	{
		id: 411,
		name: "Huyện Văn Quan",
		nameEn: "Van Quan",
		order: 0
	},
	{
		id: 416,
		name: "Huyện Đình Lập",
		nameEn: "Dinh Lap",
		order: 0
	},
	{
		id: 406,
		name: "Thành phố Lạng Sơn",
		nameEn: "Lang Son",
		order: 0
	}
],
	"38": [
	{
		id: 418,
		name: "Huyện Bát Xát",
		nameEn: "Bat Xat",
		order: 0
	},
	{
		id: 422,
		name: "Huyện Bảo Thắng",
		nameEn: "Bao Thang",
		order: 0
	},
	{
		id: 423,
		name: "Huyện Bảo Yên",
		nameEn: "Bao Yen",
		order: 0
	},
	{
		id: 421,
		name: "Huyện Bắc Hà",
		nameEn: "Bac Ha",
		order: 0
	},
	{
		id: 419,
		name: "Huyện Mường Khương",
		nameEn: "Muong Khuong",
		order: 0
	},
	{
		id: 420,
		name: "Huyện Si Ma Cai",
		nameEn: "Si Ma Cai",
		order: 0
	},
	{
		id: 425,
		name: "Huyện Văn Bàn",
		nameEn: "Van Ban",
		order: 0
	},
	{
		id: 417,
		name: "Thành phố Lào Cai",
		nameEn: "Lao Cai",
		order: 0
	},
	{
		id: 424,
		name: "Thị xã Sa Pa",
		nameEn: "Sa Pa",
		order: 0
	}
],
	"39": [
	{
		id: 435,
		name: "Huyện Bến Lức",
		nameEn: "Ben Luc",
		order: 0
	},
	{
		id: 440,
		name: "Huyện Châu Thành",
		nameEn: "Chau Thanh",
		order: 0
	},
	{
		id: 439,
		name: "Huyện Cần Giuộc",
		nameEn: "Can Giuoc",
		order: 0
	},
	{
		id: 438,
		name: "Huyện Cần Đước",
		nameEn: "Can Duoc",
		order: 0
	},
	{
		id: 430,
		name: "Huyện Mộc Hóa",
		nameEn: "Moc Hoa",
		order: 0
	},
	{
		id: 432,
		name: "Huyện Thạnh Hóa",
		nameEn: "Thanh Hoa",
		order: 0
	},
	{
		id: 436,
		name: "Huyện Thủ Thừa",
		nameEn: "Thu Thua",
		order: 0
	},
	{
		id: 428,
		name: "Huyện Tân Hưng",
		nameEn: "Tan Hung",
		order: 0
	},
	{
		id: 431,
		name: "Huyện Tân Thạnh",
		nameEn: "Tan Thanh",
		order: 0
	},
	{
		id: 437,
		name: "Huyện Tân Trụ",
		nameEn: "Tan Tru",
		order: 0
	},
	{
		id: 429,
		name: "Huyện Vĩnh Hưng",
		nameEn: "Vinh Hung",
		order: 0
	},
	{
		id: 433,
		name: "Huyện Đức Huệ",
		nameEn: "Duc Hue",
		order: 0
	},
	{
		id: 434,
		name: "Huyện Đức Hòa",
		nameEn: "Duc Hoa",
		order: 0
	},
	{
		id: 426,
		name: "Thành phố Tân An",
		nameEn: "Tan An",
		order: 0
	},
	{
		id: 427,
		name: "Thị xã Kiến Tường",
		nameEn: "Kien Tuong",
		order: 0
	}
],
	"40": [
	{
		id: 449,
		name: "Huyện Giao Thủy",
		nameEn: "Giao Thuy",
		order: 0
	},
	{
		id: 450,
		name: "Huyện Hải Hậu",
		nameEn: "Hai Hau",
		order: 0
	},
	{
		id: 442,
		name: "Huyện Mỹ Lộc",
		nameEn: "My Loc",
		order: 0
	},
	{
		id: 446,
		name: "Huyện Nam Trực",
		nameEn: "Nam Truc",
		order: 0
	},
	{
		id: 445,
		name: "Huyện Nghĩa Hưng",
		nameEn: "Nghia Hung",
		order: 0
	},
	{
		id: 447,
		name: "Huyện Trực Ninh",
		nameEn: "Truc Ninh",
		order: 0
	},
	{
		id: 443,
		name: "Huyện Vụ Bản",
		nameEn: "Vu Ban",
		order: 0
	},
	{
		id: 448,
		name: "Huyện Xuân Trường",
		nameEn: "Xuan Truong",
		order: 0
	},
	{
		id: 444,
		name: "Huyện Ý Yên",
		nameEn: "Y Yen",
		order: 0
	},
	{
		id: 441,
		name: "Thành phố Nam Định",
		nameEn: "Nam Dinh",
		order: 0
	}
],
	"41": [
	{
		id: 463,
		name: "Huyện Anh Sơn",
		nameEn: "Anh Son",
		order: 0
	},
	{
		id: 461,
		name: "Huyện Con Cuông",
		nameEn: "Con Cuong",
		order: 0
	},
	{
		id: 464,
		name: "Huyện Diễn Châu",
		nameEn: "Dien Chau",
		order: 0
	},
	{
		id: 470,
		name: "Huyện Hưng Nguyên",
		nameEn: "Hung Nguyen",
		order: 0
	},
	{
		id: 456,
		name: "Huyện Kỳ Sơn",
		nameEn: "Ky Son",
		order: 0
	},
	{
		id: 469,
		name: "Huyện Nam Đàn",
		nameEn: "Nam Dan",
		order: 0
	},
	{
		id: 468,
		name: "Huyện Nghi Lộc",
		nameEn: "Nghi Loc",
		order: 0
	},
	{
		id: 458,
		name: "Huyện Nghĩa Đàn",
		nameEn: "Nghia Dan",
		order: 0
	},
	{
		id: 454,
		name: "Huyện Quế Phong",
		nameEn: "Que Phong",
		order: 0
	},
	{
		id: 455,
		name: "Huyện Quỳ Châu",
		nameEn: "Quy Chau",
		order: 0
	},
	{
		id: 459,
		name: "Huyện Quỳ Hợp",
		nameEn: "Quy Hop",
		order: 0
	},
	{
		id: 460,
		name: "Huyện Quỳnh Lưu",
		nameEn: "Quynh Luu",
		order: 0
	},
	{
		id: 467,
		name: "Huyện Thanh Chương",
		nameEn: "Thanh Chuong",
		order: 0
	},
	{
		id: 462,
		name: "Huyện Tân Kỳ",
		nameEn: "Tan Ky",
		order: 0
	},
	{
		id: 457,
		name: "Huyện Tương Dương",
		nameEn: "Tuong Duong",
		order: 0
	},
	{
		id: 465,
		name: "Huyện Yên Thành",
		nameEn: "Yen Thanh",
		order: 0
	},
	{
		id: 466,
		name: "Huyện Đô Lương",
		nameEn: "Do Luong",
		order: 0
	},
	{
		id: 451,
		name: "Thành phố Vinh",
		nameEn: "Vinh",
		order: 0
	},
	{
		id: 452,
		name: "Thị xã Cửa Lò",
		nameEn: "Cua Lo",
		order: 0
	},
	{
		id: 471,
		name: "Thị xã Hoàng Mai",
		nameEn: "Hoang Mai",
		order: 0
	},
	{
		id: 453,
		name: "Thị xã Thái Hoà",
		nameEn: "Thai Hoa",
		order: 0
	}
],
	"42": [
	{
		id: 475,
		name: "Huyện Gia Viễn",
		nameEn: "Gia Vien",
		order: 0
	},
	{
		id: 476,
		name: "Huyện Hoa Lư",
		nameEn: "Hoa Lu",
		order: 0
	},
	{
		id: 478,
		name: "Huyện Kim Sơn",
		nameEn: "Kim Son",
		order: 0
	},
	{
		id: 474,
		name: "Huyện Nho Quan",
		nameEn: "Nho Quan",
		order: 0
	},
	{
		id: 477,
		name: "Huyện Yên Khánh",
		nameEn: "Yen Khanh",
		order: 0
	},
	{
		id: 479,
		name: "Huyện Yên Mô",
		nameEn: "Yen Mo",
		order: 0
	},
	{
		id: 472,
		name: "Thành phố Ninh Bình",
		nameEn: "Ninh Binh",
		order: 0
	},
	{
		id: 473,
		name: "Thành phố Tam Điệp",
		nameEn: "Tam Diep",
		order: 0
	}
],
	"43": [
	{
		id: 481,
		name: "Huyện Bác Ái",
		nameEn: "Bac Ai",
		order: 0
	},
	{
		id: 483,
		name: "Huyện Ninh Hải",
		nameEn: "Ninh Hai",
		order: 0
	},
	{
		id: 484,
		name: "Huyện Ninh Phước",
		nameEn: "Ninh Phuoc",
		order: 0
	},
	{
		id: 482,
		name: "Huyện Ninh Sơn",
		nameEn: "Ninh Son",
		order: 0
	},
	{
		id: 485,
		name: "Huyện Thuận Bắc",
		nameEn: "Thuan Bac",
		order: 0
	},
	{
		id: 486,
		name: "Huyện Thuận Nam",
		nameEn: "Thuan Nam",
		order: 0
	},
	{
		id: 480,
		name: "Thành phố Phan Rang-Tháp Chàm",
		nameEn: "Phan Rang-Thap Cham",
		order: 0
	}
],
	"44": [
	{
		id: 494,
		name: "Huyện Cẩm Khê",
		nameEn: "Cam Khe",
		order: 0
	},
	{
		id: 490,
		name: "Huyện Hạ Hoà",
		nameEn: "Ha Hoa",
		order: 0
	},
	{
		id: 496,
		name: "Huyện Lâm Thao",
		nameEn: "Lam Thao",
		order: 0
	},
	{
		id: 492,
		name: "Huyện Phù Ninh",
		nameEn: "Phu Ninh",
		order: 0
	},
	{
		id: 495,
		name: "Huyện Tam Nông",
		nameEn: "Tam Nong",
		order: 0
	},
	{
		id: 491,
		name: "Huyện Thanh Ba",
		nameEn: "Thanh Ba",
		order: 0
	},
	{
		id: 497,
		name: "Huyện Thanh Sơn",
		nameEn: "Thanh Son",
		order: 0
	},
	{
		id: 498,
		name: "Huyện Thanh Thuỷ",
		nameEn: "Thanh Thuy",
		order: 0
	},
	{
		id: 499,
		name: "Huyện Tân Sơn",
		nameEn: "Tan Son",
		order: 0
	},
	{
		id: 493,
		name: "Huyện Yên Lập",
		nameEn: "Yen Lap",
		order: 0
	},
	{
		id: 489,
		name: "Huyện Đoan Hùng",
		nameEn: "Doan Hung",
		order: 0
	},
	{
		id: 487,
		name: "Thành phố Việt Trì",
		nameEn: "Viet Tri",
		order: 0
	},
	{
		id: 488,
		name: "Thị xã Phú Thọ",
		nameEn: "Phu Tho",
		order: 0
	}
],
	"45": [
	{
		id: 507,
		name: "Huyện Phú Hoà",
		nameEn: "Phu Hoa",
		order: 0
	},
	{
		id: 505,
		name: "Huyện Sông Hinh",
		nameEn: "Song Hinh",
		order: 0
	},
	{
		id: 504,
		name: "Huyện Sơn Hòa",
		nameEn: "Son Hoa",
		order: 0
	},
	{
		id: 503,
		name: "Huyện Tuy An",
		nameEn: "Tuy An",
		order: 0
	},
	{
		id: 506,
		name: "Huyện Tây Hoà",
		nameEn: "Tay Hoa",
		order: 0
	},
	{
		id: 502,
		name: "Huyện Đồng Xuân",
		nameEn: "Dong Xuan",
		order: 0
	},
	{
		id: 500,
		name: "Thành phố Tuy Hoà",
		nameEn: "Tuy Hoa",
		order: 0
	},
	{
		id: 501,
		name: "Thị xã Sông Cầu",
		nameEn: "Song Cau",
		order: 0
	},
	{
		id: 508,
		name: "Thị xã Đông Hòa",
		nameEn: "Dong Hoa",
		order: 0
	}
],
	"46": [
	{
		id: 513,
		name: "Huyện Bố Trạch",
		nameEn: "Bo Trach",
		order: 0
	},
	{
		id: 515,
		name: "Huyện Lệ Thủy",
		nameEn: "Le Thuy",
		order: 0
	},
	{
		id: 510,
		name: "Huyện Minh Hóa",
		nameEn: "Minh Hoa",
		order: 0
	},
	{
		id: 514,
		name: "Huyện Quảng Ninh",
		nameEn: "Quang Ninh",
		order: 0
	},
	{
		id: 512,
		name: "Huyện Quảng Trạch",
		nameEn: "Quang Trach",
		order: 0
	},
	{
		id: 511,
		name: "Huyện Tuyên Hóa",
		nameEn: "Tuyen Hoa",
		order: 0
	},
	{
		id: 509,
		name: "Thành Phố Đồng Hới",
		nameEn: "Dong Hoi",
		order: 0
	},
	{
		id: 516,
		name: "Thị xã Ba Đồn",
		nameEn: "Ba Don",
		order: 0
	}
],
	"47": [
	{
		id: 530,
		name: "Huyện Bắc Trà My",
		nameEn: "Bac Tra My",
		order: 0
	},
	{
		id: 523,
		name: "Huyện Duy Xuyên",
		nameEn: "Duy Xuyen",
		order: 0
	},
	{
		id: 527,
		name: "Huyện Hiệp Đức",
		nameEn: "Hiep Duc",
		order: 0
	},
	{
		id: 525,
		name: "Huyện Nam Giang",
		nameEn: "Nam Giang",
		order: 0
	},
	{
		id: 531,
		name: "Huyện Nam Trà My",
		nameEn: "Nam Tra My",
		order: 0
	},
	{
		id: 534,
		name: "Huyện Nông Sơn",
		nameEn: "Nong Son",
		order: 0
	},
	{
		id: 532,
		name: "Huyện Núi Thành",
		nameEn: "Nui Thanh",
		order: 0
	},
	{
		id: 533,
		name: "Huyện Phú Ninh",
		nameEn: "Phu Ninh",
		order: 0
	},
	{
		id: 526,
		name: "Huyện Phước Sơn",
		nameEn: "Phuoc Son",
		order: 0
	},
	{
		id: 524,
		name: "Huyện Quế Sơn",
		nameEn: "Que Son",
		order: 0
	},
	{
		id: 528,
		name: "Huyện Thăng Bình",
		nameEn: "Thang Binh",
		order: 0
	},
	{
		id: 529,
		name: "Huyện Tiên Phước",
		nameEn: "Tien Phuoc",
		order: 0
	},
	{
		id: 519,
		name: "Huyện Tây Giang",
		nameEn: "Tay Giang",
		order: 0
	},
	{
		id: 520,
		name: "Huyện Đông Giang",
		nameEn: "Dong Giang",
		order: 0
	},
	{
		id: 521,
		name: "Huyện Đại Lộc",
		nameEn: "Dai Loc",
		order: 0
	},
	{
		id: 518,
		name: "Thành phố Hội An",
		nameEn: "Hoi An",
		order: 0
	},
	{
		id: 517,
		name: "Thành phố Tam Kỳ",
		nameEn: "Tam Ky",
		order: 0
	},
	{
		id: 522,
		name: "Thị xã Điện Bàn",
		nameEn: "Dien Ban",
		order: 0
	}
],
	"48": [
	{
		id: 546,
		name: "Huyện Ba Tơ",
		nameEn: "Ba To",
		order: 0
	},
	{
		id: 536,
		name: "Huyện Bình Sơn",
		nameEn: "Binh Son",
		order: 0
	},
	{
		id: 547,
		name: "Huyện Lý Sơn",
		nameEn: "Ly Son",
		order: 0
	},
	{
		id: 542,
		name: "Huyện Minh Long",
		nameEn: "Minh Long",
		order: 0
	},
	{
		id: 544,
		name: "Huyện Mộ Đức",
		nameEn: "Mo Duc",
		order: 0
	},
	{
		id: 543,
		name: "Huyện Nghĩa Hành",
		nameEn: "Nghia Hanh",
		order: 0
	},
	{
		id: 540,
		name: "Huyện Sơn Hà",
		nameEn: "Son Ha",
		order: 0
	},
	{
		id: 541,
		name: "Huyện Sơn Tây",
		nameEn: "Son Tay",
		order: 0
	},
	{
		id: 538,
		name: "Huyện Sơn Tịnh",
		nameEn: "Son Tinh",
		order: 0
	},
	{
		id: 537,
		name: "Huyện Trà Bồng",
		nameEn: "Tra Bong",
		order: 0
	},
	{
		id: 539,
		name: "Huyện Tư Nghĩa",
		nameEn: "Tu Nghia",
		order: 0
	},
	{
		id: 535,
		name: "Thành phố Quảng Ngãi",
		nameEn: "Quang Ngai",
		order: 0
	},
	{
		id: 545,
		name: "Thị xã Đức Phổ",
		nameEn: "Duc Pho",
		order: 0
	}
],
	"49": [
	{
		id: 556,
		name: "Huyện Ba Chẽ",
		nameEn: "Ba Che",
		order: 0
	},
	{
		id: 552,
		name: "Huyện Bình Liêu",
		nameEn: "Binh Lieu",
		order: 0
	},
	{
		id: 560,
		name: "Huyện Cô Tô",
		nameEn: "Co To",
		order: 0
	},
	{
		id: 555,
		name: "Huyện Hải Hà",
		nameEn: "Hai Ha",
		order: 0
	},
	{
		id: 553,
		name: "Huyện Tiên Yên",
		nameEn: "Tien Yen",
		order: 0
	},
	{
		id: 557,
		name: "Huyện Vân Đồn",
		nameEn: "Van Don",
		order: 0
	},
	{
		id: 554,
		name: "Huyện Đầm Hà",
		nameEn: "Dam Ha",
		order: 0
	},
	{
		id: 550,
		name: "Thành phố Cẩm Phả",
		nameEn: "Cam Pha",
		order: 0
	},
	{
		id: 548,
		name: "Thành phố Hạ Long",
		nameEn: "Ha Long",
		order: 0
	},
	{
		id: 549,
		name: "Thành phố Móng Cái",
		nameEn: "Mong Cai",
		order: 0
	},
	{
		id: 551,
		name: "Thành phố Uông Bí",
		nameEn: "Uong Bi",
		order: 0
	},
	{
		id: 559,
		name: "Thị xã Quảng Yên",
		nameEn: "Quang Yen",
		order: 0
	},
	{
		id: 558,
		name: "Thị xã Đông Triều",
		nameEn: "Dong Trieu",
		order: 0
	}
],
	"50": [
	{
		id: 567,
		name: "Huyện Cam Lộ",
		nameEn: "Cam Lo",
		order: 0
	},
	{
		id: 570,
		name: "Huyện Cồn Cỏ",
		nameEn: "Con Co",
		order: 0
	},
	{
		id: 565,
		name: "Huyện Gio Linh",
		nameEn: "Gio Linh",
		order: 0
	},
	{
		id: 564,
		name: "Huyện Hướng Hóa",
		nameEn: "Huong Hoa",
		order: 0
	},
	{
		id: 569,
		name: "Huyện Hải Lăng",
		nameEn: "Hai Lang",
		order: 0
	},
	{
		id: 568,
		name: "Huyện Triệu Phong",
		nameEn: "Trieu Phong",
		order: 0
	},
	{
		id: 563,
		name: "Huyện Vĩnh Linh",
		nameEn: "Vinh Linh",
		order: 0
	},
	{
		id: 566,
		name: "Huyện Đa Krông",
		nameEn: "Da Krong",
		order: 0
	},
	{
		id: 561,
		name: "Thành phố Đông Hà",
		nameEn: "Dong Ha",
		order: 0
	},
	{
		id: 562,
		name: "Thị xã Quảng Trị",
		nameEn: "Quang Tri",
		order: 0
	}
],
	"51": [
	{
		id: 572,
		name: "Huyện Châu Thành",
		nameEn: "Chau Thanh",
		order: 0
	},
	{
		id: 575,
		name: "Huyện Cù Lao Dung",
		nameEn: "Cu Lao Dung",
		order: 0
	},
	{
		id: 573,
		name: "Huyện Kế Sách",
		nameEn: "Ke Sach",
		order: 0
	},
	{
		id: 576,
		name: "Huyện Long Phú",
		nameEn: "Long Phu",
		order: 0
	},
	{
		id: 574,
		name: "Huyện Mỹ Tú",
		nameEn: "My Tu",
		order: 0
	},
	{
		id: 577,
		name: "Huyện Mỹ Xuyên",
		nameEn: "My Xuyen",
		order: 0
	},
	{
		id: 579,
		name: "Huyện Thạnh Trị",
		nameEn: "Thanh Tri",
		order: 0
	},
	{
		id: 581,
		name: "Huyện Trần Đề",
		nameEn: "Tran De",
		order: 0
	},
	{
		id: 571,
		name: "Thành phố Sóc Trăng",
		nameEn: "Soc Trang",
		order: 0
	},
	{
		id: 578,
		name: "Thị xã Ngã Năm",
		nameEn: "Nga Nam",
		order: 0
	},
	{
		id: 580,
		name: "Thị xã Vĩnh Châu",
		nameEn: "Vinh Chau",
		order: 0
	}
],
	"52": [
	{
		id: 586,
		name: "Huyện Bắc Yên",
		nameEn: "Bac Yen",
		order: 0
	},
	{
		id: 590,
		name: "Huyện Mai Sơn",
		nameEn: "Mai Son",
		order: 0
	},
	{
		id: 585,
		name: "Huyện Mường La",
		nameEn: "Muong La",
		order: 0
	},
	{
		id: 588,
		name: "Huyện Mộc Châu",
		nameEn: "Moc Chau",
		order: 0
	},
	{
		id: 587,
		name: "Huyện Phù Yên",
		nameEn: "Phu Yen",
		order: 0
	},
	{
		id: 583,
		name: "Huyện Quỳnh Nhai",
		nameEn: "Quynh Nhai",
		order: 0
	},
	{
		id: 591,
		name: "Huyện Sông Mã",
		nameEn: "Song Ma",
		order: 0
	},
	{
		id: 592,
		name: "Huyện Sốp Cộp",
		nameEn: "Sop Cop",
		order: 0
	},
	{
		id: 584,
		name: "Huyện Thuận Châu",
		nameEn: "Thuan Chau",
		order: 0
	},
	{
		id: 593,
		name: "Huyện Vân Hồ",
		nameEn: "Van Ho",
		order: 0
	},
	{
		id: 589,
		name: "Huyện Yên Châu",
		nameEn: "Yen Chau",
		order: 0
	},
	{
		id: 582,
		name: "Thành phố Sơn La",
		nameEn: "Son La",
		order: 0
	}
],
	"53": [
	{
		id: 601,
		name: "Huyện Bến Cầu",
		nameEn: "Ben Cau",
		order: 0
	},
	{
		id: 598,
		name: "Huyện Châu Thành",
		nameEn: "Chau Thanh",
		order: 0
	},
	{
		id: 597,
		name: "Huyện Dương Minh Châu",
		nameEn: "Duong Minh Chau",
		order: 0
	},
	{
		id: 600,
		name: "Huyện Gò Dầu",
		nameEn: "Go Dau",
		order: 0
	},
	{
		id: 595,
		name: "Huyện Tân Biên",
		nameEn: "Tan Bien",
		order: 0
	},
	{
		id: 596,
		name: "Huyện Tân Châu",
		nameEn: "Tan Chau",
		order: 0
	},
	{
		id: 594,
		name: "Thành phố Tây Ninh",
		nameEn: "Tay Ninh",
		order: 0
	},
	{
		id: 599,
		name: "Thị xã Hòa Thành",
		nameEn: "Hoa Thanh",
		order: 0
	},
	{
		id: 602,
		name: "Thị xã Trảng Bàng",
		nameEn: "Trang Bang",
		order: 0
	}
],
	"54": [
	{
		id: 605,
		name: "Huyện Hưng Hà",
		nameEn: "Hung Ha",
		order: 0
	},
	{
		id: 609,
		name: "Huyện Kiến Xương",
		nameEn: "Kien Xuong",
		order: 0
	},
	{
		id: 604,
		name: "Huyện Quỳnh Phụ",
		nameEn: "Quynh Phu",
		order: 0
	},
	{
		id: 607,
		name: "Huyện Thái Thụy",
		nameEn: "Thai Thuy",
		order: 0
	},
	{
		id: 608,
		name: "Huyện Tiền Hải",
		nameEn: "Tien Hai",
		order: 0
	},
	{
		id: 610,
		name: "Huyện Vũ Thư",
		nameEn: "Vu Thu",
		order: 0
	},
	{
		id: 606,
		name: "Huyện Đông Hưng",
		nameEn: "Dong Hung",
		order: 0
	},
	{
		id: 603,
		name: "Thành phố Thái Bình",
		nameEn: "Thai Binh",
		order: 0
	}
],
	"55": [
	{
		id: 619,
		name: "Huyện Phú Bình",
		nameEn: "Phu Binh",
		order: 0
	},
	{
		id: 614,
		name: "Huyện Phú Lương",
		nameEn: "Phu Luong",
		order: 0
	},
	{
		id: 616,
		name: "Huyện Võ Nhai",
		nameEn: "Vo Nhai",
		order: 0
	},
	{
		id: 617,
		name: "Huyện Đại Từ",
		nameEn: "Dai Tu",
		order: 0
	},
	{
		id: 613,
		name: "Huyện Định Hóa",
		nameEn: "Dinh Hoa",
		order: 0
	},
	{
		id: 615,
		name: "Huyện Đồng Hỷ",
		nameEn: "Dong Hy",
		order: 0
	},
	{
		id: 618,
		name: "Thành phố Phổ Yên",
		nameEn: "Pho Yen",
		order: 0
	},
	{
		id: 612,
		name: "Thành phố Sông Công",
		nameEn: "Song Cong",
		order: 0
	},
	{
		id: 611,
		name: "Thành phố Thái Nguyên",
		nameEn: "Thai Nguyen",
		order: 0
	}
],
	"56": [
	{
		id: 625,
		name: "Huyện Bá Thước",
		nameEn: "Ba Thuoc",
		order: 0
	},
	{
		id: 629,
		name: "Huyện Cẩm Thủy",
		nameEn: "Cam Thuy",
		order: 0
	},
	{
		id: 638,
		name: "Huyện Hoằng Hóa",
		nameEn: "Hoang Hoa",
		order: 0
	},
	{
		id: 631,
		name: "Huyện Hà Trung",
		nameEn: "Ha Trung",
		order: 0
	},
	{
		id: 639,
		name: "Huyện Hậu Lộc",
		nameEn: "Hau Loc",
		order: 0
	},
	{
		id: 627,
		name: "Huyện Lang Chánh",
		nameEn: "Lang Chanh",
		order: 0
	},
	{
		id: 623,
		name: "Huyện Mường Lát",
		nameEn: "Muong Lat",
		order: 0
	},
	{
		id: 640,
		name: "Huyện Nga Sơn",
		nameEn: "Nga Son",
		order: 0
	},
	{
		id: 628,
		name: "Huyện Ngọc Lặc",
		nameEn: "Ngoc Lac",
		order: 0
	},
	{
		id: 642,
		name: "Huyện Như Thanh",
		nameEn: "Nhu Thanh",
		order: 0
	},
	{
		id: 641,
		name: "Huyện Như Xuân",
		nameEn: "Nhu Xuan",
		order: 0
	},
	{
		id: 643,
		name: "Huyện Nông Cống",
		nameEn: "Nong Cong",
		order: 0
	},
	{
		id: 624,
		name: "Huyện Quan Hóa",
		nameEn: "Quan Hoa",
		order: 0
	},
	{
		id: 626,
		name: "Huyện Quan Sơn",
		nameEn: "Quan Son",
		order: 0
	},
	{
		id: 645,
		name: "Huyện Quảng Xương",
		nameEn: "Quang Xuong",
		order: 0
	},
	{
		id: 637,
		name: "Huyện Thiệu Hóa",
		nameEn: "Thieu Hoa",
		order: 0
	},
	{
		id: 635,
		name: "Huyện Thường Xuân",
		nameEn: "Thuong Xuan",
		order: 0
	},
	{
		id: 630,
		name: "Huyện Thạch Thành",
		nameEn: "Thach Thanh",
		order: 0
	},
	{
		id: 634,
		name: "Huyện Thọ Xuân",
		nameEn: "Tho Xuan",
		order: 0
	},
	{
		id: 636,
		name: "Huyện Triệu Sơn",
		nameEn: "Trieu Son",
		order: 0
	},
	{
		id: 632,
		name: "Huyện Vĩnh Lộc",
		nameEn: "Vinh Loc",
		order: 0
	},
	{
		id: 633,
		name: "Huyện Yên Định",
		nameEn: "Yen Dinh",
		order: 0
	},
	{
		id: 644,
		name: "Huyện Đông Sơn",
		nameEn: "Dong Son",
		order: 0
	},
	{
		id: 622,
		name: "Thành phố Sầm Sơn",
		nameEn: "Sam Son",
		order: 0
	},
	{
		id: 620,
		name: "Thành phố Thanh Hóa",
		nameEn: "Thanh Hoa",
		order: 0
	},
	{
		id: 621,
		name: "Thị xã Bỉm Sơn",
		nameEn: "Bim Son",
		order: 0
	},
	{
		id: 646,
		name: "Thị xã Nghi Sơn",
		nameEn: "Nghi Son",
		order: 0
	}
],
	"57": [
	{
		id: 653,
		name: "Huyện A Lưới",
		nameEn: "A Luoi",
		order: 0
	},
	{
		id: 655,
		name: "Huyện Nam Đông",
		nameEn: "Nam Dong",
		order: 0
	},
	{
		id: 648,
		name: "Huyện Phong Điền",
		nameEn: "Phong Dien",
		order: 0
	},
	{
		id: 654,
		name: "Huyện Phú Lộc",
		nameEn: "Phu Loc",
		order: 0
	},
	{
		id: 650,
		name: "Huyện Phú Vang",
		nameEn: "Phu Vang",
		order: 0
	},
	{
		id: 649,
		name: "Huyện Quảng Điền",
		nameEn: "Quang Dien",
		order: 0
	},
	{
		id: 647,
		name: "Thành phố Huế",
		nameEn: "Hue",
		order: 0
	},
	{
		id: 651,
		name: "Thị xã Hương Thủy",
		nameEn: "Huong Thuy",
		order: 0
	},
	{
		id: 652,
		name: "Thị xã Hương Trà",
		nameEn: "Huong Tra",
		order: 0
	}
],
	"58": [
	{
		id: 661,
		name: "Huyện Cai Lậy",
		nameEn: "Cai Lay District",
		order: 0
	},
	{
		id: 662,
		name: "Huyện Châu Thành",
		nameEn: "Chau Thanh",
		order: 0
	},
	{
		id: 663,
		name: "Huyện Chợ Gạo",
		nameEn: "Cho Gao",
		order: 0
	},
	{
		id: 660,
		name: "Huyện Cái Bè",
		nameEn: "Cai Be",
		order: 0
	},
	{
		id: 664,
		name: "Huyện Gò Công Tây",
		nameEn: "Go Cong Tay",
		order: 0
	},
	{
		id: 665,
		name: "Huyện Gò Công Đông",
		nameEn: "Go Cong Dong",
		order: 0
	},
	{
		id: 666,
		name: "Huyện Tân Phú Đông",
		nameEn: "Tan Phu Dong",
		order: 0
	},
	{
		id: 659,
		name: "Huyện Tân Phước",
		nameEn: "Tan Phuoc",
		order: 0
	},
	{
		id: 656,
		name: "Thành phố Mỹ Tho",
		nameEn: "My Tho",
		order: 0
	},
	{
		id: 658,
		name: "Thị xã Cai Lậy",
		nameEn: "Cai Lay Town",
		order: 0
	},
	{
		id: 657,
		name: "Thị xã Gò Công",
		nameEn: "Go Cong",
		order: 0
	}
],
	"59": [
	{
		id: 671,
		name: "Huyện Châu Thành",
		nameEn: "Chau Thanh",
		order: 0
	},
	{
		id: 668,
		name: "Huyện Càng Long",
		nameEn: "Cang Long",
		order: 0
	},
	{
		id: 669,
		name: "Huyện Cầu Kè",
		nameEn: "Cau Ke",
		order: 0
	},
	{
		id: 672,
		name: "Huyện Cầu Ngang",
		nameEn: "Cau Ngang",
		order: 0
	},
	{
		id: 674,
		name: "Huyện Duyên Hải",
		nameEn: "Duyen Hai District",
		order: 0
	},
	{
		id: 670,
		name: "Huyện Tiểu Cần",
		nameEn: "Tieu Can",
		order: 0
	},
	{
		id: 673,
		name: "Huyện Trà Cú",
		nameEn: "Tra Cu",
		order: 0
	},
	{
		id: 667,
		name: "Thành phố Trà Vinh",
		nameEn: "Tra Vinh",
		order: 0
	},
	{
		id: 675,
		name: "Thị xã Duyên Hải",
		nameEn: "Duyen Hai Town",
		order: 0
	}
],
	"60": [
	{
		id: 679,
		name: "Huyện Chiêm Hóa",
		nameEn: "Chiem Hoa",
		order: 0
	},
	{
		id: 680,
		name: "Huyện Hàm Yên",
		nameEn: "Ham Yen",
		order: 0
	},
	{
		id: 677,
		name: "Huyện Lâm Bình",
		nameEn: "Lam Binh",
		order: 0
	},
	{
		id: 678,
		name: "Huyện Na Hang",
		nameEn: "Na Hang",
		order: 0
	},
	{
		id: 682,
		name: "Huyện Sơn Dương",
		nameEn: "Son Duong",
		order: 0
	},
	{
		id: 681,
		name: "Huyện Yên Sơn",
		nameEn: "Yen Son",
		order: 0
	},
	{
		id: 676,
		name: "Thành phố Tuyên Quang",
		nameEn: "Tuyen Quang",
		order: 0
	}
],
	"61": [
	{
		id: 369,
		name: "Huyện An Biên",
		nameEn: "An Bien",
		order: 0
	},
	{
		id: 370,
		name: "Huyện An Minh",
		nameEn: "An Minh",
		order: 0
	},
	{
		id: 366,
		name: "Huyện Châu Thành",
		nameEn: "Chau Thanh",
		order: 0
	},
	{
		id: 375,
		name: "Huyện Giang Thành",
		nameEn: "Giang Thanh",
		order: 0
	},
	{
		id: 367,
		name: "Huyện Giồng Riềng",
		nameEn: "Giong Rieng",
		order: 0
	},
	{
		id: 368,
		name: "Huyện Gò Quao",
		nameEn: "Go Quao",
		order: 0
	},
	{
		id: 364,
		name: "Huyện Hòn Đất",
		nameEn: "Hon Dat",
		order: 0
	},
	{
		id: 373,
		name: "Huyện Kiên Hải",
		nameEn: "Kien Hai",
		order: 0
	},
	{
		id: 363,
		name: "Huyện Kiên Lương",
		nameEn: "Kien Luong",
		order: 0
	},
	{
		id: 365,
		name: "Huyện Tân Hiệp",
		nameEn: "Tan Hiep",
		order: 0
	},
	{
		id: 374,
		name: "Huyện U Minh Thượng",
		nameEn: "U Minh Thuong",
		order: 0
	},
	{
		id: 371,
		name: "Huyện Vĩnh Thuận",
		nameEn: "Vinh Thuan",
		order: 0
	},
	{
		id: 362,
		name: "Thành phố Hà Tiên",
		nameEn: "Ha Tien",
		order: 0
	},
	{
		id: 372,
		name: "Thành phố Phú Quốc",
		nameEn: "Phu Quoc",
		order: 0
	},
	{
		id: 361,
		name: "Thành phố Rạch Giá",
		nameEn: "Rach Gia",
		order: 0
	}
],
	"62": [
	{
		id: 686,
		name: "Huyện  Vũng Liêm",
		nameEn: " Vung Liem",
		order: 0
	},
	{
		id: 690,
		name: "Huyện Bình Tân",
		nameEn: "Binh Tan",
		order: 0
	},
	{
		id: 684,
		name: "Huyện Long Hồ",
		nameEn: "Long Ho",
		order: 0
	},
	{
		id: 685,
		name: "Huyện Mang Thít",
		nameEn: "Mang Thit",
		order: 0
	},
	{
		id: 687,
		name: "Huyện Tam Bình",
		nameEn: "Tam Binh",
		order: 0
	},
	{
		id: 689,
		name: "Huyện Trà Ôn",
		nameEn: "Tra On",
		order: 0
	},
	{
		id: 683,
		name: "Thành phố Vĩnh Long",
		nameEn: "Vinh Long",
		order: 0
	},
	{
		id: 688,
		name: "Thị xã Bình Minh",
		nameEn: "Binh Minh",
		order: 0
	}
],
	"63": [
	{
		id: 696,
		name: "Huyện Bình Xuyên",
		nameEn: "Binh Xuyen",
		order: 0
	},
	{
		id: 693,
		name: "Huyện Lập Thạch",
		nameEn: "Lap Thach",
		order: 0
	},
	{
		id: 699,
		name: "Huyện Sông Lô",
		nameEn: "Song Lo",
		order: 0
	},
	{
		id: 694,
		name: "Huyện Tam Dương",
		nameEn: "Tam Duong",
		order: 0
	},
	{
		id: 695,
		name: "Huyện Tam Đảo",
		nameEn: "Tam Dao",
		order: 0
	},
	{
		id: 698,
		name: "Huyện Vĩnh Tường",
		nameEn: "Vinh Tuong",
		order: 0
	},
	{
		id: 697,
		name: "Huyện Yên Lạc",
		nameEn: "Yen Lac",
		order: 0
	},
	{
		id: 692,
		name: "Thành phố Phúc Yên",
		nameEn: "Phuc Yen",
		order: 0
	},
	{
		id: 691,
		name: "Thành phố Vĩnh Yên",
		nameEn: "Vinh Yen",
		order: 0
	}
],
	"65": [
	{
		id: 702,
		name: "Huyện Lục Yên",
		nameEn: "Luc Yen",
		order: 0
	},
	{
		id: 704,
		name: "Huyện Mù Căng Chải",
		nameEn: "Mu Cang Chai",
		order: 0
	},
	{
		id: 706,
		name: "Huyện Trạm Tấu",
		nameEn: "Tram Tau",
		order: 0
	},
	{
		id: 705,
		name: "Huyện Trấn Yên",
		nameEn: "Tran Yen",
		order: 0
	},
	{
		id: 707,
		name: "Huyện Văn Chấn",
		nameEn: "Van Chan",
		order: 0
	},
	{
		id: 703,
		name: "Huyện Văn Yên",
		nameEn: "Van Yen",
		order: 0
	},
	{
		id: 708,
		name: "Huyện Yên Bình",
		nameEn: "Yen Binh",
		order: 0
	},
	{
		id: 700,
		name: "Thành phố Yên Bái",
		nameEn: "Yen Bai",
		order: 0
	},
	{
		id: 701,
		name: "Thị xã Nghĩa Lộ",
		nameEn: "Nghia Lo",
		order: 0
	}
],
	"69": [
	{
		id: 235,
		name: "Huyện Mường Chà",
		nameEn: "Muong Cha",
		order: 0
	},
	{
		id: 234,
		name: "Huyện Mường Nhé",
		nameEn: "Muong Nhe",
		order: 0
	},
	{
		id: 240,
		name: "Huyện Mường Ảng",
		nameEn: "Muong Ang",
		order: 0
	},
	{
		id: 241,
		name: "Huyện Nậm Pồ",
		nameEn: "Nam Po",
		order: 0
	},
	{
		id: 237,
		name: "Huyện Tuần Giáo",
		nameEn: "Tuan Giao",
		order: 0
	},
	{
		id: 236,
		name: "Huyện Tủa Chùa",
		nameEn: "Tua Chua",
		order: 0
	},
	{
		id: 238,
		name: "Huyện Điện Biên",
		nameEn: "Dien Bien",
		order: 0
	},
	{
		id: 239,
		name: "Huyện Điện Biên Đông",
		nameEn: "Dien Bien Dong",
		order: 0
	},
	{
		id: 232,
		name: "Thành phố Điện Biên Phủ",
		nameEn: "Dien Bien Phu",
		order: 0
	},
	{
		id: 233,
		name: "Thị Xã Mường Lay",
		nameEn: "Muong Lay",
		order: 0
	}
],
	"72": [
	{
		id: 327,
		name: "Huyện Châu Thành",
		nameEn: "Chau Thanh",
		order: 0
	},
	{
		id: 326,
		name: "Huyện Châu Thành A",
		nameEn: "Chau Thanh A",
		order: 0
	},
	{
		id: 330,
		name: "Huyện Long Mỹ",
		nameEn: "Long My District",
		order: 0
	},
	{
		id: 328,
		name: "Huyện Phụng Hiệp",
		nameEn: "Phung Hiep",
		order: 0
	},
	{
		id: 329,
		name: "Huyện Vị Thuỷ",
		nameEn: "Vi Thuy",
		order: 0
	},
	{
		id: 325,
		name: "Thành phố Ngã Bảy",
		nameEn: "Nga Bay",
		order: 0
	},
	{
		id: 324,
		name: "Thành phố Vị Thanh",
		nameEn: "Vi Thanh",
		order: 0
	},
	{
		id: 331,
		name: "Thị xã Long Mỹ",
		nameEn: "Long My Town",
		order: 0
	}
],
	"73": [
	{
		id: 226,
		name: "Huyện Cư Jút",
		nameEn: "Cu Jut",
		order: 0
	},
	{
		id: 228,
		name: "Huyện Krông Nô",
		nameEn: "Krong No",
		order: 0
	},
	{
		id: 231,
		name: "Huyện Tuy Đức",
		nameEn: "Tuy Duc",
		order: 0
	},
	{
		id: 225,
		name: "Huyện Đăk Glong",
		nameEn: "Dak Glong",
		order: 0
	},
	{
		id: 227,
		name: "Huyện Đắk Mil",
		nameEn: "Dak Mil",
		order: 0
	},
	{
		id: 230,
		name: "Huyện Đắk R'Lấp",
		nameEn: "Dak R'Lap",
		order: 0
	},
	{
		id: 229,
		name: "Huyện Đắk Song",
		nameEn: "Dak Song",
		order: 0
	},
	{
		id: 224,
		name: "Thành phố Gia Nghĩa",
		nameEn: "Gia Nghia",
		order: 0
	}
]
};

var highestDegreeData = [
	{
		id: 2,
		name: "Trung học",
		order: 2,
		nameEn: "High school"
	},
	{
		id: 3,
		name: "Trung cấp",
		order: 3,
		nameEn: "Associate’s degree"
	},
	{
		id: 4,
		name: "Cử nhân",
		order: 5,
		nameEn: "Bachelors"
	},
	{
		id: 5,
		name: "Thạc Sĩ",
		order: 9,
		nameEn: "Masters"
	},
	{
		id: 6,
		name: "Tiến sĩ",
		order: 12,
		nameEn: "Doctorate"
	},
	{
		id: 11,
		name: "Khác",
		order: 15,
		nameEn: "Others"
	},
	{
		id: 12,
		name: "Cao đẳng",
		order: 4,
		nameEn: "College"
	}
];

var languageProficiency = [
	{
		id: 1,
		name: "Tiếng Ả Rập",
		nameEn: "Arabic"
	},
	{
		id: 2,
		name: "Tiếng Bangladesh",
		nameEn: "Bengali"
	},
	{
		id: 3,
		name: "Tiếng Bungari",
		nameEn: "Bulgarian"
	},
	{
		id: 4,
		name: "Tiếng Miến Điện",
		nameEn: "Burmese"
	},
	{
		id: 5,
		name: "Tiếng Campuchia",
		nameEn: "Cambodian"
	},
	{
		id: 6,
		name: "tiếng Bisaya (Philippines)",
		nameEn: "Cebuano"
	},
	{
		id: 7,
		name: "Tiếng Trung (Quảng Đông)",
		nameEn: "Chinese (Cantonese)"
	},
	{
		id: 8,
		name: "Tiếng Trung (Quan Thoại)",
		nameEn: "Chinese (Mandarin)"
	},
	{
		id: 9,
		name: "Tiếng Séc",
		nameEn: "Czech"
	},
	{
		id: 10,
		name: "Tiếng Đan Mạch",
		nameEn: "Danish"
	},
	{
		id: 11,
		name: "Tiếng Hà Lan",
		nameEn: "Dutch"
	},
	{
		id: 12,
		name: "Tiếng Anh",
		nameEn: "English"
	},
	{
		id: 13,
		name: "Tiếng Phần Lan",
		nameEn: "Finnish"
	},
	{
		id: 14,
		name: "Tiếng Pháp",
		nameEn: "French"
	},
	{
		id: 15,
		name: "Tiếng Đức",
		nameEn: "German"
	},
	{
		id: 16,
		name: "Tiếng Hy Lạp",
		nameEn: "Greek"
	},
	{
		id: 17,
		name: "Tiếng Ấn Độ",
		nameEn: "Hindi"
	},
	{
		id: 18,
		name: "Tiếng Hungari",
		nameEn: "Hungarian"
	},
	{
		id: 19,
		name: "Tiếng Indonesia",
		nameEn: "Indonesian"
	},
	{
		id: 20,
		name: "Tiếng Ý",
		nameEn: "Italian"
	},
	{
		id: 21,
		name: "Tiếng Nhật",
		nameEn: "Japanese"
	},
	{
		id: 22,
		name: "Tiếng Java (Indonesia)",
		nameEn: "Javanese"
	},
	{
		id: 23,
		name: "Tiếng Hàn",
		nameEn: "Korean"
	},
	{
		id: 24,
		name: "Tiếng Lào",
		nameEn: "Laotian"
	},
	{
		id: 25,
		name: "Tiếng Mã Lai",
		nameEn: "Malay"
	},
	{
		id: 26,
		name: "Tiếng Na Uy",
		nameEn: "Norwegian"
	},
	{
		id: 27,
		name: "Tiếng Ba Lan",
		nameEn: "Polish"
	},
	{
		id: 28,
		name: "Tiếng Bồ Đào Nha",
		nameEn: "Portuguese"
	},
	{
		id: 29,
		name: "Tiếng Romania",
		nameEn: "Romanian"
	},
	{
		id: 30,
		name: "Tiếng Nga",
		nameEn: "Russian"
	},
	{
		id: 31,
		name: "Tiếng Tây Ban Nha",
		nameEn: "Spanish"
	},
	{
		id: 32,
		name: "Tiếng Thụy Điển",
		nameEn: "Swedish"
	},
	{
		id: 33,
		name: "Tiếng Tagalog (Philippines)",
		nameEn: "Tagolog"
	},
	{
		id: 34,
		name: "Tiếng Đài Loan",
		nameEn: "Taiwanese"
	},
	{
		id: 35,
		name: "Tiếng Thái",
		nameEn: "Thai"
	},
	{
		id: 36,
		name: "Tiếng Thổ Nhĩ Kỳ",
		nameEn: "Turkish"
	},
	{
		id: 37,
		name: "Tiếng UKraina",
		nameEn: "Ukranian"
	},
	{
		id: 38,
		name: "Tiếng Việt",
		nameEn: "Vietnamese"
	},
	{
		id: 39,
		name: "Khác",
		nameEn: "Other"
	}
];

var typeWorking = [
	{
		id: 1,
		name: "Toàn thời gian",
		nameEn: "Full-time"
	},
	{
		id: 2,
		name: "Bán thời gian",
		nameEn: "Part-time"
	},
	{
		id: 3,
		name: "Thực tập",
		nameEn: "Internship"
	},
	{
		id: 7,
		name: "Việc làm online",
		nameEn: "Online jobs"
	},
	{
		id: 4,
		name: "Nghề tự do",
		nameEn: "Freelancer"
	},
	{
		id: 5,
		name: "Hợp đồng thời vụ",
		nameEn: "Seasonal"
	},
	{
		id: 6,
		name: "Khác",
		nameEn: "Other"
	}
];
var salary = [
	{
		id: [
			0,
			500
		],
		name: "<= $500"
	},
	{
		id: [
			500,
			1000
		],
		name: "$500-$1000"
	},
	{
		id: [
			1000,
			1500
		],
		name: "$1000-$1500"
	},
	{
		id: [
			1500,
			2000
		],
		name: "$1500-$2000"
	},
	{
		id: [
			2000,
			3000
		],
		name: "$2000-$3000"
	},
	{
		id: [
			3000,
			0
		],
		name: ">=$3000"
	}
];
var level = [
	{
		id: 8,
		name: "Thực tập sinh/Sinh viên",
		nameEn: "Intern/Student"
	},
	{
		id: 1,
		name: "Mới tốt nghiệp",
		nameEn: "Fresher/Entry level"
	},
	{
		id: 5,
		name: "Nhân viên",
		nameEn: "Experienced (non-manager)"
	},
	{
		id: 7,
		name: "Trưởng phòng",
		nameEn: "Manager"
	},
	{
		id: 3,
		name: "Giám đốc và Cấp cao hơn",
		nameEn: "Director and above"
	}
];
var category = [
];
var categoryById = {
	"1": {
		name: "Kế toán",
		slug: "ke-toan"
	},
	"2": {
		name: "Hành chánh/Thư ký",
		slug: "hanh-chanh-thu-ky"
	},
	"3": {
		name: "Quảng cáo/Khuyến mãi/Đối ngoại",
		slug: "quang-cao-khuyen-mai-doi-ngoai"
	},
	"4": {
		name: "Nông nghiệp/Lâm nghiệp",
		slug: "nong-nghiep-lam-nghiep"
	},
	"5": {
		name: "Kiến trúc/Thiết kế nội thất ",
		slug: "kien-truc-thiet-ke-noi-that"
	},
	"6": {
		name: "Dược Phẩm/Công nghệ sinh học",
		slug: "duoc-pham-cong-nghe-sinh-hoc"
	},
	"7": {
		name: "Xây dựng",
		slug: "xay-dung"
	},
	"8": {
		name: "Tư vấn",
		slug: "tu-van"
	},
	"10": {
		name: "Mỹ Thuật/Nghệ Thuật/Thiết Kế",
		slug: "my-thuat-nghe-thuat-thiet-ke"
	},
	"11": {
		name: "Dịch vụ khách hàng",
		slug: "dich-vu-khach-hang"
	},
	"12": {
		name: "Giáo dục/Đào tạo",
		slug: "giao-duc-dao-tao"
	},
	"15": {
		name: "Mới tốt nghiệp",
		slug: "moi-tot-nghiep"
	},
	"16": {
		name: "Môi trường/Xử lý chất thải",
		slug: "moi-truong-xu-ly-chat-thai"
	},
	"17": {
		name: "Cấp quản lý điều hành",
		slug: "cap-quan-ly-dieu-hanh"
	},
	"18": {
		name: "Người nước ngoài/Việt Kiều",
		slug: "nguoi-nuoc-ngoai-viet-kieu"
	},
	"19": {
		name: "Xuất nhập khẩu",
		slug: "xuat-nhap-khau"
	},
	"21": {
		name: "Phi chính phủ/Phi lợi nhuận",
		slug: "phi-chinh-phu-phi-loi-nhuan"
	},
	"22": {
		name: "Y tế/Chăm sóc sức khỏe",
		slug: "y-te-cham-soc-suc-khoe"
	},
	"23": {
		name: "Nhân sự",
		slug: "nhan-su"
	},
	"24": {
		name: "Bảo hiểm",
		slug: "bao-hiem"
	},
	"25": {
		name: "Pháp lý",
		slug: "phap-ly"
	},
	"26": {
		name: "Sản Xuất",
		slug: "san-xuat"
	},
	"27": {
		name: "Marketing",
		slug: "marketing"
	},
	"28": {
		name: "Dầu khí",
		slug: "dau-khi"
	},
	"30": {
		name: "Bất động sản",
		slug: "bat-dong-san"
	},
	"32": {
		name: "Bán lẻ/Bán sỉ",
		slug: "ban-le-ban-si"
	},
	"33": {
		name: "Bán hàng",
		slug: "ban-hang"
	},
	"34": {
		name: "Bán hàng kỹ thuật",
		slug: "ban-hang-ky-thuat"
	},
	"35": {
		name: "IT - Phần mềm",
		slug: "it-phan-mem"
	},
	"36": {
		name: "Vận chuyển/Giao nhận",
		slug: "van-chuyen-giao-nhan"
	},
	"37": {
		name: "Hàng không/Du lịch",
		slug: "hang-khong-du-lich"
	},
	"39": {
		name: "Khác",
		slug: "khac"
	},
	"41": {
		name: "Viễn Thông",
		slug: "vien-thong"
	},
	"42": {
		name: "Ngân hàng",
		slug: "ngan-hang"
	},
	"43": {
		name: "Hóa học/Hóa sinh",
		slug: "hoa-hoc-hoa-sinh"
	},
	"47": {
		name: "Biên phiên dịch",
		slug: "bien-phien-dich"
	},
	"48": {
		name: "Truyền hình/Truyền thông/Báo chí",
		slug: "truyen-hinh-truyen-thong-bao-chi"
	},
	"49": {
		name: "Thu Mua/Vật Tư/Cung Vận",
		slug: "thu-mua-vat-tu-cung-van"
	},
	"51": {
		name: "Thời vụ/Hợp đồng ngắn hạn",
		slug: "thoi-vu-hop-dong-ngan-han"
	},
	"52": {
		name: "Dệt may/Da giày",
		slug: "det-may-da-giay"
	},
	"53": {
		name: "Kho vận",
		slug: "kho-van"
	},
	"54": {
		name: "Thực phẩm & Đồ uống",
		slug: "thuc-pham-do-uong"
	},
	"55": {
		name: "IT-Phần cứng/Mạng",
		slug: "it-phan-cung-mang"
	},
	"56": {
		name: "Chứng khoán",
		slug: "chung-khoan"
	},
	"57": {
		name: "Internet/Online Media",
		slug: "internet-online-media"
	},
	"58": {
		name: "Kiểm toán",
		slug: "kiem-toan"
	},
	"59": {
		name: "Tài chính/Đầu tư",
		slug: "tai-chinh-dau-tu"
	},
	"62": {
		name: "Hàng cao cấp",
		slug: "hang-cao-cap"
	},
	"63": {
		name: "Thời trang",
		slug: "thoi-trang"
	},
	"64": {
		name: "Điện/Điện tử",
		slug: "dien-dien-tu"
	},
	"65": {
		name: "Cơ khí",
		slug: "co-khi"
	},
	"66": {
		name: "Công nghệ cao",
		slug: "cong-nghe-cao"
	},
	"67": {
		name: "Tự động hóa/Ô tô",
		slug: "tu-dong-hoa-o-to"
	},
	"68": {
		name: "Sản phẩm công nghiệp",
		slug: "san-pham-cong-nghiep"
	},
	"69": {
		name: "Hoạch định/Dự án",
		slug: "hoach-dinh-du-an"
	},
	"70": {
		name: "QA/QC",
		slug: "qa-qc"
	},
	"71": {
		name: "Overseas Jobs",
		slug: "overseas-jobs"
	},
	"72": {
		name: "In ấn/ Xuất bản",
		slug: "in-an-xuat-ban"
	},
	"73": {
		name: "Nhà hàng/Khách sạn",
		slug: "nha-hang-khach-san"
	},
	"74": {
		name: "Hàng tiêu dùng",
		slug: "hang-tieu-dung"
	},
	"75": {
		name: "Hàng gia dụng",
		slug: "hang-gia-dung"
	},
	"76": {
		name: "Điện lạnh/Nhiệt lạnh",
		slug: "dien-lanh-nhiet-lanh"
	},
	"77": {
		name: "Địa chất/Khoáng sản",
		slug: "dia-chat-khoang-san"
	},
	"78": {
		name: "Bác sĩ",
		slug: "bac-si"
	},
	"79": {
		name: "Y sĩ/Hộ lý",
		slug: "y-si-ho-ly"
	},
	"80": {
		name: "Dược sĩ",
		slug: "duoc-si"
	},
	"81": {
		name: "Trình dược viên",
		slug: "trinh-duoc-vien"
	},
	"82": {
		name: "Hàng hải",
		slug: "hang-hai"
	},
	"83": {
		name: "An toàn lao động",
		slug: "an-toan-lao-dong"
	},
	"84": {
		name: "Bảo trì/Sửa chữa",
		slug: "bao-tri-sua-chua"
	},
	"156": {
		name: "Thương mại điện tử",
		slug: "thuong-mai-dien-tu"
	},
	"157": {
		name: "Tài chính công nghệ",
		slug: "tai-chinh-cong-nghe"
	}
};
var location = [
	{
		id: 70,
		name: "Quốc tế",
		nameEn: "International"
	},
	{
		id: 24,
		name: "Hà Nội",
		nameEn: "Ha Noi"
	},
	{
		id: 29,
		name: "Hồ Chí Minh",
		nameEn: "Ho Chi Minh"
	},
	{
		id: 28,
		name: "Hải Phòng",
		nameEn: "Hai Phong"
	},
	{
		id: 17,
		name: "Đà Nẵng",
		nameEn: "Da Nang"
	},
	{
		id: 15,
		name: "Cần Thơ",
		nameEn: "Can Tho"
	},
	{
		id: 3,
		name: "Bà Rịa - Vũng Tàu",
		nameEn: "Ba Ria - Vung Tau"
	},
	{
		id: 2,
		name: "An Giang",
		nameEn: "An Giang"
	},
	{
		id: 4,
		name: "Bắc Kạn",
		nameEn: "Bac Kan"
	},
	{
		id: 5,
		name: "Bắc Giang",
		nameEn: "Bac Giang"
	},
	{
		id: 6,
		name: "Bạc Liêu",
		nameEn: "Bac Lieu"
	},
	{
		id: 7,
		name: "Bắc Ninh",
		nameEn: "Bac Ninh"
	},
	{
		id: 8,
		name: "Bến Tre",
		nameEn: "Ben Tre"
	},
	{
		id: 10,
		name: "Bình Định",
		nameEn: "Binh Dinh"
	},
	{
		id: 11,
		name: "Bình Dương",
		nameEn: "Binh Duong"
	},
	{
		id: 12,
		name: "Bình Phước",
		nameEn: "Binh Phuoc"
	},
	{
		id: 13,
		name: "Bình Thuận",
		nameEn: "Binh Thuan"
	},
	{
		id: 14,
		name: "Cà Mau",
		nameEn: "Ca Mau"
	},
	{
		id: 16,
		name: "Cao Bằng",
		nameEn: "Cao Bang"
	},
	{
		id: 73,
		name: "Đắk Nông",
		nameEn: "Dak Nong"
	},
	{
		id: 18,
		name: "Đắk Lắk",
		nameEn: "Dak Lak"
	},
	{
		id: 71,
		name: "ĐBSCL",
		nameEn: "Mekong Delta"
	},
	{
		id: 69,
		name: "Điện Biên",
		nameEn: "Dien Bien"
	},
	{
		id: 19,
		name: "Đồng Nai",
		nameEn: "Dong Nai"
	},
	{
		id: 20,
		name: "Đồng Tháp",
		nameEn: "Dong Thap"
	},
	{
		id: 21,
		name: "Gia Lai",
		nameEn: "Gia Lai"
	},
	{
		id: 22,
		name: "Hà Giang",
		nameEn: "Ha Giang"
	},
	{
		id: 23,
		name: "Hà Nam",
		nameEn: "Ha Nam"
	},
	{
		id: 26,
		name: "Hà Tĩnh",
		nameEn: "Ha Tinh"
	},
	{
		id: 27,
		name: "Hải Dương",
		nameEn: "Hai Duong"
	},
	{
		id: 72,
		name: "Hậu Giang",
		nameEn: "Hau Giang"
	},
	{
		id: 30,
		name: "Hòa Bình",
		nameEn: "Hoa Binh"
	},
	{
		id: 32,
		name: "Hưng Yên",
		nameEn: "Hung Yen"
	},
	{
		id: 33,
		name: "Khánh Hòa",
		nameEn: "Khanh Hoa"
	},
	{
		id: 34,
		name: "Kon Tum",
		nameEn: "Kon Tum"
	},
	{
		id: 35,
		name: "Lai Châu",
		nameEn: "Lai Chau"
	},
	{
		id: 36,
		name: "Lâm Đồng",
		nameEn: "Lam Dong"
	},
	{
		id: 37,
		name: "Lạng Sơn",
		nameEn: "Lang Son"
	},
	{
		id: 38,
		name: "Lào Cai",
		nameEn: "Lao Cai"
	},
	{
		id: 39,
		name: "Long An",
		nameEn: "Long An"
	},
	{
		id: 40,
		name: "Nam Định",
		nameEn: "Nam Dinh"
	},
	{
		id: 41,
		name: "Nghệ An",
		nameEn: "Nghe An"
	},
	{
		id: 42,
		name: "Ninh Bình",
		nameEn: "Ninh Binh"
	},
	{
		id: 43,
		name: "Ninh Thuận",
		nameEn: "Ninh Thuan"
	},
	{
		id: 44,
		name: "Phú Thọ",
		nameEn: "Phu Tho"
	},
	{
		id: 45,
		name: "Phú Yên",
		nameEn: "Phu Yen"
	},
	{
		id: 46,
		name: "Quảng Bình",
		nameEn: "Quang Binh"
	},
	{
		id: 47,
		name: "Quảng Nam",
		nameEn: "Quang Nam"
	},
	{
		id: 48,
		name: "Quảng Ngãi",
		nameEn: "Quang Ngai"
	},
	{
		id: 49,
		name: "Quảng Ninh",
		nameEn: "Quang Ninh"
	},
	{
		id: 50,
		name: "Quảng Trị",
		nameEn: "Quang Tri"
	},
	{
		id: 51,
		name: "Sóc Trăng",
		nameEn: "Soc Trang"
	},
	{
		id: 52,
		name: "Sơn La",
		nameEn: "Son La"
	},
	{
		id: 53,
		name: "Tây Ninh",
		nameEn: "Tay Ninh"
	},
	{
		id: 54,
		name: "Thái Bình",
		nameEn: "Thai Binh"
	},
	{
		id: 55,
		name: "Thái Nguyên",
		nameEn: "Thai Nguyen"
	},
	{
		id: 56,
		name: "Thanh Hóa",
		nameEn: "Thanh Hoa"
	},
	{
		id: 57,
		name: "Thừa Thiên Huế",
		nameEn: "Thua Thien Hue"
	},
	{
		id: 58,
		name: "Tiền Giang",
		nameEn: "Tien Giang"
	},
	{
		id: 59,
		name: "Trà Vinh",
		nameEn: "Tra Vinh"
	},
	{
		id: 60,
		name: "Tuyên Quang",
		nameEn: "Tuyen Quang"
	},
	{
		id: 61,
		name: "Kiên Giang",
		nameEn: "Kien Giang"
	},
	{
		id: 62,
		name: "Vĩnh Long",
		nameEn: "Vinh Long"
	},
	{
		id: 63,
		name: "Vĩnh Phúc",
		nameEn: "Vinh Phuc"
	},
	{
		id: 65,
		name: "Yên Bái",
		nameEn: "Yen Bai"
	},
	{
		id: 66,
		name: "Khác",
		nameEn: "Other"
	}
];
var locationById = {
	"2": {
		name: "An Giang",
		slug: "an-giang"
	},
	"3": {
		name: "Bà Rịa - Vũng Tàu",
		slug: "ba-ria-vung-tau"
	},
	"4": {
		name: "Bắc Kạn",
		slug: "bac-kan"
	},
	"5": {
		name: "Bắc Giang",
		slug: "bac-giang"
	},
	"6": {
		name: "Bạc Liêu",
		slug: "bac-lieu"
	},
	"7": {
		name: "Bắc Ninh",
		slug: "bac-ninh"
	},
	"8": {
		name: "Bến Tre",
		slug: "ben-tre"
	},
	"9": {
		name: "Biên Hòa",
		slug: "bien-hoa"
	},
	"10": {
		name: "Bình Định",
		slug: "binh-dinh"
	},
	"11": {
		name: "Bình Dương",
		slug: "binh-duong"
	},
	"12": {
		name: "Bình Phước",
		slug: "binh-phuoc"
	},
	"13": {
		name: "Bình Thuận",
		slug: "binh-thuan"
	},
	"14": {
		name: "Cà Mau",
		slug: "ca-mau"
	},
	"15": {
		name: "Cần Thơ",
		slug: "can-tho"
	},
	"16": {
		name: "Cao Bằng",
		slug: "cao-bang"
	},
	"17": {
		name: "Đà Nẵng",
		slug: "da-nang"
	},
	"18": {
		name: "Đắk Lắk",
		slug: "dak-lak"
	},
	"19": {
		name: "Đồng Nai",
		slug: "dong-nai"
	},
	"20": {
		name: "Đồng Tháp",
		slug: "dong-thap"
	},
	"21": {
		name: "Gia Lai",
		slug: "gia-lai"
	},
	"22": {
		name: "Hà Giang",
		slug: "ha-giang"
	},
	"23": {
		name: "Hà Nam",
		slug: "ha-nam"
	},
	"24": {
		name: "Hà Nội",
		slug: "ha-noi"
	},
	"25": {
		name: "Hà Tây",
		slug: "ha-tay"
	},
	"26": {
		name: "Hà Tĩnh",
		slug: "ha-tinh"
	},
	"27": {
		name: "Hải Dương",
		slug: "hai-duong"
	},
	"28": {
		name: "Hải Phòng",
		slug: "hai-phong"
	},
	"29": {
		name: "Hồ Chí Minh",
		slug: "ho-chi-minh"
	},
	"30": {
		name: "Hòa Bình",
		slug: "hoa-binh"
	},
	"31": {
		name: "Huế",
		slug: "hue"
	},
	"32": {
		name: "Hưng Yên",
		slug: "hung-yen"
	},
	"33": {
		name: "Khánh Hòa",
		slug: "khanh-hoa"
	},
	"34": {
		name: "Kon Tum",
		slug: "kon-tum"
	},
	"35": {
		name: "Lai Châu",
		slug: "lai-chau"
	},
	"36": {
		name: "Lâm Đồng",
		slug: "lam-dong"
	},
	"37": {
		name: "Lạng Sơn",
		slug: "lang-son"
	},
	"38": {
		name: "Lào Cai",
		slug: "lao-cai"
	},
	"39": {
		name: "Long An",
		slug: "long-an"
	},
	"40": {
		name: "Nam Định",
		slug: "nam-dinh"
	},
	"41": {
		name: "Nghệ An",
		slug: "nghe-an"
	},
	"42": {
		name: "Ninh Bình",
		slug: "ninh-binh"
	},
	"43": {
		name: "Ninh Thuận",
		slug: "ninh-thuan"
	},
	"44": {
		name: "Phú Thọ",
		slug: "phu-tho"
	},
	"45": {
		name: "Phú Yên",
		slug: "phu-yen"
	},
	"46": {
		name: "Quảng Bình",
		slug: "quang-binh"
	},
	"47": {
		name: "Quảng Nam",
		slug: "quang-nam"
	},
	"48": {
		name: "Quảng Ngãi",
		slug: "quang-ngai"
	},
	"49": {
		name: "Quảng Ninh",
		slug: "quang-ninh"
	},
	"50": {
		name: "Quảng Trị",
		slug: "quang-tri"
	},
	"51": {
		name: "Sóc Trăng",
		slug: "soc-trang"
	},
	"52": {
		name: "Sơn La",
		slug: "son-la"
	},
	"53": {
		name: "Tây Ninh",
		slug: "tay-ninh"
	},
	"54": {
		name: "Thái Bình",
		slug: "thai-binh"
	},
	"55": {
		name: "Thái Nguyên",
		slug: "thai-nguyen"
	},
	"56": {
		name: "Thanh Hóa",
		slug: "thanh-hoa"
	},
	"57": {
		name: "Thừa Thiên Huế",
		slug: "thua-thien-hue"
	},
	"58": {
		name: "Tiền Giang",
		slug: "tien-giang"
	},
	"59": {
		name: "Trà Vinh",
		slug: "tra-vinh"
	},
	"60": {
		name: "Tuyên Quang",
		slug: "tuyen-quang"
	},
	"61": {
		name: "Kiên Giang",
		slug: "kien-giang"
	},
	"62": {
		name: "Vĩnh Long",
		slug: "vinh-long"
	},
	"63": {
		name: "Vĩnh Phúc",
		slug: "vinh-phuc"
	},
	"65": {
		name: "Yên Bái",
		slug: "yen-bai"
	},
	"66": {
		name: "Khác",
		slug: "khac"
	},
	"69": {
		name: "Điện Biên",
		slug: "dien-bien"
	},
	"70": {
		name: "Quốc tế",
		slug: "quoc-te"
	},
	"71": {
		name: "ĐBSCL",
		slug: "dbscl"
	},
	"72": {
		name: "Hậu Giang",
		slug: "hau-giang"
	},
	"73": {
		name: "Đắk Nông",
		slug: "dak-nong"
	}
};
var benefit = [
	{
		id: 1,
		name: "Thưởng",
		nameEn: "Bonus"
	},
	{
		id: 2,
		name: "Khám sức khoẻ",
		nameEn: "Healthcare Plan"
	},
	{
		id: 3,
		name: "Nghỉ phép",
		nameEn: "Paid Leave"
	},
	{
		id: 4,
		name: "Đào tạo",
		nameEn: "Training"
	},
	{
		id: 5,
		name: "Giải thưởng",
		nameEn: "Awards"
	},
	{
		id: 6,
		name: "Thư viện",
		nameEn: "Library"
	},
	{
		id: 7,
		name: "Laptop",
		nameEn: "Laptop"
	},
	{
		id: 8,
		name: "Điện thoại",
		nameEn: "Mobile"
	},
	{
		id: 9,
		name: "Du lịch",
		nameEn: "Travel"
	},
	{
		id: 10,
		name: "Hoạt động nhóm",
		nameEn: "Team Activities"
	},
	{
		id: 11,
		name: "Trợ cấp đi lại",
		nameEn: "Transportation"
	},
	{
		id: 12,
		name: "Căn-tin",
		nameEn: "Canteen"
	},
	{
		id: 13,
		name: "Phiếu giảm giá",
		nameEn: "Vouchers"
	},
	{
		id: 14,
		name: "Trông trẻ",
		nameEn: "Kindergarten"
	},
	{
		id: 15,
		name: "Khác",
		nameEn: "Others"
	}
];
var processedData = {
	typeWorking: typeWorking,
	salary: salary,
	level: level,
	category: category,
	categoryById: categoryById,
	location: location,
	locationById: locationById,
	benefit: benefit
};

var data = [
	{
		id: 1,
		type: "groupJobFunction",
		attributes: {
			nameVi: "Giáo Dục",
			nameEn: "Academic/Education"
		},
		relationships: {
			jobFunction: {
				data: [
					{
						id: 1,
						type: "jobFunction"
					},
					{
						id: 2,
						type: "jobFunction"
					}
				]
			}
		}
	}
];
var included = [
	{
		id: 1,
		type: "jobFunction",
		attributes: {
			nameVi: "Giáo Dục",
			nameEn: "Tư Vấn Giáo Dục"
		}
	},
	{
		id: 2,
		type: "jobFunction",
		attributes: {
			nameVi: "Quản Lý Giáo Dục",
			nameEn: "Educational Management"
		}
	}
];
var jobFunctionData = {
	data: data,
	included: included
};

var domain = {
  staging: 'https://staging-ms.vietnamworks.com',
  release: 'https://release-ms.vietnamworks.com',
  production: 'https://ms.vietnamworks.com'
};

var InitialDataProvider = /*#__PURE__*/function () {
  function InitialDataProvider() {
    this.datasetLoadStatus = {
      industry: false,
      jobFunction: false,
      level: false,
      jobFunctionCount: false
    };
    this.initDatasetRequest = {
      industry: false,
      jobFunction: false,
      level: false,
      jobFunctionCount: false
    };
    this.queuedDataSetRequest = [];
    this._initialData = processedData;
  }

  var _proto = InitialDataProvider.prototype;

  _proto.emitDatasetLoaded = function emitDatasetLoaded(datasetName) {
    var _this = this;

    if (this.datasetLoadStatus[datasetName]) {
      return;
    }

    this.datasetLoadStatus[datasetName] = true;
    this.queuedDataSetRequest.filter(function (_ref) {
      var name = _ref.name;
      return name === datasetName;
    }).forEach(function (_ref2) {
      var fulfilled = _ref2.fulfilled;
      return fulfilled(_this._initialData[datasetName]);
    });
    this.queuedDataSetRequest = this.queuedDataSetRequest.filter(function (_ref3) {
      var name = _ref3.name;
      return name !== datasetName;
    });
  };

  _proto.getDatasetAsync = function getDatasetAsync(datasetName) {
    var _this2 = this;

    if (this.datasetLoadStatus[datasetName]) {
      return Promise.resolve(this._initialData[datasetName]);
    }

    return new Promise(function (resolve) {
      _this2.queuedDataSetRequest.push({
        fulfilled: resolve,
        name: datasetName
      });
    });
  };

  _proto.initSelectData = function initSelectData(_ref4) {
    var selectDataKey = _ref4.selectDataKey,
        mode = _ref4.mode,
        _ref4$langCode = _ref4.langCode,
        langCode = _ref4$langCode === void 0 ? ELanguage.VI : _ref4$langCode;

    try {
      var _this4 = this;

      var initDataDict = {
        industry: _this4.initIndustryData.bind(_this4),
        jobFunction: _this4.initJobFunctionData.bind(_this4),
        level: _this4.initLevelListData.bind(_this4),
        jobFunctionCount: _this4.initJobFunctionCountData.bind(_this4)
      };
      var notRequestedDatasetList = selectDataKey.filter(function (key) {
        return !_this4.initDatasetRequest[key];
      });
      notRequestedDatasetList.forEach(function (requestDatasetKey) {
        return _this4.initDatasetRequest[requestDatasetKey] = true;
      });
      return Promise.resolve(Promise.allSettled(notRequestedDatasetList.map(function (key) {
        return initDataDict[key](mode, langCode);
      }))).then(function () {});
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.initLevelListData = function initLevelListData(mode) {
    if (mode === void 0) {
      mode = 'production';
    }

    try {
      var _this6 = this;

      var returnList = [];
      var apiUrl = (domain[mode] || domain.production) + "/meta/v1.0/job-levels";
      return Promise.resolve(fetch(apiUrl, {
        method: 'GET'
      })).then(function (response) {
        return Promise.resolve(response.json()).then(function (responseData) {
          var _responseData$data, _responseData$data$re;

          if (responseData === null || responseData === undefined) {
            return;
          }

          var rawLevelList = ((_responseData$data = responseData.data) === null || _responseData$data === void 0 ? void 0 : (_responseData$data$re = _responseData$data.relationships) === null || _responseData$data$re === void 0 ? void 0 : _responseData$data$re.data) || [];
          rawLevelList.map(function (levelInfo) {
            var levelItem = {
              id: levelInfo.id,
              name: levelInfo.attributes.nameVi,
              nameEn: levelInfo.attributes.nameEn
            };
            returnList.push(levelItem);
          });

          if (returnList.length > 0) {
            _this6._initialData.level = returnList;
          }

          _this6.emitDatasetLoaded('level');
        });
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.initIndustryData = function initIndustryData(mode) {
    if (mode === void 0) {
      mode = 'production';
    }

    try {
      var _this8 = this;

      var data = [];
      var apiUrl = (domain[mode] || domain.production) + "/meta/v1.0/company-industries";
      return Promise.resolve(fetch(apiUrl, {
        method: 'GET'
      })).then(function (res) {
        return Promise.resolve(res.json()).then(function (resData) {
          var _resData$data, _resData$data$relatio;

          if (resData === null || resData === undefined) {
            return;
          }

          var listIndustry = ((_resData$data = resData.data) === null || _resData$data === void 0 ? void 0 : (_resData$data$relatio = _resData$data.relationships) === null || _resData$data$relatio === void 0 ? void 0 : _resData$data$relatio.data) || [];
          listIndustry.map(function (item) {
            var formatItem = {
              id: item.id,
              name: item.attributes.nameVi,
              nameEn: item.attributes.nameEn
            };
            data.push(formatItem);
          });

          if (data.length > 0) {
            _this8._initialData.industry = data.sort(function (a, b) {
              return a.name < b.name ? -1 : 1;
            });
          }

          _this8.emitDatasetLoaded('industry');
        });
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.initJobFunctionData = function initJobFunctionData(mode, langCode) {
    if (mode === void 0) {
      mode = 'production';
    }

    try {
      var _this10 = this;

      var apiUrl = (domain[mode] || domain.production) + "/meta/v1.2/job-functions";
      return Promise.resolve(fetch(apiUrl, {
        method: 'GET'
      }).then(function (res) {
        return res.json();
      })["catch"](function (e) {
        return console.log(e);
      })).then(function (res) {
        var _res$meta;

        var defaultData = jobFunctionData;

        if ((res === null || res === void 0 ? void 0 : (_res$meta = res.meta) === null || _res$meta === void 0 ? void 0 : _res$meta.statusCode) === 200) {
          defaultData = {
            data: res.data,
            included: res.included
          };
        }

        var parent = [];
        var child = {};
        var otherItem = defaultData.data.pop();
        var sortedData = defaultData.data.sort(function (a, b) {
          if (langCode === ELanguage.VI) {
            if (a.attributes.nameVi < b.attributes.nameVi) {
              return -1;
            }

            return 0;
          }

          if (a.attributes.nameEn < b.attributes.nameEn) {
            return -1;
          }

          return 0;
        });

        if (otherItem) {
          sortedData.push(otherItem);
        }

        sortedData.map(function (item) {
          var listChild = (item.relationships.jobFunction.data || []).map(function (i) {
            var jobFunction = defaultData.included.find(function (job) {
              return job.id === i.id;
            });

            if (jobFunction) {
              return {
                id: i.id,
                name: jobFunction.attributes.nameVi,
                nameEn: jobFunction.attributes.nameEn
              };
            } else {
              return {
                id: i.id,
                name: '',
                nameEn: ''
              };
            }
          }).sort(function (a, b) {
            if (langCode === ELanguage.VI) {
              if (a.name < b.name) {
                return -1;
              }

              return 0;
            }

            if (a.nameEn < b.nameEn) {
              return -1;
            }

            return 0;
          });
          var parentItem = {
            id: item.id,
            name: item.attributes.nameVi,
            nameEn: item.attributes.nameEn
          };
          parent.push(parentItem);
          child[item.id] = listChild;
        });
        _this10._initialData.jobFunction = {
          parent: parent,
          child: child
        };

        _this10.emitDatasetLoaded('jobFunction');
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.initJobFunctionCountData = function initJobFunctionCountData(mode) {
    if (mode === void 0) {
      mode = 'production';
    }

    try {
      var _this12 = this;

      var apiUrl = (domain[mode] || domain.production) + "/job-search/v1.0/count-jobs-by-job-function";
      return Promise.resolve(fetch(apiUrl, {
        method: 'POST'
      }).then(function (res) {
        return res.json();
      })["catch"](function (e) {
        return console.log(e);
      })).then(function (res) {
        var _res$meta2;

        var defaultData = [];

        if ((res === null || res === void 0 ? void 0 : (_res$meta2 = res.meta) === null || _res$meta2 === void 0 ? void 0 : _res$meta2.code) === 200) {
          defaultData = res.data;
        }

        _this12._initialData.jobFunctionCount = defaultData;

        _this12.emitDatasetLoaded('jobFunctionCount');
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.getSelectData = function getSelectData() {
    return this._initialData;
  };

  _proto.getBenefits = function getBenefits() {
    return this._initialData.benefit;
  };

  _proto.getIndustries = function getIndustries() {
    return this._initialData.industry || [];
  };

  _proto.getLocations = function getLocations() {
    return this._initialData.location;
  };

  _proto.getDistricts = function getDistricts() {
    return districtData;
  };

  _proto.getChildrenIdsFromNestedIds = function getChildrenIdsFromNestedIds(parent, datasetName) {
    var dataset = this.getDatasetFromName(datasetName);
    return (Array.isArray(parent) ? parent : [parent]).map(function (parent) {
      var _parent$childrenIds, _parent$childrenIds2;

      return (parent === null || parent === void 0 ? void 0 : (_parent$childrenIds = parent.childrenIds) === null || _parent$childrenIds === void 0 ? void 0 : _parent$childrenIds.length) && !(parent === null || parent === void 0 ? void 0 : (_parent$childrenIds2 = parent.childrenIds) === null || _parent$childrenIds2 === void 0 ? void 0 : _parent$childrenIds2.includes(-1)) ? parent === null || parent === void 0 ? void 0 : parent.childrenIds : ((dataset === null || dataset === void 0 ? void 0 : dataset.child[parent === null || parent === void 0 ? void 0 : parent.parentId]) || []).map(function (child) {
        return child === null || child === void 0 ? void 0 : child.id;
      });
    }).flat();
  };

  _proto.getNestedIdsFromChildrenIds = function getNestedIdsFromChildrenIds(childrenIds, jobFunction) {
    var nestedIds = [];
    Object.entries(jobFunction.child).map(function (_ref5) {
      var key = _ref5[0],
          value = _ref5[1];
      var listChild = value.filter(function (item) {
        return childrenIds.includes(item.id);
      });

      if (listChild.length > 0) {
        nestedIds.push({
          parentId: Number(key),
          childrenIds: listChild.map(function (item) {
            return item.id;
          })
        });
      }

      return;
    });
    return nestedIds;
  };

  _proto.getDatasetFromName = function getDatasetFromName(datasetName) {
    var _ENestedDatasetName$J;

    return (_ENestedDatasetName$J = {}, _ENestedDatasetName$J[_microfrontends_react_components__WEBPACK_IMPORTED_MODULE_2__/* .ENestedDatasetName.JOB_FUNCTION */ .X.JOB_FUNCTION] = this._initialData.jobFunction, _ENestedDatasetName$J)[datasetName];
  };

  _proto.getChildrenNameFromNestedId = function getChildrenNameFromNestedId(nestedId, datasetName, language) {
    var dataset = this.getDatasetFromName(datasetName);
    var jobFunctionItem = dataset.child[nestedId.parentId][0];

    if (nestedId.childrenIds[0] !== -1) {
      jobFunctionItem = dataset.child[nestedId.parentId].find(function (child) {
        return child.id === nestedId.childrenIds[0];
      }) || dataset.child[nestedId.parentId][0];
    }

    return language === ELanguage.EN ? jobFunctionItem.nameEn : jobFunctionItem.name;
  };

  _proto.getDistrictsByCity = function getDistrictsByCity(cityId) {
    return districtData[cityId] || null;
  };

  _proto.getFlattenDistricts = function getFlattenDistricts() {
    var flattenDistrictData = [];

    if (!this._flattenDistrictData) {
      Object.keys(districtData).forEach(function (key) {
        flattenDistrictData = [].concat(flattenDistrictData, districtData[key]);
      });
      this._flattenDistrictData = flattenDistrictData;
    }

    return this._flattenDistrictData;
  };

  _proto.getDistrictNameFromIds = function getDistrictNameFromIds(districtId) {
    var flattenDistricts = this.getFlattenDistricts();
    return flattenDistricts.find(function (district) {
      return district.id === districtId;
    }) || null;
  };

  _proto.getCategories = function getCategories() {
    return this._initialData.category;
  };

  _proto.getLevels = function getLevels() {
    return this._initialData.level || [];
  };

  _proto.getSalaries = function getSalaries() {
    return this._initialData.salary;
  };

  _proto.getTypeWorking = function getTypeWorking() {
    return this._initialData.typeWorking;
  };

  _proto.getCountries = function getCountries() {
    return countryData;
  };

  _proto.getJobFunction = function getJobFunction() {
    return this._initialData.jobFunction || {
      parent: [],
      child: {}
    };
  };

  _proto.getJobFunctionCount = function getJobFunctionCount() {
    return this._initialData.jobFunctionCount || [];
  };

  _proto.getLoadedJobFunctionDataset = function getLoadedJobFunctionDataset() {
    return this.getDatasetAsync('jobFunction');
  };

  _proto.getLanguageProficiency = function getLanguageProficiency() {
    return languageProficiency;
  };

  _proto.getLanguageFromId = function getLanguageFromId(id) {
    return languageProficiency.find(function (item) {
      return item.id === id;
    }) || null;
  };

  _proto.getCountryNameFromId = function getCountryNameFromId(id) {
    return countryData.find(function (item) {
      return item.id === id;
    }) || null;
  };

  _proto.getHighestDegrees = function getHighestDegrees() {
    return highestDegreeData;
  };

  _proto.getLocationNameFromId = function getLocationNameFromId(id) {
    var foundItem = this._initialData.location.filter(function (item) {
      return item.id === id;
    });

    return foundItem[0];
  };

  _proto.getLocationNameFromIds = function getLocationNameFromIds(ids) {
    if (typeof ids !== 'object') {
      ids = [ids];
    }

    return this._initialData.location.filter(function (item) {
      return ids.includes(item.id);
    });
  };

  _proto.getCategoryNameFromId = function getCategoryNameFromId(id) {
    var foundItem = this._initialData.category.filter(function (item) {
      return item.id === id;
    });

    return foundItem[0];
  };

  _proto.getCategoryNameFromIds = function getCategoryNameFromIds(ids) {
    var _this13 = this;

    var returnList = [];

    if (typeof ids === 'object') {
      ids.map(function (idItem) {
        var foundItem = _this13._initialData.category.filter(function (categoryItem) {
          return categoryItem.id === idItem;
        });

        if (foundItem.length > 0) {
          returnList.push(foundItem[0]);
        }
      });
    } else {
      returnList.push(this.getCategoryNameFromId(ids));
    }

    return returnList;
  };

  _proto.getLevelNameFromId = function getLevelNameFromId(id) {
    var foundItem = this._initialData.level.filter(function (item) {
      return item.id === id;
    });

    return foundItem[0];
  };

  _proto.getIndustryNameFromId = function getIndustryNameFromId(id, language) {
    var foundItem = this._initialData.industry.find(function (item) {
      return item.id === id;
    });

    if (foundItem) {
      return language === ELanguage.EN ? foundItem.nameEn : foundItem.name;
    }

    return '';
  };

  _proto.getHighestDegreeFromId = function getHighestDegreeFromId(id) {
    var foundItem = highestDegreeData.filter(function (item) {
      return item.id === id;
    });
    return foundItem[0];
  };

  _proto.exportProvider = function exportProvider() {
    return {
      getLocations: this.getLocations.bind(this),
      getDistricts: this.getDistricts.bind(this),
      getChildrenIdsFromNestedIds: this.getChildrenIdsFromNestedIds.bind(this),
      getLoadedJobFunctionDataset: this.getLoadedJobFunctionDataset.bind(this),
      getDatasetAsync: this.getDatasetAsync.bind(this),
      initSelectData: this.initSelectData.bind(this)
    };
  };

  return InitialDataProvider;
}();

var initialDataProvider = new InitialDataProvider();

var LOGIN_POPUP = 'LOGIN_POPUP';

var _PAGE_UTM_MEDIUM_MAPP;
var PAGE_UTM_MEDIUM_MAPPING = (_PAGE_UTM_MEDIUM_MAPP = {}, _PAGE_UTM_MEDIUM_MAPP[EPages.HOME_PAGE] = 'Home_Page', _PAGE_UTM_MEDIUM_MAPP[EPages.SEARCH_RESULT] = 'Job_Search', _PAGE_UTM_MEDIUM_MAPP[EPages.TOP_MANAGEMENT_JOBS] = 'MANAGEMENT_JOBS', _PAGE_UTM_MEDIUM_MAPP[EPages.INTERVIEW] = 'Interview_Search', _PAGE_UTM_MEDIUM_MAPP[EPages.SALARY] = 'Salary_Search', _PAGE_UTM_MEDIUM_MAPP[EPages.COMPANY_LIST] = 'All_Company', _PAGE_UTM_MEDIUM_MAPP[EPages.JOB_DETAIL] = 'Job_Detail', _PAGE_UTM_MEDIUM_MAPP[EPages.MY_CAREER_CENTER] = 'My_Career_Center', _PAGE_UTM_MEDIUM_MAPP[EPages.MY_PROFILE] = 'My_Profile', _PAGE_UTM_MEDIUM_MAPP[EPages.WOW_CV] = 'WowCV', _PAGE_UTM_MEDIUM_MAPP[EPages.OTHER] = 'Other_Pages', _PAGE_UTM_MEDIUM_MAPP);
var DROPDOWN_ZINDEX = 150;
var headerMenuViPath = {
  Jobs: 'Việc làm',
  Home: 'Trang chủ',
  'Management Jobs': 'Việc làm quản lý',
  Companies: 'Công ty',
  Learning: 'Khoá học',
  Employers: 'Nhà tuyển dụng',
  employerTitle: 'Nhà tuyển dụng',
  employerSubTitle: 'Tìm kiếm nhân tài',
  employerPath: 'https://employer.vietnamworks.com/?lang=1',
  searchJobsPath: '/tim-viec-lam/tim-tat-ca-viec-lam',
  seoLandingPagePath: '/tim-viec-lam',
  companyListPath: '/danh-sach-cong-ty',
  topJobsPath: '/viec-lam-quan-ly',
  dashboardPath: '/quan-ly-nghe-nghiep/tong-quan',
  myJobsPath: '/quan-ly-nghe-nghiep/viec-lam-cua-toi',
  saveJobsPath: '/quan-ly-nghe-nghiep/viec-lam-cua-toi',
  jobAlertsPath: '/quan-ly-nghe-nghiep/thong-bao-viec-lam',
  myCompaniesPath: '/quan-ly-nghe-nghiep/cong-ty-cua-toi',
  accountSettingPath: '/quan-ly-tai-khoan',
  referralCandidatesPath: '/quan-ly-nghe-nghiep/gioi-thieu-ung-vien',
  profileSettingsPath: '/ho-so?tab=profile-settings',
  myProfilePath: '/ho-so',
  salaryConverterPath: '/tinh-luong-gross-net',
  careerPath: '/lo-trinh-su-nghiep',
  numerologyPath: '/nhan-so-hoc',
  empowerGrowth: '/empower-growth-2023',
  orderManagementPath: '/quan-ly-don-hang',
  chargeStationPath: '/tram-sac',
  'My Career Center': 'Quản Lý Nghề Nghiệp',
  Dashboard: 'Quản lý hồ sơ',
  'Update Profile': 'Cập nhập hồ sơ',
  'Update CV': 'Cập nhập hồ sơ',
  'Need helps? Read FAQ': 'Câu hỏi thường gặp',
  'Saved jobs': 'Việc làm của tôi',
  'Job alerts': 'Thông báo việc làm',
  'Who viewed my profile': 'Nhà tuyển dụng xem hồ sơ',
  'Account settings': 'Quản lý tài khoản',
  Logout: 'Thoát',
  changeLanguageTo: 'English',
  'Ready for applying jobs?': 'Sẵn sàng nộp hồ sơ?',
  'Your name': 'Tên của bạn',
  'Your job title': 'Chức danh của bạn',
  'Thousands of jobs are waiting for you.': 'Hàng ngàn công việc đang chờ bạn.',
  'Job Seeker Login': 'Người tìm việc đăng nhập',
  Login: 'Đăng nhập',
  Facebook: 'Facebook',
  Google: 'Google',
  'Register new account': 'Tạo tài khoản mới',
  Registration: 'Đăng ký thành viên',
  Notifications: 'Thông báo',
  'Notifications & News': 'Thông Báo & Tin Tức',
  'Jobs for you': 'Việc làm',
  News: 'Tin tức',
  LoginIconLabel: 'Đăng nhập',
  Expires: 'Hết hạn',
  'expires in': 'hết hạn trong',
  today: 'hôm nay',
  'day ago': 'ngày trước',
  'days ago': 'ngày trước',
  days: 'ngày',
  day: 'ngày',
  'saved jobs': 'đã lưu',
  'viewed your profile.': 'đã xem hồ sơ của bạn.',
  'viewed your profile': 'đã xem hồ sơ của bạn',
  'viewed your application for': 'vừa xem hồ sơ ứng tuyển công việc',
  'Keep your profile updated to reach dream jobs easier.': 'Làm mới hồ sơ để tìm thấy công việc mơ ước dễ dàng hơn.',
  'Keep your CV updated to reach dream.': 'Cập nhật hồ sơ để tìm thấy công việc phù hợp.',
  'Get notifications for news or jobs': 'Nhận thông báo tin tức hoặc công việc',
  'Which employers have viewed your profile in the last 7 days?': 'Nhà tuyển dụng nào đã quan tâm đến bạn trong 7 ngày vừa qua?',
  'And more information, hot jobs waiting for you.': 'Các thông tin, việc làm hấp dẫn đang chờ bạn.',
  'LOGIN NOW!': 'ĐĂNG NHẬP NGAY!',
  'Your profile hasn’t been viewed by any employer for the last 7 days': 'Hồ sơ của bạn rất ít tương tác trong 7 ngày qua',
  'Update your profile for more opportunities': 'Cập nhật hồ sơ để nâng cao cơ hội tìm việc',
  'News from VietnamWorks': 'Tin tức từ VietnamWorks',
  'There is no news currently.': 'Hiện tại chưa có thông tin nào mới.',
  'Update now.': 'Cập nhật.',
  'Update CV now.': 'Cập nhật.',
  '18 new jobs': '18 công việc mới',
  'you might be interested based on your profile.': 'hấp dẫn dành riêng cho bạn!',
  userProfilePath: '/ho-so',
  recommendationJobsPath: '/viec-lam-goi-y',
  'Sign in now to get your dream jobs.': 'Đăng nhập ngay để tìm thấy công việc mơ ước.',
  whoViewedPath: '/quan-ly-nghe-nghiep/nha-tuyen-dung-nao-xem-ho-so-cua-ban',
  interviewsPath: '/cau-hoi-phong-van',
  salaryPath: '/muc-luong',
  careerNewbies: '/career-newbies',
  'My Profile': 'Quản lý hồ sơ',
  NEW: 'MỚI',
  'Login or Register': 'Đăng Nhập hoặc Đăng Ký',
  Filter: 'Lọc',
  'Search for jobs, companies, skills': 'Tìm kiếm việc làm, công ty, kỹ năng',
  'Search for jobs, companies...': 'Tìm kiếm việc làm, công ty...',
  Search: 'Tìm kiếm',
  'Update Search': 'Cập nhật tìm kiếm',
  'Hot Keywords': 'Từ Khóa Phổ Biến',
  'Recent Searches': 'Tìm Kiếm Gần Đây',
  'Are you searching for': 'Có phải bạn đang tìm',
  'Clear all': 'Xóa tất cả',
  'Search result has been updated!': 'Kết quả search vừa được cập nhật!',
  Close: 'Đóng',
  'No Data': 'Không có kết quả nào',
  'Show more search criteria': 'Hiển thị thêm tiêu chí tìm kiếm',
  'Show less search criteria': 'Thu gọn tiêu chí tìm kiếm',
  'Show full': 'Mở rộng',
  'Show more': 'Mở rộng',
  'Show less': 'Thu gọn',
  'You can find jobs by category, location and more filters.': 'Bạn có thể tìm kiếm công việc và lọc theo lĩnh vực, khu vực, v.v.',
  'You can always show it again anytime.': 'Bạn có thể mở lại bất cứ lúc nào.',
  Sort: 'Sắp xếp',
  'All categories': 'Tất cả ngành nghề',
  'All locations': 'Tất cả địa điểm',
  job: 'việc làm',
  jobs: 'việc làm',
  'Toggle navigation': 'Mở trang điều hướng',
  'View Less': 'Thu Gọn',
  'View More': 'Xem Thêm',
  ITHub: '/it-hub',
  ITJobs: '/viec-lam?g=5',
  inTechLink: '/intech'
};
var headerMenuEnPath = {
  Jobs: 'Jobs',
  'Management Jobs': 'Management Jobs',
  Companies: 'Companies',
  employerTitle: 'For employers',
  employerSubTitle: 'Find talents',
  employerPath: 'https://employer.vietnamworks.com/',
  searchJobsPath: '/job-search/all-jobs',
  seoLandingPagePath: '/job-search',
  companyListPath: '/company-list',
  topJobsPath: '/job-channel/top-management/?utm_source_navi=vnw_header_menu&utm_medium_navi=TopManagementJobs&utm_term_navi=homepage2',
  dashboardPath: '/my-career-center/dashboard',
  myJobsPath: '/my-career-center/my-jobs',
  saveJobsPath: '/my-career-center/my-jobs',
  jobAlertsPath: '/my-career-center/my-job-alert',
  myCompaniesPath: '/my-career-center/my-companies',
  accountSettingPath: '/account-settings',
  referralCandidatesPath: '/my-career-center/referral-candidates',
  myProfilePath: '/my-profile',
  salaryConverterPath: '/gross-net-salary-converter',
  orderManagementPath: '/order-management',
  changeLanguageTo: 'Tiếng Việt',
  LoginIconLabel: 'Login',
  userProfilePath: '/my-profile',
  recommendationJobsPath: '/recommended-jobs',
  whoViewedPath: '/my-career-center/who-view-my-resume',
  interviewsPath: '/interview',
  salaryPath: '/salary',
  profileSettingsPath: '/my-profile?tab=profile-settings',
  careerPath: '/career-path',
  numerologyPath: '/numerology',
  empowerGrowth: '/empower-growth-2023/en',
  careerNewbies: '/career-newbies',
  chargeStationPath: '/tram-sac',
  ITHub: '/it-hub',
  ITJobs: '/jobs?g=5',
  inTechLink: '/intech'
};

function addQueryParam(url, params) {
  if (!params) {
    return url;
  }

  var queries = [];

  for (var _i = 0, _Object$entries = Object.entries(params); _i < _Object$entries.length; _i++) {
    var _Object$entries$_i = _Object$entries[_i],
        key = _Object$entries$_i[0],
        value = _Object$entries$_i[1];

    if (value === undefined) {
      continue;
    }

    queries.push(key + "=" + value);
  }

  if (!queries.length) {
    return url;
  }

  return (url.includes('?') ? url + '&' : url + '?') + queries.join('&');
}
var addUTMToURL = function addUTMToURL(path, utm, pageName) {
  if (pageName === void 0) {
    pageName = '';
  }

  if (!utm) {
    return path;
  }

  if (typeof utm !== 'boolean') {
    return path + (path.includes('?') ? "&" + utm : "?" + utm);
  } else {
    var utmMedium = PAGE_UTM_MEDIUM_MAPPING[pageName] || '';

    if (utmMedium !== '') {
      return addQueryParam(path, {
        utm_source_navi: 'Header',
        utm_medium_navi: utmMedium
      });
    } else {
      return addQueryParam(path, {
        utm_source_navi: 'Header'
      });
    }
  }
};
var setCookie = function setCookie(name, value, days) {
  var expires = '';

  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = '; expires=' + date.toUTCString();
  }

  document.cookie = name + '=' + value + expires + '; path=/';
};
var onClickAllJob = function onClickAllJob(path, langCode, target) {
  if (path === '') {
    return;
  }

  var params = typeof window !== 'undefined' ? localStorage.getItem('params') : '';
  var localParams = params !== '' && params !== null ? JSON.parse(params) : {};
  localParams.categoryId = [];
  localParams.jobFunctionId = [];
  localParams.query = '';
  localStorage.setItem('params', JSON.stringify(localParams));

  if (typeof window !== 'undefined' && typeof sessionStorage === 'object') {
    var sessionParams = sessionStorage.getItem('params');
    var localSessionParams = sessionParams !== '' && sessionParams !== null ? JSON.parse(sessionParams) : {};
    localSessionParams.categoryId = [];
    localSessionParams.jobFunctionId = [];
    sessionStorage.setItem('params', JSON.stringify(localSessionParams));
  }

  setCookie('VNWSearchJob[city]', 'all', 30);
  var isSearchJobPath = path.includes('/tim-viec-lam/tim-tat-ca-viec-lam') || path.includes('/job-search/all-jobs');

  if (!isSearchJobPath) {
    target === '_blank' ? window.open(path, '_blank') : window.location.href = path;
  } else {
    var _localParams$location, _localParams$location2;

    var mappedLocations = (_localParams$location = localParams === null || localParams === void 0 ? void 0 : (_localParams$location2 = localParams.locations) === null || _localParams$location2 === void 0 ? void 0 : _localParams$location2.map(function (item) {
      return item.parentId;
    })) != null ? _localParams$location : [];

    if (mappedLocations.length === 0) {
      target === '_blank' ? window.open(path, '_blank') : window.location.href = path;
      return;
    }

    var customSearchPath = (langCode === ELanguage.EN ? '/jobs' : '/viec-lam') + "?l=" + mappedLocations.join('.');
    window.location.href = customSearchPath;
  }
};

var handleNavigationClick = function handleNavigationClick(_ref) {
  var link = _ref.link,
      utm = _ref.utm,
      isUseCustomEvent = _ref.isUseCustomEvent,
      isLoggedIn = _ref.isLoggedIn,
      langCode = _ref.langCode,
      target = _ref.target;
  var path = addUTMToURL(link, utm);

  if (isUseCustomEvent) {
    if (isLoggedIn) {
      onClickAllJob(path, langCode, target);
      return;
    }

    var loginEvent = new CustomEvent(LOGIN_POPUP, {
      detail: {
        langCode: langCode,
        onLoggedIn: function onLoggedIn() {
          if (typeof window === 'undefined' || !path) {
            return;
          }

          onClickAllJob(path, langCode, target);
        }
      }
    });
    window.dispatchEvent(loginEvent);
    return;
  }

  onClickAllJob(path, langCode, target);
};

function attachQueryParamToUrl(url, params) {
  if (!Object.keys(params).length) {
    return url;
  }

  var urlEntity = new URL(url);

  for (var _i = 0, _Object$entries = Object.entries(params); _i < _Object$entries.length; _i++) {
    var _Object$entries$_i = _Object$entries[_i],
        key = _Object$entries$_i[0],
        value = _Object$entries$_i[1];

    if (value === undefined) {
      urlEntity.searchParams["delete"](key);
      continue;
    }

    if (typeof value === 'object' && !Array.isArray(value) || Number.isNaN(value)) {
      continue;
    }

    urlEntity.searchParams.set(key, value ? '' + value : value);
  }

  return urlEntity.toString();
}
function _isJobDetail() {
  if (typeof window !== 'undefined') {
    return !!window.location.pathname.match(/\d{6}(-jd|-jv)/);
  }

  return false;
}
function handleChangeLanguage(langCode) {
  var isChangeToVNLanguage = langCode === ELanguage.VI;

  if (typeof window !== 'undefined') {
    var languageIdToSwitch = langCode === ELanguage.EN ? 1 : 2;
    js_cookie.set('lang', languageIdToSwitch, {
      expires: 90
    });
  }

  if (window && window.location && window.location.pathname) {
    var pathname = window.location.pathname;
    var pathWithQuery = window.location.pathname + window.location.search;

    if (pathname === '/') {
      pathname = '/en';
    } else if (pathname === '/en') {
      pathname = '/';
    }

    if (/job-search\/all-jobs/.test(pathname)) {
      pathname = pathWithQuery;
      window.location.href = pathname.replace('job-search/all-jobs', 'tim-viec-lam/tim-tat-ca-viec-lam');
      return;
    } else if (/tim-viec-lam\/tim-tat-ca-viec-lam/.test(pathname)) {
      pathname = pathWithQuery;
      window.location.href = pathname.replace('tim-viec-lam/tim-tat-ca-viec-lam', 'job-search/all-jobs');
      return;
    }

    if (pathname === '/jobs') {
      pathname = pathWithQuery;
      window.location.href = pathname.replace('/jobs', '/viec-lam');
      return;
    } else if (pathname === '/viec-lam') {
      pathname = pathWithQuery;
      window.location.href = pathname.replace('/viec-lam', '/jobs');
      return;
    }

    if (pathname.match(/viec-can-tuyen-gap/)) {
      pathname = pathname.replace('viec-can-tuyen-gap', 'urgent-jobs');
    } else if (pathname.match(/urgent-jobs/)) {
      pathname = pathname.replace('urgent-jobs', 'viec-can-tuyen-gap');
    }

    if (pathname.match(/^\/cau-hoi-phong-van/)) {
      pathname = pathWithQuery;
      pathname = pathname.replace('cau-hoi-phong-van', 'interview');
    } else if (pathname.match(/^\/interview/)) {
      pathname = pathWithQuery;
      pathname = pathname.replace('interview', 'cau-hoi-phong-van');
    }

    if (pathname.match(/^\/muc-luong/)) {
      pathname = pathWithQuery;
      pathname = pathname.replace('muc-luong', 'salary');
    } else if (pathname.match(/^\/salary/)) {
      pathname = pathWithQuery;
      pathname = pathname.replace('salary', 'muc-luong');
    }

    if (pathname.match(/-kv-tuyen-gap-uj/)) {
      pathname = pathname.replace('-kv-tuyen-gap-uj', '-kw-urgent-uj');
    } else if (pathname.match(/-kw-urgent-uj/)) {
      pathname = pathname.replace('-kw-urgent-uj', '-kv-tuyen-gap-uj');
    }

    if (/job-search\/employer/.test(pathname)) {
      pathname = pathname.replace('job-search/employer', 'tim-viec-lam/nha-tuyen-dung');
    } else if (/tim-viec-lam\/nha-tuyen-dung/.test(pathname)) {
      pathname = pathname.replace('tim-viec-lam/nha-tuyen-dung', 'job-search/employer');
    }

    if (/-kw(\/?)$/.test(pathname)) {
      pathname = pathname.replace(/-kw$/, '-kv');
    } else if (/-kv(\/?)$/.test(pathname)) {
      pathname = pathname.replace(/-kv$/, '-kw');
    }

    if (/-en(\/?)$/.test(pathname)) {
      pathname = pathname.replace(/-en$/, '-vn');
    } else if (/-vn(\/?)$/.test(pathname)) {
      pathname = pathname.replace(/-vn$/, '-en');
    }

    var isPathFromMyCareerCenter = typeof switchLanguageURL !== 'undefined' && switchLanguageURL.match(/\/quan-ly-nghe-nghiep|\/my-career-center/);

    if (typeof switchLanguageURL !== 'undefined' && !!switchLanguageURL && !isPathFromMyCareerCenter) {
      pathname = switchLanguageURL + window.location.search;
    }

    if (pathWithQuery.match(/\/[a-zA-Z0-9-]+-(jv|jd)/)) {
      var _window$location$sear;

      var locationPath = langCode === ELanguage.VI ? 'jv' : 'jd';
      pathname = pathname.slice(0, -3) + "-" + locationPath + ((_window$location$sear = window.location.search) != null ? _window$location$sear : '');
    }

    if (pathname.match(/ung-tuyen-thanh-cong/)) {
      pathname = pathname.replace('ung-tuyen-thanh-cong', 'success-apply');
    } else if (pathname.match(/success-apply/)) {
      pathname = pathname.replace('success-apply', 'ung-tuyen-thanh-cong');
    }

    if (pathWithQuery.match(/\/(xem-truoc-dang-tuyen-viec-lam|job-posting-preview)\/\d+/)) {
      if (isChangeToVNLanguage) {
        pathname = pathWithQuery.replace('/job-posting-preview/', '/xem-truoc-dang-tuyen-viec-lam/');
      } else {
        pathname = pathWithQuery.replace('/xem-truoc-dang-tuyen-viec-lam/', '/job-posting-preview/');
      }
    }

    if (pathname.match(/\/viec-lam-quan-ly|\/management-jobs/)) {
      pathname = isChangeToVNLanguage ? 'viec-lam-quan-ly' : 'management-jobs';
    }

    if (/apply-multiple-jobs\/*/.test(pathname)) {
      pathname = pathname.replace(/apply-multiple-jobs/, 'ung-tuyen-nhieu-viec-lam');
    } else if (/ung-tuyen-nhieu-viec-lam\/*/.test(pathname)) {
      pathname = pathname.replace(/ung-tuyen-nhieu-viec-lam/, 'apply-multiple-jobs');
    }

    if (pathname.match(/\/my-profile|\/ho-so/)) {
      if (isChangeToVNLanguage) {
        pathname = pathWithQuery.replace('/my-profile', '/ho-so');
      } else {
        pathname = pathWithQuery.replace('/ho-so', '/my-profile');
      }
    }

    if (pathname.match(/\/order-management/)) {
      pathname = pathname.replace('order-management', 'quan-ly-don-hang');
    } else if (pathname.match(/\/quan-ly-don-hang/)) {
      pathname = pathname.replace('quan-ly-don-hang', 'order-management');
    }

    if (pathname.match(/\/account-setting|\/quan-ly-tai-khoan/)) {
      pathname = isChangeToVNLanguage ? '/quan-ly-tai-khoan' : '/account-settings';
    }

    if (pathname.match(/\/my-career-center\/dashboard|\/quan-ly-nghe-nghiep\/tong-quan/)) {
      pathname = isChangeToVNLanguage ? '/quan-ly-nghe-nghiep/tong-quan' : '/my-career-center/dashboard';
    }

    if (pathname.match(/\/my-career-center\/profile-settings|\/quan-ly-nghe-nghiep\/thiet-lap-ho-so/)) {
      pathname = isChangeToVNLanguage ? '/quan-ly-nghe-nghiep/thiet-lap-ho-so' : '/my-career-center/profile-settings';
    }

    if (pathname.match(/\/my-career-center\/who-view-my-resume|\/quan-ly-nghe-nghiep\/nha-tuyen-dung-nao-xem-ho-so-cua-ban/)) {
      pathname = isChangeToVNLanguage ? '/quan-ly-nghe-nghiep/nha-tuyen-dung-nao-xem-ho-so-cua-ban' : '/my-career-center/who-view-my-resume';
    }

    if (pathname.match(/\/my-career-center\/my-jobs|\/quan-ly-nghe-nghiep\/viec-lam-cua-toi/)) {
      pathname = isChangeToVNLanguage ? '/quan-ly-nghe-nghiep/viec-lam-cua-toi' : '/my-career-center/my-jobs';
    }

    if (pathname.match(/\/my-career-center\/my-job-alert|\/quan-ly-nghe-nghiep\/thong-bao-viec-lam/)) {
      pathname = isChangeToVNLanguage ? '/quan-ly-nghe-nghiep/thong-bao-viec-lam' : '/my-career-center/my-job-alert';
    }

    if (pathname.match(/\/khong-tim-thay-trang|\/error404/)) {
      pathname = isChangeToVNLanguage ? 'khong-tim-thay-trang' : 'error404';
    }

    if (window.location.href.includes('wowcv.vietnamworks')) {
      pathname = isChangeToVNLanguage ? '/' : '/en';
    }

    if (pathname.match(/wowcv$/)) {
      pathname = pathname.replace('wowcv', 'wowcv/en');
    } else if (pathname.match(/wowcv\/en$/)) {
      pathname = pathname.replace('wowcv/en', 'wowcv');
    }

    if (pathname.match(/\/wowcv\/[^\/]+(\/en)$/)) {
      pathname = pathname.replace(/\/en$/, '');
    } else if (pathname.match(/\/wowcv\/(?!en)[^\/]+/)) {
      pathname = pathname + '/en';
    }

    if (pathname.match(/mau-cv$/)) {
      pathname = pathname.replace('/mau-cv', '/cv-template');
    } else if (pathname.match(/cv-template$/)) {
      pathname = pathname.replace('/cv-template', '/mau-cv');
    }

    if (pathname.match(/xem-truoc$/)) {
      pathname = pathWithQuery.replace('/xem-truoc', '/preview-cv');
    } else if (pathname.match(/preview-cv$/)) {
      pathname = pathWithQuery.replace('/preview-cv', '/xem-truoc');
    }

    if (pathname.includes('lang=en') || pathname.includes('lang=vi')) {
      pathname = pathname.replace("lang=" + (langCode === ELanguage.EN ? ELanguage.VI : ELanguage.EN), "lang=" + langCode);
    }

    if (pathname.match(/tim-viec-lam$/)) {
      pathname = pathname.replace('tim-viec-lam', 'job-search');
    } else if (pathname.match(/job-search$/)) {
      pathname = pathname.replace('job-search', 'tim-viec-lam');
    }

    if (pathWithQuery.match(/\/quan-ly-nghe-nghiep\/cong-ty-cua-toi/)) {
      pathname = pathWithQuery.replace('quan-ly-nghe-nghiep/cong-ty-cua-toi', 'my-career-center/my-companies');
    } else if (pathWithQuery.match(/\/my-career-center\/my-companies/)) {
      pathname = pathWithQuery.replace('my-career-center/my-companies', 'quan-ly-nghe-nghiep/cong-ty-cua-toi');
    }

    if (pathWithQuery.match(/\/nha-tuyen-dung\//)) {
      pathname = pathWithQuery.replace('nha-tuyen-dung', 'companies');
    } else if (pathWithQuery.match(/\/companies\//)) {
      pathname = pathWithQuery.replace('companies', 'nha-tuyen-dung');
    }

    if (pathname.match(/\/danh-sach-cong-ty/)) {
      pathname = pathname.replace('danh-sach-cong-ty', 'company-list');
    } else if (pathname.match(/\/company-list/)) {
      pathname = pathname.replace('company-list', 'danh-sach-cong-ty');
    }

    if (pathname.match(/\/viec-lam-tot-nhat/)) {
      pathname = pathname.replace('viec-lam-tot-nhat', 'featured-jobs');
    } else if (pathname.match(/\/featured-jobs/)) {
      pathname = pathname.replace('featured-jobs', 'viec-lam-tot-nhat');
    }

    if (pathWithQuery.match(/\/viec-lam-goi-y/)) {
      pathname = pathWithQuery.replace('viec-lam-goi-y', 'recommended-jobs');
    } else if (pathWithQuery.match(/\/recommended-jobs/)) {
      pathname = pathWithQuery.replace('recommended-jobs', 'viec-lam-goi-y');
    }

    if (pathname.match(/\/gross-net-salary-converter|\/tinh-luong-gross-net/)) {
      pathname = isChangeToVNLanguage ? '/tinh-luong-gross-net' : '/gross-net-salary-converter';
    }

    if (pathWithQuery.match(/\/nhan-so-hoc\/ket-qua/)) {
      window.location.href = pathWithQuery.replace('nhan-so-hoc/ket-qua', 'numerology/result');
      return;
    } else if (pathWithQuery.match(/\/numerology\/result/)) {
      window.location.href = pathWithQuery.replace('numerology/result', 'nhan-so-hoc/ket-qua');
      return;
    }

    if (pathWithQuery.match(/\/nhan-so-hoc/)) {
      window.location.href = pathWithQuery.replace('nhan-so-hoc', 'numerology');
      return;
    } else if (pathWithQuery.match(/\/numerology/)) {
      window.location.href = pathWithQuery.replace('numerology', 'nhan-so-hoc');
      return;
    }

    if (pathWithQuery.match(/\/so-chu-dao/)) {
      window.location.href = pathWithQuery.replace('so-chu-dao', 'ruling-number');
      return;
    } else if (pathWithQuery.match(/\/ruling-number/)) {
      window.location.href = pathWithQuery.replace('ruling-number', 'so-chu-dao');
      return;
    }

    if (pathWithQuery.match(/\/career-path/)) {
      window.location.href = pathWithQuery.replace('career-path', 'lo-trinh-su-nghiep');
      return;
    } else if (pathWithQuery.match(/\/lo-trinh-su-nghiep/)) {
      window.location.href = pathWithQuery.replace('lo-trinh-su-nghiep', 'career-path');
      return;
    }

    if (pathWithQuery.match(/\/employer-privacy-policy/)) {
      window.location.href = pathWithQuery.replace('employer-privacy-policy', 'quy-dinh-bao-mat-nha-tuyen-dung');
      return;
    } else if (pathWithQuery.match(/\/quy-dinh-bao-mat-nha-tuyen-dung/)) {
      window.location.href = pathWithQuery.replace('quy-dinh-bao-mat-nha-tuyen-dung', 'employer-privacy-policy');
      return;
    }

    if (pathname.match(/\/theo-doi-ty-le-canh-tranh-cua-toi\//)) {
      pathname = pathname.replace('theo-doi-ty-le-canh-tranh-cua-toi', 'track-my-competitive-rate');
    } else if (pathname.match(/\/track-my-competitive-rate\//)) {
      pathname = pathname.replace('track-my-competitive-rate', 'theo-doi-ty-le-canh-tranh-cua-toi');
    }

    if (window.location.href.includes('empower-growth-2023')) {
      var getPathName = window.location.pathname.split('/');
      var param = '';

      if (getPathName.length > 2) {
        param = getPathName[getPathName.length - 1] === 'en' ? '' : getPathName[getPathName.length - 1];
      }

      pathname = "" + (isChangeToVNLanguage ? '/empower-growth-2023' : '/empower-growth-2023/en') + (param !== '' ? '/' + param : '');
    }

    if (pathWithQuery.match(/\/event/)) {
      window.location.href = pathWithQuery.replace('event', 'su-kien');
      return;
    } else if (pathWithQuery.match(/\/su-kien/)) {
      window.location.href = pathWithQuery.replace('su-kien', 'event');
      return;
    }

    if (pathname.match(/\/recommendation\/en\/[a-z\d-]+\/success/)) {
      pathname = pathname.replace('recommendation/en', 'recommendation');
    } else if (pathname.match(/\/recommendation\/[a-z\d-]+\/success/)) {
      pathname = pathname.replace('recommendation', 'recommendation/en');
    }

    if (pathname.match(/\/recommendation\/en\/[a-z\d-]+\/expired/)) {
      pathname = pathname.replace('recommendation/en', 'recommendation');
    } else if (pathname.match(/\/recommendation\/[a-z\d-]+\/expired/)) {
      pathname = pathname.replace('recommendation', 'recommendation/en');
    }

    if (pathWithQuery.match(/\/tai-khoan-ca-nhan/)) {
      pathname = pathWithQuery.replace('tai-khoan-ca-nhan', 'account-center');
    } else if (pathWithQuery.match(/\/account-center/)) {
      pathname = pathWithQuery.replace('account-center', 'tai-khoan-ca-nhan');
    }

    if (pathWithQuery.match(/\/xem-truoc-ho-so\//)) {
      pathname = pathWithQuery.replace('xem-truoc-ho-so', 'preview-resume');
    } else if (pathWithQuery.match(/\/preview-resume\//)) {
      pathname = pathWithQuery.replace('preview-resume', 'xem-truoc-ho-so');
    }

    if (pathWithQuery.match(/\/phan-tich-ho-so\/bao-cao-mau/)) {
      pathname = pathWithQuery.replace('phan-tich-ho-so/bao-cao-mau', 'cv-review/sample-report');
    } else if (pathWithQuery.match(/\/cv-review\/sample-report/)) {
      pathname = pathWithQuery.replace('cv-review/sample-report', 'phan-tich-ho-so/bao-cao-mau');
    } else if (pathWithQuery.match(/\/phan-tich-ho-so/)) {
      pathname = pathWithQuery.replace('phan-tich-ho-so', 'cv-review');
    } else if (pathWithQuery.match(/\/cv-review/)) {
      pathname = pathWithQuery.replace('cv-review', 'phan-tich-ho-so');
    }

    if (pathWithQuery.match(/\phan-tich-ho-so\/loi-trang/)) {
      pathname = pathWithQuery.replace('phan-tich-ho-so/loi-trang', 'cv-review/error');
    } else if (pathWithQuery.match(/\/cv-review\/error/)) {
      pathname = pathWithQuery.replace('cv-review/error', 'phan-tich-ho-so/loi-trang');
    }

    if (pathname.match(/\/quy-che-hoat-dong-thuong-mai-dien-tu/)) {
      pathname = pathname.replace('quy-che-hoat-dong-thuong-mai-dien-tu', 'operation-ecommerce');
    } else if (pathname.match(/\/operation-ecommerce/)) {
      pathname = pathname.replace('operation-ecommerce', 'quy-che-hoat-dong-thuong-mai-dien-tu');
    }

    if (pathname.match(/\/chinh-sach-hoan-tien/)) {
      pathname = pathname.replace('chinh-sach-hoan-tien', 'refund-policy');
    } else if (pathname.match(/\/refund-policy/)) {
      pathname = pathname.replace('refund-policy', 'chinh-sach-hoan-tien');
    }

    window.location.href = pathname;
  }
}
function translate(text, language, jsonFile) {
  if (language === void 0) {
    language = ELanguage.VI;
  }

  if (language === ELanguage.EN) {
    return text;
  } else {
    return jsonFile[text];
  }
}
function getEnvVars(mode, language) {
  if (mode === void 0) {
    mode = EMode.PRODUCTION;
  }

  if (language === void 0) {
    language = ELanguage.VI;
  }

  return env[language][mode];
}
function fireGlobalSearchEvent(_ref2) {
  var params = _ref2.params,
      from = _ref2.from,
      hideFilter = _ref2.hideFilter,
      clearCurrentParams = _ref2.clearCurrentParams;

  if (typeof window !== 'undefined') {
    var searchEvent = new CustomEvent('SEARCH', {
      detail: {
        params: params,
        from: from,
        hideFilter: hideFilter,
        clearCurrentParams: clearCurrentParams
      }
    });
    window.dispatchEvent(searchEvent);
  }
}
function clearLocalStorageParams(clearLocalStorageParams) {
  var params = typeof window !== 'undefined' ? localStorage.getItem('params') : '';
  var localParams = params !== '' && params !== null ? JSON.parse(params) : {};

  if (params === '') {
    return;
  }

  var updateParams = localParams;

  if (clearLocalStorageParams) {
    var _clearLocalStoragePar;

    updateParams = _extends({}, localParams, clearLocalStorageParams);

    if ((clearLocalStorageParams === null || clearLocalStorageParams === void 0 ? void 0 : clearLocalStorageParams.locations) && (clearLocalStorageParams === null || clearLocalStorageParams === void 0 ? void 0 : (_clearLocalStoragePar = clearLocalStorageParams.locations) === null || _clearLocalStoragePar === void 0 ? void 0 : _clearLocalStoragePar.length) < 1) {
      setCookie('VNWSearchJob[city]', 'all');
    }
  } else {
    updateParams.jobFunctionId = [];
    updateParams.categoryId = [];
    updateParams.query = '';
    updateParams.locations = [];
    updateParams.locationId = [];
    updateParams.districtId = [];
  }

  localStorage.setItem('params', JSON.stringify(updateParams));
  fireGlobalSearchEvent({
    params: updateParams,
    from: 'Header > IntechLogo'
  });
}

// A type of promise-like that resolves synchronously and supports only one observer

const _iteratorSymbol = /*#__PURE__*/ typeof Symbol !== "undefined" ? (Symbol.iterator || (Symbol.iterator = Symbol("Symbol.iterator"))) : "@@iterator";

const _asyncIteratorSymbol = /*#__PURE__*/ typeof Symbol !== "undefined" ? (Symbol.asyncIterator || (Symbol.asyncIterator = Symbol("Symbol.asyncIterator"))) : "@@asyncIterator";

// Asynchronously call a function and send errors to recovery continuation
function _catch(body, recover) {
	try {
		var result = body();
	} catch(e) {
		return recover(e);
	}
	if (result && result.then) {
		return result.then(void 0, recover);
	}
	return result;
}

function formatBottomTexResponse(resData) {
  if (resData.length === 0) {
    return null;
  }

  var bottomTextRaw = resData[0];
  return _extends({
    id: bottomTextRaw.id
  }, bottomTextRaw.attributes);
}

var getBottomText = function getBottomText(apiUrl, pageUrl) {
  try {
    return Promise.resolve(_catch(function () {
      return Promise.resolve(fetch(apiUrl + "?page_url=" + encodeURIComponent(pageUrl))).then(function (res) {
        var _exit = false;

        var _temp = function () {
          if (res.status === 200) {
            return Promise.resolve(res.json()).then(function (resBody) {
              _exit = true;
              return formatBottomTexResponse(resBody === null || resBody === void 0 ? void 0 : resBody.data);
            });
          }
        }();

        return _temp && _temp.then ? _temp.then(function (_result) {
          return _exit ? _result : null;
        }) : _exit ? _temp : null;
      });
    }, function (ex) {
      console.error(ex);
      return null;
    }));
  } catch (e) {
    return Promise.reject(e);
  }
};

var translations = {
  'View Less': 'Thu gọn',
  'View More': 'Xem thêm'
};

var trans = function trans(text, language) {
  return translate(text, language, translations);
};

var MAX_CONTENT_HEIGHT = 250;

function BottomText(_ref) {
  var _contentRef$current;

  var _ref$html = _ref.html,
      html = _ref$html === void 0 ? '' : _ref$html,
      _ref$imageUrl = _ref.imageUrl,
      imageUrl = _ref$imageUrl === void 0 ? '' : _ref$imageUrl,
      _ref$ssr = _ref.ssr,
      ssr = _ref$ssr === void 0 ? false : _ref$ssr;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(html),
      htmlContent = _useState[0],
      setHtmlContent = _useState[1];

  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(imageUrl),
      image = _useState2[0],
      setImage = _useState2[1];

  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false),
      isCenterImage = _useState3[0],
      setCenterImage = _useState3[1];

  var _useState4 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(true),
      showReadMore = _useState4[0],
      setShowReadMore = _useState4[1];

  var _useState5 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false),
      isExtented = _useState5[0],
      setIsExtented = _useState5[1];

  var _useState6 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(''),
      pageUrl = _useState6[0],
      setPageUrl = _useState6[1];

  var contentContainerRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
  var contentRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);

  var _useContext = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(AppShellContext),
      mode = _useContext.mode,
      langCode = _useContext.langCode;

  var bottomTextUrl = getEnvVars(mode, langCode).bottomTextUrl;
  var contentHeight = (contentRef === null || contentRef === void 0 ? void 0 : (_contentRef$current = contentRef.current) === null || _contentRef$current === void 0 ? void 0 : _contentRef$current.offsetHeight) || 0;

  function handleUrlUpdateOnSearchEvent() {
    var canonicalEle = document.querySelector("link[rel='canonical']");

    if (canonicalEle) {
      setPageUrl(canonicalEle.getAttribute('href') || '');
    } else {
      var _ref2, _window, _window$location, _window2, _window2$location;

      setPageUrl(((_ref2 = ((_window = window) === null || _window === void 0 ? void 0 : (_window$location = _window.location) === null || _window$location === void 0 ? void 0 : _window$location.origin) + ((_window2 = window) === null || _window2 === void 0 ? void 0 : (_window2$location = _window2.location) === null || _window2$location === void 0 ? void 0 : _window2$location.pathname)) === null || _ref2 === void 0 ? void 0 : _ref2.toLocaleLowerCase()) || '');
    }
  }

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    window.addEventListener('URL_UPDATED_AFTER_SEARCH', handleUrlUpdateOnSearchEvent);
    return function () {
      window.removeEventListener('URL_UPDATED_AFTER_SEARCH', handleUrlUpdateOnSearchEvent);
    };
  });
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    var callApi = function callApi(pageUrlParam) {
      try {
        return Promise.resolve(getBottomText(bottomTextUrl, pageUrlParam)).then(function (bottomText) {
          if (bottomText) {
            var content = bottomText.content,
                _image = bottomText.image;
            setHtmlContent(content);
            setImage(_image);
            setCenterImage(bottomText.isCenterImage);
          } else {
            setHtmlContent('');
            setImage('');
            setCenterImage(false);
          }
        });
      } catch (e) {
        return Promise.reject(e);
      }
    };

    var pageUrlParam = pageUrl;

    if (!pageUrlParam) {
      var canonicalEle = document.querySelector("link[rel='canonical']");

      if (canonicalEle) {
        pageUrlParam = canonicalEle.getAttribute('href') || '';
      } else {
        var _ref3, _window3, _window3$location, _window4, _window4$location;

        pageUrlParam = (_ref3 = ((_window3 = window) === null || _window3 === void 0 ? void 0 : (_window3$location = _window3.location) === null || _window3$location === void 0 ? void 0 : _window3$location.origin) + ((_window4 = window) === null || _window4 === void 0 ? void 0 : (_window4$location = _window4.location) === null || _window4$location === void 0 ? void 0 : _window4$location.pathname)) === null || _ref3 === void 0 ? void 0 : _ref3.toLocaleLowerCase();
      }
    }

    if (!ssr) {
      callApi(pageUrlParam);
    }

    if (contentHeight) {
      if (showReadMore && contentHeight <= MAX_CONTENT_HEIGHT) {
        setShowReadMore(false);
      }
    }
  }, [pageUrl]);
  var revealContentHeight = contentHeight + 50;
  var contentStyles = {
    maxHeight: revealContentHeight > MAX_CONTENT_HEIGHT ? revealContentHeight : MAX_CONTENT_HEIGHT
  };

  if (showReadMore && !isExtented) {
    contentStyles = {
      maxHeight: MAX_CONTENT_HEIGHT
    };
  }

  if (htmlContent === '') {
    return null;
  }

  return react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: 'bottomText'
  }, react__WEBPACK_IMPORTED_MODULE_0__.createElement(_microfrontends_react_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, null, react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: 'left-side'
  }, react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: 'content-container',
    ref: contentContainerRef,
    style: contentStyles
  }, react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: htmlContent
    },
    className: "bottom-content editorable " + (isCenterImage ? 'center-image' : ''),
    ref: contentRef
  })), showReadMore && react__WEBPACK_IMPORTED_MODULE_0__.createElement("button", {
    onClick: function onClick() {

      setIsExtented(!isExtented);
    },
    className: 'read-more'
  }, isExtented ? trans('View Less', langCode) : trans('View More', langCode) + " ...")), image !== '' && react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: "right-side bottom-image " + (isCenterImage ? 'center-image' : '')
  }, react__WEBPACK_IMPORTED_MODULE_0__.createElement("img", {
    src: image,
    alt: '',
    loading: 'lazy'
  }))));
}

var config = {
  top_locations: [29, 24, 28, 17, 15],
  top_categories: [1, 42, 35, 55, 7],
  faq_url: {
    en: 'https://faq.vietnamworks.com/en',
    vi: 'https://faq.vietnamworks.com/vi'
  },
  ios_download_url: {
    en: 'https://vietnamworks.onelink.me/UtAm?pid=mobile&url=%2F',
    vi: 'https://vietnamworks.onelink.me/UtAm?pid=mobile&url=%2F'
  },
  android_download_url: {
    en: 'https://play.google.com/store/apps/details?id=com.vietnamworks.vietnamworks&hl=en',
    vi: 'https://play.google.com/store/apps/details?id=com.vietnamworks.vietnamworks&hl=vi'
  },
  registered_gov_url: {
    en: 'https://online.gov.vn/nen-tang/abeb0981-da02-4f84-8312-b9fe8d57082e',
    vi: 'https://online.gov.vn/nen-tang/abeb0981-da02-4f84-8312-b9fe8d57082e'
  },
  facebook_url: {
    en: 'https://www.facebook.com/VietnamWorksFanpage',
    vi: 'https://www.facebook.com/VietnamWorksFanpage'
  },
  linkedin_url: {
    en: 'https://www.linkedin.com/company/vietnamworks',
    vi: 'https://www.linkedin.com/company/vietnamworks'
  }
};

var translations$1 = {
  'About Us': 'Về VietnamWorks',
  'Contact Us': 'Liên Hệ',
  '/contact-us': '/lien-he',
  FAQ: 'Hỏi Đáp',
  'Terms Of Use': 'Thỏa Thuận Sử Dụng',
  '/terms-of-use': '/thoa-thuan-su-dung',
  'Privacy Statement': 'Quy Định Bảo Mật',
  Privacy: 'Quy Định Bảo Mật',
  '/privacy-policy': '/quy-dinh-bao-mat',
  'Operation Regulation Of VietnamWorks E-Commerce Trading Floor': 'Quy Chế Hoạt Động Sàn Giao Dịch Thương Mại Điện Tử VietnamWorks',
  '/mobile': '/di-dong',
  'Jobs by location': 'Việc làm theo khu vực',
  'See all locations': 'Xem tất cả khu vực',
  'Search all locations': 'Tìm theo khu vực',
  'Search job by category': 'Tìm việc làm theo ngành nghề',
  'Search job by city': 'Tìm việc làm theo khu vực',
  'Jobs by category': 'Việc làm theo ngành nghề',
  'Jobs by categories': 'Việc làm theo ngành nghề',
  'See all categories': 'Xem tất cả ngành nghề',
  'Job search': 'Tìm việc làm',
  'Search all categories': 'Tìm theo ngành nghề',
  'Job by categories at': 'Việc làm theo ngành nghề tại',
  'Mobile app': 'Ứng dụng di động',
  'Verified by': 'Chứng nhận bởi',
  'Copyright © Navigos Group Vietnam Joint Stock Company': 'Copyright © Công Ty Cổ Phần Navigos Group Việt Nam',
  'Floor 20, E.Town Central, 11 Doan Van Bo Street, Ward 13, District 4, Ho Chi Minh City, Vietnam': 'Tầng 20, tòa nhà E.Town Central, 11 Đoàn Văn Bơ, Phường 13, Quận 4, TP.HCM, Việt Nam',
  Terms: 'Thỏa thuận sử dụng',
  'Site Map': 'Sơ Đồ Trang Web',
  '/site-map': '/so-do-trang-web',
  'Follow us on': 'Kết Nối Với VietnamWorks',
  '/job-search': '/tim-viec-lam',
  '/job-search#recruitment': '/tim-viec-lam#tuyển_dụng',
  '/job-by-locations': '/tat-ca-khu-vuc',
  '/company/navigosgroup?lang=en': '/company/navigosgroup',
  '/operation-ecommerce': '/quy-che-hoat-dong-thuong-mai-dien-tu',
  'For Employers': 'Dành cho Nhà tuyển dụng',
  'Post Job': 'Đăng tuyển dụng',
  'Search Resume': 'Tìm kiếm hồ sơ',
  'HR Insider': 'Báo cáo thị trường tuyển dụng',
  Contact: 'Liên hệ',
  'Follow VietnamWorks on': 'Theo dõi Vietnamworks trên',
  'About VietnamWorks inTECH': 'Về VietnamWorks inTECH',
  '/intech': '/intech'
};

var translationFooter = function translationFooter(text, language) {
  return translate(text, language, translations$1);
};

var CopyRights = function CopyRights(props) {
  return react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: 'footer__content has-text-centered'
  }, translationFooter('Copyright © Navigos Group Vietnam Joint Stock Company', props.langCode), react__WEBPACK_IMPORTED_MODULE_0__.createElement("br", null), react__WEBPACK_IMPORTED_MODULE_0__.createElement("address", null, translationFooter('Floor 20, E.Town Central, 11 Doan Van Bo Street, Ward 13, District 4, Ho Chi Minh City, Vietnam', props.langCode)));
};

var logoFooterImage = "data:image/png;base64,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";
var appleDownloadImage = "data:image/png;base64,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";
var androidDownloadImage = "data:image/png;base64,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";
var registeredImage = "data:image/png;base64,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";
var LinkedInIcon = react__WEBPACK_IMPORTED_MODULE_0__.memo(function () {
  return react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", {
    "aria-hidden": 'true',
    focusable: 'false',
    "data-prefix": 'fab',
    "data-icon": 'linkedin-in',
    className: 'svg-inline--fa fa-linkedin-in fa-w-14 ',
    role: 'img',
    xmlns: 'http://www.w3.org/2000/svg',
    viewBox: '0 0 448 512',
    width: 12,
    height: 14
  }, react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: 'currentColor',
    d: 'M100.28 448H7.4V148.9h92.88zM53.79 108.1C24.09 108.1 0 83.5 0 53.8a53.79 53.79 0 0 1 107.58 0c0 29.7-24.1 54.3-53.79 54.3zM447.9 448h-92.68V302.4c0-34.7-.7-79.2-48.29-79.2-48.29 0-55.69 37.7-55.69 76.7V448h-92.78V148.9h89.08v40.8h1.3c12.4-23.5 42.69-48.3 87.88-48.3 94 0 111.28 61.9 111.28 142.3V448z'
  }));
});
var FacebookIcon = react__WEBPACK_IMPORTED_MODULE_0__.memo(function () {
  return react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", {
    "aria-hidden": 'true',
    focusable: 'false',
    "data-prefix": 'fab',
    "data-icon": 'facebook-f',
    className: 'svg-inline--fa fa-facebook-f fa-w-10',
    role: 'img',
    viewBox: '0 0 320 512',
    width: 8,
    height: 14
  }, react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: 'currentColor',
    d: 'M279.14 288l14.22-92.66h-88.91v-60.13c0-25.35 12.42-50.06 52.24-50.06h40.42V6.26S260.43 0 225.36 0c-73.22 0-121.08 44.38-121.08 124.72v70.62H22.89V288h81.39v224h100.17V288z'
  }));
});
var ChevronRightIcon = react__WEBPACK_IMPORTED_MODULE_0__.memo(function () {
  return react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", {
    "aria-hidden": 'true',
    focusable: 'false',
    "data-prefix": 'fas',
    "data-icon": 'chevron-right',
    className: 'svg-inline--fa fa-chevron-right fa-w-10 fa-sm ',
    role: 'img',
    xmlns: 'http://www.w3.org/2000/svg',
    viewBox: '0 0 320 512'
  }, react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: 'currentColor',
    d: 'M285.476 272.971L91.132 467.314c-9.373 9.373-24.569 9.373-33.941 0l-22.667-22.667c-9.357-9.357-9.375-24.522-.04-33.901L188.505 256 34.484 101.255c-9.335-9.379-9.317-24.544.04-33.901l22.667-22.667c9.373-9.373 24.569-9.373 33.941 0L285.475 239.03c9.373 9.372 9.373 24.568.001 33.941z'
  }));
});
var NavigosGroupLogo = react__WEBPACK_IMPORTED_MODULE_0__.memo(function (props) {
  var clipPathId = props.clipPathId;
  return react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", {
    width: 84,
    height: 30,
    viewBox: '0 0 84 30',
    fill: 'none',
    xmlns: 'http://www.w3.org/2000/svg',
    xmlnsXlink: 'http://www.w3.org/1999/xlink'
  }, react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", {
    clipPath: "url(#clip0_2205_42650-" + clipPathId + ")"
  }, react__WEBPACK_IMPORTED_MODULE_0__.createElement("mask", {
    id: "mask0_2205_42650-" + clipPathId,
    style: {
      maskType: 'luminance'
    },
    maskUnits: 'userSpaceOnUse',
    x: 0,
    y: 0,
    width: 84,
    height: 30
  }, react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: 'M83.8462 0H0V30H83.8462V0Z',
    fill: 'white'
  })), react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", {
    mask: "url(#mask0_2205_42650-" + clipPathId + ")"
  }, react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: 'M282.308 -8.46155H-30V40H282.308V-8.46155Z',
    fill: "url(#pattern0-" + clipPathId + ")"
  }))), react__WEBPACK_IMPORTED_MODULE_0__.createElement("defs", null, react__WEBPACK_IMPORTED_MODULE_0__.createElement("pattern", {
    id: "pattern0-" + clipPathId,
    patternContentUnits: 'objectBoundingBox',
    width: 1,
    height: 1
  }, react__WEBPACK_IMPORTED_MODULE_0__.createElement("use", {
    xlinkHref: "#image0_2205_42650-" + clipPathId,
    transform: 'matrix(0.000668847 0 0 0.00431034 -0.00163496 0)'
  })), react__WEBPACK_IMPORTED_MODULE_0__.createElement("clipPath", {
    id: "clip0_2205_42650-" + clipPathId
  }, react__WEBPACK_IMPORTED_MODULE_0__.createElement("rect", {
    width: '83.8462',
    height: 30,
    fill: 'white'
  })), react__WEBPACK_IMPORTED_MODULE_0__.createElement("image", {
    id: "image0_2205_42650-" + clipPathId,
    width: 1500,
    height: 232,
    xlinkHref: 'data:image/png;base64,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'
  })));
});

var LegacyLink = function LegacyLink(props) {
  if (props === void 0) {
    props = {
      childOnly: false
    };
  }

  var context = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(AppShellContext);
  var mode = context.mode,
      langCode = context.langCode;
  var jobSeekerUrl = getEnvVars(mode, langCode).jobSeekerUrl;
  var href = props.absoluteUrl ? props.absoluteUrl : "" + jobSeekerUrl + translationFooter(props.path, langCode) + "?utm_source_navi=footer";
  var target = props.target ? props.target : props.absoluteUrl ? '_blank' : '';
  var content = react__WEBPACK_IMPORTED_MODULE_0__.createElement("a", {
    href: href,
    target: target,
    className: props.className,
    title: translationFooter(props.title, langCode)
  }, props.icon, translationFooter(props.title, langCode), props.children);

  if (props.childOnly) {
    content = react__WEBPACK_IMPORTED_MODULE_0__.createElement("a", {
      href: href,
      target: target,
      className: props.className,
      title: translationFooter(props.title, langCode)
    }, props.children);
  }

  return content;
};

function slugify(slug) {
  slug = slug.replace(/^\s+|\s+$/g, '');
  slug = slug.toLowerCase();
  slug = transformToLatin(slug);
  slug = slug.replace(/[^a-z0-9 -]/g, '-').replace(/\s+/g, '-').replace(/-+/g, '-');
  return slug;
}
function transformToLatin(text) {
  text = text.toString().toLowerCase().trim();
  var sets = [{
    to: 'a',
    from: '[ÀÁÂÃÄÅÆĀĂĄẠẢẤẦẨẪẬẮẰẲẴẶἀ]'
  }, {
    to: 'c',
    from: '[ÇĆĈČ]'
  }, {
    to: 'd',
    from: '[ÐĎĐÞ]'
  }, {
    to: 'e',
    from: '[ÈÉÊËĒĔĖĘĚẸẺẼẾỀỂỄỆ]'
  }, {
    to: 'g',
    from: '[ĜĞĢǴ]'
  }, {
    to: 'h',
    from: '[ĤḦ]'
  }, {
    to: 'i',
    from: '[ÌÍÎÏĨĪĮİỈỊ]'
  }, {
    to: 'j',
    from: '[Ĵ]'
  }, {
    to: 'ij',
    from: '[Ĳ]'
  }, {
    to: 'k',
    from: '[Ķ]'
  }, {
    to: 'l',
    from: '[ĹĻĽŁ]'
  }, {
    to: 'm',
    from: '[Ḿ]'
  }, {
    to: 'n',
    from: '[ÑŃŅŇ]'
  }, {
    to: 'o',
    from: '[ÒÓÔÕÖØŌŎŐỌỎỐỒỔỖỘỚỜỞỠỢǪǬƠ]'
  }, {
    to: 'oe',
    from: '[Œ]'
  }, {
    to: 'p',
    from: '[ṕ]'
  }, {
    to: 'r',
    from: '[ŔŖŘ]'
  }, {
    to: 's',
    from: '[ßŚŜŞŠȘ]'
  }, {
    to: 't',
    from: '[ŢŤ]'
  }, {
    to: 'u',
    from: '[ÙÚÛÜŨŪŬŮŰŲỤỦỨỪỬỮỰƯ]'
  }, {
    to: 'w',
    from: '[ẂŴẀẄ]'
  }, {
    to: 'x',
    from: '[ẍ]'
  }, {
    to: 'y',
    from: '[ÝŶŸỲỴỶỸ]'
  }, {
    to: 'z',
    from: '[ŹŻŽ]'
  }, {
    to: '-',
    from: "[·/_,:;']"
  }];
  sets.forEach(function (set) {
    text = text.replace(new RegExp(set.from, 'gi'), set.to);
  });
  return text;
}

var industryList = {
  1: {
    vi: {
      name: 'Kế toán'
    },
    en: {
      name: 'Accounting'
    }
  },
  42: {
    vi: {
      name: 'Ngân hàng'
    },
    en: {
      name: 'Banking'
    }
  },
  35: {
    vi: {
      name: 'Phần mềm máy tính'
    },
    en: {
      name: 'Software developer'
    }
  },
  55: {
    vi: {
      name: 'IT Support / Help Desk'
    },
    en: {
      name: 'IT Support / Help Desk'
    }
  },
  7: {
    vi: {
      name: 'Xây dựng'
    },
    en: {
      name: 'Civil Engineering'
    }
  }
};
function getTopIndustries(industryIds, langCode, jobSeekerUrl, variantLocation) {
  return industryIds.map(function (industryId) {
    if (Object.prototype.hasOwnProperty.call(industryList, industryId)) {
      var industryData = industryList[industryId];

      if (Object.prototype.hasOwnProperty.call(industryData, langCode)) {
        var industryName = industryData[langCode].name;
        var url = buildSearchByIndustryUrl(industryName, industryId, langCode, jobSeekerUrl, variantLocation);
        return {
          name: industryName,
          url: url + "?utm_source_navi=footer"
        };
      }
    }

    return {};
  });
}

function buildSearchByIndustryUrl(industryName, industryId, languageId, jobSeekerUrl, variantLocation) {
  var industrySlug = slugify(industryName);
  var url = '/#';

  if (typeof variantLocation.id === 'object' && variantLocation.id.length > 0) {
    var locationSlug = slugify(variantLocation.name);
    var locationId = variantLocation.id;

    if (languageId === ELanguage.EN) {
      url = "/" + industrySlug + "-jobs-in-" + locationSlug + "-i" + industryId + "v" + locationId.join('.') + "-" + URL_SUFFIX_EN;
    } else {
      url = "/viec-lam-" + industrySlug + "-tai-" + locationSlug + "-i" + industryId + "v" + locationId.join('.') + "-" + URL_SUFFIX_VI;
    }
  } else {
    if (languageId === ELanguage.EN) {
      url = "/" + industrySlug + "-" + URL_KEYWORD_SUFFIX_EN;
    } else {
      url = "/" + industrySlug + "-" + URL_KEYWORD_SUFFIX_VI;
    }
  }

  return jobSeekerUrl + url;
}

var JobsByCategory = react__WEBPACK_IMPORTED_MODULE_0__.memo(function (props) {
  var variantLocation = props.variantLocation;

  var _useContext = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(AppShellContext),
      mode = _useContext.mode,
      langCode = _useContext.langCode;

  var jobSeekerUrl = getEnvVars(mode, langCode).jobSeekerUrl;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(''),
      variantLocationName = _useState[0],
      setVariantLocationName = _useState[1];

  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(translationFooter('Jobs by categories', langCode)),
      listHeading = _useState2[0],
      setListHeading = _useState2[1];

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    if (variantLocation === undefined) {
      setVariantLocationName('');
    } else {
      if (typeof variantLocation === 'object') {
        var locationList = initialDataProvider.getLocationNameFromIds(variantLocation);

        if (locationList.length > 0) {
          var locationName = '';
          locationList.map(function (item, index) {
            if (index > 0) {
              locationName += ', ';
            }

            locationName += langCode === ELanguage.EN ? item.nameEn : item.name;
          });
          setVariantLocationName(locationName);
        }
      } else {
        var variantLocationCheck = variantLocation;

        if (variantLocationCheck === -1) {
          setVariantLocationName('');
        } else {
          var _locationName = initialDataProvider.getLocationNameFromId(variantLocation);

          setVariantLocationName(langCode === ELanguage.EN ? _locationName.nameEn : _locationName.name);
        }
      }
    }
  }, [variantLocation]);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    if (variantLocationName) {
      if (langCode === ELanguage.EN) {
        setListHeading("Job by categories at " + variantLocationName);
      } else {
        setListHeading("Vi\u1EC7c l\xE0m t\u1EA1i " + variantLocationName);
      }
    } else {
      setListHeading(translationFooter('Jobs by categories', langCode));
    }
  }, [variantLocationName]);
  var industryList = [];

  if (props.jobCategories) {
    var variantLocationData = {
      id: variantLocation,
      name: variantLocationName
    };
    industryList = getTopIndustries(props.jobCategories, props.langCode, jobSeekerUrl, variantLocationData);
  }

  var topIndustryLinks = (industryList || []).map(function (industry, index) {
    return react__WEBPACK_IMPORTED_MODULE_0__.createElement("li", {
      key: index
    }, react__WEBPACK_IMPORTED_MODULE_0__.createElement("a", {
      href: industry === null || industry === void 0 ? void 0 : industry.url
    }, industry === null || industry === void 0 ? void 0 : industry.name));
  });
  return react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, react__WEBPACK_IMPORTED_MODULE_0__.createElement("ul", {
    className: 'footer__link'
  }, react__WEBPACK_IMPORTED_MODULE_0__.createElement("li", {
    className: 'footer__link-head has-text-centered-mobile'
  }, listHeading), topIndustryLinks), react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: 'footer__link'
  }, react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: 'footer__link-cta'
  }, react__WEBPACK_IMPORTED_MODULE_0__.createElement(LegacyLink, {
    path: '/job-search#recruitment',
    childOnly: true
  }, translationFooter('Job search', langCode), react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", {
    className: 'icon'
  }, react__WEBPACK_IMPORTED_MODULE_0__.createElement(ChevronRightIcon, null))))));
});

var locationList = {
  29: {
    vi: {
      name: 'Hồ Chí Minh'
    },
    en: {
      name: 'Ho Chi Minh'
    }
  },
  24: {
    vi: {
      name: 'Hà Nội'
    },
    en: {
      name: 'Ha Noi'
    }
  },
  28: {
    vi: {
      name: 'Hải Phòng'
    },
    en: {
      name: 'Hai Phong'
    }
  },
  17: {
    vi: {
      name: 'Đà Nẵng'
    },
    en: {
      name: 'Da Nang'
    }
  },
  15: {
    vi: {
      name: 'Cần Thơ'
    },
    en: {
      name: 'Can Tho'
    }
  },
  11: {
    vi: {
      name: 'Bình Dương'
    },
    en: {
      name: 'Binh Duong'
    }
  }
};
function getTopLocations(locationIds, langCode, jobSeekerUrl, variantCategory) {
  return locationIds.map(function (locationId) {
    if (locationList[locationId]) {
      var locationData = locationList[locationId];

      if (locationData[langCode]) {
        var locationName = locationData[langCode].name;
        var url = buildSearchByLocationUrl(locationName, locationId, langCode, jobSeekerUrl, variantCategory);
        return {
          name: locationName,
          url: url + "?utm_source_navi=footer"
        };
      }
    }

    return [];
  });
}

function buildSearchByLocationUrl(locationName, locationId, languageId, jobSeekerUrl, variantCategory) {
  var locationSlug = slugify(locationName);
  var url = '/#';

  if (variantCategory.id !== undefined && typeof variantCategory.id === 'number' && variantCategory.id !== -1 || typeof variantCategory.id === 'object' && variantCategory.id.length > 0) {
    var categorySlug = slugify(variantCategory.name);
    var categoryId = variantCategory.id;

    if (languageId === ELanguage.EN) {
      url = "/" + categorySlug + "-jobs-in" + locationSlug + "-i" + categoryId + "v" + locationId + "-" + URL_SUFFIX_EN;
    } else {
      url = "/viec-lam-" + categorySlug + "-tai-" + locationSlug + "-i" + categoryId + "v" + locationId + "-" + URL_SUFFIX_VI;
    }
  } else {
    if (languageId === ELanguage.EN) {
      url = "/" + locationSlug + "-jobs-v" + locationId + "-" + URL_SUFFIX_EN;
    } else {
      url = "/viec-lam-" + locationSlug + "-v" + locationId + "-" + URL_SUFFIX_VI;
    }
  }

  return jobSeekerUrl + url;
}

var JobsByLocation = react__WEBPACK_IMPORTED_MODULE_0__.memo(function (props) {
  var variantCategory = props.variantCategory;

  var _useContext = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(AppShellContext),
      mode = _useContext.mode,
      langCode = _useContext.langCode;

  var jobSeekerUrl = getEnvVars(mode, langCode).jobSeekerUrl;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(''),
      variantCategoryName = _useState[0],
      setVariantCategoryName = _useState[1];

  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(translationFooter('Jobs by location', langCode)),
      listHeading = _useState2[0],
      setListHeading = _useState2[1];

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    if (variantCategory === undefined) {
      setVariantCategoryName('');
      return;
    }

    if (typeof variantCategory === 'number' && variantCategory === -1) {
      setVariantCategoryName('');
    } else if (typeof variantCategory === 'object' && variantCategory.length > 0) {
      if (typeof variantCategory === 'object') {
        var categoryList = initialDataProvider.getCategoryNameFromIds(variantCategory);

        if (categoryList.length > 0) {
          var categoryName = '';
          categoryList.map(function (category, index) {
            var categoryNameItem = '';

            if (langCode === ELanguage.EN) {
              categoryNameItem = category.nameEn;
            } else {
              categoryNameItem = category.name;
            }

            categoryName += (index > 0 ? ', ' : '') + categoryNameItem;
          });
          setVariantCategoryName(categoryName);
        }
      } else {
        var category = initialDataProvider.getCategoryNameFromId(variantCategory);

        if (langCode === ELanguage.EN) {
          setVariantCategoryName(category.nameEn);
        } else {
          setVariantCategoryName(category.name);
        }
      }
    } else if (typeof variantCategory === 'object' && variantCategory.length === 0) {
      setVariantCategoryName('');
    }
  }, [variantCategory]);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    if (variantCategoryName) {
      if (langCode === ELanguage.EN) {
        setListHeading(variantCategoryName + " jobs by location");
      } else {
        setListHeading("Vi\u1EC7c l\xE0m " + variantCategoryName + " t\u1EA1i");
      }
    } else {
      setListHeading(translationFooter('Jobs by location', langCode));
    }
  }, [variantCategoryName]);
  var locationList = [];

  if (props.jobLocations) {
    var variantCategoryData = {
      id: variantCategory,
      name: variantCategoryName
    };
    locationList = getTopLocations(props.jobLocations, props.langCode, jobSeekerUrl, variantCategoryData);
  }

  var topLocationLinks = locationList.map(function (location, index) {
    return react__WEBPACK_IMPORTED_MODULE_0__.createElement("li", {
      key: index
    }, react__WEBPACK_IMPORTED_MODULE_0__.createElement("a", {
      href: location.url
    }, location.name));
  });
  return react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, react__WEBPACK_IMPORTED_MODULE_0__.createElement("ul", {
    className: 'footer__link'
  }, react__WEBPACK_IMPORTED_MODULE_0__.createElement("li", {
    className: 'footer__link-head has-text-centered-mobile'
  }, listHeading), topLocationLinks), react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: 'footer__link'
  }, react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: 'footer__link-cta'
  }, react__WEBPACK_IMPORTED_MODULE_0__.createElement(LegacyLink, {
    path: '/job-by-locations',
    childOnly: true
  }, translationFooter('See all locations', langCode), react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", {
    className: 'icon'
  }, react__WEBPACK_IMPORTED_MODULE_0__.createElement(ChevronRightIcon, null))))));
});

var links = [{
  title: 'Post Job',
  url: 'employerPostJob'
}, {
  title: 'Search Resume',
  url: 'employerSearchResume'
}, {
  title: 'HR Insider',
  url: 'employerOtherServices'
}, {
  title: 'Contact',
  url: 'employerContact'
}];
function EmployerLink() {
  var _useContext = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(AppShellContext),
      langCode = _useContext.langCode,
      mode = _useContext.mode;

  var envParams = getEnvVars(mode, langCode);
  return react__WEBPACK_IMPORTED_MODULE_0__.createElement("ul", {
    className: 'footer__link has-text-centered-mobile'
  }, react__WEBPACK_IMPORTED_MODULE_0__.createElement("li", {
    className: 'footer__link-head'
  }, translationFooter('For Employers', langCode)), links.map(function (link, index) {
    var title = translationFooter(link.title, langCode);
    var url = envParams[link.url] || '#';
    return react__WEBPACK_IMPORTED_MODULE_0__.createElement("li", {
      key: index
    }, react__WEBPACK_IMPORTED_MODULE_0__.createElement("a", {
      href: url,
      title: title,
      target: '_blank',
      rel: 'noreferrer'
    }, title));
  }));
}

var MobileAppDownload = function MobileAppDownload(props) {
  var langCode = props.langCode,
      mode = props.mode;
  var iosDownloadUrl = config.ios_download_url[langCode];
  var androidDownloadUrl = config.android_download_url[langCode];
  var govRegisteredUrl = config.registered_gov_url[langCode];
  var envVars = getEnvVars(mode, langCode);
  return react__WEBPACK_IMPORTED_MODULE_0__.createElement("ul", {
    className: 'footer__link footer__mobile-download'
  }, react__WEBPACK_IMPORTED_MODULE_0__.createElement("li", {
    className: 'footer__link-head has-text-centered-mobile'
  }, translationFooter('Mobile app', langCode)), react__WEBPACK_IMPORTED_MODULE_0__.createElement("li", {
    className: 'is-mobile is-variable is-1-mobile row-app-download'
  }, react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: 'column is-narrow wrapper-app-download'
  }, react__WEBPACK_IMPORTED_MODULE_0__.createElement("a", {
    href: iosDownloadUrl,
    title: translationFooter('Mobile app', langCode),
    rel: 'noreferrer',
    target: '_blank',
    className: 'wrap-ios'
  }, react__WEBPACK_IMPORTED_MODULE_0__.createElement("img", {
    width: 108,
    height: 32,
    className: 'is-hidden-tablet mr-2',
    src: appleDownloadImage,
    alt: translationFooter('Mobile app', langCode),
    loading: 'lazy'
  }), react__WEBPACK_IMPORTED_MODULE_0__.createElement("img", {
    width: 108,
    height: 32,
    className: 'is-hidden-mobile',
    src: appleDownloadImage,
    alt: translationFooter('Mobile app', langCode),
    loading: 'lazy'
  })), react__WEBPACK_IMPORTED_MODULE_0__.createElement("a", {
    href: androidDownloadUrl,
    title: translationFooter('Mobile app', langCode),
    target: '_blank',
    rel: 'noreferrer',
    className: 'wrap-android'
  }, react__WEBPACK_IMPORTED_MODULE_0__.createElement("img", {
    width: 108,
    height: 32,
    className: 'is-hidden-tablet ml-2',
    src: androidDownloadImage,
    alt: translationFooter('Mobile app', langCode),
    loading: 'lazy'
  }), react__WEBPACK_IMPORTED_MODULE_0__.createElement("img", {
    width: 108,
    height: 32,
    className: 'is-hidden-mobile',
    src: androidDownloadImage,
    alt: translationFooter('Mobile app', langCode),
    loading: 'lazy'
  })))), react__WEBPACK_IMPORTED_MODULE_0__.createElement("li", {
    className: 'footer__link-head has-text-centered-mobile is-hidden-mobile'
  }, translationFooter('Verified by', langCode)), react__WEBPACK_IMPORTED_MODULE_0__.createElement("li", {
    className: 'has-text-centered-mobile is-hidden-mobile'
  }, react__WEBPACK_IMPORTED_MODULE_0__.createElement("a", {
    href: govRegisteredUrl,
    target: '_blank',
    rel: 'noreferrer',
    title: translationFooter('Verified by', langCode),
    style: {
      display: 'inline-block'
    }
  }, react__WEBPACK_IMPORTED_MODULE_0__.createElement("img", {
    src: registeredImage,
    width: '124',
    height: '46.84',
    alt: translationFooter('Verified by', langCode),
    loading: 'lazy'
  }))), react__WEBPACK_IMPORTED_MODULE_0__.createElement("li", {
    className: 'footer__link-head has-text-centered-mobile is-hidden-mobile'
  }, translationFooter('Follow VietnamWorks on', langCode)), react__WEBPACK_IMPORTED_MODULE_0__.createElement("li", {
    className: 'social-icons has-text-centered-mobile is-hidden-mobile'
  }, react__WEBPACK_IMPORTED_MODULE_0__.createElement("a", {
    href: envVars.facebookLink,
    target: '_blank',
    rel: 'noreferrer',
    title: "VietnamWorks's Facebook"
  }, react__WEBPACK_IMPORTED_MODULE_0__.createElement("img", {
    src: envVars.facebookIcon,
    width: 20,
    height: 20,
    alt: "VietnamWorks's Facebook",
    loading: 'lazy'
  })), react__WEBPACK_IMPORTED_MODULE_0__.createElement("a", {
    href: envVars.linkedinLink,
    target: '_blank',
    rel: 'noreferrer',
    title: "VietnamWorks's Linkedin"
  }, react__WEBPACK_IMPORTED_MODULE_0__.createElement("img", {
    src: envVars.linkedinIcon,
    width: 20,
    height: 20,
    alt: "VietnamWorks's Linkedin",
    loading: 'lazy'
  })), react__WEBPACK_IMPORTED_MODULE_0__.createElement("a", {
    href: envVars.tiktokLink,
    target: '_blank',
    rel: 'noreferrer',
    title: "VietnamWorks's Tiktok"
  }, react__WEBPACK_IMPORTED_MODULE_0__.createElement("img", {
    src: envVars.tiktokIcon,
    width: 20,
    height: 20,
    alt: "VietnamWorks's Tiktok",
    loading: 'lazy'
  })), react__WEBPACK_IMPORTED_MODULE_0__.createElement("a", {
    href: envVars.youtubeLink,
    target: '_blank',
    rel: 'noreferrer',
    title: "VietnamWorks's Youtube"
  }, react__WEBPACK_IMPORTED_MODULE_0__.createElement("img", {
    src: envVars.youtubeIcon,
    width: 20,
    height: 20,
    alt: "VietnamWorks's Youtube",
    loading: 'lazy'
  })), react__WEBPACK_IMPORTED_MODULE_0__.createElement("a", {
    href: envVars.spotifyLink,
    target: '_blank',
    rel: 'noreferrer',
    title: "VietnamWorks's Spotify"
  }, react__WEBPACK_IMPORTED_MODULE_0__.createElement("img", {
    src: envVars.spotifyIcon,
    width: 20,
    height: 20,
    alt: "VietnamWorks's Spotify",
    loading: 'lazy'
  }))));
};

var FollowUs = function FollowUs(props) {
  var langCode = props.langCode,
      mode = props.mode;
  var envVars = getEnvVars(mode, langCode);
  return react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: 'has-text-centered is-hidden-tablet footer__follow-us'
  }, react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: 'footer__link-head'
  }, translationFooter('Follow us on', langCode)), react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: 'columns is-mobile is-variable is-1'
  }, react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: 'column is-narrow social-icons social-icons-responsive'
  }, react__WEBPACK_IMPORTED_MODULE_0__.createElement("a", {
    href: envVars.facebookLink,
    target: '_blank',
    rel: 'noreferrer',
    title: "VietnamWorks's Facebook"
  }, react__WEBPACK_IMPORTED_MODULE_0__.createElement("img", {
    src: envVars.facebookIcon,
    width: 20,
    height: 20,
    alt: "VietnamWorks's Facebook",
    loading: 'lazy'
  })), react__WEBPACK_IMPORTED_MODULE_0__.createElement("a", {
    href: envVars.linkedinLink,
    target: '_blank',
    rel: 'noreferrer',
    title: "VietnamWorks's Linkedin"
  }, react__WEBPACK_IMPORTED_MODULE_0__.createElement("img", {
    src: envVars.linkedinIcon,
    width: 20,
    height: 20,
    alt: "VietnamWorks's Linkedin",
    loading: 'lazy'
  })), react__WEBPACK_IMPORTED_MODULE_0__.createElement("a", {
    href: envVars.tiktokLink,
    target: '_blank',
    rel: 'noreferrer',
    title: "VietnamWorks's Tiktok"
  }, react__WEBPACK_IMPORTED_MODULE_0__.createElement("img", {
    src: envVars.tiktokIcon,
    width: 20,
    height: 20,
    alt: "VietnamWorks's Tiktok",
    loading: 'lazy'
  })), react__WEBPACK_IMPORTED_MODULE_0__.createElement("a", {
    href: envVars.youtubeLink,
    target: '_blank',
    rel: 'noreferrer',
    title: "VietnamWorks's Youtube"
  }, react__WEBPACK_IMPORTED_MODULE_0__.createElement("img", {
    src: envVars.youtubeIcon,
    width: 20,
    height: 20,
    alt: "VietnamWorks's Youtube",
    loading: 'lazy'
  })), react__WEBPACK_IMPORTED_MODULE_0__.createElement("a", {
    href: envVars.spotifyLink,
    target: '_blank',
    rel: 'noreferrer',
    title: "VietnamWorks's Spotify"
  }, react__WEBPACK_IMPORTED_MODULE_0__.createElement("img", {
    src: envVars.spotifyIcon,
    width: 20,
    height: 20,
    alt: "VietnamWorks's Spotify",
    loading: 'lazy'
  })))));
};

var MobileJobsByCategory = function MobileJobsByCategory(props) {
  return react__WEBPACK_IMPORTED_MODULE_0__.createElement("ul", {
    className: 'footer__link'
  }, react__WEBPACK_IMPORTED_MODULE_0__.createElement("li", {
    className: 'footer__link-head has-text-centered-mobile is-hidden-tablet'
  }, react__WEBPACK_IMPORTED_MODULE_0__.createElement(LegacyLink, {
    path: '/job-search#recruitment',
    childOnly: true
  }, translationFooter('Job search', props.langCode), react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", {
    className: 'icon'
  }, react__WEBPACK_IMPORTED_MODULE_0__.createElement(ChevronRightIcon, null)))));
};

var MobileJobsByLocation = function MobileJobsByLocation(props) {
  return react__WEBPACK_IMPORTED_MODULE_0__.createElement("ul", {
    className: 'footer__link'
  }, react__WEBPACK_IMPORTED_MODULE_0__.createElement("li", {
    className: 'footer__link-head has-text-centered-mobile is-hidden-tablet'
  }, react__WEBPACK_IMPORTED_MODULE_0__.createElement(LegacyLink, {
    path: '/job-by-locations',
    childOnly: true
  }, translationFooter('Search all locations', props.langCode), react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", {
    className: 'icon'
  }, react__WEBPACK_IMPORTED_MODULE_0__.createElement(ChevronRightIcon, null)))));
};

var INTECH_LOGO = '/vnw_intech_logo_white.png';

var VietnamWorksLinks = function VietnamWorksLinks(props) {
  var _useContext = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(AppShellContext),
      mode = _useContext.mode,
      langCode = _useContext.langCode;

  var envVars = getEnvVars(mode, langCode);
  var fullLogo = "" + envVars.pageContainerImageService + INTECH_LOGO;
  return react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, react__WEBPACK_IMPORTED_MODULE_0__.createElement("hr", null), react__WEBPACK_IMPORTED_MODULE_0__.createElement("nav", {
    className: 'level'
  }, react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: 'level-left'
  }, react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: 'level-item'
  }, react__WEBPACK_IMPORTED_MODULE_0__.createElement("a", {
    href: props.homepageUrl,
    className: 'mr-2',
    title: 'VietnamWorks Logo'
  }, react__WEBPACK_IMPORTED_MODULE_0__.createElement("img", {
    src: logoFooterImage,
    width: '38',
    height: '38',
    alt: 'VietnamWorks Logo',
    loading: 'lazy'
  })), react__WEBPACK_IMPORTED_MODULE_0__.createElement("a", {
    href: props.homepageUrl,
    className: 'footer-main-logo'
  }, "\xA9 VietnamWorks")), react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: 'level-item ml-38'
  }, react__WEBPACK_IMPORTED_MODULE_0__.createElement("a", {
    href: envVars.jobSeekerUrl + "/intech?utm_source_navi=footer",
    className: 'footer-main-logo mr-2',
    title: 'VietnamWorks inTECH Logo',
    target: '_blank'
  }, react__WEBPACK_IMPORTED_MODULE_0__.createElement("img", {
    src: fullLogo,
    width: '132',
    height: '38',
    alt: 'VietnamWorks inTECH Logo',
    loading: 'lazy'
  }))), react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: 'level-item ml-38'
  }, react__WEBPACK_IMPORTED_MODULE_0__.createElement("a", {
    href: 'https://www.navigosgroup.com/?utm_source_navi=footer',
    className: 'footer-main-logo mr-2',
    title: 'Navigos Group Logo',
    target: '_blank'
  }, "Powered by", react__WEBPACK_IMPORTED_MODULE_0__.createElement(NavigosGroupLogo, {
    clipPathId: 'desktop'
  }))))));
};

var VietnamWorksLinks$1 = function VietnamWorksLinks(props) {
  var faqUrl = props.faqUrl;
  return react__WEBPACK_IMPORTED_MODULE_0__.createElement("ul", {
    className: 'footer__link'
  }, react__WEBPACK_IMPORTED_MODULE_0__.createElement("li", {
    className: 'footer__link-head'
  }, "VietnamWorks"), react__WEBPACK_IMPORTED_MODULE_0__.createElement("li", null, react__WEBPACK_IMPORTED_MODULE_0__.createElement(LegacyLink, {
    path: '/company/navigosgroup?lang=en',
    target: '_blank',
    title: 'About Us'
  })), react__WEBPACK_IMPORTED_MODULE_0__.createElement("li", null, react__WEBPACK_IMPORTED_MODULE_0__.createElement(LegacyLink, {
    path: '/intech',
    target: '_blank',
    title: 'About VietnamWorks inTECH'
  })), react__WEBPACK_IMPORTED_MODULE_0__.createElement("li", null, react__WEBPACK_IMPORTED_MODULE_0__.createElement(LegacyLink, {
    path: '/contact-us',
    title: 'Contact Us'
  })), react__WEBPACK_IMPORTED_MODULE_0__.createElement("li", null, react__WEBPACK_IMPORTED_MODULE_0__.createElement(LegacyLink, {
    absoluteUrl: faqUrl,
    title: 'FAQ'
  })), react__WEBPACK_IMPORTED_MODULE_0__.createElement("li", null, react__WEBPACK_IMPORTED_MODULE_0__.createElement(LegacyLink, {
    path: '/terms-of-use',
    title: 'Terms Of Use'
  })), react__WEBPACK_IMPORTED_MODULE_0__.createElement("li", null, react__WEBPACK_IMPORTED_MODULE_0__.createElement(LegacyLink, {
    path: '/privacy-policy',
    title: 'Privacy Statement'
  })), react__WEBPACK_IMPORTED_MODULE_0__.createElement("li", null, react__WEBPACK_IMPORTED_MODULE_0__.createElement(LegacyLink, {
    path: '/operation-ecommerce',
    title: 'Operation Regulation Of VietnamWorks E-Commerce Trading Floor'
  })), react__WEBPACK_IMPORTED_MODULE_0__.createElement("li", null, react__WEBPACK_IMPORTED_MODULE_0__.createElement(LegacyLink, {
    path: '/site-map',
    title: 'Site Map'
  })));
};

var getSeoKeywordAPI = function getSeoKeywordAPI(msBasePath) {
  var apiUrl = msBasePath + '/meta/v1.0/keyword-seo';
  return Promise.resolve(_catch(function () {
    return Promise.resolve(fetch(apiUrl, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      }
    })).then(function (res) {
      var _exit = false;

      var _temp = function () {
        if (res.status === 200) {
          return Promise.resolve(res.json()).then(function (data) {
            _exit = true;
            return data.data.relationships.data;
          });
        }
      }();

      return _temp && _temp.then ? _temp.then(function (_result) {
        return _exit ? _result : null;
      }) : _exit ? _temp : null;
    });
  }, function () {
    return null;
  }));
};
var getIntechBannerAPI = function getIntechBannerAPI(apiUrl) {
  return Promise.resolve(_catch(function () {
    return Promise.resolve(fetch(apiUrl, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      }
    })).then(function (res) {
      var _temp2 = res.status === 200;

      return _temp2 ? Promise.resolve(res.json()) : null;
    });
  }, function () {
    return null;
  }));
};

function _templateObject3() {
  var data = _taggedTemplateLiteralLoose(["\n    display: inline-block;\n    padding: 9px 6px;\n    font-weight: 500;\n    line-height: 14px;\n    font-size: 12px;\n    color: #939393;\n    &:hover,\n    &:active,\n    &:focus {\n        color: #ff7d55;\n    }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n    border: 1px solid #eaeaf0;\n    border-radius: 12px;\n    padding: 16px;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n    display: flex;\n    padding: 32px 0;\n\n    &.container {\n        padding: 0 0 32px 0;\n    }\n\n    @media (max-width: 991px) {\n        padding: 16px 0;\n    }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}
var SeoKeywordTag = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div */ .ZP.div(_templateObject());
var Wrapper = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div */ .ZP.div(_templateObject2());
var SeoItem = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].a */ .ZP.a(_templateObject3());

var SeoKeyword = function SeoKeyword(_ref) {
  var seoKeywordData = _ref.seoKeywordData,
      msBasePath = _ref.msBasePath;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(seoKeywordData || []),
      seoKeywords = _useState[0],
      setSeoKeywords = _useState[1];

  var getSeoKeywords = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function () {
    try {
      return Promise.resolve(getSeoKeywordAPI(msBasePath)).then(function (data) {
        if (data && data.length > 0) {
          setSeoKeywords(data);
        }
      });
    } catch (e) {
      return Promise.reject(e);
    }
  }, [msBasePath]);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    if (!seoKeywordData) {
      getSeoKeywords();
      return;
    }

    setSeoKeywords(seoKeywordData);
  }, [seoKeywordData, getSeoKeywords]);

  if (seoKeywords.length === 0) {
    return null;
  }

  var renderKeywordList = function renderKeywordList() {
    return seoKeywords.map(function (item) {
      return react__WEBPACK_IMPORTED_MODULE_0__.createElement(SeoItem, {
        key: item.id,
        href: item.attributes.link,
        target: '_blank'
      }, item.attributes.name);
    });
  };

  return react__WEBPACK_IMPORTED_MODULE_0__.createElement(SeoKeywordTag, null, react__WEBPACK_IMPORTED_MODULE_0__.createElement(_microfrontends_react_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, null, react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, null, renderKeywordList())));
};

var Footer = /*#__PURE__*/function (_React$PureComponent) {
  _inheritsLoose(Footer, _React$PureComponent);

  function Footer(props) {
    var _this;

    _this = _React$PureComponent.call(this, props) || this;
    _this.state = {
      isUMD: false,
      keyword: '',
      variantLocation: _this.getVariantLocationUMD(),
      variantCategory: _this.getVariantCategoryUMD(),
      enableZaloWidget: false
    };
    _this.envVars = getEnvVars(props.mode, props.langCode);
    _this.appContext = {
      langCode: _this.props.langCode,
      mode: props.mode,
      bottomSEOContent: props.bottomSEOContent,
      user: _this.props.user,
      categoryId: [],
      companyIndustries: [],
      locationId: [],
      locations: [],
      keyword: '',
      jobFunctions: []
    };
    _this.handleUpdateSearchParams = _this.handleUpdateSearchParams.bind(_assertThisInitialized(_this));
    return _this;
  }

  var _proto = Footer.prototype;

  _proto.getVariantLocationUMD = function getVariantLocationUMD() {
    if (typeof window !== 'undefined') {
      var searchParams = JSON.parse(localStorage.getItem('params') || '{}');
      return searchParams.locationId;
    }

    return [];
  };

  _proto.getVariantCategoryUMD = function getVariantCategoryUMD() {
    if (typeof window !== 'undefined') {
      var searchParams = JSON.parse(localStorage.getItem('params') || '{}');
      return searchParams.categoryId;
    }

    return [];
  };

  _proto.render = function render() {
    var _this$props2;

    var _this$props = this.props,
        mode = _this$props.mode,
        langCode = _this$props.langCode;

    var _getEnvVars = getEnvVars(mode, langCode),
        faqUrl = _getEnvVars.faqUrl,
        jobSeekerUrl = _getEnvVars.jobSeekerUrl,
        msBasePath = _getEnvVars.msBasePath;

    var keyword = this.state.keyword;
    var homepageUrl = "" + jobSeekerUrl + (langCode === ELanguage.EN ? '/en?utm_source_navi=footer' : '/?utm_source_navi=footer');
    return react__WEBPACK_IMPORTED_MODULE_0__.createElement(AppShellContext.Provider, {
      value: this.appContext
    }, react__WEBPACK_IMPORTED_MODULE_0__.createElement("footer", {
      className: 'vnw'
    }, react__WEBPACK_IMPORTED_MODULE_0__.createElement(BottomText, Object.assign({}, this.props.bottomSEOContent, {
      keyword: keyword
    })), ((_this$props2 = this.props) === null || _this$props2 === void 0 ? void 0 : _this$props2.isHiddenSeoKeyword) ? null : react__WEBPACK_IMPORTED_MODULE_0__.createElement(SeoKeyword, {
      seoKeywordData: this.props.seoKeywordData,
      msBasePath: msBasePath
    }), react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
      className: 'footer animated fadeIn'
    }, react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
      className: 'footer__container'
    }, react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
      className: 'columns is-hidden-tablet footer__sitemap is-gapless mb-5'
    }, react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
      className: 'column'
    }, react__WEBPACK_IMPORTED_MODULE_0__.createElement(MobileJobsByCategory, {
      langCode: langCode
    })), react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
      className: 'column'
    }, react__WEBPACK_IMPORTED_MODULE_0__.createElement(MobileJobsByLocation, {
      langCode: langCode
    }))), react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
      className: 'columns'
    }, react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
      className: 'column is-hidden-mobile'
    }, react__WEBPACK_IMPORTED_MODULE_0__.createElement(VietnamWorksLinks$1, {
      faqUrl: faqUrl
    })), react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
      className: 'column'
    }, react__WEBPACK_IMPORTED_MODULE_0__.createElement(EmployerLink, null)), react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
      className: 'column is-hidden-mobile'
    }, react__WEBPACK_IMPORTED_MODULE_0__.createElement(JobsByLocation, {
      langCode: langCode,
      jobLocations: config.top_locations
    })), react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
      className: 'column is-hidden-mobile'
    }, react__WEBPACK_IMPORTED_MODULE_0__.createElement(JobsByCategory, {
      langCode: langCode,
      jobCategories: config.top_categories
    })), react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
      className: 'column'
    }, react__WEBPACK_IMPORTED_MODULE_0__.createElement(MobileAppDownload, {
      langCode: langCode,
      mode: mode
    }))), react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
      className: 'columns has-text-centered is-hidden-tablet mb-40'
    }, react__WEBPACK_IMPORTED_MODULE_0__.createElement("a", {
      href: 'https://www.navigosgroup.com/?utm_source_navi=footer',
      className: 'footer__link-head',
      title: 'Navigos Group Logo',
      target: '_blank'
    }, "Powered by", react__WEBPACK_IMPORTED_MODULE_0__.createElement(NavigosGroupLogo, {
      clipPathId: 'mobile'
    }))), react__WEBPACK_IMPORTED_MODULE_0__.createElement(FollowUs, {
      langCode: langCode,
      mode: mode
    }), react__WEBPACK_IMPORTED_MODULE_0__.createElement(CopyRights, {
      langCode: langCode
    }), react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
      className: 'is-hidden-mobile'
    }, react__WEBPACK_IMPORTED_MODULE_0__.createElement(VietnamWorksLinks, {
      langCode: langCode,
      homepageUrl: homepageUrl
    }))))));
  };

  _proto.handleUpdateSearchParams = function handleUpdateSearchParams(event) {
    var eventDetail = event.detail;
    var _eventDetail$params = eventDetail.params,
        _eventDetail$params$q = _eventDetail$params.query,
        query = _eventDetail$params$q === void 0 ? '' : _eventDetail$params$q,
        _eventDetail$params$l = _eventDetail$params.locationId,
        locationId = _eventDetail$params$l === void 0 ? [] : _eventDetail$params$l,
        _eventDetail$params$c = _eventDetail$params.categoryId,
        categoryId = _eventDetail$params$c === void 0 ? [] : _eventDetail$params$c;
    this.setState({
      variantCategory: categoryId,
      variantLocation: locationId,
      keyword: query
    });
  };

  _proto.componentDidMount = function componentDidMount() {
    if (typeof window !== 'undefined') {
      window.addEventListener('SEARCH', this.handleUpdateSearchParams);
    }
  };

  return Footer;
}(react__WEBPACK_IMPORTED_MODULE_0__.PureComponent);

Footer.contextType = AppShellContext;
Footer.defaultProps = {
  searchBoxSettings: {
    active: false,
    locationSelectData: [],
    categorySelectData: []
  },
  bottomSEOContent: {
    html: '',
    imageUrl: ''
  }
};

function useDomContentLoaded() {
  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false),
      isDomContentLoaded = _useState[0],
      setIsDomContentLoaded = _useState[1];

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    if (isDomContentLoaded === false) {
      setIsDomContentLoaded(true);
    }
  }, [isDomContentLoaded]);
  return isDomContentLoaded;
}

var initialValues = {
  langCode: ELanguage.VI,
  bottomSEOContent: null,
  mode: EMode.STAGING,
  user: null,
  keyword: '',
  companyIndustries: [],
  jobFunctions: [],
  locationId: [],
  categoryId: [],
  locations: [],
  pageName: EPages.NONE,
  translate: function translate() {
    return '';
  },
  isLoggedIn: false,
  hiddenSearchBar: false,
  userIp: '',
  isMobile: false,
  isTablet: false,
  isHomePage: false,
  responsive: {
    type: 'home-page',
    cornerColor: '#fff'
  },
  optionList: [],
  isPageContainer: false,
  zoneName: ETopBannerZoneName.EMPTY,
  forceShowTopBanner: false,
  topBannerData: null,
  autoFetchTopBanner: true,
  showTabFindJob: true
};
var AppShellContext$1 = react__WEBPACK_IMPORTED_MODULE_0__.createContext(initialValues);

var useAppShellContext = function useAppShellContext() {
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(AppShellContext$1);
};

var INTECH_LOGO$1 = '/vnw_intech_logo_white.svg';
var VNW_LOGO_MINI = '/vnw_empower_growth_mini_logo.png';
var VNW_LOGO_WHITE = '/vnw_empower_growth_logo_white.png';
var EShowSubMenu;

(function (EShowSubMenu) {
  EShowSubMenu["JOBS"] = "jobs";
  EShowSubMenu["TOOLS"] = "tools";
})(EShowSubMenu || (EShowSubMenu = {}));

var TOTAL_HEIGHT_OF_POPUP_NEW_USER = 78;
var POPUP_NEW_USER_CLOSE_TIMES = 3;
var TOP_BANNER_HEIGHT = 50;

function _templateObject3$1() {
  var data = _taggedTemplateLiteralLoose(["\n    position: relative;\n    z-index: 1;\n    flex-shrink: 0;\n"]);

  _templateObject3$1 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$1() {
  var data = _taggedTemplateLiteralLoose(["\n    display: none;\n    height: ", ";\n    @media (max-width: 1200px) {\n        display: block;\n        width: auto !important;\n    }\n    @media (max-width: 767px) {\n        display: none;\n    }\n    @media (max-width: 767px) {\n        display: none;\n    }\n"]);

  _templateObject2$1 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$1() {
  var data = _taggedTemplateLiteralLoose(["\n    display: block;\n    height: ", ";\n    @media (max-width: 1200px) {\n        display: none;\n    }\n    @media (max-width: 767px) {\n        display: block;\n    }\n"]);

  _templateObject$1 = function _templateObject() {
    return data;
  };

  return data;
}
var FullLogo = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].img */ .ZP.img(_templateObject$1(), function (_ref) {
  var isIntech = _ref.isIntech;
  return isIntech ? '24px' : '40px';
});
var MiniLogo = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].img */ .ZP.img(_templateObject2$1(), function (_ref2) {
  var isIntech = _ref2.isIntech;
  return isIntech ? '24px' : '40px';
});
var Link = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].a */ .ZP.a(_templateObject3$1());
function Logo(_ref3) {
  var _ref3$isIntech = _ref3.isIntech,
      isIntech = _ref3$isIntech === void 0 ? false : _ref3$isIntech;

  var _useAppShellContext = useAppShellContext(),
      mode = _useAppShellContext.mode,
      langCode = _useAppShellContext.langCode,
      pageName = _useAppShellContext.pageName;

  var envVars = getEnvVars(mode, langCode);
  var fullLogo = "" + envVars.pageContainerImageService + (isIntech ? INTECH_LOGO$1 : VNW_LOGO_WHITE);
  var miniLogo = "" + envVars.pageContainerImageService + (isIntech ? INTECH_LOGO$1 : VNW_LOGO_MINI);
  var titleTextVI = 'VietnamWorks - Nền tảng tuyển dụng, việc làm, tra cứu lương & tư vấn nghề nghiệp hàng đầu Việt Nam';
  var titleTextEN = 'VietnamWorks - Recruitment, employment, salary lookup & career advice platform';
  var titleTextIntechVI = 'VietnamWorks inTECH - việc làm IT trên VietnamWorks.com';
  var titleTextIntechEN = 'VietnamWorks inTECH - IT jobs on VietnamWorks.com';

  var urlLogo = function () {
    var logoLinkUtm = "utm_source_navi=header&utm_medium_navi=" + (isIntech ? 'intechlogo' : 'vnwlogo');
    var url = envVars.jobSeekerUrl;

    if (isIntech) {
      url += (langCode === ELanguage.EN ? "/jobs?g=5" : "/viec-lam?g=5") + "&" + logoLinkUtm;
    } else {
      url += "/" + (langCode === ELanguage.EN ? langCode : "") + "?" + logoLinkUtm;
    }

    return url;
  }();

  var handleClearParams = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function (e) {
    e.preventDefault();
    e.stopPropagation();
    var defaultParamsWillClear = {
      categoryId: [],
      query: '',
      indexName: envVars.sortDefaultIndex
    };

    if (isIntech) {
      clearLocalStorageParams(_extends({}, defaultParamsWillClear, {
        locations: [],
        locationId: [],
        districtId: []
      }));
    } else {
      clearLocalStorageParams(_extends({}, defaultParamsWillClear, {
        jobFunctionId: []
      }));
    }

    window.location.assign(urlLogo);
  }, []);
  var titleText = langCode === ELanguage.VI ? titleTextVI : titleTextEN;

  if (isIntech) {
    titleText = langCode === ELanguage.VI ? titleTextIntechVI : titleTextIntechEN;
  }

  var renderLogo = function renderLogo() {
    return react__WEBPACK_IMPORTED_MODULE_0__.createElement(Link, {
      href: urlLogo,
      title: titleText,
      onClick: handleClearParams,
      tabIndex: 0
    }, react__WEBPACK_IMPORTED_MODULE_0__.createElement(FullLogo, {
      isIntech: isIntech,
      src: fullLogo,
      alt: titleText,
      width: 167,
      height: 40
    }), react__WEBPACK_IMPORTED_MODULE_0__.createElement(MiniLogo, {
      isIntech: isIntech,
      width: 40,
      height: 40,
      src: miniLogo,
      alt: titleText
    }));
  };

  return pageName === EPages.HOME_PAGE && !isIntech ? react__WEBPACK_IMPORTED_MODULE_0__.createElement("h1", {
    title: titleText
  }, renderLogo()) : renderLogo();
}

var BellIcon = function BellIcon(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 20 : _ref$size;
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("svg", {
    width: size,
    height: size,
    viewBox: '0 0 20 20',
    fill: 'none',
    xmlns: 'http://www.w3.org/2000/svg'
  }, (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("path", {
    d: 'M10.0001 2C9.26339 2 8.66672 2.59667 8.66672 3.33333V3.50781C6.36789 4.10087 4.66672 6.1827 4.66672 8.66667V10.263C4.66672 11.323 4.44902 12.3647 4.04302 13.3333H15.9571C15.5511 12.3653 15.3334 11.323 15.3334 10.263V8.66667C15.3334 6.1827 13.6322 4.10087 11.3334 3.50781V3.33333C11.3334 2.59667 10.7367 2 10.0001 2ZM3.33339 14.6667C3.24505 14.6654 3.15734 14.6817 3.07536 14.7147C2.99338 14.7476 2.91877 14.7965 2.85585 14.8586C2.79294 14.9206 2.74298 14.9945 2.70888 15.076C2.67479 15.1575 2.65723 15.245 2.65723 15.3333C2.65723 15.4217 2.67479 15.5092 2.70888 15.5907C2.74298 15.6722 2.79294 15.7461 2.85585 15.8081C2.91877 15.8701 2.99338 15.919 3.07536 15.952C3.15734 15.9849 3.24505 16.0012 3.33339 16H8.11724C8.04059 16.2139 8.00096 16.4394 8.00006 16.6667C8.00006 17.1971 8.21077 17.7058 8.58584 18.0809C8.96091 18.456 9.46962 18.6667 10.0001 18.6667C10.5305 18.6667 11.0392 18.456 11.4143 18.0809C11.7893 17.7058 12.0001 17.1971 12.0001 16.6667C11.9996 16.4395 11.9604 16.214 11.8842 16H16.6667C16.7551 16.0012 16.8428 15.9849 16.9248 15.952C17.0067 15.919 17.0813 15.8701 17.1443 15.8081C17.2072 15.7461 17.2571 15.6722 17.2912 15.5907C17.3253 15.5092 17.3429 15.4217 17.3429 15.3333C17.3429 15.245 17.3253 15.1575 17.2912 15.076C17.2571 14.9945 17.2072 14.9206 17.1443 14.8586C17.0813 14.7965 17.0067 14.7476 16.9248 14.7147C16.8428 14.6817 16.7551 14.6654 16.6667 14.6667H10.0001H3.33339Z',
    fill: '#fff'
  }));
};

var UserIcon = function UserIcon(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size;
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("svg", {
    width: size,
    height: size,
    viewBox: '0 0 24 24',
    fill: 'none',
    xmlns: 'http://www.w3.org/2000/svg'
  }, (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("path", {
    d: 'M12 2.40039C9.34882 2.40039 7.20002 4.54919 7.20002 7.20039V8.00039C7.20002 10.6516 9.34882 12.8004 12 12.8004C14.6512 12.8004 16.8 10.6516 16.8 8.00039V7.20039C16.8 4.54919 14.6512 2.40039 12 2.40039ZM11.9985 15.2004C8.79366 15.2004 4.68166 16.9339 3.49846 18.4723C2.76726 19.4235 3.46332 20.8004 4.66252 20.8004H19.336C20.5352 20.8004 21.2312 19.4235 20.5 18.4723C19.3168 16.9347 15.2033 15.2004 11.9985 15.2004Z',
    fill: 'currentColor'
  }));
};

var SettingIcon = function SettingIcon() {
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("svg", {
    width: 21,
    height: 20,
    viewBox: '0 0 21 20',
    fill: 'none',
    xmlns: 'http://www.w3.org/2000/svg'
  }, (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("path", {
    d: 'M19.364 8.48845L17 8.10205C16.8616 7.62765 16.6724 7.17165 16.4356 6.74005L17.8156 4.77325C17.9272 4.61445 17.908 4.39805 17.7708 4.26045L16.2152 2.70565C16.0764 2.56725 15.858 2.54925 15.6988 2.66405L13.7616 4.05645C13.326 3.81565 12.866 3.62445 12.3888 3.48565L11.9764 1.13125C11.9428 0.940049 11.7768 0.800049 11.5824 0.800049H9.38238C9.18638 0.800049 9.01918 0.942049 8.98758 1.13565L8.60518 3.47725C8.12518 3.61525 7.66438 3.80445 7.23038 4.04205L5.29838 2.66205C5.13878 2.54805 4.92158 2.56645 4.78278 2.70445L3.22798 4.25925C3.09078 4.39645 3.07158 4.61245 3.18318 4.77125L4.54278 6.71645C4.30078 7.15445 4.10798 7.61805 3.96758 8.10045L1.63518 8.48885C1.44238 8.52085 1.30078 8.68805 1.30078 8.88325V11.0833C1.30078 11.2773 1.43998 11.4432 1.63078 11.4773L3.96318 11.8908C4.10278 12.372 4.29558 12.8357 4.53838 13.2748L3.16198 15.2001C3.04838 15.3589 3.06638 15.5769 3.20438 15.7157L4.75958 17.2721C4.89678 17.4093 5.11318 17.4284 5.27198 17.3169L7.21998 15.9525C7.65718 16.1929 8.11918 16.3837 8.59798 16.522L8.98838 18.8665C9.01998 19.0589 9.18678 19.2001 9.38238 19.2001H11.5824C11.7764 19.2001 11.9424 19.0609 11.976 18.8701L12.394 16.5141C12.8736 16.3729 13.3332 16.1809 13.766 15.94L15.728 17.3165C15.8872 17.4289 16.1032 17.4093 16.2408 17.2721L17.796 15.7157C17.9344 15.5769 17.9524 15.3581 17.8376 15.1989L16.4384 13.2561C16.6756 12.824 16.864 12.3673 17.0012 11.8928L19.3684 11.4773C19.56 11.4437 19.6992 11.2773 19.6992 11.0833V8.88325C19.6996 8.68725 19.5576 8.52005 19.364 8.48845ZM10.5 12.8C8.95358 12.8 7.69998 11.5464 7.69998 10C7.69998 8.45365 8.95358 7.20005 10.5 7.20005C12.0464 7.20005 13.3 8.45365 13.3 10C13.3 11.5464 12.0464 12.8 10.5 12.8Z',
    fill: 'currentColor'
  }));
};

var HomeIcon = function HomeIcon() {
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("svg", {
    xmlns: 'http://www.w3.org/2000/svg',
    width: 21,
    height: 22,
    viewBox: '0 0 21 22',
    fill: 'none'
  }, (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("path", {
    d: 'M10.5 1.8999C10.317 1.89991 10.1413 1.97156 10.0106 2.09951L2.37481 8.34483C2.36599 8.35146 2.35733 8.35829 2.34883 8.36533L2.32286 8.38721V8.38858C2.25265 8.45398 2.19664 8.53312 2.1583 8.62109C2.11997 8.70905 2.10012 8.80395 2.10001 8.8999C2.10001 9.08556 2.17376 9.2636 2.30503 9.39488C2.43631 9.52615 2.61435 9.59991 2.80001 9.59991H3.50001V17.2999C3.50001 18.0734 4.12651 18.6999 4.90001 18.6999H16.1C16.8735 18.6999 17.5 18.0734 17.5 17.2999V9.59991H18.2C18.3857 9.59991 18.5637 9.52615 18.695 9.39488C18.8263 9.2636 18.9 9.08556 18.9 8.8999C18.9001 8.80372 18.8803 8.70856 18.842 8.62034C18.8036 8.53213 18.7475 8.45277 18.6772 8.38721L18.6662 8.37901C18.6509 8.36509 18.6349 8.35186 18.6184 8.33936L16.1 6.27901V3.2999C16.1 2.9135 15.7864 2.5999 15.4 2.5999H14.7C14.3136 2.5999 14 2.9135 14 3.2999V4.56182L10.9744 2.08721C10.8455 1.96733 10.6761 1.90045 10.5 1.8999ZM8.40001 11.6999H12.6V17.2999H8.40001V11.6999Z',
    fill: 'currentColor'
  }));
};

var ResponsiveJobIcon = function ResponsiveJobIcon() {
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("svg", {
    xmlns: 'http://www.w3.org/2000/svg',
    width: 21,
    height: 22,
    viewBox: '0 0 21 22',
    fill: 'none'
  }, (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("path", {
    d: 'M9.79999 2.6001C9.02649 2.6001 8.39999 3.2266 8.39999 4.0001H2.79999C2.02649 4.0001 1.39999 4.6266 1.39999 5.4001V11.7001C1.39999 12.4736 2.02649 13.1001 2.79999 13.1001H18.2C18.9735 13.1001 19.6 12.4736 19.6 11.7001V5.4001C19.6 4.6266 18.9735 4.0001 18.2 4.0001H12.6C12.6 3.2266 11.9735 2.6001 11.2 2.6001H9.79999ZM10.5 10.3001C10.8864 10.3001 11.2 10.6137 11.2 11.0001C11.2 11.3865 10.8864 11.7001 10.5 11.7001C10.1136 11.7001 9.79999 11.3865 9.79999 11.0001C9.79999 10.6137 10.1136 10.3001 10.5 10.3001ZM1.39999 14.1104V16.6001C1.39999 17.3736 2.02649 18.0001 2.79999 18.0001H18.2C18.9735 18.0001 19.6 17.3736 19.6 16.6001V14.1104C19.1863 14.3512 18.7124 14.5001 18.2 14.5001H2.79999C2.28759 14.5001 1.81369 14.3512 1.39999 14.1104Z',
    fill: 'currentColor'
  }));
};

var ResponsiveCompanyIcon = function ResponsiveCompanyIcon() {
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("svg", {
    xmlns: 'http://www.w3.org/2000/svg',
    width: 21,
    height: 22,
    viewBox: '0 0 21 22',
    fill: 'none'
  }, (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("path", {
    d: 'M16.8 2.18H4.2c-.694 0-1.26.566-1.26 1.26V19.4c0 .233.189.42.42.42h14.28c.233 0 .42-.187.42-.42V3.44c0-.694-.566-1.26-1.26-1.26ZM7.56 17.72H5.04v-2.1h2.52v2.1Zm0-3.78H5.04v-2.1h2.52v2.1Zm0-3.78H5.04v-2.1h2.52v2.1Zm0-3.78H5.04v-2.1h2.52v2.1Zm4.2 12.6H9.24v-3.36h2.52v3.36Zm0-5.04H9.24v-2.1h2.52v2.1Zm0-3.78H9.24v-2.1h2.52v2.1Zm0-3.78H9.24v-2.1h2.52v2.1Zm4.2 11.34h-2.52v-2.1h2.52v2.1Zm0-3.78h-2.52v-2.1h2.52v2.1Zm0-3.78h-2.52v-2.1h2.52v2.1Zm0-3.78h-2.52v-2.1h2.52v2.1Z',
    fill: 'currentColor'
  }));
};

var ReponsiveMyJobIcon = function ReponsiveMyJobIcon() {
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("svg", {
    xmlns: 'http://www.w3.org/2000/svg',
    width: 21,
    height: 22,
    viewBox: '0 0 21 22',
    fill: 'none'
  }, (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("path", {
    d: 'M6.681 3.3A4.581 4.581 0 0 0 2.1 7.881c0 4.405 5.11 8.614 7.496 10.488l.007.006.055.043.001-.001a1.4 1.4 0 0 0 .841.283c.304 0 .6-.1.842-.283v.001l.017-.012.012-.01a.76.76 0 0 0 .014-.012c2.38-1.867 7.515-6.087 7.515-10.503a4.58 4.58 0 0 0-4.581-4.58C11.9 3.3 10.5 5.4 10.5 5.4S9.1 3.3 6.681 3.3Z',
    fill: 'currentColor'
  }));
};

var faqUrl = {
  vi: {
    staging: 'https://staging-faq.vietnamworks.com/vi',
    release: 'https://release-faq.vietnamworks.com/vi',
    production: 'https://faq.vietnamworks.com/vi'
  },
  en: {
    staging: 'https://staging-faq.vietnamworks.com/en',
    release: 'https://release-faq.vietnamworks.com/en',
    production: 'https://faq.vietnamworks.com/en'
  }
};
var logoutUrl = {
  vi: {
    staging: 'https://staging-secure.vietnamworks.com/logout/vi?client_id=3',
    release: 'https://release-secure.vietnamworks.com/logout/vi?client_id=3',
    production: 'https://secure.vietnamworks.com/logout/vi?client_id=3'
  },
  en: {
    staging: 'https://staging-secure.vietnamworks.com/logout/en?client_id=3',
    release: 'https://release-secure.vietnamworks.com/logout/en?client_id=3',
    production: 'https://secure.vietnamworks.com/logout/en?client_id=3'
  }
};
var jobSeekerUrl = {
  staging: 'https://staging.vietnamworks.com',
  release: 'https://release.vietnamworks.com',
  production: 'https://www.vietnamworks.com'
};

var translation = {
  'Your name': 'Tên của bạn',
  'Update CV': 'Cập nhật hồ sơ',
  'Need helps? Read FAQ': 'Tham khảo những câu hỏi thường gặp',
  Dashboard: 'Tổng Quan',
  'My Profile': 'Hồ Sơ Của Tôi',
  'Profile Settings': 'Thiết Lập Hồ Sơ',
  'My Companies': 'Công Ty Của Tôi',
  'My Jobs': 'Việc Làm Của Tôi',
  'Job Alerts': 'Thông Báo Việc Làm',
  'Account Settings': 'Quản Lý Tài Khoản',
  Logout: 'Thoát',
  'Job Seeker Login': 'Người tìm việc đăng nhập',
  Facebook: 'Facebook',
  Google: 'Google',
  Login: 'Đăng nhập',
  'Register new account': 'Tạo tài khoản mới',
  'Order Management': 'Quản Lý Đơn Hàng'
};

function translator(langCode) {
  return function (key) {
    if (langCode === ELanguage.EN) {
      return key;
    }

    return translation[key];
  };
}

var ACCESS_TOKEN_LENGTH = 86;

var detectEncryptAccessToken = function detectEncryptAccessToken(accessToken) {
  return accessToken.length === ACCESS_TOKEN_LENGTH ? accessToken : _microfrontends_react_components__WEBPACK_IMPORTED_MODULE_5__/* .decrypt */ .pe(accessToken != null ? accessToken : '');
};

var buildUserMenu = function buildUserMenu(user, langCode, mode) {
  var _user$accessToken;

  var menuPaths = langCode === ELanguage.VI ? headerMenuViPath : headerMenuEnPath;
  var logoutPath = logoutUrl[langCode][mode] + ("" + ((user === null || user === void 0 ? void 0 : user.userId) ? '&accessToken=' + detectEncryptAccessToken((_user$accessToken = user === null || user === void 0 ? void 0 : user.accessToken) != null ? _user$accessToken : '') : ''));
  return [{
    id: 'Dashboard',
    title: translator(langCode)('Dashboard'),
    path: jobSeekerUrl[mode] + menuPaths.dashboardPath,
    icon: (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(_microfrontends_react_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
      width: 20
    }),
    isNew: true,
    utm: 'utm_source_navi=header&utm_medium_navi=dashboard'
  }, {
    id: 'myProfile',
    title: translator(langCode)('My Profile'),
    path: jobSeekerUrl[mode] + menuPaths.myProfilePath,
    icon: (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(_microfrontends_react_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
      width: 20
    }),
    utm: 'utm_source_navi=header&utm_medium_navi=myprofile'
  }, {
    id: 'whoViewMyProfile',
    title: translator(langCode)('My Companies'),
    path: jobSeekerUrl[mode] + menuPaths.myCompaniesPath,
    icon: (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(_microfrontends_react_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
      width: 20
    }),
    utm: 'utm_source_navi=header&utm_medium_navi=mycompanies'
  }, {
    id: 'MyJobs',
    title: translator(langCode)('My Jobs'),
    path: jobSeekerUrl[mode] + menuPaths.myJobsPath,
    icon: (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(_microfrontends_react_components__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
      width: 20
    }),
    utm: 'utm_source_navi=header&utm_medium_navi=myjobs'
  }, {
    id: 'jobAlerts',
    title: translator(langCode)('Job Alerts'),
    path: jobSeekerUrl[mode] + menuPaths.jobAlertsPath,
    icon: (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(_microfrontends_react_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
      width: 20
    }),
    utm: 'utm_source_navi=header&utm_medium_navi=jobalerts'
  }, {
    id: EPages.ORDER_MANAGEMENT,
    title: translator(langCode)('Order Management'),
    path: jobSeekerUrl[mode] + menuPaths.orderManagementPath,
    icon: (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(_microfrontends_react_components__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
      width: 20
    }),
    utm: 'utm_source_navi=header&utm_medium_navi=ordermanagement'
  }, {
    id: 'accountSettings',
    title: translator(langCode)('Account Settings'),
    path: jobSeekerUrl[mode] + menuPaths.accountSettingPath,
    icon: (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(_microfrontends_react_components__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
      width: 20
    }),
    utm: 'utm_source_navi=header&utm_medium_navi=accountsettings'
  }, {
    id: 'logout',
    title: translator(langCode)('Logout'),
    path: logoutPath,
    icon: (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(_microfrontends_react_components__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
      width: 20
    }),
    utm: 'utm_source_navi=header&utm_medium_navi=logout'
  }];
};

function _templateObject10() {
  var data = _taggedTemplateLiteralLoose(["\n    display: grid;\n    grid-template-columns: 1fr auto;\n    transition: color 0.2s ease-in-out;\n    align-items: center;\n    color: ", ";\n    &:hover {\n        color: ", ";\n    }\n"]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteralLoose(["\n    padding: 0 24px 24px 24px;\n"]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteralLoose(["\n    margin-bottom: 0;\n    margin: 0 8px 0 10px;\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteralLoose(["\n    display: flex;\n    align-items: center;\n    padding: 8px;\n    color: ", ";\n    line-height: 24px;\n    background: #fff;\n    border: 1px solid #fff;\n    transition: all 0.2s ease-in-out;\n    border-radius: 12px;\n    &:hover {\n        background: #ebf2ff;\n        border-color: #d9e6ff;\n        color: ", ";\n    }\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteralLoose(["\n    display: grid;\n    row-gap: 8px;\n    padding: 8px 16px;\n    margin: 0;\n    list-style: none;\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteralLoose(["\n    cursor: default;\n    margin-bottom: 0;\n    font-size: 13px;\n    color: ", ";\n    display: -webkit-box;\n    -webkit-line-clamp: 1;\n    -webkit-box-orient: vertical;\n    overflow: hidden;\n    word-break: break-word;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteralLoose(["\n    cursor: default;\n    margin-bottom: 0;\n    font-weight: 500;\n    display: -webkit-box;\n    -webkit-line-clamp: 1;\n    -webkit-box-orient: vertical;\n    overflow: hidden;\n    word-break: break-word;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$2() {
  var data = _taggedTemplateLiteralLoose(["\n    display: grid;\n    grid-template-columns: 1fr auto;\n    align-items: center;\n    column-gap: 8px;\n"]);

  _templateObject3$2 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$2() {
  var data = _taggedTemplateLiteralLoose(["\n    padding: 24px 24px 0 24px;\n"]);

  _templateObject2$2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$2() {
  var data = _taggedTemplateLiteralLoose(["\n    background: #fff;\n    border-radius: 12px;\n    color: ", ";\n    width: 350px;\n    box-shadow: 0px 4px 40px 0px rgba(0, 0, 0, 0.16);\n"]);

  _templateObject$2 = function _templateObject() {
    return data;
  };

  return data;
}
var Container = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div */ .ZP.div(_templateObject$2(), _microfrontends_react_components__WEBPACK_IMPORTED_MODULE_14__/* .colors.grey[20] */ .O9.grey[20]);
var Header = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div */ .ZP.div(_templateObject2$2());
var UserInfo = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div */ .ZP.div(_templateObject3$2());
var UserName = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].p */ .ZP.p(_templateObject4());
var Email = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].p */ .ZP.p(_templateObject5(), _microfrontends_react_components__WEBPACK_IMPORTED_MODULE_14__/* .colors.grey[60] */ .O9.grey[60]);
var Menu = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].ul */ .ZP.ul(_templateObject6());
var MenuLink = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].a */ .ZP.a(_templateObject7(), _microfrontends_react_components__WEBPACK_IMPORTED_MODULE_14__/* .colors.grey[20] */ .O9.grey[20], _microfrontends_react_components__WEBPACK_IMPORTED_MODULE_14__/* .colors.grey[20] */ .O9.grey[20]);
var MenuTitle = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].p */ .ZP.p(_templateObject8());
var Footer$1 = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div */ .ZP.div(_templateObject9());
var FAQLink = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].a */ .ZP.a(_templateObject10(), _microfrontends_react_components__WEBPACK_IMPORTED_MODULE_14__/* .colors.primary[40] */ .O9.primary[40], _microfrontends_react_components__WEBPACK_IMPORTED_MODULE_14__/* .colors.secondary[40] */ .O9.secondary[40]);

var UserMenu = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function (_ref, ref) {
  var _faq$replace;

  var show = _ref.show,
      style = _ref.style,
      placement = _ref.placement,
      user = _ref.user,
      langCode = _ref.langCode,
      mode = _ref.mode,
      _ref$userMenuClass = _ref.userMenuClass,
      userMenuClass = _ref$userMenuClass === void 0 ? '' : _ref$userMenuClass;
  var translate = translator(langCode);
  var menuPaths = langCode === ELanguage.VI ? headerMenuViPath : headerMenuEnPath;
  var faq = faqUrl[langCode][mode];
  var processedFAQ = faq === null || faq === void 0 ? void 0 : (_faq$replace = faq.replace('/en', '')) === null || _faq$replace === void 0 ? void 0 : _faq$replace.replace('/vi', '');
  var transFaqUrl = (langCode === ELanguage.EN ? processedFAQ + "/en" : processedFAQ + "/vi") + '?utm_source_navi=header&utm_medium_navi=faq';
  var menuItems = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function () {
    return buildUserMenu(user, langCode, mode);
  }, []);
  var userName = (user === null || user === void 0 ? void 0 : user.firstName) && user.lastName ? user.firstName + " " + user.lastName : translate('Your name');

  var _Hooks$useDropdownAni = _microfrontends_react_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z(show, placement),
      isMounted = _Hooks$useDropdownAni.isMounted,
      styles = _Hooks$useDropdownAni.styles;

  return isMounted ? react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    style: style,
    ref: ref
  }, react__WEBPACK_IMPORTED_MODULE_0__.createElement(Container, {
    style: styles,
    className: userMenuClass
  }, react__WEBPACK_IMPORTED_MODULE_0__.createElement(Header, null, react__WEBPACK_IMPORTED_MODULE_0__.createElement(UserInfo, null, react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", null, react__WEBPACK_IMPORTED_MODULE_0__.createElement(UserName, {
    title: userName
  }, userName), react__WEBPACK_IMPORTED_MODULE_0__.createElement(Email, {
    title: user === null || user === void 0 ? void 0 : user.userName
  }, user === null || user === void 0 ? void 0 : user.userName)), react__WEBPACK_IMPORTED_MODULE_0__.createElement("a", {
    href: jobSeekerUrl[mode] + menuPaths.userProfilePath + '?utm_source_navi=header&utm_medium_navi=updatecv'
  }, react__WEBPACK_IMPORTED_MODULE_0__.createElement(_microfrontends_react_components__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
    type: 'primary',
    outline: 'outline',
    size: 'sm'
  }, translate('Update CV'))))), react__WEBPACK_IMPORTED_MODULE_0__.createElement(Menu, null, menuItems.map(function (item) {
    return react__WEBPACK_IMPORTED_MODULE_0__.createElement("li", {
      key: item.id
    }, react__WEBPACK_IMPORTED_MODULE_0__.createElement(MenuLink, {
      href: item.path
    }, item.icon, react__WEBPACK_IMPORTED_MODULE_0__.createElement(MenuTitle, null, item.title)));
  })), react__WEBPACK_IMPORTED_MODULE_0__.createElement(Footer$1, null, react__WEBPACK_IMPORTED_MODULE_0__.createElement(FAQLink, {
    href: transFaqUrl
  }, translate('Need helps? Read FAQ'), react__WEBPACK_IMPORTED_MODULE_0__.createElement(_microfrontends_react_components__WEBPACK_IMPORTED_MODULE_17__/* .ArrowRight */ .ol, {
    color: 'currentColor'
  }))))) : null;
});

var NOT_SET = '(not set)';
var DIRECT = '(direct)';
var ETrackingPosition;

(function (ETrackingPosition) {
  ETrackingPosition["USER_DROPDOWN_NO_LOGIN"] = "userDropdownNoLogin";
})(ETrackingPosition || (ETrackingPosition = {}));

var UTM_SOURCE_MAPPING = {
  wowCv: 'WowCv'
};
var UTM_MEDIUM_MAPPING = {
  userDropdownNoLogin: 'Header'
};
function buildUTMQueryString(pageName, position) {
  return "utm_source_navi=" + pageNameToUTMSource(pageName) + "&utm_medium_navi=" + positionToUTMMedium(position);
}
function pageNameToUTMSource(pageName) {
  var _UTM_SOURCE_MAPPING$p;

  return (_UTM_SOURCE_MAPPING$p = UTM_SOURCE_MAPPING[pageName]) != null ? _UTM_SOURCE_MAPPING$p : '';
}
function positionToUTMMedium(position) {
  var _UTM_MEDIUM_MAPPING$p;

  return (_UTM_MEDIUM_MAPPING$p = UTM_MEDIUM_MAPPING[position]) != null ? _UTM_MEDIUM_MAPPING$p : '';
}
function addUtmToUrl(url, pageName, position, utmTracking) {
  var utmString = buildUTMQueryString(pageName, position);

  if (utmTracking) {
    utmString = utmString + "&" + utmTracking;
  }

  return url.indexOf('?') > -1 ? url + "&" + utmString : url + "?" + utmString;
}
function getDatetime(today) {
  if (today === void 0) {
    today = new Date();
  }

  var renderNumber = function renderNumber(value, size) {
    var text = String(value);
    return text.padStart(size, '0');
  };

  var year = renderNumber(today.getFullYear(), 4);
  var month = renderNumber(today.getMonth() + 1, 2);
  var day = renderNumber(today.getDate(), 2);
  var hours = renderNumber(today.getHours(), 2);
  var minutes = renderNumber(today.getMinutes(), 2);
  var seconds = renderNumber(today.getSeconds(), 2);
  return year + "-" + month + "-" + day + "T" + hours + ":" + minutes + ":" + seconds + "+07:00";
}
function getCurrentURLInfo() {
  return new URL(window.location.href);
}
function getParameter(urlData, name) {
  return (urlData === null || urlData === void 0 ? void 0 : urlData.searchParams.get(name)) || null;
}
function getUtmForGoogleAds(urlData, referrerUrl) {
  var _getParameter2;

  if (getParameter(urlData, 'gclid')) {
    var _getParameter;

    return {
      utm_source: 'google',
      utm_medium: 'cpc',
      utm_campaign: (_getParameter = getParameter(urlData, 'utm_campaign')) != null ? _getParameter : 'adwords',
      utm_term: 'adwords',
      utm_content: 'adwords',
      utm_url: urlData,
      utm_referer: referrerUrl,
      utm_datetime: getDatetime()
    };
  }

  return getParameter(urlData, 'gclsrc') ? {
    utm_source: 'google',
    utm_medium: 'cpc',
    utm_campaign: (_getParameter2 = getParameter(urlData, 'utm_campaign')) != null ? _getParameter2 : 'DoubleClick',
    utm_term: 'DoubleClick',
    utm_content: 'DoubleClick',
    utm_url: urlData,
    utm_referer: referrerUrl,
    utm_datetime: getDatetime()
  } : null;
}
function getUtmForQueryString(urlData, referrerUrl) {
  var utmSource = getParameter(urlData, 'utm_source');
  var utmMedium = getParameter(urlData, 'utm_medium');
  var utmCampaign = getParameter(urlData, 'utm_campaign');
  var utmTerm = getParameter(urlData, 'utm_term');
  var utmContent = getParameter(urlData, 'utm_content');
  var isUtmExits = utmSource || utmMedium || utmCampaign || utmTerm || utmContent;
  return isUtmExits ? {
    utm_source: utmSource || DIRECT,
    utm_medium: utmMedium || NOT_SET,
    utm_campaign: utmCampaign || DIRECT,
    utm_term: utmTerm || NOT_SET,
    utm_content: utmContent || NOT_SET,
    utm_url: urlData,
    utm_referer: referrerUrl,
    utm_datetime: getDatetime()
  } : null;
}
function trackUtms(internalRefererUrl, referrerUrl, cookieData) {
  var urlData = getCurrentURLInfo();
  var utmData = getUtmForGoogleAds(urlData, referrerUrl);

  if (utmData) {
    return utmData;
  }

  utmData = getUtmForQueryString(urlData, referrerUrl);

  if (utmData) {
    return utmData;
  }

  var utm = {
    utm_source: DIRECT,
    utm_medium: '(none)',
    utm_campaign: DIRECT,
    utm_term: NOT_SET,
    utm_content: NOT_SET,
    utm_url: urlData,
    utm_referer: referrerUrl,
    utm_datetime: getDatetime()
  };

  if (!referrerUrl) {
    return utm;
  }

  var refererData = new URL(referrerUrl);

  if (!refererData.host.match(internalRefererUrl)) {
    utm.utm_source = referrerUrl;
    utm.utm_medium = 'referral';
    utm.utm_campaign = NOT_SET;
    return utm;
  }

  return !cookieData ? utm : null;
}

var IconLogin = function IconLogin(_ref) {
  var _ref$width = _ref.width,
      width = _ref$width === void 0 ? 25 : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? 25 : _ref$height,
      _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? '#555555' : _ref$fill,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 'unset' : _ref$stroke,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      _ref$onClick = _ref.onClick,
      onClick = _ref$onClick === void 0 ? function () {} : _ref$onClick;
  return react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", {
    width: width,
    height: height,
    fill: fill,
    className: className,
    stroke: stroke,
    xmlns: 'http://www.w3.org/2000/svg',
    viewBox: '0 0 50 50',
    onClick: onClick
  }, react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: 'M 25 2 C 15.257933 2 6.9235076 8.0691703 3.5761719 16.636719 A 1.0001 1.0001 0 1 0 5.4375 17.363281 C 8.4921642 9.5448298 16.088067 4 25 4 C 36.609534 4 46 13.390466 46 25 C 46 36.609534 36.609534 46 25 46 C 16.088067 46 8.4921642 40.455171 5.4375 32.636719 A 1.0001 1.0001 0 1 0 3.5761719 33.363281 C 6.9235076 41.930829 15.257933 48 25 48 C 37.690466 48 48 37.690466 48 25 C 48 12.309534 37.690466 2 25 2 z M 25.990234 15.990234 A 1.0001 1.0001 0 0 0 25.292969 17.707031 L 31.585938 24 L 3 24 A 1.0001 1.0001 0 1 0 3 26 L 31.585938 26 L 25.292969 32.292969 A 1.0001 1.0001 0 1 0 26.707031 33.707031 L 34.707031 25.707031 A 1.0001 1.0001 0 0 0 34.707031 24.292969 L 26.707031 16.292969 A 1.0001 1.0001 0 0 0 25.990234 15.990234 z'
  }));
};

var IconRegistration = function IconRegistration(_ref) {
  var _ref$width = _ref.width,
      width = _ref$width === void 0 ? 25 : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? 25 : _ref$height,
      _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? '#555555' : _ref$fill,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 'unset' : _ref$stroke,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      _ref$onClick = _ref.onClick,
      onClick = _ref$onClick === void 0 ? function () {} : _ref$onClick;
  return react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", {
    width: width,
    height: height,
    fill: fill,
    className: className,
    stroke: stroke,
    xmlns: 'http://www.w3.org/2000/svg',
    viewBox: '0 0 50 50',
    onClick: onClick
  }, react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: 'M 19.875 0.40625 C 15.203125 0.492188 12.21875 2.378906 10.9375 5.3125 C 9.714844 8.105469 9.988281 11.632813 10.875 15.28125 C 10.398438 15.839844 10.019531 16.589844 10.15625 17.71875 C 10.304688 18.949219 10.644531 19.824219 11.125 20.4375 C 11.390625 20.773438 11.738281 20.804688 12.0625 20.96875 C 12.238281 22.015625 12.53125 23.0625 12.96875 23.9375 C 13.21875 24.441406 13.503906 24.90625 13.78125 25.28125 C 13.90625 25.449219 14.085938 25.546875 14.21875 25.6875 C 14.226563 26.921875 14.230469 27.949219 14.125 29.25 C 13.800781 30.035156 13.042969 30.667969 11.8125 31.28125 C 10.542969 31.914063 8.890625 32.5 7.21875 33.21875 C 5.546875 33.9375 3.828125 34.8125 2.46875 36.1875 C 1.109375 37.5625 0.148438 39.449219 0 41.9375 L -0.0625 43 L 25 43 L 24.34375 41 L 2.25 41 C 2.53125 39.585938 3.058594 38.449219 3.90625 37.59375 C 4.972656 36.515625 6.425781 35.707031 8 35.03125 C 9.574219 34.355469 11.230469 33.820313 12.6875 33.09375 C 14.144531 32.367188 15.492188 31.410156 16.0625 29.875 L 16.125 29.625 C 16.277344 27.949219 16.21875 26.761719 16.21875 25.3125 L 16.21875 24.71875 L 15.6875 24.4375 C 15.777344 24.484375 15.5625 24.347656 15.375 24.09375 C 15.1875 23.839844 14.957031 23.476563 14.75 23.0625 C 14.335938 22.234375 13.996094 21.167969 13.90625 20.3125 L 13.8125 19.5 L 12.96875 19.4375 C 12.960938 19.4375 12.867188 19.449219 12.6875 19.21875 C 12.507813 18.988281 12.273438 18.480469 12.15625 17.5 C 12.058594 16.667969 12.480469 16.378906 12.4375 16.40625 L 13.09375 16 L 12.90625 15.28125 C 11.964844 11.65625 11.800781 8.363281 12.78125 6.125 C 13.757813 3.894531 15.75 2.492188 19.90625 2.40625 C 19.917969 2.40625 19.925781 2.40625 19.9375 2.40625 C 21.949219 2.414063 23.253906 3.003906 23.625 3.65625 L 23.875 4.0625 L 24.34375 4.125 C 25.734375 4.320313 26.53125 4.878906 27.09375 5.65625 C 27.65625 6.433594 27.96875 7.519531 28.0625 8.71875 C 28.25 11.117188 27.558594 13.910156 27.125 15.21875 L 26.875 16 L 27.5625 16.40625 C 27.519531 16.378906 27.945313 16.667969 27.84375 17.5 C 27.726563 18.480469 27.492188 18.988281 27.3125 19.21875 C 27.132813 19.449219 27.039063 19.4375 27.03125 19.4375 L 26.1875 19.5 L 26.09375 20.3125 C 26 21.175781 25.652344 22.234375 25.25 23.0625 C 25.046875 23.476563 24.839844 23.839844 24.65625 24.09375 C 24.472656 24.347656 24.28125 24.488281 24.375 24.4375 L 23.84375 24.71875 L 23.84375 25.3125 C 23.84375 26.757813 23.785156 27.949219 23.9375 29.625 L 23.9375 29.75 L 24 29.875 C 24.320313 30.738281 24.882813 31.605469 25.8125 32.15625 L 26.84375 30.4375 C 26.421875 30.1875 26.144531 29.757813 25.9375 29.25 C 25.832031 27.949219 25.835938 26.921875 25.84375 25.6875 C 25.972656 25.546875 26.160156 25.449219 26.28125 25.28125 C 26.554688 24.902344 26.816406 24.4375 27.0625 23.9375 C 27.488281 23.0625 27.796875 22.011719 27.96875 20.96875 C 28.28125 20.804688 28.617188 20.765625 28.875 20.4375 C 29.355469 19.824219 29.695313 18.949219 29.84375 17.71875 C 29.976563 16.625 29.609375 15.902344 29.15625 15.34375 C 29.644531 13.757813 30.269531 11.195313 30.0625 8.5625 C 29.949219 7.125 29.582031 5.691406 28.71875 4.5 C 27.929688 3.40625 26.648438 2.609375 25.03125 2.28125 C 23.980469 0.917969 22.089844 0.40625 19.90625 0.40625 Z M 38 26 C 31.382813 26 26 31.382813 26 38 C 26 44.617188 31.382813 50 38 50 C 44.617188 50 50 44.617188 50 38 C 50 31.382813 44.617188 26 38 26 Z M 38 28 C 43.535156 28 48 32.464844 48 38 C 48 43.535156 43.535156 48 38 48 C 32.464844 48 28 43.535156 28 38 C 28 32.464844 32.464844 28 38 28 Z M 37 32 L 37 37 L 32 37 L 32 39 L 37 39 L 37 44 L 39 44 L 39 39 L 44 39 L 44 37 L 39 37 L 39 32 Z'
  }));
};

var IconFacebook = function IconFacebook(_ref) {
  var _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? 'currentColor' : _ref$fill,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 'unset' : _ref$stroke,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      _ref$onClick = _ref.onClick,
      onClick = _ref$onClick === void 0 ? function () {} : _ref$onClick,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? 20 : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? 20 : _ref$height;
  return react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", {
    fill: fill,
    className: className,
    stroke: stroke,
    xmlns: 'http://www.w3.org/2000/svg',
    viewBox: '0 0 48 48',
    onClick: onClick,
    width: width,
    height: height
  }, react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: 'M44,38.44A5.56,5.56,0,0,1,38.44,44H9.56A5.56,5.56,0,0,1,4,38.44V9.56A5.56,5.56,0,0,1,9.56,4H38.44A5.56,5.56,0,0,1,44,9.56Z',
    style: {
      fill: '#3f51b5'
    }
  }), react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: 'M35.52,25.11H31.78V39.56H26.22V25.11H22.89V20.67h3.33V18c0-3.9,1.62-6.21,6.22-6.21h3.78v4.44H33.68c-1.79,0-1.91.67-1.91,1.91v2.53h4.44Z',
    style: {
      fill: '#fff'
    }
  }));
};

var IconGoogle = function IconGoogle(_ref) {
  var _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? 'currentColor' : _ref$fill,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 'unset' : _ref$stroke,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      _ref$onClick = _ref.onClick,
      onClick = _ref$onClick === void 0 ? function () {} : _ref$onClick,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? 20 : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? 20 : _ref$height;
  return react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", {
    fill: fill,
    className: className,
    stroke: stroke,
    xmlns: 'http://www.w3.org/2000/svg',
    viewBox: '0 0 48 48',
    onClick: onClick,
    width: width,
    height: height
  }, react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    style: {
      fill: '#FFC107'
    },
    d: 'M 43.609375 20.082031 L 42 20.082031 L 42 20 L 24 20 L 24 28 L 35.304688 28 C 33.652344 32.65625 29.222656 36 24 36 C 17.371094 36 12 30.628906 12 24 C 12 17.371094 17.371094 12 24 12 C 27.058594 12 29.84375 13.152344 31.960938 15.039063 L 37.617188 9.382813 C 34.046875 6.054688 29.269531 4 24 4 C 12.953125 4 4 12.953125 4 24 C 4 35.046875 12.953125 44 24 44 C 35.046875 44 44 35.046875 44 24 C 44 22.660156 43.863281 21.351563 43.609375 20.082031 Z '
  }), react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    style: {
      fill: '#FF3D00'
    },
    d: 'M 6.304688 14.691406 L 12.878906 19.511719 C 14.65625 15.109375 18.960938 12 24 12 C 27.058594 12 29.84375 13.152344 31.960938 15.039063 L 37.617188 9.382813 C 34.046875 6.054688 29.269531 4 24 4 C 16.316406 4 9.65625 8.335938 6.304688 14.691406 Z '
  }), react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    style: {
      fill: '#4CAF50'
    },
    d: 'M 24 44 C 29.164063 44 33.859375 42.023438 37.410156 38.808594 L 31.21875 33.570313 C 29.210938 35.089844 26.714844 36 24 36 C 18.796875 36 14.382813 32.683594 12.71875 28.054688 L 6.195313 33.078125 C 9.503906 39.554688 16.226563 44 24 44 Z '
  }), react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    style: {
      fill: '#1976D2'
    },
    d: 'M 43.609375 20.082031 L 42 20.082031 L 42 20 L 24 20 L 24 28 L 35.304688 28 C 34.511719 30.238281 33.070313 32.164063 31.214844 33.570313 C 31.21875 33.570313 31.21875 33.570313 31.21875 33.570313 L 37.410156 38.808594 C 36.972656 39.203125 44 34 44 24 C 44 22.660156 43.863281 21.351563 43.609375 20.082031 Z '
  }));
};

function _templateObject6$1() {
  var data = _taggedTemplateLiteralLoose(["\n    display: grid;\n    grid-template-columns: auto 1fr;\n    padding: 16px 24px;\n    cursor: pointer;\n    column-gap: 16px;\n    align-items: center;\n    color: ", ";\n    background: #fff;\n    transition: background 0.2s ease-in-out;\n    ", "\n    &:hover {\n        color: ", ";\n        background: ", ";\n    }\n"]);

  _templateObject6$1 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5$1() {
  var data = _taggedTemplateLiteralLoose(["\n    display: grid;\n    grid-template-columns: auto 1fr;\n    column-gap: 8px;\n    white-space: nowrap;\n    padding: 6px 16px;\n    border: 1px solid ", ";\n    color: ", ";\n    font-weight: 600;\n    border-radius: 4px;\n    background: #fff;\n    transition: background 0.2s ease-in-out;\n    &:hover {\n        background: ", ";\n        color: ", ";\n    }\n"]);

  _templateObject5$1 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$1() {
  var data = _taggedTemplateLiteralLoose(["\n    display: grid;\n    grid-template-columns: repeat(2, 1fr);\n    column-gap: 8px;\n"]);

  _templateObject4$1 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$3() {
  var data = _taggedTemplateLiteralLoose(["\n    margin-bottom: 0;\n    font-size: 18px;\n    font-weight: 600;\n"]);

  _templateObject3$3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$3() {
  var data = _taggedTemplateLiteralLoose(["\n    display: grid;\n    row-gap: 16px;\n    padding: 20px 24px;\n    border-bottom: 1px solid ", ";\n"]);

  _templateObject2$3 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$3() {
  var data = _taggedTemplateLiteralLoose(["\n    background: #fff;\n    border-radius: 12px;\n    color: ", ";\n    width: 380px;\n    box-shadow: 0px 4px 40px 0px rgba(0, 0, 0, 0.16);\n    overflow: hidden;\n"]);

  _templateObject$3 = function _templateObject() {
    return data;
  };

  return data;
}
var Container$1 = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div */ .ZP.div(_templateObject$3(), _microfrontends_react_components__WEBPACK_IMPORTED_MODULE_14__/* .colors.grey[20] */ .O9.grey[20]);
var SocialLoginContainer = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div */ .ZP.div(_templateObject2$3(), _microfrontends_react_components__WEBPACK_IMPORTED_MODULE_14__/* .colors.grey[90] */ .O9.grey[90]);
var Heading = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].p */ .ZP.p(_templateObject3$3());
var SocialLogin = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div */ .ZP.div(_templateObject4$1());
var SocialLoginLink = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].a */ .ZP.a(_templateObject5$1(), _microfrontends_react_components__WEBPACK_IMPORTED_MODULE_14__/* .colors.grey[80] */ .O9.grey[80], _microfrontends_react_components__WEBPACK_IMPORTED_MODULE_14__/* .colors.grey[20] */ .O9.grey[20], _microfrontends_react_components__WEBPACK_IMPORTED_MODULE_14__/* .colors.grey[90] */ .O9.grey[90], _microfrontends_react_components__WEBPACK_IMPORTED_MODULE_14__/* .colors.grey[20] */ .O9.grey[20]);
var Item = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].a */ .ZP.a(_templateObject6$1(), _microfrontends_react_components__WEBPACK_IMPORTED_MODULE_14__/* .colors.grey[20] */ .O9.grey[20], function (_ref) {
  var separate = _ref.separate;
  return separate ? "border-bottom: 1px solid " + _microfrontends_react_components__WEBPACK_IMPORTED_MODULE_14__/* .colors.grey[90] */ .O9.grey[90] + ";" : '';
}, _microfrontends_react_components__WEBPACK_IMPORTED_MODULE_14__/* .colors.grey[20] */ .O9.grey[20], _microfrontends_react_components__WEBPACK_IMPORTED_MODULE_14__/* .colors.grey[95] */ .O9.grey[95]);

var LoginMenu = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function (_ref, ref) {
  var langCode = _ref.langCode,
      pageName = _ref.pageName,
      show = _ref.show,
      placement = _ref.placement,
      style = _ref.style,
      mode = _ref.mode,
      utmTracking = _ref.utmTracking,
      _ref$loginMenuClass = _ref.loginMenuClass,
      loginMenuClass = _ref$loginMenuClass === void 0 ? '' : _ref$loginMenuClass;
  var isClientRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(false);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    isClientRef.current = true;
  }, []);

  var redirectHref = function () {
    if (typeof window !== 'undefined') {
      var href = window.location.href;
      var queryString = window.location.search;
      var uri = queryString.includes('lang=en') ? '/my-career-center/dashboard' : '/quan-ly-nghe-nghiep/tong-quan';
      return href.replace('/logout', uri);
    }

    return '';
  }();

  var translate = translator(langCode);
  var trackingPageName = pageName || EPages.OTHER;
  var trackingPosition = ETrackingPosition.USER_DROPDOWN_NO_LOGIN;
  var jsUrl = jobSeekerUrl[mode];
  var redirectUrl = langCode === ELanguage.VI ? 'dang-nhap' : 'login';
  var socialLoginUrl = jsUrl + "/" + redirectUrl;
  var facebookLoginUrl = isClientRef.current ? socialLoginUrl + "?type=facebook&redirectURL=" + encodeURIComponent(addUtmToUrl(redirectHref, trackingPageName, trackingPosition, utmTracking != null ? utmTracking : '')) + "&t=" + Date.now() : socialLoginUrl + '?type=facebook';
  var googleLoginUrl = isClientRef.current ? socialLoginUrl + "?type=google&redirectURL=" + encodeURIComponent(addUtmToUrl(redirectHref, trackingPageName, trackingPosition, utmTracking != null ? utmTracking : '')) + "&t=" + Date.now() : socialLoginUrl + '?type=google';
  var registrationUrl = jsUrl + "/" + (langCode === ELanguage.VI ? 'dang-ky' : 'sign-up') + "?redirectURL=" + encodeURIComponent(addUtmToUrl(redirectHref, trackingPageName, trackingPosition, utmTracking != null ? utmTracking : '')) + "&t=" + Date.now() + "&utm_source_navi=header&utm_medium_navi=register";

  var showLoginModal = function showLoginModal() {
    var loginEvent = new CustomEvent(LOGIN_POPUP, {
      detail: {
        langCode: langCode === ELanguage.VI ? 'vi' : 'en',
        isNeedReload: pageName === 'jobDetail',
        trackingProperties: {
          pageName: 'appShell'
        },
        onLoggedIn: function onLoggedIn() {
          if (typeof window === 'undefined') {
            return;
          }

          if (window.location.href.indexOf('.com/logout') >= 1) {
            window.location.href = langCode === ELanguage.VI ? jsUrl + "/quan-ly-nghe-nghiep/tong-quan" : jsUrl + "/my-career-center/dashboard";
          }
        }
      }
    });
    window.dispatchEvent(loginEvent);
  };

  var _Hooks$useDropdownAni = _microfrontends_react_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z(show, placement),
      isMounted = _Hooks$useDropdownAni.isMounted,
      styles = _Hooks$useDropdownAni.styles;

  return isMounted ? react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    ref: ref,
    style: style,
    className: loginMenuClass
  }, react__WEBPACK_IMPORTED_MODULE_0__.createElement(Container$1, {
    style: styles
  }, react__WEBPACK_IMPORTED_MODULE_0__.createElement(SocialLoginContainer, null, react__WEBPACK_IMPORTED_MODULE_0__.createElement(Heading, null, translate('Job Seeker Login')), react__WEBPACK_IMPORTED_MODULE_0__.createElement(SocialLogin, null, react__WEBPACK_IMPORTED_MODULE_0__.createElement(SocialLoginLink, {
    href: facebookLoginUrl,
    className: 'Header_LoginFB',
    tabIndex: 0
  }, react__WEBPACK_IMPORTED_MODULE_0__.createElement(IconFacebook, null), react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", null, translate('Facebook'))), react__WEBPACK_IMPORTED_MODULE_0__.createElement(SocialLoginLink, {
    href: googleLoginUrl,
    className: 'Header_LoginGG',
    tabIndex: 0
  }, react__WEBPACK_IMPORTED_MODULE_0__.createElement(IconGoogle, null), react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", null, translate('Google'))))), react__WEBPACK_IMPORTED_MODULE_0__.createElement(Item, {
    onClick: showLoginModal,
    className: 'Header_Login',
    tabIndex: 0,
    separate: true
  }, react__WEBPACK_IMPORTED_MODULE_0__.createElement(IconLogin, null), react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", null, translate('Login'))), react__WEBPACK_IMPORTED_MODULE_0__.createElement(Item, {
    tabIndex: 0,
    onClick: function onClick(e) {
      try {
        e.preventDefault();
        var ph = typeof window !== 'undefined' && window.posthog || null;

        if (!ph) {
          window.location.href = registrationUrl;
          return;
        }

        ph.capture('js_registration:signup_start', {
          page_name: typeof window !== 'undefined' && window.location ? window.location.href : ''
        });
        setTimeout(function () {
          try {
            window.location.href = registrationUrl;
          } catch (_) {}
        }, 1000);
      } catch (error) {
        console.warn('PostHog event failed, redirecting anyway:', error);

        try {
          window.location.href = registrationUrl;
        } catch (_) {}
      }
    }
  }, react__WEBPACK_IMPORTED_MODULE_0__.createElement(IconRegistration, null), react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", null, translate('Register new account'))))) : null;
});

function _templateObject4$2() {
  var data = _taggedTemplateLiteralLoose(["\n    width: 100%;\n    height: 32px;\n    border-radius: 9999px;\n    border: none;\n    padding: unset;\n    background: transparent;\n    overflow: hidden;\n    color: inherit;\n    font-weight: 500;\n    &:focus {\n        outline: none;\n    }\n    ", "\n"]);

  _templateObject4$2 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$4() {
  var data = _taggedTemplateLiteralLoose(["\n    width: 100%;\n    height: 100%;\n"]);

  _templateObject3$4 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$4() {
  var data = _taggedTemplateLiteralLoose(["\n    position: relative;\n    width: 100%;\n    height: 100%;\n"]);

  _templateObject2$4 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$4() {
  var data = _taggedTemplateLiteralLoose(["\n    width: ", ";\n    height: 32px;\n    border-radius: 9999px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border: none;\n    font-weight: 500;\n"]);

  _templateObject$4 = function _templateObject() {
    return data;
  };

  return data;
}
var Wrapper$1 = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div */ .ZP.div(_templateObject$4(), function (_ref) {
  var isLoggedIn = _ref.isLoggedIn;
  return isLoggedIn ? '32px' : '100%';
});
var Container$2 = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div */ .ZP.div(_templateObject2$4());
var Image$1 = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].img */ .ZP.img(_templateObject3$4());
var Button = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].button */ .ZP.button(_templateObject4$2(), function (_ref2) {
  var hasLoginText = _ref2.hasLoginText,
      isLoggedIn = _ref2.isLoggedIn;
  return hasLoginText && !isLoggedIn ? "\n        display: grid;\n        grid-template-columns: auto 1fr;\n        column-gap: 6px;\n        align-items: center;\n        padding: 0 8px;\n    " : '';
});

function AuthButton(props) {
  var user = props.user,
      _props$hasLoginText = props.hasLoginText,
      hasLoginText = _props$hasLoginText === void 0 ? false : _props$hasLoginText,
      language = props.language,
      mode = props.mode,
      pageName = props.pageName,
      className = props.className,
      utmTracking = props.utmTracking,
      _props$userMenuClass = props.userMenuClass,
      userMenuClass = _props$userMenuClass === void 0 ? '' : _props$userMenuClass;

  var _React$useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false),
      show = _React$useState[0],
      setShow = _React$useState[1];

  var isMounted = useDomContentLoaded();

  var _Hooks$useFloating = _microfrontends_react_components__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z({
    placement: 'bottom-end',
    position: 'fixed',
    config: {
      offset: 8,
      detectHidden: true,
      useWindowAsFlippingContainer: false,
      isFlip: false
    }
  }),
      context = _Hooks$useFloating.context,
      refs = _Hooks$useFloating.refs,
      FloatingPortal = _Hooks$useFloating.FloatingPortal;

  _microfrontends_react_components__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z(function () {
    return setShow(false);
  }, {
    nodeRefs: [refs.popup, refs.reference]
  });
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    if (context.isReferenceHidden) {
      setShow(false);
    }
  }, [context.isReferenceHidden]);
  var isLoggedIn = !!user && !!user.userId;
  var profilePicture = (user === null || user === void 0 ? void 0 : user.profilePicture) || '';
  var loginText = language === ELanguage.VI ? 'Đăng nhập' : 'Login';
  var abTestValue = 'new-flow';

  var showLoginModal = function showLoginModal() {
    var jsUrl = jobSeekerUrl[mode];
    var loginEvent = new CustomEvent(LOGIN_POPUP, {
      detail: {
        langCode: language === ELanguage.VI ? 'vi' : 'en',
        isNeedReload: pageName === 'jobDetail',
        trackingProperties: {
          pageName: 'appShell'
        },
        onLoggedIn: function onLoggedIn() {
          if (typeof window === 'undefined') {
            return;
          }

          if (window.location.href.includes('.com/logout')) {
            window.location.href = language === ELanguage.VI ? jsUrl + "/quan-ly-nghe-nghiep/tong-quan" : jsUrl + "/my-career-center/dashboard";
          }
        }
      }
    });
    window.dispatchEvent(loginEvent);
  };

  var handleButtonClick = function handleButtonClick() {
    if (!isLoggedIn) {
      showLoginModal();
      return;
    }

    setShow(function (prevState) {
      return !prevState;
    });
  };

  return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(Wrapper$1, {
    isLoggedIn: isLoggedIn,
    className: className
  }, (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(Container$2, null, (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(Button, {
    "aria-label": 'profile-button',
    className: 'Header_UMenu',
    onClick: handleButtonClick,
    ref: refs.setReference,
    hasLoginText: hasLoginText,
    isLoggedIn: isLoggedIn
  }, profilePicture ? (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(Image$1, {
    src: profilePicture,
    alt: user === null || user === void 0 ? void 0 : user.userName
  }) : (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(UserIcon, {
    size: 20
  }), hasLoginText && !isLoggedIn ? loginText : ''), isMounted && isLoggedIn ? (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(FloatingPortal, {
    enable: true
  }, (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(UserMenu, {
    ref: refs.setPopup,
    placement: context.placement,
    show: show,
    style: {
      position: context.position,
      top: context.y,
      left: context.x,
      zIndex: DROPDOWN_ZINDEX
    },
    langCode: language,
    mode: mode,
    user: user,
    userMenuClass: userMenuClass
  })) : null), isMounted && !isLoggedIn && (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(_microfrontends_react_components__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z, {
    featureFlag: abTestValue,
    useNewLoginModal: true,
    langCode: language,
    pageName: pageName,
    utmTracking: utmTracking
  }));
}

function _templateObject3$5() {
  var data = _taggedTemplateLiteralLoose(["\n    background-color: ", ";\n    color: #fff;\n    transition: background 0.25s ease-in-out;\n    &:hover {\n        background-color: ", ";\n    }\n"]);

  _templateObject3$5 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$5() {
  var data = _taggedTemplateLiteralLoose(["\n    position: relative;\n    cursor: pointer;\n    &:hover,\n    &:focus {\n        outline: none;\n        .notification-icon {\n            opacity: 1;\n        }\n    }\n    .notification-icon {\n        transition: all 0.3s;\n        opacity: 0.9;\n        svg {\n            width: 18px;\n            height: 18px;\n        }\n    }\n    .new-notification {\n        position: absolute;\n        top: -9px;\n        right: -1px;\n        width: 8px;\n        height: 8px;\n        svg {\n            fill: #f85a5a;\n            border: 1px solid white;\n            border-radius: 5px;\n        }\n    }\n"]);

  _templateObject2$5 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$5() {
  var data = _taggedTemplateLiteralLoose(["\n    position: relative;\n    display: grid;\n    grid-template-columns: ", ";\n    padding: 4px;\n    column-gap: 8px;\n    border-radius: 95px;\n    border: 1px solid ", ";\n"]);

  _templateObject$5 = function _templateObject() {
    return data;
  };

  return data;
}
var Container$3 = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div */ .ZP.div(_templateObject$5(), function (_ref) {
  var isHomePage = _ref.isHomePage;
  return isHomePage ? 'auto auto 1fr' : 'repeat(3, 1fr)';
}, _microfrontends_react_components__WEBPACK_IMPORTED_MODULE_14__/* .colors.primary[40] */ .O9.primary[40]);
var NotificationWrapper = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div */ .ZP.div(_templateObject2$5());
var StyledAuthButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(AuthButton)(_templateObject3$5(), _microfrontends_react_components__WEBPACK_IMPORTED_MODULE_14__/* .colors.primary[40] */ .O9.primary[40], _microfrontends_react_components__WEBPACK_IMPORTED_MODULE_14__/* .colors.primary[50] */ .O9.primary[50]);

var useDelayShow = function useDelayShow(initialDelay) {
  if (initialDelay === void 0) {
    initialDelay = 500;
  }

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false),
      show = _useState[0],
      setShow = _useState[1];

  var delayRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(initialDelay);
  var timeoutRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);

  var clearDelayTimeout = function clearDelayTimeout() {
    if (timeoutRef.current !== null) {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = null;
    }
  };

  var open = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function () {
    clearDelayTimeout();
    timeoutRef.current = window.setTimeout(function () {
      setShow(true);
    }, delayRef.current);
  }, []);
  var close = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function () {
    clearDelayTimeout();
    timeoutRef.current = window.setTimeout(function () {
      setShow(false);
    }, delayRef.current);
  }, []);
  var toggle = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function () {
    clearDelayTimeout();
    timeoutRef.current = window.setTimeout(function () {
      setShow(function (prevState) {
        return !prevState;
      });
    }, delayRef.current);
  }, []);
  return {
    show: show,
    open: open,
    close: close,
    toggle: toggle
  };
};

function _templateObject5$2() {
  var data = _taggedTemplateLiteralLoose(["\n        width: ", ";\n        display: block;\n        line-height: 40px;\n        padding: 0px 10px;\n        cursor: pointer;\n        white-space: nowrap;\n        color: ", ";\n        font-weight: ", ";\n        ", "\n        &:hover {\n            background: #f1f2f4;\n            border-radius: 6px;\n        }\n        &:first-child {\n            margin-bottom: 5px;\n        }\n        ", "\n    "]);

  _templateObject5$2 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$3() {
  var data = _taggedTemplateLiteralLoose(["\n        margin-bottom: 0;\n        list-style: none;\n        padding-left: 0 !important;\n        display: ", ";\n        flex-wrap: ", ";\n        height: 100%;\n        ", "\n    "]);

  _templateObject4$3 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$6() {
  var data = _taggedTemplateLiteralLoose(["\n        position: fixed;\n        border-radius: 12px;\n        width: 120px;\n        z-index: ", ";\n        ", "\n    "]);

  _templateObject3$6 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$6() {
  var data = _taggedTemplateLiteralLoose(["\n    position: relative;\n    border: 0;\n    background: transparent;\n    padding: 0;\n    height: 100%;\n    cursor: pointer;\n    &:focus {\n        outline: none;\n    }\n"]);

  _templateObject2$6 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$6() {
  var data = _taggedTemplateLiteralLoose(["\n    position: relative;\n    height: 100%;\n    display: flex;\n"]);

  _templateObject$6 = function _templateObject() {
    return data;
  };

  return data;
}
var Wrapper$2 = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div */ .ZP.div(_templateObject$6());
var Div = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div */ .ZP.div(_templateObject2$6());
var Popup = {
  Wrap: styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div */ .ZP.div(_templateObject3$6(), function (_ref) {
    var zIndex = _ref.zIndex;
    return zIndex;
  }, function (_ref2) {
    var isNavigation = _ref2.isNavigation,
        positionTop = _ref2.positionTop,
        positionLeft = _ref2.positionLeft;
    return isNavigation === true ? "\n                display: flex;\n                flex-wrap: wrap;\n                background: #002466;\n                width: 1284px;\n                padding: 8px;\n                max-width: 100vw;\n                left: 50%;\n                margin-left: -642px;\n                top: " + positionTop + "px;\n                align-items: stretch;\n                justify-content: space-between;\n                transition-duration: 350ms !important;\n                @media (max-width: 1279px) {\n                    left: 0;\n                    margin-left: 0;\n                }" : "\n                top: " + positionTop + "px;\n                left:" + positionLeft + "px;\n                padding: 5px;\n                background: #ffffff;\n            ";
  }),
  List: styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].ul */ .ZP.ul(_templateObject4$3(), function (_ref3) {
    var width = _ref3.width;
    return width === 'full' ? "flex" : "block !important";
  }, function (_ref4) {
    var width = _ref4.width;
    return width === 'full' ? "wrap" : "unset";
  }, function (_ref5) {
    var mode = _ref5.mode;
    return mode === 'hover' ? "\n            &::after {\n                content: '';\n                position: absolute;\n                height: 10px;\n                left: 0;\n                right: 0;\n                top: -10px;\n            }\n        " : '';
  }),
  Item: styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].li */ .ZP.li(_templateObject5$2(), function (_ref6) {
    var columWidth = _ref6.columWidth;
    return columWidth === 'full' ? "33.33%" : "100%";
  }, function (_ref7) {
    var parentLink = _ref7.parentLink;
    return parentLink === true ? _microfrontends_react_components__WEBPACK_IMPORTED_MODULE_14__/* .colors.primary[20] */ .O9.primary[20] : _microfrontends_react_components__WEBPACK_IMPORTED_MODULE_14__/* .colors.grey[20] */ .O9.grey[20];
  }, function (_ref8) {
    var parentLink = _ref8.parentLink;
    return parentLink === true ? "bold" : "";
  }, function (_ref9) {
    var isActive = _ref9.isActive;
    return isActive ? "\n                background: #EFF5FF;\n                color: #005AFF;\n                border-radius:6px;\n                pointer-events: none;\n                " : '';
  }, function (_ref10) {
    var link = _ref10.link,
        parentLink = _ref10.parentLink;
    return link === '' || parentLink === true ? "\n                    pointer-events: none;\n                    font-size:16px;\n            " : '';
  })
};

function Dropdown(_ref) {
  var children = _ref.children,
      options = _ref.options,
      defaultValue = _ref.defaultValue,
      _ref$placement = _ref.placement,
      placement = _ref$placement === void 0 ? 'bottom-start' : _ref$placement,
      onChange = _ref.onChange,
      _ref$mode = _ref.mode,
      mode = _ref$mode === void 0 ? 'click' : _ref$mode,
      _ref$fieldKey = _ref.fieldKey,
      fieldKey = _ref$fieldKey === void 0 ? 'id' : _ref$fieldKey,
      _ref$fieldValue = _ref.fieldValue,
      fieldValue = _ref$fieldValue === void 0 ? 'name' : _ref$fieldValue,
      _ref$dropdownColumn = _ref.dropdownColumn,
      dropdownColumn = _ref$dropdownColumn === void 0 ? 1 : _ref$dropdownColumn,
      _ref$disable = _ref.disable,
      disable = _ref$disable === void 0 ? false : _ref$disable,
      _ref$notSaveSelected = _ref.notSaveSelected,
      notSaveSelected = _ref$notSaveSelected === void 0 ? false : _ref$notSaveSelected,
      _ref$isNavigation = _ref.isNavigation,
      isNavigation = _ref$isNavigation === void 0 ? false : _ref$isNavigation,
      bannerUrl = _ref.bannerUrl,
      bannerTarget = _ref.bannerTarget,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'ALL_CATE' : _ref$type;
  var getSelectedOption = null;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(getSelectedOption),
      selectedOption = _useState[0],
      setSelectedOption = _useState[1];

  var _useDelayShow = useDelayShow(mode === 'click' ? 0 : 100),
      show = _useDelayShow.show,
      open = _useDelayShow.open,
      close = _useDelayShow.close,
      toggle = _useDelayShow.toggle;

  var _Hooks$useFloating = _microfrontends_react_components__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z({
    placement: placement,
    position: 'fixed',
    config: {
      offset: 8,
      detectHidden: true,
      isShift: true
    }
  }),
      context = _Hooks$useFloating.context,
      refs = _Hooks$useFloating.refs,
      FloatingPortal = _Hooks$useFloating.FloatingPortal;

  _microfrontends_react_components__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z(function () {
    return close();
  }, {
    nodeRefs: [refs.popup, refs.reference]
  });
  var optionRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)('');
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    if (defaultValue) {
      if (defaultValue !== optionRef.current) {
        var _options$find;

        var _getSelectedOption = (_options$find = options.find(function (option) {
          return option[fieldKey] === defaultValue;
        })) != null ? _options$find : null;

        setSelectedOption(_getSelectedOption);
        optionRef.current = (_getSelectedOption === null || _getSelectedOption === void 0 ? void 0 : _getSelectedOption[fieldKey]) || '';
      }
    }
  }, [defaultValue, JSON.stringify(options)]);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    if (context.isReferenceHidden) {
      close();
    }
  }, [context.isReferenceHidden]);
  var handleChange = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function (option) {
    return function (e) {
      e.preventDefault();
      e.stopPropagation();

      if (option.id === 'it_jobs') {
        clearLocalStorageParams({
          categoryId: [],
          query: '',
          locations: [],
          locationId: [],
          districtId: []
        });
      }

      if (!notSaveSelected) {
        setSelectedOption(option);
        optionRef.current = option[fieldKey] || '';
      }

      onChange && onChange(option);
    };
  }, [notSaveSelected, onChange]);
  var handleClick = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function () {
    if (mode === 'click' && !disable) {
      toggle();
    }
  }, [mode, disable]);
  var handleMouseEnter = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function () {
    if (mode === 'hover' && !disable) {
      open();
    }
  }, [mode, show]);
  var handleMouseLeave = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function () {
    if (mode === 'hover' && !disable) {
      close();
    }
  }, [mode, show]);

  var _Hooks$useDropdownAni = _microfrontends_react_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z(show, context.placement),
      isMounted = _Hooks$useDropdownAni.isMounted,
      styles = _Hooks$useDropdownAni.styles;

  var mediaMatch = _microfrontends_react_components__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z('screen and (min-width: 768px) and (max-width: 1024px)') || false;
  return react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper$2, null, react__WEBPACK_IMPORTED_MODULE_0__.createElement(Div, {
    ref: refs.setReference,
    className: type === 'ALL_CATE' ? 'Header_AllCate' : 'Header_Lang',
    onClick: handleClick,
    onMouseEnter: handleMouseEnter,
    onMouseLeave: handleMouseLeave
  }, children), isMounted ? isNavigation === true ? react__WEBPACK_IMPORTED_MODULE_0__.createElement(FloatingPortal, {
    enable: true
  }, react__WEBPACK_IMPORTED_MODULE_0__.createElement(Popup.Wrap, {
    ref: refs.setPopup,
    onMouseEnter: handleMouseEnter,
    onMouseLeave: handleMouseLeave,
    onTouchStart: handleMouseEnter,
    onTouchEnd: handleMouseLeave,
    mode: mode,
    positionTop: context.y,
    positionLeft: context.x,
    style: styles,
    zIndex: DROPDOWN_ZINDEX,
    isNavigation: true
  }, react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    style: {
      width: "" + (mediaMatch === true ? "100%" : "calc(100% - 384px)"),
      padding: '10px 16px',
      display: 'flex',
      flexWrap: 'wrap',
      background: '#fff',
      borderRadius: 12,
      border: '4px solid #005AFF'
    }
  }, options.filter(function (option) {
    return option.parentMenu === true && option.id !== 'vnws_intech';
  }).map(function (item, index) {
    return react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
      key: "col_" + index,
      style: {
        width: "" + (item['columnWidth'] === 'full' ? "100%" : "33.33%")
      }
    }, react__WEBPACK_IMPORTED_MODULE_0__.createElement(Popup.List, {
      ref: refs.setPopup,
      onMouseEnter: handleMouseEnter,
      onMouseLeave: handleMouseLeave,
      onTouchStart: handleMouseEnter,
      onTouchEnd: handleMouseLeave,
      mode: mode,
      column: dropdownColumn,
      style: styles,
      width: item['columnWidth']
    }, react__WEBPACK_IMPORTED_MODULE_0__.createElement(Popup.Item, {
      key: item[fieldKey],
      isActive: item[fieldKey] && item[fieldKey] === (selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption[fieldKey]),
      onClick: handleChange(item),
      parentLink: item['parentMenu'],
      style: styles,
      link: item['link']
    }, item[fieldValue]), options.filter(function (option) {
      return option.parentItem === item.id && option.parentMenu === false;
    }).map(function (option, index) {
      return react__WEBPACK_IMPORTED_MODULE_0__.createElement(Popup.Item, {
        key: option[fieldKey] + "_" + index,
        isActive: option[fieldKey] && option[fieldKey] === (selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption[fieldKey]),
        onClick: handleChange(option),
        parentLink: option['parentMenu'],
        columWidth: item['columnWidth']
      }, option[fieldValue]);
    })));
  })), options.filter(function (option) {
    return option.parentMenu === true && option.id === 'vnws_intech';
  }).map(function (item, index) {
    return react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
      key: "col_" + index,
      style: {
        width: "" + (mediaMatch === true ? "100%" : "374px"),
        padding: "10px",
        background: '#fff',
        border: '4px solid #005AFF',
        borderRadius: 12,
        position: 'relative',
        marginTop: "" + (mediaMatch === true ? "10px" : "0"),
        display: "" + (mediaMatch === true ? "flex" : "block"),
        height: "auto",
        justifyContent: "space-between"
      }
    }, react__WEBPACK_IMPORTED_MODULE_0__.createElement(Popup.List, {
      ref: refs.setPopup,
      onMouseEnter: handleMouseEnter,
      onMouseLeave: handleMouseLeave,
      onTouchStart: handleMouseEnter,
      onTouchEnd: handleMouseLeave,
      mode: mode,
      column: dropdownColumn,
      style: styles,
      width: item['columnWidth']
    }, react__WEBPACK_IMPORTED_MODULE_0__.createElement(Popup.Item, {
      key: item[fieldKey] + "_" + index,
      isActive: item[fieldKey] && item[fieldKey] === (selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption[fieldKey]),
      onClick: handleChange(item),
      parentLink: item['parentMenu'],
      style: styles
    }, item[fieldValue]), options.filter(function (option) {
      return option.parentItem === item.id && option.parentMenu === false;
    }).map(function (option) {
      return react__WEBPACK_IMPORTED_MODULE_0__.createElement(Popup.Item, {
        key: option[fieldKey],
        isActive: option[fieldKey] && option[fieldKey] === (selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption[fieldKey]),
        onClick: handleChange(option),
        parentLink: option['parentMenu'],
        columWidth: item['columnWidth']
      }, option[fieldValue]);
    })), bannerUrl != '' ? react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
      style: {
        width: "" + (mediaMatch === true ? "33.33%" : "100%"),
        position: "relative",
        marginTop: "" + (mediaMatch === true ? "0" : "-200px")
      }
    }, react__WEBPACK_IMPORTED_MODULE_0__.createElement("a", {
      href: bannerTarget
    }, react__WEBPACK_IMPORTED_MODULE_0__.createElement("img", {
      src: bannerUrl,
      height: 200,
      style: {
        borderRadius: 8,
        width: '100%',
        height: "" + (mediaMatch === true ? "auto" : "200px")
      },
      loading: 'lazy'
    }))) : null);
  }))) : react__WEBPACK_IMPORTED_MODULE_0__.createElement(FloatingPortal, {
    enable: true
  }, react__WEBPACK_IMPORTED_MODULE_0__.createElement(Popup.Wrap, {
    ref: refs.setPopup,
    onMouseEnter: handleMouseEnter,
    onMouseLeave: handleMouseLeave,
    onTouchStart: handleMouseEnter,
    onTouchEnd: handleMouseLeave,
    mode: mode,
    positionTop: context.y,
    positionLeft: context.x,
    style: styles,
    zIndex: DROPDOWN_ZINDEX,
    isNavigation: false
  }, options.map(function (item, index) {
    var _item$className;

    return react__WEBPACK_IMPORTED_MODULE_0__.createElement(Popup.List, {
      key: "list-" + item.id + "-" + index,
      ref: refs.setPopup,
      onMouseEnter: handleMouseEnter,
      onMouseLeave: handleMouseLeave,
      onTouchStart: handleMouseEnter,
      onTouchEnd: handleMouseLeave,
      mode: mode,
      column: dropdownColumn,
      style: styles,
      width: item['columnWidth']
    }, react__WEBPACK_IMPORTED_MODULE_0__.createElement(Popup.Item, {
      key: item[fieldKey],
      isActive: item[fieldKey] && item[fieldKey] === (selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption[fieldKey]),
      onClick: handleChange(item),
      parentLink: item['parentMenu'],
      className: (_item$className = item.className) != null ? _item$className : '',
      style: styles
    }, item[fieldValue]), options.filter(function (option) {
      return option.parentItem === item.id && option.parentMenu === false;
    }).map(function (option, index) {
      return react__WEBPACK_IMPORTED_MODULE_0__.createElement(Popup.Item, {
        key: option[fieldKey] + "_" + index,
        isActive: option[fieldKey] && option[fieldKey] === (selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption[fieldKey]),
        onClick: handleChange(option),
        parentLink: option['parentMenu'],
        columWidth: item['columnWidth']
      }, option[fieldValue]);
    }));
  }))) : null);
}

var LANGUAGE_OPTIONS = [{
  id: ELanguage.VI,
  name: 'Tiếng Việt',
  className: 'Header_Lang_Vi'
}, {
  id: ELanguage.EN,
  name: 'English',
  className: 'Header_Lang_En'
}];

function Actions() {
  var _useAppShellContext = useAppShellContext(),
      langCode = _useAppShellContext.langCode,
      isHomePage = _useAppShellContext.isHomePage,
      user = _useAppShellContext.user,
      mode = _useAppShellContext.mode,
      pageName = _useAppShellContext.pageName;

  var isMounted = useDomContentLoaded();

  var renderTextButton = function renderTextButton() {
    if (!isMounted) {
      return 'Vi';
    }

    return langCode === ELanguage.VI ? 'Vi' : 'En';
  };

  return react__WEBPACK_IMPORTED_MODULE_0__.createElement(Container$3, {
    isHomePage: isHomePage
  }, react__WEBPACK_IMPORTED_MODULE_0__.createElement(Dropdown, {
    defaultValue: langCode,
    options: LANGUAGE_OPTIONS,
    type: 'LANGUAGE',
    onChange: function onChange(value) {
      return handleChangeLanguage(value.id);
    }
  }, react__WEBPACK_IMPORTED_MODULE_0__.createElement(_microfrontends_react_components__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
    isRounded: true,
    type: 'info',
    isIcon: true,
    size: 'sm'
  }, renderTextButton())), react__WEBPACK_IMPORTED_MODULE_0__.createElement(NotificationWrapper, {
    className: 'NotificationIcon',
    tabIndex: 0
  }, react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: 'notification-icon Header_Noti'
  }, react__WEBPACK_IMPORTED_MODULE_0__.createElement(_microfrontends_react_components__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
    type: 'info',
    size: 'sm',
    isRounded: true,
    "aria-label": langCode === ELanguage.VI ? 'Thông báo' : 'Notifications',
    isIcon: true
  }, react__WEBPACK_IMPORTED_MODULE_0__.createElement(BellIcon, null))), react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    id: 'desktopRedDotContainer'
  })), react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledAuthButton, {
    user: user,
    hasLoginText: isHomePage,
    language: langCode,
    mode: mode,
    pageName: pageName
  }));
}

var translations$2 = {
  'MY CAREER CENTER': 'QUẢN LÝ NGHỀ NGHIỆP',
  Jobs: 'Việc làm',
  Companies: 'Công ty',
  'Interview question': 'Câu hỏi phỏng vấn',
  'Salary report': 'Báo cáo lương',
  'For employers': 'Nhà tuyển dụng',
  'All Jobs': 'All Jobs',
  'Jobs for IT-Softwares': 'Jobs for IT-Softwares',
  'Jobs for Marketing': 'Jobs for Marketing',
  '/job-search/all-jobs': '/tim-viec-lam/tim-tat-ca-viec-lam',
  'Newest jobs': 'Việc làm mới nhất',
  '/job-search': '/tim-viec-lam',
  'Find jobs': 'Tìm việc làm',
  Career: 'Nghề nghiệp',
  'Salary convertor': 'Công cụ tính lương',
  'Career path': 'Lộ trình sự nghiệp',
  Numerology: 'Nhân số học',
  'Management jobs': 'Việc làm quản lý',
  'WowCV templates': 'WowCV - Thư viện CV mẫu',
  'My jobs': 'Việc của tôi',
  'Saved jobs': 'Việc đã lưu',
  'Applied jobs': 'Việc đã ứng tuyển',
  'Jobs alert': 'Thông báo việc làm',
  'Jobs for you': 'Việc dành cho bạn',
  'For employer': 'Dành cho Nhà tuyển dụng',
  'FOR EMPLOYER?': 'NHÀ TUYỂN DỤNG?',
  'Empower growth': 'Tìm kiếm nhân tài',
  'Charge station': 'Trạm sạc',
  'IT Jobs': 'IT Jobs',
  'IT Hub': 'IT Hub',
  'All companies': 'Tất cả công ty',
  'Explore': 'Khám phá',
  'All categories': 'Tất cả danh mục'
};

var translate$1 = function translate(language) {
  return function (key) {
    if (language === ELanguage.EN) {
      return key;
    }

    return translations$2[key];
  };
};

var buildListMenu = function buildListMenu(langCode, envVars) {
  var buildPathMenu = function buildPathMenu(path) {
    if (langCode === ELanguage.VI) {
      return "" + envVars.jobSeekerUrl + headerMenuViPath[path];
    } else {
      return "" + envVars.jobSeekerUrl + headerMenuEnPath[path];
    }
  };

  var subMenuTools = [{
    link: envVars.wowCvUrl,
    label: translate$1(langCode)('WowCV templates'),
    pageName: EPages.WOW_CV,
    target: '_self'
  }, {
    label: translate$1(langCode)('Salary convertor'),
    link: buildPathMenu('salaryConverterPath'),
    pageName: EPages.SALARY_CONVERTER,
    target: '_self'
  }, {
    label: translate$1(langCode)('Salary report'),
    link: buildPathMenu('salaryPath'),
    pageName: EPages.SALARY,
    utm: true,
    target: '_self'
  }, {
    label: translate$1(langCode)('Numerology'),
    link: buildPathMenu('numerologyPath'),
    pageName: EPages.NUMEROLOGY,
    target: '_self'
  }, {
    label: translate$1(langCode)('Interview question'),
    link: buildPathMenu('interviewsPath'),
    pageName: EPages.INTERVIEW,
    utm: true,
    target: '_self'
  }, {
    label: translate$1(langCode)('Career path'),
    link: buildPathMenu('careerPath'),
    pageName: EPages.CAREER_PATH,
    target: '_self'
  }, {
    label: 'HR Insider',
    link: envVars.hrInsiderUrl,
    pageName: EPages.HR_INSIDER,
    utm: 'utm_source_navi=vnw_header',
    target: '_blank'
  }, {
    label: translate$1(langCode)('Charge station'),
    link: buildPathMenu('chargeStationPath'),
    pageName: EPages.CHARGE_STATION,
    target: '_self'
  }, {
    label: 'Career newbies',
    link: buildPathMenu('careerNewbies'),
    pageName: EPages.CAREER_NEWBIES,
    target: '_self'
  }];
  var menuList = [{
    id: 'jobs',
    path: buildPathMenu('searchJobsPath'),
    title: translate$1(langCode)('Jobs'),
    target: '_self',
    pageName: EPages.SEARCH_RESULT,
    isHaveSub: true,
    icon: react__WEBPACK_IMPORTED_MODULE_0__.createElement(ResponsiveJobIcon, null),
    responsiveIcon: react__WEBPACK_IMPORTED_MODULE_0__.createElement(ResponsiveJobIcon, null),
    placement: 'bottom-start',
    subMenuList: [{
      label: translate$1(langCode)('Newest jobs'),
      link: buildPathMenu('searchJobsPath'),
      pageName: EPages.SEARCH_RESULT,
      target: '_self',
      id: 'jobs_1',
      parentMenu: false
    }, {
      label: translate$1(langCode)('Find jobs'),
      link: buildPathMenu('seoLandingPagePath'),
      pageName: EPages.SEO_LANDING_PAGE,
      target: '_self',
      id: 'jobs_2',
      parentMenu: false
    }, {
      label: translate$1(langCode)('Management jobs'),
      link: buildPathMenu('topJobsPath'),
      pageName: EPages.TOP_MANAGEMENT_JOBS,
      target: '_self',
      id: 'jobs_3',
      parentMenu: false
    }]
  }, {
    id: 'companies',
    path: buildPathMenu('companyListPath'),
    title: translate$1(langCode)('Companies'),
    target: '_self',
    utm: true,
    pageName: EPages.COMPANY_LIST,
    isHaveSub: false,
    icon: react__WEBPACK_IMPORTED_MODULE_0__.createElement(ResponsiveCompanyIcon, null),
    responsiveIcon: react__WEBPACK_IMPORTED_MODULE_0__.createElement(ResponsiveCompanyIcon, null),
    placement: 'bottom-start'
  }, {
    id: 'myJobsGroups',
    path: buildPathMenu('saveJobsPath') + '?section=saved',
    title: translate$1(langCode)('My jobs'),
    target: '_self',
    pageName: EPages.MY_JOBS,
    isHaveSub: true,
    isUseCustomEvent: true,
    icon: react__WEBPACK_IMPORTED_MODULE_0__.createElement(ReponsiveMyJobIcon, null),
    responsiveIcon: react__WEBPACK_IMPORTED_MODULE_0__.createElement(ReponsiveMyJobIcon, null),
    placement: 'bottom-start',
    subMenuList: [{
      label: translate$1(langCode)('Saved jobs'),
      link: buildPathMenu('saveJobsPath') + '?section=saved',
      pageName: EPages.MY_JOBS,
      section: ESection.SAVED_JOB,
      isUseCustomEvent: true,
      target: '_self',
      id: 'myJobs_1',
      parentMenu: false
    }, {
      label: translate$1(langCode)('Applied jobs'),
      link: buildPathMenu('saveJobsPath') + '?section=applied',
      pageName: EPages.MY_JOBS,
      section: ESection.APPLIED_JOB,
      isUseCustomEvent: true,
      target: '_self',
      id: 'myJobs_2',
      parentMenu: false
    }, {
      label: translate$1(langCode)('Jobs alert'),
      link: buildPathMenu('jobAlertsPath'),
      pageName: EPages.JOB_ALERTS,
      isUseCustomEvent: true,
      target: '_self',
      id: 'myJobs_3',
      parentMenu: false
    }, {
      label: translate$1(langCode)('Jobs for you'),
      link: buildPathMenu('recommendationJobsPath'),
      pageName: EPages.RECOMMENDED_JOBS,
      target: '_self',
      id: 'myJobs_4',
      parentMenu: false
    }]
  }, {
    id: 'careerTools',
    path: '#',
    title: translate$1(langCode)('Career'),
    target: '_self',
    pageName: EPages.CAREER_TOOLS,
    isHaveSub: true,
    subMenuGridColumns: 2,
    subMenuList: subMenuTools,
    icon: react__WEBPACK_IMPORTED_MODULE_0__.createElement(SettingIcon, null),
    placement: 'bottom',
    hiddenOnMobile: true
  }];
  return menuList;
};

var buildFindJobTabItems = function buildFindJobTabItems(langCode, envVars) {
  var buildPathMenu = function buildPathMenu(path) {
    if (langCode === ELanguage.VI) {
      return "" + envVars.jobSeekerUrl + headerMenuViPath[path];
    } else {
      return "" + envVars.jobSeekerUrl + headerMenuEnPath[path];
    }
  };

  return [{
    label: translate$1(langCode)('Newest jobs'),
    link: buildPathMenu('searchJobsPath'),
    pageName: EPages.SEARCH_RESULT,
    target: '_self',
    id: 'searchJobsPath',
    parentMenu: false
  }, {
    label: translate$1(langCode)('Find jobs'),
    link: buildPathMenu('seoLandingPagePath'),
    pageName: EPages.SEO_LANDING_PAGE,
    target: '_self',
    id: 'seoLandingPagePath',
    parentMenu: false
  }, {
    label: translate$1(langCode)('Management jobs'),
    link: buildPathMenu('topJobsPath'),
    pageName: EPages.TOP_MANAGEMENT_JOBS,
    target: '_self',
    id: 'topJobsPath',
    parentMenu: false
  }];
};

var buildInTechMenus = function buildInTechMenus(langCode, envVars) {
  var buildPathMenu = function buildPathMenu(path) {
    if (langCode === ELanguage.VI) {
      return "" + envVars.jobSeekerUrl + headerMenuViPath[path];
    } else {
      return "" + envVars.jobSeekerUrl + headerMenuEnPath[path];
    }
  };

  return [{
    label: translate$1(langCode)('Jobs'),
    link: '',
    pageName: EPages.SEARCH_RESULT,
    target: '_self',
    id: 'all-jobs',
    parentMenu: true
  }, {
    label: translate$1(langCode)('Newest jobs'),
    link: buildPathMenu('searchJobsPath'),
    pageName: EPages.SEARCH_RESULT,
    target: '_self',
    id: 'searchJobsPath',
    utm: 'utm_source_navi=header&utm_medium_navi=newestjobs',
    parentMenu: false,
    parentItem: 'all-jobs'
  }, {
    label: translate$1(langCode)('Find jobs'),
    link: buildPathMenu('seoLandingPagePath'),
    pageName: EPages.SEO_LANDING_PAGE,
    target: '_self',
    id: 'seoLandingPagePath',
    utm: 'utm_source_navi=header&utm_medium_navi=findjobs',
    parentMenu: false,
    parentItem: 'all-jobs'
  }, {
    label: translate$1(langCode)('Management jobs'),
    link: buildPathMenu('topJobsPath'),
    pageName: EPages.TOP_MANAGEMENT_JOBS,
    target: '_self',
    id: 'topJobsPath',
    utm: 'utm_source_navi=header&utm_medium_navi=managementjobs',
    parentMenu: false,
    parentItem: 'all-jobs'
  }, {
    label: translate$1(langCode)('My jobs'),
    link: '',
    pageName: EPages.SEARCH_RESULT,
    target: '_self',
    id: 'all-my-jobs',
    parentMenu: true
  }, {
    label: translate$1(langCode)('Saved jobs'),
    link: buildPathMenu('saveJobsPath') + '?section=saved&utm_source_navi=header&utm_medium_navi=savedjobs',
    pageName: EPages.MY_JOBS,
    section: ESection.SAVED_JOB,
    isUseCustomEvent: true,
    target: '_self',
    id: 'saveJobsPathSaved',
    parentMenu: false,
    parentItem: 'all-my-jobs'
  }, {
    label: translate$1(langCode)('Applied jobs'),
    link: buildPathMenu('saveJobsPath') + '?section=applied&utm_source_navi=header&utm_medium_navi=appliedjobs',
    pageName: EPages.MY_JOBS,
    section: ESection.APPLIED_JOB,
    isUseCustomEvent: true,
    target: '_self',
    id: 'saveJobsPathSavedApplied',
    parentMenu: false,
    parentItem: 'all-my-jobs'
  }, {
    label: translate$1(langCode)('Jobs alert'),
    link: buildPathMenu('jobAlertsPath'),
    pageName: EPages.JOB_ALERTS,
    isUseCustomEvent: true,
    target: '_self',
    id: 'jobAlertsPath',
    utm: 'utm_source_navi=header&utm_medium_navi=jobalerts',
    parentMenu: false,
    parentItem: 'all-my-jobs'
  }, {
    label: translate$1(langCode)('Jobs for you'),
    link: buildPathMenu('recommendationJobsPath'),
    pageName: EPages.RECOMMENDED_JOBS,
    target: '_self',
    id: 'recommendationJobsPath',
    utm: 'utm_source_navi=header&utm_medium_navi=jobsforyou',
    parentMenu: false,
    parentItem: 'all-my-jobs'
  }, {
    label: translate$1(langCode)('Companies'),
    link: '',
    pageName: EPages.RECOMMENDED_JOBS,
    target: '_self',
    id: 'company',
    parentMenu: true
  }, {
    label: translate$1(langCode)('All companies'),
    link: buildPathMenu('companyListPath'),
    pageName: EPages.RECOMMENDED_JOBS,
    target: '_self',
    id: 'recommendationJobsPath',
    utm: 'utm_source_navi=header&utm_medium_navi=allcompanies',
    parentMenu: false,
    parentItem: 'company'
  }, {
    label: translate$1(langCode)('Explore'),
    link: '',
    pageName: EPages.RECOMMENDED_JOBS,
    target: '_self',
    id: 'discover',
    parentMenu: true,
    columnWidth: 'full'
  }, {
    link: envVars.wowCvUrl,
    label: translate$1(langCode)('WowCV templates'),
    pageName: EPages.WOW_CV,
    target: '_self',
    utm: 'utm_source_navi=header&utm_medium_navi=wowcvtemplate',
    parentMenu: false,
    parentItem: 'discover'
  }, {
    label: translate$1(langCode)('Salary report'),
    link: buildPathMenu('salaryPath'),
    pageName: EPages.SALARY,
    utm: 'utm_source_navi=header&utm_medium_navi=salaryreport',
    target: '_self',
    parentMenu: false,
    parentItem: 'discover'
  }, {
    label: translate$1(langCode)('Interview question'),
    link: buildPathMenu('interviewsPath'),
    pageName: EPages.INTERVIEW,
    utm: 'utm_source_navi=header&utm_medium_navi=interviewquestion',
    target: '_self',
    parentMenu: false,
    parentItem: 'discover'
  }, {
    label: 'HR Insider',
    link: envVars.hrInsiderUrl,
    pageName: EPages.HR_INSIDER,
    utm: 'utm_source_navi=header&utm_medium_navi=hrinsider',
    target: '_blank',
    parentMenu: false,
    parentItem: 'discover'
  }, {
    label: translate$1(langCode)('Salary convertor'),
    link: buildPathMenu('salaryConverterPath'),
    pageName: EPages.SALARY_CONVERTER,
    target: '_self',
    utm: 'utm_source_navi=header&utm_medium_navi=salaryconverter',
    parentMenu: false,
    parentItem: 'discover'
  }, {
    label: translate$1(langCode)('Numerology'),
    link: buildPathMenu('numerologyPath'),
    pageName: EPages.NUMEROLOGY,
    target: '_self',
    utm: 'utm_source_navi=header&utm_medium_navi=numerology',
    parentMenu: false,
    parentItem: 'discover'
  }, {
    label: translate$1(langCode)('Career path'),
    link: buildPathMenu('careerPath'),
    pageName: EPages.CAREER_PATH,
    target: '_self',
    utm: 'utm_source_navi=header&utm_medium_navi=careerpath',
    parentMenu: false,
    parentItem: 'discover'
  }, {
    label: translate$1(langCode)('Charge station'),
    link: buildPathMenu('chargeStationPath'),
    pageName: EPages.CHARGE_STATION,
    target: '_blank',
    utm: 'utm_source_navi=header&utm_medium_navi=chargestation',
    parentMenu: false,
    parentItem: 'discover'
  }, {
    label: 'Career newbies',
    link: buildPathMenu('careerNewbies'),
    pageName: EPages.CAREER_NEWBIES,
    target: '_self',
    utm: 'utm_source_navi=header&utm_medium_navi=careernewbies',
    parentMenu: false,
    parentItem: 'discover'
  }, {
    label: 'VietnamWorks inTECH',
    link: '',
    pageName: EPages.SEARCH_RESULT,
    target: '_self',
    id: 'vnws_intech',
    parentMenu: true
  }, {
    label: translate$1(langCode)('IT Jobs'),
    link: buildPathMenu('ITJobs'),
    pageName: EPages.SEARCH_RESULT,
    target: '_self',
    id: 'it_jobs',
    parentMenu: false,
    parentItem: 'vnws_intech'
  }, {
    label: translate$1(langCode)('IT Hub'),
    link: buildPathMenu('inTechLink'),
    pageName: EPages.SEO_LANDING_PAGE,
    target: '_self',
    id: 'about_intech',
    parentMenu: false,
    parentItem: 'vnws_intech'
  }];
};

var BurgerIcon = function BurgerIcon() {
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("svg", {
    style: {
      marginRight: '10px'
    },
    width: '18',
    height: '12',
    viewBox: '0 0 18 12',
    fill: 'none',
    xmlns: 'http://www.w3.org/2000/svg'
  }, (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("path", {
    d: 'M1.00004 0.666571C0.911704 0.665321 0.823995 0.681642 0.742016 0.714585C0.660037 0.747527 0.585423 0.796434 0.52251 0.858464C0.459597 0.920493 0.409639 0.994409 0.375541 1.07591C0.341442 1.15742 0.323883 1.24489 0.323883 1.33324C0.323883 1.42159 0.341442 1.50906 0.375541 1.59056C0.409639 1.67207 0.459597 1.74598 0.52251 1.80801C0.585423 1.87004 0.660037 1.91895 0.742016 1.95189C0.823995 1.98483 0.911704 2.00115 1.00004 1.9999H17C17.0884 2.00115 17.1761 1.98483 17.2581 1.95189C17.3401 1.91895 17.4147 1.87004 17.4776 1.80801C17.5405 1.74598 17.5905 1.67207 17.6245 1.59056C17.6586 1.50906 17.6762 1.42159 17.6762 1.33324C17.6762 1.24489 17.6586 1.15742 17.6245 1.07591C17.5905 0.994409 17.5405 0.920493 17.4776 0.858464C17.4147 0.796434 17.3401 0.747527 17.2581 0.714585C17.1761 0.681642 17.0884 0.665321 17 0.666571H1.00004ZM1.00004 5.33324C0.911704 5.33199 0.823995 5.34831 0.742016 5.38125C0.660037 5.41419 0.585423 5.4631 0.52251 5.52513C0.459597 5.58716 0.409639 5.66107 0.375541 5.74258C0.341442 5.82408 0.323883 5.91155 0.323883 5.9999C0.323883 6.08825 0.341442 6.17572 0.375541 6.25723C0.409639 6.33873 0.459597 6.41265 0.52251 6.47468C0.585423 6.53671 0.660037 6.58561 0.742016 6.61856C0.823995 6.6515 0.911704 6.66782 1.00004 6.66657H17C17.0884 6.66782 17.1761 6.6515 17.2581 6.61856C17.3401 6.58561 17.4147 6.53671 17.4776 6.47468C17.5405 6.41265 17.5905 6.33873 17.6245 6.25723C17.6586 6.17572 17.6762 6.08825 17.6762 5.9999C17.6762 5.91155 17.6586 5.82408 17.6245 5.74258C17.5905 5.66107 17.5405 5.58716 17.4776 5.52513C17.4147 5.4631 17.3401 5.41419 17.2581 5.38125C17.1761 5.34831 17.0884 5.33199 17 5.33324H1.00004ZM1.00004 9.9999C0.911704 9.99865 0.823995 10.015 0.742016 10.0479C0.660037 10.0809 0.585423 10.1298 0.52251 10.1918C0.459597 10.2538 0.409639 10.3277 0.375541 10.4092C0.341442 10.4908 0.323883 10.5782 0.323883 10.6666C0.323883 10.7549 0.341442 10.8424 0.375541 10.9239C0.409639 11.0054 0.459597 11.0793 0.52251 11.1413C0.585423 11.2034 0.660037 11.2523 0.742016 11.2852C0.823995 11.3182 0.911704 11.3345 1.00004 11.3332H17C17.0884 11.3345 17.1761 11.3182 17.2581 11.2852C17.3401 11.2523 17.4147 11.2034 17.4776 11.1413C17.5405 11.0793 17.5905 11.0054 17.6245 10.9239C17.6586 10.8424 17.6762 10.7549 17.6762 10.6666C17.6762 10.5782 17.6586 10.4908 17.6245 10.4092C17.5905 10.3277 17.5405 10.2538 17.4776 10.1918C17.4147 10.1298 17.3401 10.0809 17.2581 10.0479C17.1761 10.015 17.0884 9.99865 17 9.9999H1.00004Z',
    fill: 'white'
  }));
};

function _templateObject11() {
  var data = _taggedTemplateLiteralLoose(["\n    border: 1px solid #347bff;\n    border-radius: 48px;\n    padding: 0;\n    margin-left: 20px;\n    line-height: 40px;\n    &:hover {\n        background: #002466;\n    }\n    @media (max-width: 1023px) {\n        width: 40px;\n        height: 40px !important;\n        span {\n            font-size: 0;\n            margin-left: -10px;\n        }\n    }\n"]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10$1() {
  var data = _taggedTemplateLiteralLoose(["\n    display: grid;\n    row-gap: 4px;\n    text-align: center;\n    color: #fff;\n    transition: color 0.2s ease-in-out;\n    font-weight: 500;\n    margin-left: 10px;\n    border: 1px solid #347bff;\n    border-radius: 48px;\n    padding: 0 10px;\n    line-height: 40px;\n    @media (min-width: 1285px) {\n        font-size: 14px;\n    }\n    &:hover {\n        background: #002466;\n        color: #fff !important;\n    }\n    & > span {\n        white-space: nowrap;\n    }\n    & > .small {\n        font-size: 12px;\n        font-weight: 400;\n        display: none;\n        @media (min-width: 1285px) {\n            display: inline;\n        }\n    }\n"]);

  _templateObject10$1 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9$1() {
  var data = _taggedTemplateLiteralLoose(["\n    height: 48px;\n    width: 0px;\n    background: ", ";\n    margin: 0 12px;\n    @media (min-width: 1024px) {\n        width: 1px;\n        margin: 0 16px;\n    }\n    @media (min-width: 1368px) {\n        margin: 0 24px;\n    }\n    @media (min-width: 1513px) {\n        margin: 0 32px;\n    }\n"]);

  _templateObject9$1 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8$1() {
  var data = _taggedTemplateLiteralLoose(["\n    font-size: 12px;\n    @media (min-width: 1513px) {\n        font-size: 14px;\n    }\n    display: none;\n    @media (min-width: 1024px) {\n        display: inline;\n    }\n"]);

  _templateObject8$1 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7$1() {
  var data = _taggedTemplateLiteralLoose(["\n    display: grid;\n    row-gap: 4px;\n    place-items: center;\n    padding: 0 8px;\n    white-space: nowrap;\n    cursor: pointer;\n    height: 100%;\n    transition: color 0.2s ease-in-out;\n    ", "\n    ", "\n"]);

  _templateObject7$1 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6$2() {
  var data = _taggedTemplateLiteralLoose(["\n    height: 100%;\n    &:not(:last-of-type) {\n        margin-right: 16px;\n        @media (min-width: 1368px) {\n            margin-right: 24px;\n        }\n        @media (min-width: 1728px) {\n            margin-right: 56px;\n        }\n    }\n    ", "\n"]);

  _templateObject6$2 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5$3() {
  var data = _taggedTemplateLiteralLoose(["\n    display: flex;\n    list-style: none;\n    padding: 0;\n    margin-bottom: 0;\n"]);

  _templateObject5$3 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$4() {
  var data = _taggedTemplateLiteralLoose(["\n    height: fit-content;\n    flex: 1;\n"]);

  _templateObject4$4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$7() {
  var data = _taggedTemplateLiteralLoose(["\n    display: flex;\n    align-items: center;\n"]);

  _templateObject3$7 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$7() {
  var data = _taggedTemplateLiteralLoose(["\n    display: flex;\n    align-items: center;\n    ", "\n"]);

  _templateObject2$7 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$7() {
  var data = _taggedTemplateLiteralLoose(["\n    display: flex;\n    align-items: center;\n    position: static;\n    flex: 1;\n"]);

  _templateObject$7 = function _templateObject() {
    return data;
  };

  return data;
}
var Container$4 = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div */ .ZP.div(_templateObject$7());
var NavigationWrapper = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div */ .ZP.div(_templateObject2$7(), function (_ref) {
  var isHomePage = _ref.isHomePage;
  return isHomePage ? "\n            justify-content: flex-end;\n        " : '';
});
var NavigationContainer = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div */ .ZP.div(_templateObject3$7());
var SearchBarMask = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div */ .ZP.div(_templateObject4$4());
var ListNavigation = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].ul */ .ZP.ul(_templateObject5$3());
var ItemNavigation = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].li */ .ZP.li(_templateObject6$2(), function (_ref2) {
  var isHomePage = _ref2.isHomePage;
  return isHomePage ? "\n        &:first-of-type {\n            a {\n                padding-left: 0;\n            }\n        }\n        &:last-of-type {\n            a {\n                padding-right: 0;\n            }\n        }\n    " : '';
});
var NavigationLink = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].a */ .ZP.a(_templateObject7$1(), function (_ref3) {
  var color = _ref3.color;
  return "\n        color: " + color + ";\n        &:hover {\n            color: #fff;\n        }\n        &:not([href]) {\n            color: " + color + ";\n        }\n        &:not([href]):hover {\n            color: #fff;\n        }\n    ";
}, function (_ref4) {
  var isHomePage = _ref4.isHomePage;
  return isHomePage ? "\n        column-gap: 8px;\n        row-gap: 4px;\n        @media (min-width: 1024px) {\n            grid-template-columns: auto 1fr;\n        }\n    " : "\n        @media (min-width: 1513px) {\n            grid-template-columns: auto 1fr;\n            column-gap: 8px;\n        }\n\n    ";
});
var NavigationTitle = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].span */ .ZP.span(_templateObject8$1());
var Separator = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div */ .ZP.div(_templateObject9$1(), _microfrontends_react_components__WEBPACK_IMPORTED_MODULE_14__/* .colors.primary[40] */ .O9.primary[40]);
var EmployerLink$1 = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].a */ .ZP.a(_templateObject10$1());
var HeaderButton = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div */ .ZP.div(_templateObject11());

var ListMenu = function ListMenu(_ref) {
  var listMenu = _ref.listMenu,
      pageName = _ref.pageName,
      isLoggedIn = _ref.isLoggedIn,
      isTablet = _ref.isTablet,
      langCode = _ref.langCode,
      isHomePage = _ref.isHomePage,
      section = _ref.section;
  return react__WEBPACK_IMPORTED_MODULE_0__.createElement(ListNavigation, null, listMenu.map(function (item) {
    var _item$subMenuList, _item$subMenuList$fil;

    var isActive = item.pageName === pageName || item.subMenuList && item.subMenuList.length > 0 && item.subMenuList.filter(function (item) {
      return item.pageName === pageName;
    }).length > 0 || false;
    var isHaveSection = !!section && item.subMenuList && ((_item$subMenuList = item.subMenuList) === null || _item$subMenuList === void 0 ? void 0 : (_item$subMenuList$fil = _item$subMenuList.filter(function (item) {
      return item.section;
    })) === null || _item$subMenuList$fil === void 0 ? void 0 : _item$subMenuList$fil.length) > 0;
    return react__WEBPACK_IMPORTED_MODULE_0__.createElement(ItemNavigation, {
      key: item.id,
      isHomePage: isHomePage
    }, react__WEBPACK_IMPORTED_MODULE_0__.createElement(Dropdown, {
      defaultValue: isHaveSection ? section : pageName,
      options: item.subMenuList || [],
      key: item.id,
      fieldKey: isHaveSection ? 'section' : 'pageName',
      fieldValue: 'label',
      dropdownColumn: item.subMenuGridColumns,
      mode: isTablet ? 'click' : 'hover',
      placement: item.placement,
      disable: !item.subMenuList,
      notSaveSelected: true,
      onChange: function onChange(value) {
        handleNavigationClick({
          link: value.link,
          utm: value.utm,
          isUseCustomEvent: value.isUseCustomEvent || false,
          isLoggedIn: isLoggedIn,
          langCode: langCode
        });
      }
    }, react__WEBPACK_IMPORTED_MODULE_0__.createElement(NavigationLink, {
      isHomePage: isHomePage,
      href: item.path !== '' ? item.path : undefined,
      color: isActive ? '#fff' : _microfrontends_react_components__WEBPACK_IMPORTED_MODULE_14__/* .colors.primary[80] */ .O9.primary[80],
      onClick: function onClick(e) {
        e.preventDefault();

        if (isTablet && item.isHaveSub) {
          return;
        }

        handleNavigationClick({
          link: item.path,
          utm: item.utm,
          isUseCustomEvent: item.isUseCustomEvent || false,
          isLoggedIn: isLoggedIn,
          langCode: langCode
        });
      }
    }, item.icon, react__WEBPACK_IMPORTED_MODULE_0__.createElement(NavigationTitle, null, item.title))));
  }));
};

function Navigation() {
  var _useAppShellContext = useAppShellContext(),
      langCode = _useAppShellContext.langCode,
      mode = _useAppShellContext.mode,
      pageName = _useAppShellContext.pageName,
      isLoggedIn = _useAppShellContext.isLoggedIn,
      user = _useAppShellContext.user,
      userIp = _useAppShellContext.userIp,
      isHomePage = _useAppShellContext.isHomePage,
      isMobile = _useAppShellContext.isMobile,
      isTablet = _useAppShellContext.isTablet,
      translate = _useAppShellContext.translate,
      optionList = _useAppShellContext.optionList,
      isPageContainer = _useAppShellContext.isPageContainer,
      subMenuSection = _useAppShellContext.subMenuSection;

  var envVars = getEnvVars(mode, langCode);
  var listMenu = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function () {
    return buildListMenu(langCode, envVars);
  }, []);
  var listMenuIntech = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function () {
    return buildInTechMenus(langCode, envVars);
  }, []);

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(''),
      urlBanner = _useState[0],
      setUrlBanner = _useState[1];

  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(''),
      bannerTarget = _useState2[0],
      setBannerTarget = _useState2[1];

  var getIntechBanner = function getIntechBanner() {
    try {
      var _getEnvVars = getEnvVars(mode, langCode),
          msBasePath = _getEnvVars.msBasePath;

      return Promise.resolve(getIntechBannerAPI(msBasePath + "/banners/v1.0/header-banner")).then(function (result) {
        var resArray = result === null || result === void 0 ? void 0 : result.data;
        var currentDate = new Date();
        var milliseconds = currentDate.getMilliseconds();
        resArray && resArray.filter(function (item) {
          return item.type === 'header';
        }).map(function (img) {
          setUrlBanner(img.attributes.image + "?ver=" + milliseconds);
          setBannerTarget("" + img.attributes.url);
        });
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    getIntechBanner();
  }, []);
  return react__WEBPACK_IMPORTED_MODULE_0__.createElement(Container$4, {
    style: {
      maxWidth: "" + (isHomePage ? 'auto' : "1440px")
    }
  }, react__WEBPACK_IMPORTED_MODULE_0__.createElement(_microfrontends_react_components__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z, {
    style: {
      position: 'relative',
      maxWidth: 'inherit',
      justifyContent: 'space-between',
      width: '100%',
      padding: '0 10px'
    }
  }, react__WEBPACK_IMPORTED_MODULE_0__.createElement(_microfrontends_react_components__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z, null, react__WEBPACK_IMPORTED_MODULE_0__.createElement(NavigationWrapper, {
    isHomePage: isHomePage
  }, react__WEBPACK_IMPORTED_MODULE_0__.createElement(SearchBarMask, {
    className: 'Header_Search',
    style: {
      maxWidth: "calc(100% - " + (isTablet === true ? "314px" : "450px")
    }
  }, !isHomePage ? react__WEBPACK_IMPORTED_MODULE_0__.createElement(_microfrontends_react_components__WEBPACK_IMPORTED_MODULE_24__/* ["default"] */ .Z, {
    userId: (user === null || user === void 0 ? void 0 : user.userId) || 0,
    userJobFunction: (user === null || user === void 0 ? void 0 : user.jobFunction) || [],
    langCode: langCode,
    isMobile: isMobile,
    pageName: pageName != null ? pageName : '',
    dataProvider: initialDataProvider.exportProvider(),
    msBaseUrl: envVars.msBasePath,
    searchBarOptions: {
      isHomepage: false,
      isNeedNavigate: !isPageContainer
    },
    userIP: userIp,
    VNWAppId: envVars.appId,
    responsiveStyle: 'icon',
    optionList: optionList,
    mode: mode
  }) : null), react__WEBPACK_IMPORTED_MODULE_0__.createElement(NavigationContainer, {
    isHomePage: isHomePage,
    isLoggedIn: isLoggedIn
  }, !isHomePage && isMobile ? react__WEBPACK_IMPORTED_MODULE_0__.createElement(ListMenu, {
    isHomePage: isHomePage,
    listMenu: listMenu,
    pageName: pageName,
    langCode: langCode,
    isLoggedIn: isLoggedIn,
    isTablet: isTablet,
    section: subMenuSection
  }) : null, react__WEBPACK_IMPORTED_MODULE_0__.createElement(Logo, {
    isIntech: true
  }), !isMobile ? react__WEBPACK_IMPORTED_MODULE_0__.createElement(Dropdown, {
    defaultValue: langCode,
    options: listMenuIntech,
    fieldKey: 'pageName',
    fieldValue: 'label',
    dropdownColumn: 1,
    mode: 'click',
    notSaveSelected: true,
    isNavigation: true,
    bannerUrl: urlBanner,
    bannerTarget: bannerTarget,
    nodeEnv: mode,
    onChange: function onChange(value) {
      handleNavigationClick({
        link: value.link,
        utm: value.utm,
        isUseCustomEvent: value.isUseCustomEvent || false,
        isLoggedIn: isLoggedIn,
        langCode: langCode,
        target: value.target
      });
    }
  }, react__WEBPACK_IMPORTED_MODULE_0__.createElement(HeaderButton, null, react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    style: {
      lineHeight: '38px',
      width: "" + (!isTablet ? "160px" : "auto"),
      textAlign: 'center'
    }
  }, react__WEBPACK_IMPORTED_MODULE_0__.createElement(BurgerIcon, null), react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", null, translate('All categories'))))) : null, react__WEBPACK_IMPORTED_MODULE_0__.createElement(EmployerLink$1, {
    href: envVars.employerUrl,
    target: '_blank',
    tabIndex: 0
  }, react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", null, translate('For employer'))))))));
}

function _templateObject2$8() {
  var data = _taggedTemplateLiteralLoose(["\n    position: relative;\n    padding: 8px;\n    white-space: nowrap;\n    color: ", ";\n    font-weight: 500;\n    &:not(:last-of-type) {\n        margin-right: 24px;\n    }\n    ", "\n"]);

  _templateObject2$8 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$8() {
  var data = _taggedTemplateLiteralLoose(["\n    position: sticky;\n    top: 0;\n    background: ", ";\n    overflow-x: auto;\n    display: flex;\n    width: 100vw;\n    z-index: -1;\n    &::-webkit-scrollbar {\n        display: none;\n    }\n    -ms-overflow-style: none; /* IE and Edge */\n    scrollbar-width: none; /* Firefox */\n    padding: 0 8px;\n    @media (min-width: 768px) {\n        display: none;\n    }\n"]);

  _templateObject$8 = function _templateObject() {
    return data;
  };

  return data;
}
var TabContainer = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div */ .ZP.div(_templateObject$8(), function (_ref) {
  var backgroundColor = _ref.backgroundColor;
  return backgroundColor;
});
var TabItem = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div */ .ZP.div(_templateObject2$8(), function (_ref2) {
  var isActive = _ref2.isActive;
  return isActive ? _microfrontends_react_components__WEBPACK_IMPORTED_MODULE_14__/* .colors.primary[40] */ .O9.primary[40] : _microfrontends_react_components__WEBPACK_IMPORTED_MODULE_14__/* .colors.grey[40] */ .O9.grey[40];
}, function (_ref3) {
  var isActive = _ref3.isActive;
  return isActive ? "\n        &::after {\n            content: '';\n            display: block;\n            height: 2px;\n            background: " + _microfrontends_react_components__WEBPACK_IMPORTED_MODULE_14__/* .colors.primary[40] */ .O9.primary[40] + ";\n            position: absolute;\n            bottom: 0;\n            left: 0;\n            right: 0;\n        }\n    " : '';
});

function FindJobsTab() {
  var _useAppShellContext = useAppShellContext(),
      langCode = _useAppShellContext.langCode,
      mode = _useAppShellContext.mode,
      pageName = _useAppShellContext.pageName,
      isLoggedIn = _useAppShellContext.isLoggedIn,
      responsive = _useAppShellContext.responsive;

  var envVars = getEnvVars(mode, langCode);
  var findJobItems = buildFindJobTabItems(langCode, envVars);
  var backgroundColor = responsive.cornerColor || '#fff';
  var tabContainerRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    if (tabContainerRef.current) {
      var childs = tabContainerRef.current.childNodes;
      var activeIndex = findJobItems.findIndex(function (item) {
        return item.pageName === pageName;
      });
      var activeElement = childs[activeIndex];
      tabContainerRef.current.scrollTo({
        left: activeElement.offsetLeft,
        behavior: 'smooth'
      });
    }
  }, [pageName]);
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(TabContainer, {
    backgroundColor: backgroundColor,
    ref: tabContainerRef
  }, findJobItems.map(function (item) {
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(TabItem, {
      isActive: pageName === item.pageName,
      key: item.label,
      onClick: function onClick() {
        handleNavigationClick({
          link: item.link || '',
          utm: item.utm,
          isUseCustomEvent: item.isUseCustomEvent || false,
          isLoggedIn: isLoggedIn,
          langCode: langCode
        });
      }
    }, item.label);
  }));
}

var IMAGE_SIZE = {
  width: 2560,
  height: 94
};
var TOP_BANNER_URL = '/banners/v1.0/top-banner';

function getBackgroundColor(imgEl) {
  var result = {
    leftBg: '',
    rightBg: ''
  };
  var canvas = document.createElement('canvas');
  canvas.width = IMAGE_SIZE.width;
  canvas.height = IMAGE_SIZE.height;
  var ctx = canvas.getContext && canvas.getContext('2d');

  if (ctx) {
    var _ctx$getImageData, _ctx$getImageData2;

    ctx.drawImage(imgEl, 0, 0, IMAGE_SIZE.width, IMAGE_SIZE.height);
    var leftData = (_ctx$getImageData = ctx.getImageData(1, 1, 1, 1)) === null || _ctx$getImageData === void 0 ? void 0 : _ctx$getImageData.data;
    var rightData = (_ctx$getImageData2 = ctx.getImageData(canvas.width - 2, canvas.height - 2, 1, 1)) === null || _ctx$getImageData2 === void 0 ? void 0 : _ctx$getImageData2.data;

    if (leftData && leftData.length !== 0 && rightData && rightData.length !== 0) {
      result = {
        leftBg: "rgba(" + leftData[0] + "," + leftData[1] + "," + leftData[2] + "," + leftData[3] / 255 + ")",
        rightBg: "rgba(" + rightData[0] + "," + rightData[1] + "," + rightData[2] + "," + rightData[3] / 255 + ")"
      };
    }
  }

  return result;
}
var TOP_BANNER_PREFIX_KEY = '-vnw-top-banner';
function getActiveTopBannerIndexFromLocal(zoneName, maxIndex) {
  if (localStorage && maxIndex > 0) {
    var key = zoneName + TOP_BANNER_PREFIX_KEY;
    var activeIndex = parseInt(localStorage.getItem(key) || '0');
    var increasedIndex = activeIndex + 1;

    if (increasedIndex > maxIndex) {
      increasedIndex = 0;
    }

    localStorage.setItem(key, increasedIndex.toString());
    return activeIndex;
  }

  return 0;
}
function getDefaultBanner(listTopBanners) {
  if (listTopBanners.length > 0) {
    return listTopBanners[0];
  }

  return {
    allowClose: 0,
    attributes: {
      image: '',
      url: ''
    },
    id: 0,
    type: ''
  };
}

var getTopBanner = function getTopBanner(topBanner, langCode, companyIndustries, jobFunction) {
  try {
    return Promise.resolve(initialDataProvider.getDatasetAsync(_microfrontends_react_components__WEBPACK_IMPORTED_MODULE_2__/* .ENestedDatasetName.JOB_FUNCTION */ .X.JOB_FUNCTION)).then(function () {
      var topBannerUrl = topBanner.msBaseUrl + TOP_BANNER_URL;
      var url = attachQueryParamToUrl(topBannerUrl, {
        zoneName: topBanner.zoneName,
        industryV3Id: (companyIndustries === null || companyIndustries === void 0 ? void 0 : companyIndustries.length) ? companyIndustries : [],
        jobFunctionIds: initialDataProvider.getChildrenIdsFromNestedIds(jobFunction, _microfrontends_react_components__WEBPACK_IMPORTED_MODULE_2__/* .ENestedDatasetName.JOB_FUNCTION */ .X.JOB_FUNCTION)
      });
      return Promise.resolve(fetch(url, {
        method: 'GET',
        mode: 'cors',
        signal: topBanner.signal,
        headers: {
          'Accept-Language': langCode,
          'Content-Type': 'application/json'
        }
      }).then(function (res) {
        if (res.status === 200) {
          return res.json();
        } else {
          console.error('status code ' + res.status);
        }
      })["catch"](function (error) {
        if (error.name === 'AbortError') {
          return;
        }

        console.error("Error when getting Top Banner: " + error.message);
      }));
    });
  } catch (e) {
    return Promise.reject(e);
  }
};

function _templateObject5$4() {
  var data = _taggedTemplateLiteralLoose(["\n    position: relative;\n    height: 50px;\n    img {\n        object-fit: contain;\n    }\n"]);

  _templateObject5$4 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$5() {
  var data = _taggedTemplateLiteralLoose(["\n    display: block;\n    width: 100%;\n    height: 100%;\n"]);

  _templateObject4$5 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$8() {
  var data = _taggedTemplateLiteralLoose(["\n    background: unset;\n    border: unset;\n    outline: none;\n    position: absolute;\n    right: 25px;\n    color: #333;\n    z-index: 1;\n    cursor: pointer;\n    &:focus {\n        outline: none;\n    }\n    &:hover {\n        color: #000;\n    }\n"]);

  _templateObject3$8 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$9() {
  var data = _taggedTemplateLiteralLoose(["\n    height: 50px;\n    object-fit: contain;\n"]);

  _templateObject2$9 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$9() {
  var data = _taggedTemplateLiteralLoose(["\n    position: relative;\n    height: 50px;\n    display: flex;\n    align-items: center;\n    background: #c8e9f8;\n    overflow: hidden;\n    @media (max-width: 992px) {\n        display: none;\n    }\n"]);

  _templateObject$9 = function _templateObject() {
    return data;
  };

  return data;
}
var TopBannerContainer = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div */ .ZP.div(_templateObject$9());
var BannerImage = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].img */ .ZP.img(_templateObject2$9());
var CloseButon = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].button */ .ZP.button(_templateObject3$8());
var Link$1 = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].a */ .ZP.a(_templateObject4$5());
var NextImageContainer = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div */ .ZP.div(_templateObject5$4());

function TopBanner(props) {
  var _props$nextImage = props.nextImage,
      nextImage = _props$nextImage === void 0 ? null : _props$nextImage,
      handleSetHaveTopBanner = props.handleSetHaveTopBanner;

  var _useContext = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(AppShellContext$1),
      mode = _useContext.mode,
      langCode = _useContext.langCode,
      zoneName = _useContext.zoneName,
      companyIndustries = _useContext.companyIndustries,
      jobFunctions = _useContext.jobFunctions,
      forceShowTopBanner = _useContext.forceShowTopBanner,
      topBannerData = _useContext.topBannerData,
      autoFetchTopBanner = _useContext.autoFetchTopBanner;

  if (zoneName === ETopBannerZoneName.EMPTY) {
    return null;
  }

  var _getEnvVars = getEnvVars(mode, langCode),
      trackingAPI = _getEnvVars.trackingAPI,
      msBasePath = _getEnvVars.msBasePath;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(topBannerData),
      listTopBanner = _useState[0],
      setListTopBanner = _useState[1];

  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(forceShowTopBanner),
      showTopBanner = _useState2[0],
      setShowTopBanner = _useState2[1];

  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)({
    leftBg: '',
    rightBg: ''
  }),
      bgColors = _useState3[0],
      setBgColors = _useState3[1];

  var bannerInfo = getDefaultBanner(topBannerData != null ? topBannerData : []);

  var _useState4 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(bannerInfo),
      banner = _useState4[0],
      setBanner = _useState4[1];

  var _useState5 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)((topBannerData === null || topBannerData === void 0 ? void 0 : topBannerData.length) === 0),
      isLoading = _useState5[0],
      setLoading = _useState5[1];

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    var fetchTopBanner = function fetchTopBanner() {
      try {
        return Promise.resolve(initialDataProvider.getDatasetAsync(_microfrontends_react_components__WEBPACK_IMPORTED_MODULE_2__/* .ENestedDatasetName.JOB_FUNCTION */ .X.JOB_FUNCTION)).then(function () {
          var topBannerConfig = {
            zoneName: zoneName,
            msBaseUrl: msBasePath,
            signal: abortController.signal
          };
          return Promise.resolve(getTopBanner(topBannerConfig, langCode, companyIndustries, jobFunctions)).then(function (result) {
            if (result && Object.keys(result).length !== 0 && result.data.length !== 0) {
              setListTopBanner(result.data);
            } else if (!abortController.signal.aborted) {
              setShowTopBanner(false);
              handleSetHaveTopBanner(false);
            }
          });
        });
      } catch (e) {
        return Promise.reject(e);
      }
    };

    if (!autoFetchTopBanner) {
      if (topBannerData && topBannerData.length > 0) {
        setShowTopBanner(true);
      } else {
        setShowTopBanner(false);
      }

      return;
    }

    var abortController = new AbortController();

    if (zoneName !== ETopBannerZoneName.HOME_PAGE) {
      fetchTopBanner();
    }

    return function () {
      abortController.abort();
    };
  }, [mode, zoneName, companyIndustries, jobFunctions, autoFetchTopBanner, topBannerData]);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    if (listTopBanner && listTopBanner.length > 0) {
      var index = getActiveTopBannerIndexFromLocal(zoneName, listTopBanner.length - 1);
      var _banner = listTopBanner[index];

      if (!_banner) {
        _banner = listTopBanner[listTopBanner.length - 1];
      }

      setBanner(_banner);
      setShowTopBanner(true);
      handleSetHaveTopBanner(true);
    }
  }, [zoneName, listTopBanner]);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    var img = new Image();
    img.src = banner.attributes.image;
    img.crossOrigin = 'anonymous';
    img.style.display = 'none';

    img.onload = function () {
      var bgColors = getBackgroundColor(img);
      setBgColors(bgColors);
      setLoading(false);
      img.remove();
    };
  }, [banner]);

  var _Hooks$useTransition = _microfrontends_react_components__WEBPACK_IMPORTED_MODULE_25__/* ["default"] */ .Z({
    open: showTopBanner
  }, {
    initial: {
      height: 50,
      opacity: 1
    },
    enter: {
      height: 50,
      opacity: 1
    },
    leave: {
      height: 0,
      opacity: 0
    }
  }),
      isMounted = _Hooks$useTransition.isMounted,
      styles = _Hooks$useTransition.styles;

  var background = bgColors.leftBg && bgColors.rightBg ? "linear-gradient(to right, " + bgColors.leftBg + "49%, " + bgColors.rightBg + "51%)" : 'none';
  var NextImageWrapper = nextImage !== null ? nextImage() : null;

  var renderBanner = function renderBanner() {
    if (nextImage !== null && NextImageWrapper !== null) {
      return react__WEBPACK_IMPORTED_MODULE_0__.createElement(NextImageContainer, null, react__WEBPACK_IMPORTED_MODULE_0__.createElement(NextImageWrapper, {
        src: banner.attributes.image,
        alt: "Vietnamworks's top banner",
        layout: 'fill',
        priority: true
      }));
    }

    return react__WEBPACK_IMPORTED_MODULE_0__.createElement(BannerImage, {
      height: 50,
      width: '100%',
      src: banner.attributes.image,
      alt: "Vietnamworks's top banner"
    });
  };

  return isMounted ? react__WEBPACK_IMPORTED_MODULE_0__.createElement(TopBannerContainer, {
    style: _extends({
      background: background
    }, styles)
  }, react__WEBPACK_IMPORTED_MODULE_0__.createElement(Link$1, {
    rel: 'noreferrer',
    target: '_blank',
    href: banner.attributes.url !== '' ? banner.attributes.url : undefined,
    "aria-label": "Vietnamworks's banner",
    onClick: function onClick(e) {
      if (isLoading) {
        e.preventDefault();
      }

      (0,_microfrontends_react_components__WEBPACK_IMPORTED_MODULE_26__/* .callTrackingUTM */ .eW)(e, trackingAPI);
    }
  }, isLoading ? react__WEBPACK_IMPORTED_MODULE_0__.createElement(_microfrontends_react_components__WEBPACK_IMPORTED_MODULE_27__/* ["default"] */ .Z, {
    height: 50
  }) : renderBanner()), banner.allowClose === 1 ? react__WEBPACK_IMPORTED_MODULE_0__.createElement(CloseButon, {
    onClick: function onClick() {
      setShowTopBanner(false);
      handleSetHaveTopBanner(false);
    },
    "aria-label": 'Close top banner'
  }, react__WEBPACK_IMPORTED_MODULE_0__.createElement(_microfrontends_react_components__WEBPACK_IMPORTED_MODULE_28__/* ["default"] */ .Z, {
    fill: 'currentColor'
  })) : null) : null;
}

function _templateObject2$a() {
  var data = _taggedTemplateLiteralLoose(["\n    width: 100%;\n"]);

  _templateObject2$a = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$a() {
  var data = _taggedTemplateLiteralLoose(["\n    width: ", ";\n    height: 40px;\n    border-radius: 9999px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background-color: ", ";\n    border: none;\n    color: #fff;\n    font-weight: 500;\n    transition: background 0.25s ease-in-out;\n    position: relative;\n    &:hover {\n        background-color: ", ";\n    }\n"]);

  _templateObject$a = function _templateObject() {
    return data;
  };

  return data;
}
var Icon = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div */ .ZP.div(_templateObject$a(), function (_ref) {
  var isMobile = _ref.isMobile,
      isLoggedIn = _ref.isLoggedIn;
  return isMobile || isLoggedIn ? '40px' : '100%';
}, _microfrontends_react_components__WEBPACK_IMPORTED_MODULE_14__/* .colors.primary[40] */ .O9.primary[40], _microfrontends_react_components__WEBPACK_IMPORTED_MODULE_14__/* .colors.primary[50] */ .O9.primary[50]);
var SearchResultWrapper = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div */ .ZP.div(_templateObject2$a());

function MainPageHeader() {
  return react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, react__WEBPACK_IMPORTED_MODULE_0__.createElement(Logo, null), react__WEBPACK_IMPORTED_MODULE_0__.createElement(Icon, {
    id: 'mobileRedDotContainer',
    className: 'menu-notification notification-icon',
    isMobile: true
  }, react__WEBPACK_IMPORTED_MODULE_0__.createElement(BellIcon, null)));
}

function SearchResultHeader() {
  var _useAppShellContext = useAppShellContext(),
      user = _useAppShellContext.user,
      userIp = _useAppShellContext.userIp,
      mode = _useAppShellContext.mode,
      langCode = _useAppShellContext.langCode,
      isPageContainer = _useAppShellContext.isPageContainer,
      optionList = _useAppShellContext.optionList;

  var envVars = getEnvVars(mode, langCode);
  return react__WEBPACK_IMPORTED_MODULE_0__.createElement(SearchResultWrapper, null, react__WEBPACK_IMPORTED_MODULE_0__.createElement(_microfrontends_react_components__WEBPACK_IMPORTED_MODULE_24__/* ["default"] */ .Z, {
    userId: (user === null || user === void 0 ? void 0 : user.userId) || 0,
    userJobFunction: (user === null || user === void 0 ? void 0 : user.jobFunction) || [],
    langCode: langCode,
    isMobile: true,
    pageName: EPages.SEARCH_RESULT,
    dataProvider: initialDataProvider.exportProvider(),
    msBaseUrl: envVars.msBasePath,
    searchBarOptions: {
      isHomepage: false,
      isNeedNavigate: !isPageContainer
    },
    userIP: userIp,
    VNWAppId: envVars.appId,
    responsiveStyle: 'fill',
    optionList: optionList,
    mode: mode
  }));
}

function _templateObject4$6() {
  var data = _taggedTemplateLiteralLoose(["\n    color: #fff;\n    background: transparent;\n    border: none;\n    margin-right: 10px;\n    padding: 0;\n    &:focus {\n        outline: none;\n    }\n"]);

  _templateObject4$6 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$9() {
  var data = _taggedTemplateLiteralLoose(["\n    display: flex;\n    align-items: center;\n    height: 40px;\n"]);

  _templateObject3$9 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$b() {
  var data = _taggedTemplateLiteralLoose(["\n    margin-bottom: 0;\n    font-size: 20px;\n    font-weight: 600;\n    line-height: 24px;\n"]);

  _templateObject2$b = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$b() {
  var data = _taggedTemplateLiteralLoose(["\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    width: 100%;\n"]);

  _templateObject$b = function _templateObject() {
    return data;
  };

  return data;
}
var Container$5 = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div */ .ZP.div(_templateObject$b());
var Title = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].p */ .ZP.p(_templateObject2$b());
var ActionWrapper = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div */ .ZP.div(_templateObject3$9());
var Button$1 = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].button */ .ZP.button(_templateObject4$6());

function SubPageHeader() {
  var _useAppShellContext = useAppShellContext(),
      responsive = _useAppShellContext.responsive;

  return react__WEBPACK_IMPORTED_MODULE_0__.createElement(Container$5, null, react__WEBPACK_IMPORTED_MODULE_0__.createElement(ActionWrapper, null, react__WEBPACK_IMPORTED_MODULE_0__.createElement(Button$1, {
    onClick: function onClick() {
      if (typeof window === 'undefined') {
        return;
      }

      if (responsive.backLink) {
        window.location.href = responsive.backLink;
        return;
      }

      window.history.back();
    }
  }, react__WEBPACK_IMPORTED_MODULE_0__.createElement(_microfrontends_react_components__WEBPACK_IMPORTED_MODULE_17__/* .ArrowLeft */ .Xd, {
    color: '#fff',
    size: 20
  })), react__WEBPACK_IMPORTED_MODULE_0__.createElement(Title, null, responsive.pageTitle)));
}

function _templateObject2$c() {
  var data = _taggedTemplateLiteralLoose(["\n    margin-bottom: 0;\n    font-size: 24px;\n    font-weight: 600;\n    line-height: 32px;\n"]);

  _templateObject2$c = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$c() {
  var data = _taggedTemplateLiteralLoose(["\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    width: 100%;\n    position: relative;\n"]);

  _templateObject$c = function _templateObject() {
    return data;
  };

  return data;
}
var Container$6 = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div */ .ZP.div(_templateObject$c());
var Title$1 = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].p */ .ZP.p(_templateObject2$c());

function PageWithTitleHeader() {
  var _useAppShellContext = useAppShellContext(),
      responsive = _useAppShellContext.responsive,
      user = _useAppShellContext.user,
      userIp = _useAppShellContext.userIp,
      mode = _useAppShellContext.mode,
      langCode = _useAppShellContext.langCode,
      optionList = _useAppShellContext.optionList,
      isPageContainer = _useAppShellContext.isPageContainer;

  var _responsive$pageTitle = responsive.pageTitle,
      pageTitle = _responsive$pageTitle === void 0 ? 'Career center' : _responsive$pageTitle;
  var envVars = getEnvVars(mode, langCode);
  return react__WEBPACK_IMPORTED_MODULE_0__.createElement(Container$6, null, react__WEBPACK_IMPORTED_MODULE_0__.createElement(Title$1, null, pageTitle), react__WEBPACK_IMPORTED_MODULE_0__.createElement(_microfrontends_react_components__WEBPACK_IMPORTED_MODULE_24__/* ["default"] */ .Z, {
    userId: (user === null || user === void 0 ? void 0 : user.userId) || 0,
    userJobFunction: (user === null || user === void 0 ? void 0 : user.jobFunction) || [],
    langCode: langCode,
    isMobile: true,
    pageName: EPages.MY_JOBS,
    dataProvider: initialDataProvider.exportProvider(),
    msBaseUrl: envVars.msBasePath,
    searchBarOptions: {
      isHomepage: false,
      isNeedNavigate: !isPageContainer
    },
    userIP: userIp,
    VNWAppId: envVars.appId,
    responsiveStyle: 'icon',
    optionList: optionList,
    mode: mode
  }));
}

function _templateObject6$3() {
  var data = _taggedTemplateLiteralLoose(["\n    position: absolute;\n    bottom: ", "px;\n    left: 0;\n    right: 0;\n"]);

  _templateObject6$3 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5$5() {
  var data = _taggedTemplateLiteralLoose(["\n    width: 24px;\n    height: 24px;\n    border-radius: 9999px;\n    margin-bottom: 4px;\n"]);

  _templateObject5$5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$7() {
  var data = _taggedTemplateLiteralLoose(["\n    width: 24px;\n    height: 24px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin-bottom: 4px;\n"]);

  _templateObject4$7 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$a() {
  var data = _taggedTemplateLiteralLoose(["\n    position: relative;\n    display: flex;\n    flex-grow: 1;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    ", "\n    color: ", ";\n    font-size: 12px;\n    font-weight: 500;\n    &::after {\n        content: '';\n        display: ", ";\n        position: absolute;\n        bottom: 0;\n        left: 0;\n        height: 3px;\n        width: 100%;\n        background: ", ";\n    }\n    & > svg {\n        margin-bottom: 4px;\n    }\n"]);

  _templateObject3$a = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$d() {
  var data = _taggedTemplateLiteralLoose(["\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    padding: 10px 8px 6px 8px;\n    color: unset;\n    &:hover {\n        color: unset;\n    }\n    & > svg {\n        margin-bottom: 4px;\n    }\n"]);

  _templateObject2$d = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$d() {
  var data = _taggedTemplateLiteralLoose(["\n    display: none;\n    position: fixed;\n    bottom: ", ";\n    left: 0;\n    width: 100%;\n    background: #fff;\n    z-index: 90;\n    transition: bottom 0.2s ease-in-out 0s;\n    box-shadow: 0px 4px 40px 0px rgba(0, 0, 0, 0.16);\n    &.show-bottom-sheet {\n        bottom: 0;\n    }\n    @media (max-width: 767px) {\n        display: flex;\n    }\n"]);

  _templateObject$d = function _templateObject() {
    return data;
  };

  return data;
}
var Container$7 = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div */ .ZP.div(_templateObject$d(), function (_ref) {
  var height = _ref.height;
  return -height + 'px';
});
var MenuLink$1 = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].a */ .ZP.a(_templateObject2$d());
var MenuItem = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div */ .ZP.div(_templateObject3$a(), function (_ref2) {
  var noPadding = _ref2.noPadding;
  return noPadding ? '' : 'padding: 15px 12px 15px 12px;';
}, function (_ref3) {
  var active = _ref3.active;
  return active ? _microfrontends_react_components__WEBPACK_IMPORTED_MODULE_14__/* .colors.primary[40] */ .O9.primary[40] : _microfrontends_react_components__WEBPACK_IMPORTED_MODULE_14__/* .colors.neutral[50] */ .O9.neutral[50];
}, function (_ref4) {
  var active = _ref4.active;
  return active ? 'block' : 'none';
}, _microfrontends_react_components__WEBPACK_IMPORTED_MODULE_14__/* .colors.primary[40] */ .O9.primary[40]);
var UserImageWrapper = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div */ .ZP.div(_templateObject4$7());
var UserImage = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].img */ .ZP.img(_templateObject5$5());
var ExternalElement = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div */ .ZP.div(_templateObject6$3(), function (_ref5) {
  var bottomSheetHeight = _ref5.bottomSheetHeight;
  return bottomSheetHeight;
});

var VERTICAL_THRESHOLD = 3;
var BOUNDING_LIMIT = 20;
function BottomTabNavigation() {
  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(0),
      bottomSheetHeight = _useState[0],
      setBottomSheetHeight = _useState[1];

  var _useHog = (0,_microfrontends_react_components__WEBPACK_IMPORTED_MODULE_29__/* ["default"] */ .Z)(),
      tracking = _useHog.tracking;

  var _useAppShellContext = useAppShellContext(),
      langCode = _useAppShellContext.langCode,
      mode = _useAppShellContext.mode,
      user = _useAppShellContext.user,
      pageName = _useAppShellContext.pageName,
      isLoggedIn = _useAppShellContext.isLoggedIn,
      responsive = _useAppShellContext.responsive;

  var envVars = getEnvVars(mode, langCode);
  var bottomTabRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
  var lastScrollPosition = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(0);
  var handleScroll = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function () {
    if (typeof window !== 'undefined' && bottomTabRef.current) {
      var currentScrollPosition = window.pageYOffset || document.documentElement.scrollTop;
      var limitTop = BOUNDING_LIMIT;
      var limitBottom = document.body.scrollHeight - window.innerHeight - BOUNDING_LIMIT;

      if (Math.abs(currentScrollPosition - lastScrollPosition.current) > VERTICAL_THRESHOLD) {
        if (currentScrollPosition < lastScrollPosition.current) {
          if (currentScrollPosition > limitBottom) {
            bottomTabRef.current.classList.remove('show-bottom-sheet');
          } else {
            bottomTabRef.current.classList.add('show-bottom-sheet');
          }
        } else {
          if (currentScrollPosition < limitTop) {
            bottomTabRef.current.classList.add('show-bottom-sheet');
          } else {
            bottomTabRef.current.classList.remove('show-bottom-sheet');
          }
        }
      }

      lastScrollPosition.current = currentScrollPosition;
    }
  }, []);

  var trackingMenuFooter = function trackingMenuFooter(page, callback) {
    switch (page) {
      case EPages.HOME_PAGE:
        tracking({
          eventName: 'js_platform_discovery:nav_home_tap'
        }, {
          transport: 'sendBeacon'
        });
        break;

      case EPages.SEARCH_RESULT:
        tracking({
          eventName: 'js_platform_discovery:nav_job_search_tap'
        }, {
          transport: 'sendBeacon'
        });
        break;

      case EPages.COMPANY_LIST:
        tracking({
          eventName: 'js_platform_discovery:nav_company_list_tap'
        }, {
          transport: 'sendBeacon'
        });
        break;

      case EPages.MY_JOBS:
        tracking({
          eventName: 'js_platform_discovery:nav_saved_job_tap'
        }, {
          transport: 'sendBeacon'
        });
        break;

      case EPages.ACCOUNT_CENTER:
        tracking({
          eventName: 'js_platform_discovery:nav_user_tap'
        }, {
          transport: 'sendBeacon'
        });
        break;
    }

    if (callback) callback();
  };

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    var _bottomTabRef$current;

    setBottomSheetHeight(((_bottomTabRef$current = bottomTabRef.current) === null || _bottomTabRef$current === void 0 ? void 0 : _bottomTabRef$current.clientHeight) || 0);
    document.addEventListener('scroll', handleScroll, {
      passive: true
    });
    return function () {
      document.removeEventListener('scroll', handleScroll);
    };
  }, []);
  var listMenu = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function () {
    return buildListMenu(langCode, envVars);
  }, []);
  var profilePicture = (user === null || user === void 0 ? void 0 : user.profilePicture) || '';

  if (typeof window === 'undefined') {
    return null;
  }

  var node = document.body;
  return (0,react_dom__WEBPACK_IMPORTED_MODULE_1__.createPortal)(react__WEBPACK_IMPORTED_MODULE_0__.createElement(Container$7, {
    ref: bottomTabRef,
    className: 'show-bottom-sheet',
    height: bottomSheetHeight
  }, (responsive === null || responsive === void 0 ? void 0 : responsive.externalBottomTabElement) ? react__WEBPACK_IMPORTED_MODULE_0__.createElement(ExternalElement, {
    bottomSheetHeight: bottomSheetHeight
  }, responsive.externalBottomTabElement) : null, react__WEBPACK_IMPORTED_MODULE_0__.createElement(MenuItem, {
    active: pageName === EPages.HOME_PAGE,
    noPadding: true
  }, react__WEBPACK_IMPORTED_MODULE_0__.createElement(MenuLink$1, {
    onClick: function onClick() {
      return trackingMenuFooter(EPages.HOME_PAGE);
    },
    href: "" + envVars.jobSeekerUrl + (langCode === ELanguage.EN ? '/en' : ''),
    "aria-label": 'Vietnamworks Home page'
  }, react__WEBPACK_IMPORTED_MODULE_0__.createElement(HomeIcon, null))), listMenu.map(function (item) {
    var isActive = item.pageName === pageName || item.subMenuList && item.subMenuList.length > 0 && item.subMenuList.filter(function (item) {
      return item.pageName === pageName;
    }).length > 0 || false;
    return item.hiddenOnMobile ? null : react__WEBPACK_IMPORTED_MODULE_0__.createElement(MenuItem, {
      key: item.id,
      active: isActive,
      onClick: function onClick() {
        return trackingMenuFooter(item.pageName, function () {
          handleNavigationClick({
            link: item.path,
            utm: item.utm,
            isUseCustomEvent: item.isUseCustomEvent || false,
            isLoggedIn: isLoggedIn,
            langCode: langCode
          });
        });
      }
    }, item.responsiveIcon);
  }), react__WEBPACK_IMPORTED_MODULE_0__.createElement(MenuItem, {
    active: pageName === EPages.ACCOUNT_CENTER,
    onClick: function onClick() {
      return trackingMenuFooter(EPages.ACCOUNT_CENTER, function () {
        return handleNavigationClick({
          link: envVars.jobSeekerUrl + "/" + (langCode === ELanguage.EN ? 'account-center' : 'tai-khoan-ca-nhan'),
          utm: '',
          isUseCustomEvent: true,
          isLoggedIn: true,
          langCode: langCode
        });
      });
    }
  }, profilePicture ? react__WEBPACK_IMPORTED_MODULE_0__.createElement(UserImage, {
    src: profilePicture,
    alt: user === null || user === void 0 ? void 0 : user.userName
  }) : react__WEBPACK_IMPORTED_MODULE_0__.createElement(UserImageWrapper, null, react__WEBPACK_IMPORTED_MODULE_0__.createElement(UserIcon, null)))), node);
}

function _templateObject5$6() {
  var data = _taggedTemplateLiteralLoose(["\n    transform: translateY(-12px);\n    margin-bottom: -12px;\n    border-radius: 12px 12px 0 0;\n    overflow: hidden;\n    position: relative;\n    z-index: 9;\n"]);

  _templateObject5$6 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$8() {
  var data = _taggedTemplateLiteralLoose(["\n    position: sticky;\n    top: 0;\n    display: ", ";\n    @media (max-width: 767px) {\n        display: ", ";\n        background-color: ", ";\n    }\n"]);

  _templateObject4$8 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$b() {
  var data = _taggedTemplateLiteralLoose(["\n    position: relative;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 4px 15px;\n    background-color: ", ";\n    color: #fff;\n    z-index: 10;\n\n    ", "\n\n    @media screen and (max-width: 767px) {\n        position: ", ";\n        width: 100%;\n        padding: 12px 16px;\n        height: auto;\n        z-index: 10;\n        top: 0px;\n        &::after {\n            display: block;\n        }\n    }\n"]);

  _templateObject3$b = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$e() {
  var data = _taggedTemplateLiteralLoose(["\n    height: 64px;\n    display: block;\n    width: 100%;\n"]);

  _templateObject2$e = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$e() {
  var data = _taggedTemplateLiteralLoose(["\n    position: relative;\n    background: ", ";\n    height: 12px;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    border-top-left-radius: 12px;\n    border-top-right-radius: 12px;\n    z-index: 9;\n"]);

  _templateObject$e = function _templateObject() {
    return data;
  };

  return data;
}
var BottomCornerWrapper = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div */ .ZP.div(_templateObject$e(), function (_ref) {
  var cornerColor = _ref.cornerColor;
  return cornerColor;
});
var FakeEmptyDiv = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div */ .ZP.div(_templateObject2$e());
var Container$8 = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div */ .ZP.div(_templateObject3$b(), _microfrontends_react_components__WEBPACK_IMPORTED_MODULE_14__/* .colors.primary[20] */ .O9.primary[20], function (_ref2) {
  var isContainerHeader = _ref2.isContainerHeader;

  if (!isContainerHeader) {
    return '';
  }

  return (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)(["position:", ";"], function (_ref3) {
    var isStickyHeader = _ref3.isStickyHeader;
    return isStickyHeader ? 'fixed' : 'relative';
  });
}, function (_ref4) {
  var isStickyHeader = _ref4.isStickyHeader;
  return isStickyHeader ? 'fixed' : 'relative';
});
var Wrapper$3 = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div */ .ZP.div(_templateObject4$8(), function (_ref5) {
  var appearOnMobile = _ref5.appearOnMobile;
  return appearOnMobile ? 'none' : 'block';
}, function (_ref6) {
  var appearOnMobile = _ref6.appearOnMobile;
  return appearOnMobile ? 'block' : 'none';
}, _microfrontends_react_components__WEBPACK_IMPORTED_MODULE_14__/* .colors.primary[20] */ .O9.primary[20]);
var ResponsiveElementWrapper = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div */ .ZP.div(_templateObject5$6());
var HeaderContainer = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div */ .ZP.div(function (_ref7) {
  var isHaveTopBanner = _ref7.isHaveTopBanner,
      isSticky = _ref7.isSticky;
  return _extends({}, isSticky ? {
    position: 'sticky',
    top: isHaveTopBanner ? -TOP_BANNER_HEIGHT : 0
  } : {
    position: 'relative'
  }, {
    zIndex: 110
  });
});

var responsiveHeader = {
  'home-page': react__WEBPACK_IMPORTED_MODULE_0__.createElement(MainPageHeader, null),
  'search-page': react__WEBPACK_IMPORTED_MODULE_0__.createElement(SearchResultHeader, null),
  'page-with-title': react__WEBPACK_IMPORTED_MODULE_0__.createElement(PageWithTitleHeader, null),
  'sub-page': react__WEBPACK_IMPORTED_MODULE_0__.createElement(SubPageHeader, null)
};
var TRACKING_COOKIE = 'VNW_TRACKING_GA';
var TRACKING_COOKIE_FIRST = 'VNW_TRACKING_GA_FIRST';
function Header$1(_ref) {
  var pageName = _ref.pageName,
      mode = _ref.mode,
      user = _ref.user,
      langCode = _ref.langCode,
      _ref$hiddenSearchBar = _ref.hiddenSearchBar,
      hiddenSearchBar = _ref$hiddenSearchBar === void 0 ? false : _ref$hiddenSearchBar,
      topBannerZone = _ref.topBannerZone,
      _ref$isHomePage = _ref.isHomePage,
      isHomePage = _ref$isHomePage === void 0 ? false : _ref$isHomePage,
      _ref$userIp = _ref.userIp,
      userIp = _ref$userIp === void 0 ? '::1' : _ref$userIp,
      responsive = _ref.responsive,
      _ref$isHaveBottomTab = _ref.isHaveBottomTab,
      isHaveBottomTab = _ref$isHaveBottomTab === void 0 ? true : _ref$isHaveBottomTab,
      subMenuSection = _ref.subMenuSection,
      shellContext = _ref.shellContext,
      _ref$forceShowTopBann = _ref.forceShowTopBanner,
      forceShowTopBanner = _ref$forceShowTopBann === void 0 ? false : _ref$forceShowTopBann,
      _ref$topBannerData = _ref.topBannerData,
      topBannerData = _ref$topBannerData === void 0 ? null : _ref$topBannerData,
      _ref$autoFetchTopBann = _ref.autoFetchTopBanner,
      autoFetchTopBanner = _ref$autoFetchTopBann === void 0 ? true : _ref$autoFetchTopBann,
      _ref$showTabFindJob = _ref.showTabFindJob,
      showTabFindJob = _ref$showTabFindJob === void 0 ? true : _ref$showTabFindJob,
      _ref$nextImage = _ref.nextImage,
      nextImage = _ref$nextImage === void 0 ? null : _ref$nextImage,
      _ref$isSticky = _ref.isSticky,
      isSticky = _ref$isSticky === void 0 ? false : _ref$isSticky;
  var isMobile = _microfrontends_react_components__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z('(max-width: 767px)') || false;
  var isTablet = _microfrontends_react_components__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z('(max-width: 1023px)') || false;
  var isMounted = useDomContentLoaded();

  var _ref2 = responsive || {},
      _ref2$type = _ref2.type,
      responsiveHeaderType = _ref2$type === void 0 ? 'home-page' : _ref2$type,
      _ref2$cornerColor = _ref2.cornerColor,
      cornerColor = _ref2$cornerColor === void 0 ? '#fff' : _ref2$cornerColor;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(_extends({}, initialValues)),
      appShellContext = _useState[0],
      setAppShellContext = _useState[1];

  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)([]),
      locations = _useState2[0],
      setLocations = _useState2[1];

  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false),
      isStickyHeader = _useState3[0],
      setStickyHeader = _useState3[1];

  var _useState4 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(isMobile != null ? isMobile : false),
      isHavePopupNewUser = _useState4[0],
      setHavePopupNewUser = _useState4[1];

  var _useState5 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(!!topBannerData && topBannerData.length > 0),
      isHaveTopBanner = _useState5[0],
      setHaveTopBanner = _useState5[1];

  var handleUpdateSearchParams = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function (event) {
    var eventDetail = event.detail;
    var _eventDetail$params = eventDetail.params,
        categoryId = _eventDetail$params.categoryId,
        locationId = _eventDetail$params.locationId,
        query = _eventDetail$params.query,
        locations = _eventDetail$params.locations,
        companyIndustries = _eventDetail$params.companyIndustries,
        jobFunctionId = _eventDetail$params.jobFunctionId;
    var newState = {};
    if (query || typeof query === 'string' && query.trim() === '') newState.keyword = query;
    if (locationId) newState.locationId = locationId;
    if (categoryId) newState.categoryId = categoryId;
    if (companyIndustries) newState.companyIndustries = companyIndustries;
    if (jobFunctionId) newState.jobFunctions = jobFunctionId;
    if (locations) newState.locations = locations;
    setAppShellContext(function (prevState) {
      return _extends({}, prevState, newState);
    });
  }, []);
  var getLocationData = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function () {
    var _initialData$location;

    var initialData = initialDataProvider.getSelectData();

    if (initialData === null || initialData === void 0 ? void 0 : (_initialData$location = initialData.location) === null || _initialData$location === void 0 ? void 0 : _initialData$location.length) {
      var location = initialData.location.map(function (item) {
        var locationItem = {
          id: item.id,
          name: langCode === ELanguage.EN ? item.nameEn : item.name,
          nameEn: item.nameEn
        };
        return locationItem;
      });
      setLocations(location);
    } else {
      console.error('[LocationSelector] > initial data does not exist');
    }
  }, [langCode]);

  var updateUserState = function updateUserState(e) {
    try {
      var _e$detail;

      if (!(e === null || e === void 0 ? void 0 : (_e$detail = e.detail) === null || _e$detail === void 0 ? void 0 : _e$detail.user)) {
        return Promise.resolve();
      }

      var isShowOnBoarding = e.detail.isNewRegistered;

      if (isShowOnBoarding) {
        var onboardingPathname = langCode === ELanguage.EN ? '/welcome/start' : '/chao-mung/bat-dau';
        window.location.assign(onboardingPathname);
      }

      return Promise.resolve();
    } catch (e) {
      return Promise.reject(e);
    }
  };

  var detectPopupNewUser = function detectPopupNewUser() {
    var popupElement = document.querySelector('.content-popup .app-title');
    var rawPopupNewUser = localStorage.getItem('popupNewUser');
    var popupNewUser = JSON.parse(rawPopupNewUser != null ? rawPopupNewUser : '[]');
    var isHavePopup = popupNewUser.length < POPUP_NEW_USER_CLOSE_TIMES && popupElement !== null;

    if (isHavePopupNewUser === isHavePopup) {
      return;
    }

    setHavePopupNewUser(isHavePopup);
  };

  var onScroll = function onScroll() {
    detectPopupNewUser();
    var limitStickyTop = isHavePopupNewUser ? TOTAL_HEIGHT_OF_POPUP_NEW_USER : 1;
    var newStickyHeaderCondition = window.scrollY >= limitStickyTop;

    if (isStickyHeader === newStickyHeaderCondition) {
      return;
    }

    setStickyHeader(newStickyHeaderCondition);
  };

  var storeUtmCookie = function storeUtmCookie(cookieName) {
    var _getEnvVars, _document;

    var internalRefererUrl = new RegExp((_getEnvVars = getEnvVars(mode, langCode)) === null || _getEnvVars === void 0 ? void 0 : _getEnvVars.internalRefererUrls) || '//';
    var utm = trackUtms(internalRefererUrl, (_document = document) === null || _document === void 0 ? void 0 : _document.referrer, js_cookie.get(cookieName));

    if (utm) {
      var _getEnvVars2;

      var cookieDomain = (_getEnvVars2 = getEnvVars(mode, langCode)) === null || _getEnvVars2 === void 0 ? void 0 : _getEnvVars2.cookieDomain;
      var cookieOptions = {
        expires: 30,
        domain: cookieDomain
      };
      js_cookie.set(cookieName, JSON.stringify(utm), cookieOptions);
    }
  };

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    if (typeof window !== 'undefined') {
      window.addEventListener('SEARCH', handleUpdateSearchParams);
      window.addEventListener('UPDATE_USER', updateUserState);
    }

    getLocationData();
    return function () {
      window.removeEventListener('SEARCH', handleUpdateSearchParams);
      window.removeEventListener('UPDATE_USER', updateUserState);
    };
  }, [getLocationData]);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    window.addEventListener('scroll', onScroll);
    return function () {
      window.removeEventListener('scroll', onScroll);
    };
  }, [isHavePopupNewUser, isStickyHeader]);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    if (pageName === 'jobDetail') {
      initialDataProvider.initSelectData({
        selectDataKey: ['industry', 'jobFunction'],
        mode: mode,
        langCode: langCode
      });
    }

    if (!_isJobDetail() && typeof window !== 'undefined' && typeof document !== 'undefined') {
      storeUtmCookie(TRACKING_COOKIE);

      if (!js_cookie.get(TRACKING_COOKIE_FIRST)) {
        storeUtmCookie(TRACKING_COOKIE_FIRST);
      }
    }

    setTimeout(function () {
      detectPopupNewUser();
    }, 100);
  }, []);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    if (shellContext) {
      setAppShellContext(function (prevState) {
        return _extends({}, prevState, shellContext);
      });
    }
  }, [shellContext]);

  var _getEnvVars3 = getEnvVars(mode, langCode),
      zaloWidgetOaid = _getEnvVars3.zaloWidgetOaid;

  var isFindJobTabAvailable = [EPages.TOP_MANAGEMENT_JOBS, EPages.SEARCH_RESULT, EPages.SEO_LANDING_PAGE].includes(pageName);
  var notNavigate = [EPages.TOP_MANAGEMENT_JOBS, EPages.SEARCH_RESULT].includes(pageName);
  var renderPopupNewUser = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function () {
    if (!isMounted) {
      return react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null);
    }

    if (isMounted && isMobile) {
      return react__WEBPACK_IMPORTED_MODULE_0__.createElement(_microfrontends_react_components__WEBPACK_IMPORTED_MODULE_30__/* ["default"] */ .Z, {
        langCode: langCode,
        onClosePopup: function onClosePopup() {
          return setHavePopupNewUser(false);
        }
      });
    }

    return react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null);
  }, [isMounted, isMobile]);
  var envVars = getEnvVars(mode, langCode);
  return react__WEBPACK_IMPORTED_MODULE_0__.createElement(AppShellContext$1.Provider, {
    value: _extends({}, appShellContext, {
      translate: translate$1(langCode),
      isLoggedIn: !!user && !!user.userId,
      hiddenSearchBar: hiddenSearchBar,
      userIp: userIp,
      pageName: pageName,
      mode: mode,
      user: user,
      langCode: langCode,
      isHomePage: isHomePage,
      isMobile: isMobile,
      isTablet: isTablet,
      isPageContainer: notNavigate,
      subMenuSection: subMenuSection,
      responsive: responsive || {
        type: 'home-page',
        cornerColor: '#fff'
      },
      zoneName: topBannerZone || ETopBannerZoneName.EMPTY,
      optionList: locations,
      forceShowTopBanner: forceShowTopBanner,
      topBannerData: topBannerData,
      autoFetchTopBanner: autoFetchTopBanner,
      showTabFindJob: showTabFindJob
    })
  }, react__WEBPACK_IMPORTED_MODULE_0__.createElement(HeaderContainer, {
    "data-cname": 'Header',
    className: 'appHeader',
    isSticky: isSticky,
    isHaveTopBanner: isHaveTopBanner
  }, react__WEBPACK_IMPORTED_MODULE_0__.createElement(TopBanner, {
    nextImage: nextImage,
    handleSetHaveTopBanner: setHaveTopBanner
  }), renderPopupNewUser, react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper$3, {
    isSticky: isSticky
  }, react__WEBPACK_IMPORTED_MODULE_0__.createElement(Container$8, null, react__WEBPACK_IMPORTED_MODULE_0__.createElement(Logo, null), react__WEBPACK_IMPORTED_MODULE_0__.createElement(Navigation, null), react__WEBPACK_IMPORTED_MODULE_0__.createElement(Actions, null))), isMobile ? react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper$3, {
    appearOnMobile: true,
    isSticky: false
  }, isStickyHeader && react__WEBPACK_IMPORTED_MODULE_0__.createElement(FakeEmptyDiv, null), react__WEBPACK_IMPORTED_MODULE_0__.createElement(Container$8, {
    isContainerHeader: true,
    isStickyHeader: isStickyHeader
  }, responsiveHeader[responsiveHeaderType]), react__WEBPACK_IMPORTED_MODULE_0__.createElement(BottomCornerWrapper, {
    "data-cname": 'BottomCornerWrapper',
    cornerColor: cornerColor,
    isHaveExternalElement: false
  }), (responsive === null || responsive === void 0 ? void 0 : responsive.externalElement) ? react__WEBPACK_IMPORTED_MODULE_0__.createElement(ResponsiveElementWrapper, null, responsive.externalElement) : null, isMounted && isHaveBottomTab ? react__WEBPACK_IMPORTED_MODULE_0__.createElement(BottomTabNavigation, null) : null) : null, isFindJobTabAvailable && showTabFindJob === true ? react__WEBPACK_IMPORTED_MODULE_0__.createElement(FindJobsTab, null) : null, react__WEBPACK_IMPORTED_MODULE_0__.createElement(_microfrontends_react_components__WEBPACK_IMPORTED_MODULE_31__/* ["default"] */ .Z, {
    langCode: langCode,
    mode: mode,
    user: user,
    pageName: pageName,
    baseImgUrl: envVars.jobSeekerImageUrl
  }), react__WEBPACK_IMPORTED_MODULE_0__.createElement(_microfrontends_react_components__WEBPACK_IMPORTED_MODULE_32__/* ["default"] */ .Z, {
    oaid: zaloWidgetOaid
  })));
}

var useInitialData = function useInitialData(langCode) {
  var _useState = useState({
    locations: [],
    jobFunctions: {
      parent: [],
      child: {}
    },
    companyIndustries: [],
    jobLevels: [],
    educations: [],
    countries: [],
    cities: [],
    districts: {},
    benefits: []
  }),
      initData = _useState[0],
      setInitData = _useState[1];

  var initSelectData = function initSelectData() {
    try {
      return Promise.resolve(initialDataProvider.initSelectData({
        selectDataKey: ['industry', 'jobFunction', 'level'],
        mode: process.env.APP_SHELL_MODE,
        langCode: langCode
      })).then(function () {
        return Promise.resolve(initialDataProvider.getDatasetAsync('jobFunction')).then(function () {
          return Promise.resolve(initialDataProvider.getDatasetAsync('industry')).then(function () {
            setInitData({
              locations: initialDataProvider.getLocations(),
              jobFunctions: initialDataProvider.getJobFunction(),
              companyIndustries: initialDataProvider.getIndustries(),
              jobLevels: initialDataProvider.getLevels(),
              educations: initialDataProvider.getHighestDegrees(),
              countries: initialDataProvider.getCountries(),
              cities: initialDataProvider.getLocations(),
              districts: initialDataProvider.getDistricts(),
              benefits: initialDataProvider.getBenefits()
            });
          });
        });
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };

  useEffect(function () {
    initSelectData();
  }, []);
  return initData;
};


//# sourceMappingURL=index.modern.js.map


/***/ })

}]);